import React, { useState, useEffect, Component, useMemo, Children } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import styled, { keyframes, css, createGlobalStyle } from 'styled-components';
import reactIs from 'react-is';
import { Link, useLocation } from 'react-router-dom';
import { useTable, useGlobalFilter, useSortBy, useExpanded, usePagination, useRowSelect } from 'react-table';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/* eslint-disable react/prop-types */

// NOTE: DO NOT ADD MORE PATHS HERE
// NOTE: ADD THEM TO THE ICONPATHS FOLDER
var iconPaths = {
  ModeratelyGoodSignal: function ModeratelyGoodSignal() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-m1"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#FAD961",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#F76B1C",
      offset: "100%"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-m2"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#FAD961",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#F76B1C",
      offset: "100%"
    }))), /*#__PURE__*/React.createElement("g", {
      id: "Moderately",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M116.712747,135 C99.7500923,135 86,150.199408 86,168.966406 L86,268.032778 C86,286.785081 99.7500923,302 116.712747,302 L121.287253,302 C138.249908,302 152,286.792429 152,268.033594 L152,168.966406 C152,150.206755 138.24917,135 121.287253,135 L116.712747,135 Z",
      id: "Path",
      fill: "url(#linearGradient-m1)",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M202.713091,302 L207.286909,302 C224.249754,302 238,286.834163 238,268.126809 L238,112.873191 C238,94.173164 224.249016,79 207.286909,79 L202.713091,79 C185.750246,79 172,94.1658367 172,112.873191 L172,268.126809 C171.999262,286.826836 185.750246,302 202.713091,302 Z",
      id: "Path",
      fill: "#D6D6D6",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M324,268.130856 L324,33.8691437 C324,15.171351 310.249323,0 293.286858,0 L288.706498,0 C271.750677,0 258,15.1640246 258,33.8691437 L258,268.130042 C258,286.827835 271.750677,302 288.706498,302 L293.286858,302 C310.249323,302 324,286.835975 324,268.130856 Z",
      id: "Path",
      fill: "#D6D6D6",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.2899496,176 L30.7159552,176 C13.7559355,176 0,191.154983 0,209.849763 L0,268.150237 C0,286.837695 13.7559355,302 30.7166933,302 L35.2906877,302 C52.2440645,302 66,286.845017 66,268.151051 L66,209.849763 C66,191.154983 52.2440645,176 35.2899496,176 Z",
      id: "Path",
      fill: "url(#linearGradient-m2)",
      fillRule: "nonzero"
    })));
  },
  VeryGoodSignal: function VeryGoodSignal() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-v1"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D1F353",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#61841A",
      offset: "100%"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-v2"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D1F353",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#61841A",
      offset: "100%"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-v3"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D1F353",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#61841A",
      offset: "100%"
    }))), /*#__PURE__*/React.createElement("g", {
      id: "Very",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M116.712747,135 C99.7500923,135 86,150.199408 86,168.966406 L86,268.032778 C86,286.785081 99.7500923,302 116.712747,302 L121.287253,302 C138.249908,302 152,286.792429 152,268.033594 L152,168.966406 C152,150.206755 138.24917,135 121.287253,135 L116.712747,135 Z",
      id: "Path",
      fill: "url(#linearGradient-v1)",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M202.713091,302 L207.286909,302 C224.249754,302 238,286.834163 238,268.126809 L238,112.873191 C238,94.173164 224.249016,79 207.286909,79 L202.713091,79 C185.750246,79 172,94.1658367 172,112.873191 L172,268.126809 C171.999262,286.826836 185.750246,302 202.713091,302 Z",
      id: "Path",
      fill: "url(#linearGradient-v2)",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M324,268.130856 L324,33.8691437 C324,15.171351 310.249323,0 293.286858,0 L288.706498,0 C271.750677,0 258,15.1640246 258,33.8691437 L258,268.130042 C258,286.827835 271.750677,302 288.706498,302 L293.286858,302 C310.249323,302 324,286.835975 324,268.130856 Z",
      id: "Path",
      fill: "#D6D6D6",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.2899496,176 L30.7159552,176 C13.7559355,176 0,191.154983 0,209.849763 L0,268.150237 C0,286.837695 13.7559355,302 30.7166933,302 L35.2906877,302 C52.2440645,302 66,286.845017 66,268.151051 L66,209.849763 C66,191.154983 52.2440645,176 35.2899496,176 Z",
      id: "Path",
      fill: "url(#linearGradient-v3)",
      fillRule: "nonzero"
    })));
  },
  RemarkableSignal: function RemarkableSignal() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-r1"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#39B34A",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#374A12",
      offset: "100%"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-r2"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#39B34A",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#374A12",
      offset: "100%"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-r3"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#39B34A",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#374A12",
      offset: "100%"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      x1: "50%",
      y1: "0%",
      x2: "50%",
      y2: "100%",
      id: "linearGradient-r4"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#39B34A",
      offset: "0%"
    }), /*#__PURE__*/React.createElement("stop", {
      stopColor: "#374A12",
      offset: "100%"
    }))), /*#__PURE__*/React.createElement("g", {
      id: "Remarkably",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M116.712747,135 C99.7500923,135 86,150.199408 86,168.966406 L86,268.032778 C86,286.785081 99.7500923,302 116.712747,302 L121.287253,302 C138.249908,302 152,286.792429 152,268.033594 L152,168.966406 C152,150.206755 138.24917,135 121.287253,135 L116.712747,135 Z",
      id: "Path",
      fill: "url(#linearGradient-r1)",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M202.713091,302 L207.286909,302 C224.249754,302 238,286.834163 238,268.126809 L238,112.873191 C238,94.173164 224.249016,79 207.286909,79 L202.713091,79 C185.750246,79 172,94.1658367 172,112.873191 L172,268.126809 C171.999262,286.826836 185.750246,302 202.713091,302 Z",
      id: "Path",
      fill: "url(#linearGradient-r2)",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M324,268.130856 L324,33.8691437 C324,15.171351 310.249323,0 293.286858,0 L288.706498,0 C271.750677,0 258,15.1640246 258,33.8691437 L258,268.130042 C258,286.827835 271.750677,302 288.706498,302 L293.286858,302 C310.249323,302 324,286.835975 324,268.130856 Z",
      id: "Path",
      fill: "url(#linearGradient-r3)",
      fillRule: "nonzero"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.2899496,176 L30.7159552,176 C13.7559355,176 0,191.154983 0,209.849763 L0,268.150237 C0,286.837695 13.7559355,302 30.7166933,302 L35.2906877,302 C52.2440645,302 66,286.845017 66,268.151051 L66,209.849763 C66,191.154983 52.2440645,176 35.2899496,176 Z",
      id: "Path",
      fill: "url(#linearGradient-r4)",
      fillRule: "nonzero"
    })));
  },
  Activate: function Activate(_ref) {
    var color = _ref.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M24.9,50A22.65,22.65,0,0,1,16.1,6.5a1.72,1.72,0,0,1,2.3.9,1.48,1.48,0,0,1-.9,2.1A19.05,19.05,0,0,0,5.7,27.2,19.2,19.2,0,1,0,32.4,9.5a1.35,1.35,0,0,1-.9-.9,2.85,2.85,0,0,1,0-1.3,2,2,0,0,1,2.4-.8A22.62,22.62,0,0,1,41,43.4,23.12,23.12,0,0,1,24.9,50Zm0-20.1a1.86,1.86,0,0,1-1.8-1.8V1.8A1.66,1.66,0,0,1,23.6.5,1.79,1.79,0,0,1,24.9,0h0a1.86,1.86,0,0,1,1.8,1.8V28.2A1.84,1.84,0,0,1,24.9,29.9Z"
    });
  },
  ActuarialLCD: function ActuarialLCD(_ref2) {
    var color = _ref2.color;
    return (
      /*#__PURE__*/
      // viewBox="0 0 60 50"
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M28 26a1.1 1.1 0 0 0 .3-1c0-.2 0-.6-.4-.8l-10-8.9a1.3 1.3 0 0 0-1.9 0 1 1 0 0 0 0 1.6l8.1 7H13.4c-.8 0-1.4.5-1.4 1 0 .7.6 1.2 1.4 1.2h10.5l-7.9 7a1 1 0 0 0 0 1.5c.6.6 1.3.6 1.9 0z"
      }), /*#__PURE__*/React.createElement("rect", {
        width: "56.5",
        height: "46.5",
        x: "1.8",
        y: "1.8",
        fill: "none",
        stroke: color,
        strokeWidth: "3.5",
        rx: "3.3"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M39.4 38.6V11.4h1.7v27.2Zm5-18.5a2.8 2.8 0 0 0-1.2-2 5 5 0 0 0-3-1c-1 0-1.5 0-2.3.3a3.2 3.2 0 0 0-1.3 1 2.5 2.5 0 0 0 0 2.6c0 .4.4.6.8 1l1.1.5 1.3.4 2.1.4 2.5.8 1.8 1.3a5.5 5.5 0 0 1 2 4.3 5.9 5.9 0 0 1-3.8 5.7 11.1 11.1 0 0 1-4.4.7 11.3 11.3 0 0 1-4.3-.7 6.6 6.6 0 0 1-3-2.5 6.8 6.8 0 0 1-1.2-3.7h4c0 .9.3 1.5.7 1.8a3.8 3.8 0 0 0 1.5 1.4l2.3.3c1 0 1.7 0 2.3-.3a3.8 3.8 0 0 0 1.5-1.2 2.6 2.6 0 0 0 .6-1.7c0-.5 0-1-.4-1.3a3.8 3.8 0 0 0-1.5-1 13.2 13.2 0 0 0-2-.7L38 26a10 10 0 0 1-4.1-2 5 5 0 0 1-1.5-3.8 5.7 5.7 0 0 1 .9-3.4 8.3 8.3 0 0 1 2.8-2.3 10 10 0 0 1 4.2-.7 9.4 9.4 0 0 1 4 .7 5.7 5.7 0 0 1 2.8 2.3c.8 1 1 1.9 1.1 3.2z"
      }))
    );
  },
  ActuarialLCM: function ActuarialLCM(_ref3) {
    var color = _ref3.color;
    return (
      /*#__PURE__*/
      // viewBox="0 0 60 50"
      React.createElement("g", {
        fill: "none"
      }, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "m13.9 14.1 4.8 7.98h.17l4.82-7.99h4.51L21.48 25l6.83 10.9h-4.58l-4.86-7.93h-.17l-4.86 7.94H9.28L16.18 25 9.36 14.1zm26.54 24.54V11.36h1.75v27.28zm5.04-18.55a2.9 2.9 0 0 0-1.26-2.17 4.83 4.83 0 0 0-2.85-.78 5.4 5.4 0 0 0-2.12.37 3.2 3.2 0 0 0-1.36 1.01 2.46 2.46 0 0 0-.17 2.64c.22.34.5.62.87.86.36.22.76.42 1.2.57.44.16.88.29 1.33.4l2.05.5c.82.2 1.61.46 2.37.79.77.32 1.45.73 2.06 1.23.6.5 1.1 1.1 1.45 1.8.35.7.53 1.53.53 2.47 0 1.28-.33 2.4-.98 3.38a6.48 6.48 0 0 1-2.83 2.27c-1.23.54-2.72.8-4.47.8-1.7 0-3.17-.25-4.42-.78a6.58 6.58 0 0 1-2.92-2.3 6.8 6.8 0 0 1-1.13-3.69h3.9c.05.76.28 1.4.7 1.9.4.5.94.88 1.6 1.13.67.25 1.42.37 2.24.37.86 0 1.61-.13 2.26-.38a3.66 3.66 0 0 0 1.53-1.09c.37-.47.56-1.01.57-1.64a2.1 2.1 0 0 0-.5-1.4 3.67 3.67 0 0 0-1.38-.94c-.58-.26-1.26-.49-2.04-.68l-2.49-.64a10 10 0 0 1-4.26-2.1 4.84 4.84 0 0 1-1.55-3.76c0-1.29.35-2.41 1.04-3.38a6.9 6.9 0 0 1 2.87-2.25 9.95 9.95 0 0 1 4.1-.8c1.55 0 2.9.26 4.07.8a6.63 6.63 0 0 1 2.76 2.23 5.68 5.68 0 0 1 1.03 3.26z"
      }), /*#__PURE__*/React.createElement("rect", {
        width: "11.3",
        height: "9.3",
        x: ".35",
        y: ".35",
        stroke: color,
        strokeWidth: ".7",
        rx: ".65",
        transform: "scale(5)"
      }))
    );
  },
  ActuarialSeverity: function ActuarialSeverity(_ref4) {
    var color = _ref4.color;
    return (
      /*#__PURE__*/
      // viewBox="0 0 60 50"
      React.createElement("g", {
        fill: "none"
      }, /*#__PURE__*/React.createElement("rect", {
        width: "11.3",
        height: "9.3",
        x: ".35",
        y: ".35",
        stroke: color,
        strokeWidth: ".7",
        rx: ".65",
        transform: "scale(5)"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M41.47 37.76c.48.49 1.28.49 1.76 0l7.96-7.96a1.25 1.25 0 0 0-1.77-1.76l-7.07 7.07-7.07-7.07a1.25 1.25 0 0 0-1.77 1.76zm-.37-25.88v25h2.5v-25Zm-22.57.36a1.25 1.25 0 0 0-1.76 0L8.8 20.2a1.25 1.25 0 0 0 1.77 1.76l7.07-7.07 7.07 7.07a1.25 1.25 0 0 0 1.77-1.76zm.37 25.89v-25h-2.5v25z"
      }))
    );
  },
  Add: function Add(_ref5) {
    var color = _ref5.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11,11 L8,11 C7.44771525,11 7,11.4477153 7,12 C7,12.5522847 7.44771525,13 8,13 L11,13 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,13 L16,13 C16.5522847,13 17,12.5522847 17,12 C17,11.4477153 16.5522847,11 16,11 L13,11 L13,8 C13,7.44771525 12.5522847,7 12,7 C11.4477153,7 11,7.44771525 11,8 L11,11 Z M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z"
    });
  },
  AddBoxed: function AddBoxed(_ref6) {
    var color = _ref6.color;
    return /*#__PURE__*/React.createElement("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: color
    }, /*#__PURE__*/React.createElement("path", {
      d: "M2.1 1.4a.7.7 0 0 0-.7.7v9.8a.7.7 0 0 0 .7.7h9.8a.7.7 0 0 0 .7-.7V2.1a.7.7 0 0 0-.7-.7H2.1ZM0 2.1C0 .94.94 0 2.1 0h9.8c1.16 0 2.1.94 2.1 2.1v9.8a2.1 2.1 0 0 1-2.1 2.1H2.1A2.1 2.1 0 0 1 0 11.9V2.1Z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3.5a.7.7 0 0 1 .7.7v5.6a.7.7 0 1 1-1.4 0V4.2a.7.7 0 0 1 .7-.7Z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.5 7a.7.7 0 0 1 .7-.7h5.6a.7.7 0 1 1 0 1.4H4.2a.7.7 0 0 1-.7-.7Z"
    }));
  },
  AI: function AI(_ref7) {
    var color = _ref7.color;
    return (
      /*#__PURE__*/
      // viewBox="0 0 51 60"
      React.createElement("path", {
        d: "M45.57 41.38a5.14 5.14 0 0 0-5 3.99h-2.52L35.4 40.8c-.2-.35-.58-.57-1-.57h-6.76V35.2h4.67c.38 0 .73-.19.94-.5l3.25-4.56h4.07a5.14 5.14 0 1 0 0-2.3H35.9c-.38 0-.73.18-.94.48L31.7 32.9h-4.07V17.2h8.95a5.14 5.14 0 1 0 0-2.3h-8.95V8.18c0-3.22-1.8-6.12-4.58-7.39-.79-.36-3.55-1.43-6.2-.21-1.65.76-2.87 2.23-3.63 4.37a6 6 0 0 0-1.25.3c-2.16.8-3.67 2.8-4.5 5.93-.78.3-2.02.97-2.95 2.34-1.1 1.63-1.47 3.75-1.1 6.31a8.43 8.43 0 0 0-1.6 12c-1.19 2.08-2.07 5.75.63 9.02a6.31 6.31 0 0 0-.37 4.81c.7 1.84 2.4 3.2 5.06 4.07a7.37 7.37 0 0 0 9.52 7.46c.95 1.02 3 2.82 5.53 2.82a5.4 5.4 0 0 0 2.03-.4 5.62 5.62 0 0 0 3.4-5.23V42.55h6.1l2.67 4.55c.2.35.58.57 1 .57h3.16a5.14 5.14 0 1 0 5-6.29h.02Zm0-15.24a2.83 2.83 0 1 1-.01 5.67 2.83 2.83 0 0 1 0-5.67Zm-3.99-12.92a2.83 2.83 0 1 1 0 5.66 2.83 2.83 0 0 1 0-5.66ZM25.32 54.37a3.3 3.3 0 0 1-1.95 3.1c-1.78.7-3.5-.44-4.52-1.37a7.33 7.33 0 0 0 2.96-4.78 7.33 7.33 0 0 0-1.26-5.46 1.15 1.15 0 1 0-1.88 1.33 5.08 5.08 0 0 1-2.13 7.6h-.03a5.04 5.04 0 0 1-6.12-1.71 5.04 5.04 0 0 1-.9-3.7.44.44 0 0 0 .08-.17 1.15 1.15 0 0 0-.83-1.4c-1.7-.44-3.86-1.3-4.5-2.95-.63-1.67.56-3.52.57-3.53.31-.46.26-1.07-.14-1.46-3.4-3.4-.62-7.26-.49-7.44l.03-.03.05-.1a.78.78 0 0 0 .06-.1l.03-.1.04-.11.01-.1.02-.12v-.1c0-.04 0-.08-.02-.12l-.02-.1a.7.7 0 0 0-.03-.11l-.05-.1-.05-.1-.07-.09-.07-.1-.02-.02a6.15 6.15 0 1 1 10.52-4.32 1.15 1.15 0 1 0 2.3 0 8.46 8.46 0 0 0-11.3-7.94c-.3-4.56 2.69-5.36 3.05-5.43.46-.09.82-.44.91-.9.6-2.69 1.67-4.34 3.2-4.9 2.87-1.08 6.71 1.77 6.75 1.8a1.16 1.16 0 0 0 1.39-1.84c-.14-.1-2.47-1.84-5.25-2.36a4.59 4.59 0 0 1 2.16-2.36c1.75-.8 3.7-.03 4.27.22a5.75 5.75 0 0 1 3.23 5.3v6.71h-7.5a3.03 3.03 0 0 1-3.03-3.03 1.16 1.16 0 0 0-2.3 0 5.33 5.33 0 0 0 5.33 5.34h7.5v15.67H14.67a5.07 5.07 0 0 1-5.06-5.06 1.16 1.16 0 1 0-2.3 0c0 4.07 3.3 7.37 7.36 7.37h10.65v5.06h-7.08a6.28 6.28 0 0 0-6.28 6.28 1.16 1.16 0 1 0 2.3 0 3.98 3.98 0 0 1 3.98-3.98h7.08V54.4v-.02Zm20.25-5.02a2.83 2.83 0 1 1 0-5.67 2.83 2.83 0 0 1 0 5.67Z",
        fill: color
      })
    );
  },
  AlertSolid: function AlertSolid(_ref8) {
    var color = _ref8.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.7557911,3.21895043 L22.3867068,19.0422957 C22.9156322,20.0119924 22.5583166,21.2268657 21.5886199,21.7557911 C21.2948427,21.9160333 20.9655536,22 20.6309156,22 L3.36908438,22 C2.26451488,22 1.36908438,21.1045695 1.36908438,20 C1.36908438,19.665362 1.45305112,19.3360729 1.61329323,19.0422957 L10.2442089,3.21895043 C10.7731343,2.24925376 11.9880076,1.89193809 12.9577043,2.42086355 C13.2948373,2.6047543 13.5719004,2.8818174 13.7557911,3.21895043 Z M12.0952381,16.5 C11.5429533,16.5 11.0952381,16.9477153 11.0952381,17.5 C11.0952381,18.0522847 11.5429533,18.5 12.0952381,18.5 C12.6475228,18.5 13.0952381,18.0522847 13.0952381,17.5 C13.0952381,16.9477153 12.6475228,16.5 12.0952381,16.5 Z M12.0952381,9 C11.5429533,9 11.0952381,9.44771525 11.0952381,10 L11.0952381,14 C11.0952381,14.5522847 11.5429533,15 12.0952381,15 C12.6475228,15 13.0952381,14.5522847 13.0952381,14 L13.0952381,10 C13.0952381,9.44771525 12.6475228,9 12.0952381,9 Z"
    });
  },
  Alert: function Alert(_ref9) {
    var color = _ref9.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.3867068,3.04267403 L22.0176224,18.8660193 C22.5465478,19.835716 22.1892322,21.0505893 21.2195355,21.5795147 C20.9257583,21.7397568 20.5964692,21.8237236 20.2618312,21.8237236 L3,21.8237236 C1.8954305,21.8237236 1,20.9282931 1,19.8237236 C1,19.4890856 1.08396675,19.1597965 1.24420885,18.8660193 L9.87512447,3.04267403 C10.4040499,2.07297735 11.6189232,1.71566168 12.5886199,2.24458714 C12.9257529,2.42847789 13.202816,2.70554099 13.3867068,3.04267403 Z M11.6309156,4.00037829 L3,19.8237236 L20.2618312,19.8237236 L11.6309156,4.00037829 Z M11.6309156,16.3237236 C12.1832004,16.3237236 12.6309156,16.7714388 12.6309156,17.3237236 C12.6309156,17.8760083 12.1832004,18.3237236 11.6309156,18.3237236 C11.0786309,18.3237236 10.6309156,17.8760083 10.6309156,17.3237236 C10.6309156,16.7714388 11.0786309,16.3237236 11.6309156,16.3237236 Z M11.6309156,8.82372359 C12.1832004,8.82372359 12.6309156,9.27143884 12.6309156,9.82372359 L12.6309156,13.8237236 C12.6309156,14.3760083 12.1832004,14.8237236 11.6309156,14.8237236 C11.0786309,14.8237236 10.6309156,14.3760083 10.6309156,13.8237236 L10.6309156,9.82372359 C10.6309156,9.27143884 11.0786309,8.82372359 11.6309156,8.82372359 Z"
    });
  },
  // viewBox="0 0 50 50"
  ArrowDown: function ArrowDown(_ref10) {
    var color = _ref10.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 8.9,19.7 c 0,-0.4 0.1,-0.8 0.4,-1.1 0.6,-0.6 1.5,-0.6 2.1,0 L 25,32.1 38.5,18.6 c 0.6,-0.6 1.5,-0.6 2.1,0 0.6,0.6 0.6,1.5 0,2.1 L 26.1,35.3 c -0.6,0.6 -1.5,0.6 -2.1,0 L 9.4,20.7 C 9.1,20.4 8.9,20 8.9,19.7 Z M 47,47 H 3 V 3 h 44 v 44 m 3,0 V 3 C 50,1.3 48.7,0 47,0 H 3 C 1.3,0 0,1.3 0,3 v 44 c 0,1.7 1.3,3 3,3 h 44 c 1.7,0 3,-1.3 3,-3 z"
    });
  },
  // viewBox="0 0 50 50"
  ArrowRight: function ArrowRight(_ref11) {
    var color = _ref11.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 19.7,41.1 C 19.3,41.1 18.9,41 18.6,40.7 18,40.1 18,39.2 18.6,38.6 L 32.1,25 18.6,11.5 C 18,10.9 18,10 18.6,9.4 c 0.6,-0.6 1.5,-0.6 2.1,0 L 35.3,24 c 0.6,0.6 0.6,1.5 0,2.1 L 20.7,40.6 c -0.3,0.3 -0.7,0.5 -1,0.5 z M 47,3 V 47 H 3 V 3 H 47 M 47,0 H 3 C 1.3,0 0,1.3 0,3 v 44 c 0,1.7 1.3,3 3,3 h 44 c 1.7,0 3,-1.3 3,-3 V 3 C 50,1.3 48.7,0 47,0 Z"
    });
  },
  // viewBox="0 0 50 50"
  ArrowUp: function ArrowUp(_ref12) {
    var color = _ref12.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "m 41.1,30.3 c 0,0.4 -0.1,0.8 -0.4,1.1 -0.6,0.6 -1.5,0.6 -2.1,0 L 25,17.9 11.5,31.4 C 10.9,32 10,32 9.4,31.4 8.8,30.8 8.8,29.9 9.4,29.3 L 24,14.7 c 0.6,-0.6 1.5,-0.6 2.1,0 l 14.6,14.6 c 0.2,0.3 0.4,0.7 0.4,1 z M 3,3 H 47 V 47 H 3 V 3 M 0,3 v 44 c 0,1.7 1.3,3 3,3 h 44 c 1.7,0 3,-1.3 3,-3 V 3 C 50,1.3 48.7,0 47,0 H 3 C 1.3,0 0,1.3 0,3 Z"
    });
  },
  Attachment: function Attachment(_ref13) {
    var color = _ref13.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.663227,13.835664 C17.0537513,13.4451398 17.6869163,13.4451398 18.0774406,13.835664 C18.4679649,14.2261883 18.4679649,14.8593533 18.0774406,15.2498776 L13.7764086,19.5509096 C11.5399199,21.7873983 7.91385523,21.7873983 5.67736653,19.5509096 C3.44087782,17.3144209 3.44087782,13.6883563 5.67736653,11.4518676 L12.9133587,4.21587538 C14.534526,2.59470819 17.1629574,2.59470821 18.7841246,4.21587543 C20.4052918,5.83704264 20.4052918,8.46547402 18.78374,10.0870257 L11.5402586,17.3226335 C10.5344129,18.3284792 8.90361468,18.3284792 7.89776892,17.3226335 C6.89192316,16.3167877 6.89192316,14.6859895 7.89818572,13.6797272 L12.2528571,9.330185 C12.6436114,8.9398909 13.2767763,8.94026401 13.6670704,9.33101836 C14.0573645,9.72177271 14.0569914,10.3549376 13.666237,10.7452317 C11.9727537,12.4367203 11.9727537,12.4367203 9.31198248,15.0943573 C9.0871853,15.3191545 9.0871853,15.6836227 9.31198248,15.9084199 C9.53677966,16.1332171 9.9012479,16.1332171 10.1264297,15.9080355 L17.369911,8.67242772 C18.2100297,7.83230907 18.2100297,6.47020763 17.369911,5.63008899 C16.5297924,4.78997035 15.1676909,4.78997034 14.3275723,5.63008895 L7.09158009,12.8660812 C5.63613997,14.3215213 5.63613997,16.6812559 7.09158009,18.1366961 C8.54702021,19.5921362 10.9067549,19.5921362 12.362195,18.1366961 L16.663227,13.835664 Z"
    });
  },
  Back: function Back(_ref14) {
    var color = _ref14.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 25,34.688875 c 0.975138,0.975139 0.950134,2.575366 0,3.550504 -0.975139,0.975138 -2.550362,0.975138 -3.525501,0 L 9.9978712,26.762751 c -0.9751384,-0.975139 -0.9751384,-2.550362 0,-3.525501 L 21.474499,11.760622 c 0.975139,-0.975139 2.550362,-0.975139 3.525501,0 0.975138,0.975138 0.975138,2.550361 0,3.5255 l -9.701377,9.701377 z m 15.002128,0 c 0.975139,0.975139 0.950135,2.575366 0,3.550504 -0.975138,0.975138 -2.550362,0.975138 -3.5255,0 L 25,26.762751 C 24.024861,25.787612 24.024861,24.212389 25,23.23725 L 36.476628,11.760622 c 0.975138,-0.975139 2.550362,-0.975139 3.5255,0 0.975139,0.975138 0.975139,2.550361 0,3.5255 l -9.701376,9.701377 z"
    });
  },
  Bag: function Bag(_ref15) {
    var color = _ref15.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M22,9.0125 L17.21,9.0125 L12.82,2.4425 C12.42,1.8525 11.55,1.8525 11.16,2.4425 L6.77,9.0125 L2,9.0125 C1.45,9.0125 1,9.4625 1,10.0125 C1,10.1025 1.01,10.1925 1.04,10.2825 L3.58,19.5525 C3.81,20.3925 4.58,21.0125 5.5,21.0125 L18.5,21.0125 C19.42,21.0125 20.19,20.3925 20.43,19.5525 L22.97,10.2825 L23,10.0125 C23,9.4625 22.55,9.0125 22,9.0125 Z M11.99,4.8025 L14.8,9.0125 L9.18,9.0125 L11.99,4.8025 Z M12,17.0125 C10.9,17.0125 10,16.1125 10,15.0125 C10,13.9125 10.9,13.0125 12,13.0125 C13.1,13.0125 14,13.9125 14,15.0125 C14,16.1125 13.1,17.0125 12,17.0125 Z"
    });
  },
  BarChart: function BarChart(_ref16) {
    var color = _ref16.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m48 0h-46a2 2 0 0 0-2 2v10.7c0 0.2 0 0.3 0.1 0.4a0.9 0.9 0 0 0-0.1 0.5v35.1a1.32 1.32 0 0 0 1.3 1.3h18.4a1.32 1.32 0 0 0 1.3-1.3v-10.5h5.4a1.54 1.54 0 0 0 1.5-1.5v-10.2h11.3a1.79 1.79 0 0 0 1.8-1.8v-9.9h7a2 2 0 0 0 2-2v-10.8a2 2 0 0 0-2-2zm-30 47h-15v-8.8h15zm6.9-11.8h-21.9v-8.8h21.9zm13.1-11.7h-35v-8.8h35zm9-11.7h-44v-8.8h44z"
    });
  },
  Behance: function Behance(_ref17) {
    var color = _ref17.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M19.6924776,7.70686567 L14.8668209,7.70686567 L14.8668209,6.50820896 L19.6928806,6.50820896 L19.6928806,7.70686567 L19.6924776,7.70686567 L19.6924776,7.70686567 Z M11.6542687,12.6221642 C11.9656418,13.1044478 12.1212388,13.6900299 12.1212388,14.3775224 C12.1212388,15.0884776 11.945806,15.7262687 11.5888955,16.2896418 C11.3618358,16.6624478 11.0799254,16.9773582 10.741194,17.2308806 C10.3597015,17.5240746 9.90804478,17.7251194 9.3888209,17.8325373 C8.8679403,17.9401343 8.30416418,17.9944925 7.69686567,17.9944925 L2.3,17.9944925 L2.3,6.0110597 L8.08731343,6.0110597 C9.54607463,6.03479104 10.5802687,6.45743284 11.1909701,7.28744776 C11.5574179,7.79650746 11.7389851,8.40734328 11.7389851,9.11735821 C11.7389851,9.84998507 11.5552239,10.436194 11.185194,10.8815821 C10.9793582,11.1312985 10.6752836,11.3584478 10.2727463,11.5634776 C10.8824627,11.7866866 11.3450896,12.1381791 11.6542687,12.6221642 Z M5.06367164,10.7355224 L7.59943284,10.7355224 C8.12053731,10.7355224 8.54179104,10.6364776 8.86623881,10.4384776 C9.19046269,10.240791 9.35223881,9.88938806 9.35223881,9.38485075 C9.35223881,8.82743284 9.13802985,8.45744776 8.70858209,8.27937313 C8.33944776,8.15565672 7.86714925,8.0919403 7.2940597,8.0919403 L5.06367164,8.0919403 L5.06367164,10.7355224 Z M9.59640299,14.2063433 C9.59640299,13.5838657 9.34198507,13.1535224 8.8341791,12.9226119 C8.55020896,12.7913731 8.14955224,12.7242985 7.63583582,12.7195075 L5.06367164,12.7195075 L5.06367164,15.9130299 L7.59602985,15.9130299 C8.11628358,15.9130299 8.51895522,15.8449254 8.80955224,15.7028507 C9.33361194,15.4416269 9.59640299,14.9444776 9.59640299,14.2063433 Z M21.4829403,12.2568358 C21.5412388,12.6488955 21.5676119,13.2177313 21.5569104,13.9612388 L15.3071493,13.9612388 C15.3416269,14.8238955 15.6394328,15.4271642 16.2042388,15.7723881 C16.5448507,15.9888806 16.9578209,16.094597 17.441403,16.094597 C17.9513134,16.094597 18.3669254,15.9656866 18.6868507,15.7007015 C18.8611642,15.5602388 19.0149254,15.3619701 19.1478657,15.111806 L21.4386119,15.111806 C21.3786119,15.6213134 21.102791,16.1380746 20.6071194,16.663209 C19.8391642,17.4978806 18.7621194,17.916403 17.3788955,17.916403 C16.236209,17.916403 15.2291493,17.5634328 14.3550299,16.8600448 C13.4838209,16.154194 13.0462687,15.0094478 13.0462687,13.4214627 C13.0462687,11.9323433 13.4390896,10.7925672 14.2273731,9.99922388 C15.0185672,9.20440299 16.0396418,8.80880597 17.2982537,8.80880597 C18.0442687,8.80880597 18.7167612,8.94214925 19.3167164,9.21022388 C19.914791,9.47856716 20.4090746,9.90089552 20.7983582,10.4813284 C21.1506567,10.9924925 21.3772239,11.5835373 21.4829403,12.2568358 Z M19.2281493,12.4804478 C19.1861493,11.8839403 18.9869851,11.4324627 18.6283731,11.1239104 C18.2727164,10.8145075 17.828403,10.6591791 17.2982537,10.6591791 C16.7212687,10.6591791 16.2757463,10.825209 15.9591791,11.1515373 C15.6404627,11.477194 15.4421493,11.9199403 15.3608806,12.4804925 L19.2281493,12.4804925 L19.2281493,12.4804478 Z"
    });
  },
  Bell: function Bell(_ref18) {
    var color = _ref18.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 45.16,36.66 c -5.58,0 -6.5,-9.11 -6.5,-9.17 V 17.66 A 15.89,15.89 0 0 0 38.21,13.53 7.79,7.79 0 0 0 39.7,11.22 8.16,8.16 0 0 0 39.92,5.15 7.59,7.59 0 0 0 35.92,0.69 8,8 0 0 0 25.55,4.3 H 25 c -0.64,0 -6.37,0.11 -10.2,3.94 a 12.81,12.81 0 0 0 -3.46,9.32 v 9.7 c 0,0.09 -1,9.2 -6.51,9.2 a 1.47,1.47 0 0 0 -1.46,1.46 v 5.21 a 1.46,1.46 0 0 0 1.46,1.46 H 16.49 A 9.33,9.33 0 0 0 25,50 9.56,9.56 0 0 0 33.5,44.79 h 11.66 a 1.47,1.47 0 0 0 1.46,-1.46 v -5.21 a 1.45,1.45 0 0 0 -1.46,-1.46 z m -15,8 A 6.74,6.74 0 0 1 25,47.18 6.63,6.63 0 0 1 19.82,44.69 Z M 25.55,11.63 a 7.78,7.78 0 0 0 4.65,4 7.65,7.65 0 0 0 5.55,-0.33 4.79,4.79 0 0 1 0,2.29 v 10.1 0.17 c 0.41,3.15 2,10.49 7.85,11.5 v 2.55 H 6.1 V 39.32 C 13.12,38.09 14,27.6 14,27.49 v -9.83 a 9.62,9.62 0 0 1 2.74,-7.22 c 2.67,-2.75 6.74,-3.16 8,-3.22 a 7.37,7.37 0 0 0 0.81,4.41 z"
    });
  },
  BookmarkSolid: function BookmarkSolid(_ref19) {
    var color = _ref19.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.8458278,2 L16.1541722,2 C17.4914503,2 17.9763797,2.13923842 18.4652686,2.40069906 C18.9541574,2.66215969 19.3378403,3.04584256 19.5993009,3.53473144 C19.8607616,4.02362033 20,4.50854969 20,5.8458278 L20,21 C20,21.5522847 19.5522847,22 19,22 C18.7836298,22 18.5730962,21.9298221 18.4,21.8 L12,17 L5.6,21.8 C5.1581722,22.1313708 4.53137085,22.0418278 4.2,21.6 C4.07017787,21.4269038 4,21.2163702 4,21 L4,5.8458278 C4,4.50854969 4.13923842,4.02362033 4.40069906,3.53473144 C4.66215969,3.04584256 5.04584256,2.66215969 5.53473144,2.40069906 C6.02362033,2.13923842 6.50854969,2 7.8458278,2 Z"
    });
  },
  Bookmark: function Bookmark(_ref20) {
    var color = _ref20.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.8,15.4 C11.5111111,14.8666667 12.4888889,14.8666667 13.2,15.4 L18,19 L18,5 C18,4.44771525 17.5522847,4 17,4 L7,4 C6.44771525,4 6,4.44771525 6,5 L6,19 L10.8,15.4 Z M7,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,21 C20,21.5522847 19.5522847,22 19,22 C18.7836298,22 18.5730962,21.9298221 18.4,21.8 L12,17 L5.6,21.8 C5.1581722,22.1313708 4.53137085,22.0418278 4.2,21.6 C4.07017787,21.4269038 4,21.2163702 4,21 L4,5 C4,3.34314575 5.34314575,2 7,2 Z"
    });
  },
  Bulk: function Bulk(_ref21) {
    var color = _ref21.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M8,20 L16,20 C16.55,20 17,19.55 17,19 L17,6 C17,5.45 16.55,5 16,5 L8,5 C7.45,5 7,5.45 7,6 L7,19 C7,19.55 7.45,20 8,20 Z M3,18 L5,18 C5.55,18 6,17.55 6,17 L6,8 C6,7.45 5.55,7 5,7 L3,7 C2.45,7 2,7.45 2,8 L2,17 C2,17.55 2.45,18 3,18 Z M18,8 L18,17 C18,17.55 18.45,18 19,18 L21,18 C21.55,18 22,17.55 22,17 L22,8 C22,7.45 21.55,7 21,7 L19,7 C18.45,7 18,7.45 18,8 Z"
    });
  },
  Butterfly: function Butterfly(_ref22) {
    var color = _ref22.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M21.9,0a2,2,0,0,0-2,2v9.7H2a2,2,0,0,0-2,2V24.5a2,2,0,0,0,2,2H19.9v8.7H11a2,2,0,0,0-2,2V48a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V38.3H36a2,2,0,0,0,2-2V25.5a2,2,0,0,0-2-2H23V14.7H48a2,2,0,0,0,2-2V0Zm-2,23.5H3V14.7H19.9Zm0,23.5H12V38.3h7.9Zm15-20.5v8.8h-12V26.6h12ZM47,11.8H22.9V3H47Z"
    });
  },
  // viewBox="0 0 40 40"
  CardView: function CardView(_ref23) {
    var color = _ref23.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 0 0 L 0 18.191406 L 18.033203 18.191406 L 18.033203 0 L 0 0 z M 21.966797 0 L 21.966797 18.191406 L 40 18.191406 L 40 0 L 21.966797 0 z M 0 21.8125 L 0 40 L 18.033203 40 L 18.033203 21.8125 L 0 21.8125 z M 21.966797 21.8125 L 21.966797 40 L 40 40 L 40 21.8125 L 21.966797 21.8125 z"
    });
  },
  CameraSolid: function CameraSolid(_ref24) {
    var color = _ref24.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M3.5638852,6 L7,6 L9,3 L15,3 L17,6 L20.4361148,6 C21.3276335,6 21.6509198,6.09282561 21.9768457,6.2671327 C22.3027716,6.4414398 22.5585602,6.69722837 22.7328673,7.0231543 C22.9071744,7.34908022 23,7.67236646 23,8.5638852 L23,18.4361148 C23,19.3276335 22.9071744,19.6509198 22.7328673,19.9768457 C22.5585602,20.3027716 22.3027716,20.5585602 21.9768457,20.7328673 C21.6509198,20.9071744 21.3276335,21 20.4361148,21 L3.5638852,21 C2.67236646,21 2.34908022,20.9071744 2.0231543,20.7328673 C1.69722837,20.5585602 1.4414398,20.3027716 1.2671327,19.9768457 C1.09282561,19.6509198 1,19.3276335 1,18.4361148 L1,8.5638852 C1,7.67236646 1.09282561,7.34908022 1.2671327,7.0231543 C1.4414398,6.69722837 1.69722837,6.4414398 2.0231543,6.2671327 C2.34908022,6.09282561 2.67236646,6 3.5638852,6 Z M10,13 C10,11.8912362 10.8912362,11 12,11 C13.1087638,11 14,11.8912362 14,13 C14,14.1087638 13.1087638,15 12,15 C10.8912362,15 10,14.1087638 10,13 Z M8,13 C8,15.2133333 9.78666667,17 12,17 C14.2133333,17 16,15.2133333 16,13 C16,10.7866667 14.2133333,9 12,9 C9.78666667,9 8,10.7866667 8,13 Z"
    });
  },
  Camera: function Camera(_ref25) {
    var color = _ref25.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.9296325,5 L10.0703675,5 L8.66410059,7.10940039 C8.29316903,7.66579773 7.66870638,8 7,8 L3,8 L3,19 L21,19 L21,8 L17,8 C16.3312936,8 15.706831,7.66579773 15.3358994,7.10940039 L13.9296325,5 Z M3,6 L7,6 L9,3 L15,3 L17,6 L21,6 C22.1045695,6 23,6.8954305 23,8 L23,19 C23,20.1045695 22.1045695,21 21,21 L3,21 C1.8954305,21 1,20.1045695 1,19 L1,8 C1,6.8954305 1.8954305,6 3,6 Z M10,13 C10,11.8912362 10.8912362,11 12,11 C13.1087638,11 14,11.8912362 14,13 C14,14.1087638 13.1087638,15 12,15 C10.8912362,15 10,14.1087638 10,13 Z M8,13 C8,15.2133333 9.78666667,17 12,17 C14.2133333,17 16,15.2133333 16,13 C16,10.7866667 14.2133333,9 12,9 C9.78666667,9 8,10.7866667 8,13 Z"
    });
  },
  Card: function Card(_ref26) {
    var color = _ref26.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20,4 L4,4 C2.89,4 2.01,4.89 2.01,6 L2,18 C2,19.11 2.89,20 4,20 L20,20 C21.11,20 22,19.11 22,18 L22,6 C22,4.89 21.11,4 20,4 Z M19,18 L5,18 C4.45,18 4,17.55 4,17 L4,12 L20,12 L20,17 C20,17.55 19.55,18 19,18 Z M20,8 L4,8 L4,6 L20,6 L20,8 Z"
    });
  },
  Checked: function Checked(_ref27) {
    var color = _ref27.color;
    return (
      /*#__PURE__*/
      // viewBox="1 8 48 35"
      React.createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "m 42.884128,8.9243433 c 1.205647,-1.2056473 3.160388,-1.2056473 4.366035,0 1.205647,1.2056477 1.205647,3.1603877 0,4.3660357 L 19.464885,41.075657 c -1.205647,1.205647 -3.160388,1.205647 -4.366035,0 L 2.7498375,28.726644 c -1.2056473,-1.205647 -1.2056473,-3.160388 0,-4.366035 1.2056474,-1.205647 3.1603875,-1.205647 4.3660355,0 l 10.165994,10.165995 z"
      })
    );
  },
  ClassifierModel: function ClassifierModel(_ref28) {
    var color = _ref28.color;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M7.52 2.17c.42 0 .76.34.76.76v5.01h-6.1V2.93c0-.42.34-.76.76-.76zm0-.63H2.94c-.77 0-1.39.62-1.39 1.39v5.64h7.36V2.93c0-.77-.62-1.39-1.39-1.39z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M8.37.62c.81 0 1.48.66 1.48 1.47v11.82c0 .81-.67 1.47-1.48 1.47H2.09c-.81 0-1.47-.66-1.47-1.47V2.09c0-.81.66-1.47 1.47-1.47zm0-.62H2.09A2.1 2.1 0 0 0 0 2.1v11.8C0 15.07.94 16 2.1 16h6.27a2.1 2.1 0 0 0 2.1-2.1V2.1A2.1 2.1 0 0 0 8.36 0Z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M7.06 12.42H3.4a.3.3 0 0 1-.31-.3c0-.18.14-.32.3-.32h3.67a.3.3 0 1 1 0 .62zm0-7.67H5.54V3.22a.3.3 0 0 0-.3-.3.3.3 0 0 0-.32.3v1.53H3.4a.3.3 0 0 0-.31.3c0 .17.14.31.3.31h1.53V6.9c0 .17.14.3.31.3a.3.3 0 0 0 .3-.3V5.36h1.53a.3.3 0 0 0 .31-.3.3.3 0 0 0-.3-.31z"
    }));
  },
  // viewBox 0 0 100 100
  Client: function Client(_ref29) {
    var color = _ref29.color;
    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M58.004,34.238c1.683,0.188,3.16,0.479,3.16,0.479c-3.358-1.847-3.272-8.476-3.272-8.476   c0.587-12.839-7.886-12.167-7.886-12.167L50,14.094l-0.007-0.02c0,0-8.473-0.671-7.885,12.167c0,0,0.086,6.629-3.273,8.476   c0,0,0.905-0.061,2.114-0.084c-3.426,1.53-5.813,4.967-5.813,8.962c0,5.418,4.392,4.46,9.812,4.46h10.105   c5.419,0,9.812,0.958,9.812-4.46C64.864,39.205,61.979,35.491,58.004,34.238z M52.27,36.811L50,40.499l-2.27-3.688   c-1.649-0.374-2.924-1.143-3.438-2.093c1.331,0.116,2.459,0.359,2.75,0.838l-1.25-2.788c1.197,1.196,2.646,1.897,4.206,1.897   c1.525,0,2.943-0.669,4.124-1.815l-0.871,1.815c0.291-0.481,1.391-0.611,2.679-0.579C55.726,35.321,54.273,36.356,52.27,36.811z    M56.516,24.995c-0.128,1.7-0.56,3.265-1.215,4.578c-1.191,2.389-3.122,3.942-5.302,3.942c-3.321,0-6.065-3.609-6.496-8.288   c0,0,2.623-0.435,4.188-1.053c0,0,2.837-0.948,6.303-3.443c0.018-0.012,0.034-0.024,0.052-0.037c0,0,0.063,0.089,0.151,0.241   c0.3,0.516,0.944,2.052-0.274,2.755l2.219,0.282h0.041l0.406,0.075C56.584,24.369,56.561,24.686,56.516,24.995z"
    })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      d: "M27.869,72.049c1.683,0.188,3.161,0.479,3.161,0.479c-3.359-1.847-3.272-8.477-3.272-8.477    c0.586-12.838-7.886-12.166-7.886-12.166l-0.006,0.02l-0.007-0.02c0,0-8.473-0.672-7.885,12.166c0,0,0.086,6.63-3.273,8.477    c0,0,0.904-0.062,2.114-0.085C7.388,73.975,5,77.411,5,81.406c0,5.418,4.393,4.461,9.813,4.461h10.105    c5.419,0,9.812,0.957,9.812-4.461C34.729,77.016,31.845,73.303,27.869,72.049z M22.134,74.621l-2.269,3.689l-2.271-3.689    c-1.648-0.373-2.923-1.143-3.437-2.093c1.331,0.116,2.458,0.359,2.75,0.839l-1.25-2.788c1.197,1.195,2.646,1.896,4.207,1.896    c1.525,0,2.943-0.669,4.125-1.815l-0.872,1.815c0.292-0.481,1.391-0.611,2.679-0.579C25.591,73.131,24.138,74.168,22.134,74.621z     M26.381,62.807c-0.128,1.698-0.56,3.265-1.215,4.578c-1.192,2.39-3.122,3.941-5.302,3.941c-3.32,0-6.065-3.608-6.497-8.288    c0,0,2.623-0.434,4.188-1.053c0,0,2.838-0.947,6.304-3.443c0.017-0.012,0.034-0.023,0.051-0.037c0,0,0.062,0.09,0.151,0.241    c0.301,0.517,0.944,2.053-0.273,2.756l2.218,0.282h0.042l0.406,0.075C26.45,62.181,26.426,62.497,26.381,62.807z",
      fill: color
    })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M85.849,70.341c-0.042,1.839-2.765,3.321-6.119,3.321c-3.355,0-6.078-1.482-6.118-3.321    c-5.133,0.47-9.152,4.785-9.152,10.038c0,5.567,4.513,5.554,10.08,5.554H84.92c5.567,0,10.08,0.014,10.08-5.554    C95,75.126,90.98,70.811,85.849,70.341z"
    }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M84.486,56.853c0,0-2.22,1.078-4.757,1.147c-2.538-0.069-4.758-1.147-4.758-1.147     c-1.608,0.635-0.847,5.159-0.847,5.159c-0.401-0.28-0.771-0.426-1.07-0.502c0.442,4.808,3.262,8.515,6.675,8.515     c3.412,0,6.231-3.707,6.674-8.515c-0.3,0.076-0.668,0.222-1.07,0.502C85.333,62.012,86.096,57.487,84.486,56.853z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M87.354,58.767c-0.564-3.899-3.763-6.888-7.625-6.888c-3.863,0-7.063,2.988-7.625,6.888     c-0.059,0.402-0.089,0.813-0.089,1.231c0,0.171,0.007,0.339,0.017,0.506c0.014,0.246,0.036,0.488,0.072,0.727     c0.006,0.073,0.011,0.146,0.018,0.218c0.487,5.503,3.707,9.755,7.607,9.755s7.12-4.252,7.606-9.755     c0.007-0.072,0.013-0.145,0.019-0.218c0.034-0.238,0.058-0.48,0.071-0.727c0.01-0.167,0.017-0.335,0.017-0.506     C87.442,59.58,87.412,59.169,87.354,58.767z M79.729,70.024c-3.413,0-6.232-3.707-6.675-8.515c0.3,0.076,0.669,0.222,1.07,0.502     c0,0-0.762-4.524,0.847-5.159c0,0,2.22,1.078,4.758,1.147c2.537-0.069,4.757-1.147,4.757-1.147     c1.609,0.635,0.847,5.159,0.847,5.159c0.402-0.28,0.771-0.426,1.07-0.502C85.961,66.317,83.142,70.024,79.729,70.024z"
    })))), /*#__PURE__*/React.createElement("polygon", {
      points: "52.459,64.185 52.459,51.905 47.54,51.905 47.54,64.185 36.911,70.321 39.371,74.581 50,68.444 60.629,74.581   63.089,70.321 "
    }));
  },
  CloseSolid: function CloseSolid(_ref30) {
    var color = _ref30.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.4142136,12 L15.7071068,9.70710678 C16.0976311,9.31658249 16.0976311,8.68341751 15.7071068,8.29289322 C15.3165825,7.90236893 14.6834175,7.90236893 14.2928932,8.29289322 L12,10.5857864 L9.70710678,8.29289322 C9.31658249,7.90236893 8.68341751,7.90236893 8.29289322,8.29289322 C7.90236893,8.68341751 7.90236893,9.31658249 8.29289322,9.70710678 L10.5857864,12 L8.29289322,14.2928932 C7.90236893,14.6834175 7.90236893,15.3165825 8.29289322,15.7071068 C8.68341751,16.0976311 9.31658249,16.0976311 9.70710678,15.7071068 L12,13.4142136 L14.2928932,15.7071068 C14.6834175,16.0976311 15.3165825,16.0976311 15.7071068,15.7071068 C16.0976311,15.3165825 16.0976311,14.6834175 15.7071068,14.2928932 L13.4142136,12 Z M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z"
    });
  },
  Close: function Close(_ref31) {
    var color = _ref31.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M13.4142136,12 L15.7071068,9.70710678 C16.0976311,9.31658249 16.0976311,8.68341751 15.7071068,8.29289322 C15.3165825,7.90236893 14.6834175,7.90236893 14.2928932,8.29289322 L12,10.5857864 L9.70710678,8.29289322 C9.31658249,7.90236893 8.68341751,7.90236893 8.29289322,8.29289322 C7.90236893,8.68341751 7.90236893,9.31658249 8.29289322,9.70710678 L10.5857864,12 L8.29289322,14.2928932 C7.90236893,14.6834175 7.90236893,15.3165825 8.29289322,15.7071068 C8.68341751,16.0976311 9.31658249,16.0976311 9.70710678,15.7071068 L12,13.4142136 L14.2928932,15.7071068 C14.6834175,16.0976311 15.3165825,16.0976311 15.7071068,15.7071068 C16.0976311,15.3165825 16.0976311,14.6834175 15.7071068,14.2928932 L13.4142136,12 Z M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z"
    });
  },
  // viewBox="0 0 50 50"
  Clusters: function Clusters(_ref32) {
    var color = _ref32.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M45.3,36.4c-1.1,0-2.1,0.4-2.9,1l-9.1-7.1c1-1.5,1.5-3.3,1.5-5.2c0-2.8-1.2-5.3-3.1-7.1l6.7-8.8c0.6,0.2,1.2,0.4,1.8,0.4  c2.6,0,4.7-2.1,4.7-4.7C45,2.1,42.9,0,40.3,0c-2.6,0-4.7,2.1-4.7,4.7c0,1.2,0.5,2.4,1.3,3.2l-6.7,8.7c-1.5-0.9-3.3-1.5-5.1-1.5  c-2.4,0-4.7,0.9-6.4,2.4l-6-5.7c0.4-0.7,0.6-1.5,0.6-2.3c0-2.6-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7  c1,0,2-0.3,2.8-0.9l6,5.7c-1.3,1.7-2.1,3.7-2.1,6c0,1.8,0.5,3.5,1.4,4.9l-8.6,6.3C7.1,35.5,6,35,4.7,35C2.1,35,0,37.1,0,39.7  c0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7c0-0.7-0.1-1.3-0.4-1.9l8.6-6.3c1.6,1.8,3.8,3,6.3,3.2v5.9c-2.1,0.5-3.7,2.4-3.7,4.6  c0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7c0-2.3-1.6-4.2-3.7-4.6v-5.9c2.4-0.2,4.5-1.3,6.1-3l9,7.1c-0.4,0.7-0.6,1.4-0.6,2.2  c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C50,38.5,47.9,36.4,45.3,36.4z M40.3,2C41.8,2,43,3.2,43,4.7c0,1.5-1.2,2.7-2.7,2.7  c-1.5,0-2.7-1.2-2.7-2.7C37.6,3.2,38.8,2,40.3,2z M4.7,42.5c-1.5,0-2.7-1.2-2.7-2.7C2,38.2,3.2,37,4.7,37s2.7,1.2,2.7,2.7  C7.5,41.2,6.2,42.5,4.7,42.5z M8.5,12.2C7,12.2,5.7,11,5.7,9.5C5.7,8,7,6.8,8.5,6.8c1.5,0,2.7,1.2,2.7,2.7C11.2,11,10,12.2,8.5,12.2  z M27.7,45.3c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7S27.7,43.8,27.7,45.3z M25,31.8c-3.8,0-6.8-3.1-6.8-6.8  s3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8S28.8,31.8,25,31.8z M45.3,43.9c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7  c1.5,0,2.7,1.2,2.7,2.7C48,42.6,46.8,43.9,45.3,43.9z"
    });
  },
  // viewBox 0 0 50 50
  Company: function Company(_ref33) {
    var color = _ref33.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 45.2,31.8 H 37 c -0.6,0 -1,0.5 -1,1 0,0.5 0.5,1 1,1 h 8.1 c 0.6,0 1,-0.5 1,-1 0.1,-0.6 -0.3,-1 -0.9,-1 z M 23.3,42.3 h 5.6 c 0.6,0 1,-0.5 1,-1 0,-0.6 -0.5,-1 -1,-1 h -5.6 c -0.6,0 -1,0.5 -1,1 0,0.6 0.4,1 1,1 z m 0,-4.2 h 5.6 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.5,-1 -1,-1 h -5.6 c -0.6,0 -1,0.5 -1,1 0,0.5 0.4,1 1,1 z m 0,-4.3 h 5.6 c 0.6,0 1,-0.5 1,-1 0,-0.6 -0.5,-1 -1,-1 h -5.6 c -0.6,0 -1,0.5 -1,1 0,0.5 0.4,1 1,1 z m 0,-4.1 h 5.6 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.5,-1 -1,-1 h -5.6 c -0.6,0 -1,0.5 -1,1 0,0.5 0.4,1 1,1 z M 45.2,27.6 H 37 c -0.6,0 -1,0.5 -1,1 0,0.5 0.5,1 1,1 h 8.1 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.3,-1 -0.9,-1 z m 0,-4.2 H 37 c -0.6,0 -1,0.5 -1,1 0,0.5 0.5,1 1,1 h 8.1 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.3,-1 -0.9,-1 z M 16.4,32 H 4.7 c -0.6,0 -1,0.5 -1,1 0,0.5 0.5,1 1,1 h 11.7 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.4,-1 -1,-1 z m 0,-4.3 H 4.7 c -0.6,0 -1,0.5 -1,1 0,0.6 0.5,1 1,1 h 11.7 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.4,-1 -1,-1 z m 0,-4.2 H 4.7 c -0.6,0 -1,0.5 -1,1 0,0.6 0.5,1 1,1 h 11.7 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.4,-1 -1,-1 z M 4.7,19.3 c -0.6,0 -1,0.5 -1,1 0,0.5 0.5,1 1,1 h 11.7 c 0.6,0 1,-0.5 1,-1 0,-0.5 -0.5,-1 -1,-1 z M 48.9,16.7 H 48.2 V 14.1 C 48.2,13.5 47.7,13 47.1,13 H 35.3 c -0.6,0 -1.1,0.5 -1.1,1.1 v 2.6 h -0.7 c -0.6,0 -1.1,0.5 -1.1,1.1 v 5.4 H 20.8 V 11.8 c 0,-0.6 -0.5,-1.1 -1.1,-1.1 H 17.6 V 6.1 C 17.6,5.5 17.1,5 16.5,5 H 8.9 V 1 C 8.9,0.4 8.4,0 7.9,0 7.4,0 6.9,0.5 6.9,1 V 4.9 H 4.7 C 4.1,4.9 3.6,5.4 3.6,6 v 4.6 H 1.1 C 0.5,10.6 0,11.1 0,11.7 V 48.8 C 0,49.4 0.5,50 1.1,50 h 18.5 13.9 15.4 c 0.6,0 1.1,-0.5 1.1,-1.1 v -31 c 0,-0.6 -0.5,-1.2 -1.1,-1.2 z M 36.5,15.2 h 9.4 v 1.5 H 36.5 Z M 5.9,7.2 h 9.4 v 3.4 H 5.9 Z m 6.5,40.5 H 8.9 v -6.8 h 3.4 v 6.8 z m 6,0 h -3.9 v -7.8 c 0,-0.6 -0.5,-1 -1,-1 H 7.9 c -0.6,0 -1,0.5 -1,1 v 7.8 H 2.3 V 13.1 h 2.4 11.7 2 z m 13.8,0 H 20.8 V 25.6 h 11.5 v 22.1 z m 11,0 h -3.4 v -6.8 h 3.4 z m 4.5,0 h -2.4 v -7.8 c 0,-0.6 -0.5,-1 -1,-1 h -5.5 c -0.6,0 -1,0.5 -1,1 v 7.8 H 34.7 V 24.4 19 h 0.7 11.6 0.7 z"
    });
  },
  Compare: function Compare(_ref34) {
    var color = _ref34.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 49.62,29.37 v 0 L 45.85,25.6 a 7.67,7.67 0 0 0 1.46,-4.52 7.81,7.81 0 0 0 -7.81,-7.8 7.72,7.72 0 0 0 -6.08,2.93 h -7.24 a 1.3,1.3 0 0 0 0,2.59 h 5.87 a 7.74,7.74 0 0 0 -0.35,2.28 7.63,7.63 0 0 0 0.46,2.63 h -6 a 1.29,1.29 0 0 0 0,2.58 h 7.53 a 7.8,7.8 0 0 0 5.79,2.59 7.7,7.7 0 0 0 4.52,-1.45 l 3.77,3.77 a 1.32,1.32 0 0 0 0.92,0.38 1.3,1.3 0 0 0 0.91,-2.21 z M 39.5,26.29 a 5.22,5.22 0 1 1 5.22,-5.21 5.21,5.21 0 0 1 -5.22,5.21 z M 39.81,34 a 1.3,1.3 0 0 0 0,-2.59 H 26.18 a 1.3,1.3 0 0 0 0,2.59 z m 5.89,0.37 a 1.29,1.29 0 0 0 -1.29,1.29 v 5.24 a 0.67,0.67 0 0 1 -0.67,0.67 H 22.25 A 0.67,0.67 0 0 1 21.58,40.9 V 9.1 a 0.67,0.67 0 0 1 0.67,-0.67 h 21.49 c 0.38,0 0.67,0.21 0.67,0.4 v 1.7 a 1.3,1.3 0 1 0 2.59,0 v -1.7 a 3.14,3.14 0 0 0 -3.26,-3 H 22.25 A 3.26,3.26 0 0 0 19,9.1 v 31.8 a 3.26,3.26 0 0 0 3.26,3.26 H 43.74 A 3.27,3.27 0 0 0 47,40.9 V 35.66 A 1.3,1.3 0 0 0 45.7,34.37 Z M 15.83,31.39 H 7.19 a 1.3,1.3 0 0 0 0,2.59 h 8.64 a 1.3,1.3 0 0 0 0,-2.59 z m 0,-7.68 H 7.19 a 1.29,1.29 0 0 0 0,2.58 h 8.64 a 1.29,1.29 0 1 0 0,-2.58 z m 0,-7.5 H 7.19 a 1.3,1.3 0 0 0 0,2.59 h 8.64 a 1.3,1.3 0 0 0 0,-2.59 z m 0,-10.37 H 3.26 A 3.26,3.26 0 0 0 0,9.1 v 31.8 a 3.26,3.26 0 0 0 3.26,3.26 h 12.57 a 1.3,1.3 0 0 0 0,-2.59 H 3.26 A 0.67,0.67 0 0 1 2.59,40.9 V 9.1 A 0.67,0.67 0 0 1 3.26,8.43 h 12.57 a 1.3,1.3 0 0 0 0,-2.59 z"
    });
  },
  Crm: function Crm(_ref35) {
    var color = _ref35.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 33.1,35.7 a 3.56,3.56 0 0 0 -2,-3.2 l -4.9,-2.2 a 5.9,5.9 0 0 0 1.8,-4 l 0.1,-4 a 5.89,5.89 0 0 0 -5.9,-5.8 h -1.1 a 5.89,5.89 0 0 0 -5.9,5.8 l 0.1,3.9 a 6,6 0 0 0 1.8,4 l -4.9,2.3 a 3.56,3.56 0 0 0 -2,3.2 v 3.1 h 23 V 35.7 Z M 21.2,18.6 h 1.1 a 3.56,3.56 0 0 1 3.6,3.5 L 25.8,26 a 3.7,3.7 0 0 1 -2.2,3.4 l -1.9,0.9 -1.9,-0.9 A 4.06,4.06 0 0 1 17.6,26 l -0.1,-3.9 a 3.72,3.72 0 0 1 3.7,-3.5 z m 9.7,18.1 H 12.6 v -0.8 a 1.41,1.41 0 0 1 0.8,-1.2 l 8.4,-3.9 8.4,3.9 a 1.21,1.21 0 0 1 0.8,1.2 v 0.8 z M 43.3,11.6 V 7.5 H 5.1 A 2.11,2.11 0 0 1 3,5.4 V 5.1 A 2.18,2.18 0 0 1 5.1,3 H 41.7 A 1.54,1.54 0 0 0 43.2,1.5 1.54,1.54 0 0 0 41.7,0 H 5.1 A 5.12,5.12 0 0 0 0,5.1 V 42 a 8,8 0 0 0 8,8 H 43.2 V 46.5 H 50 V 11.6 Z m -3.1,0 V 47 H 8 A 5,5 0 0 1 3,42 V 10.1 a 4.64,4.64 0 0 0 2.1,0.4 H 40.2 Z M 47,43.5 H 43.2 V 35.9 H 47 Z M 47,32.9 H 43.2 V 25.3 H 47 Z M 47,22.2 H 43.2 V 14.6 H 47 Z"
    });
  },
  Cross: function Cross(_ref36) {
    var color = _ref36.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 5.9843749,3.959213 a 2,2 0 0 0 -1.439453,0.5859375 2,2 0 0 0 0,2.828125 L 22.171875,25.000229 4.5449219,42.627182 a 2,2 0 0 0 0,2.828125 2,2 0 0 0 2.828125,0 L 25,27.828354 42.626953,45.455307 a 2,2 0 0 0 2.828125,0 2,2 0 0 0 0,-2.828125 L 27.828125,25.000229 45.455078,7.3732755 a 2,2 0 0 0 0,-2.828125 2,2 0 0 0 -1.390625,-0.5859375 2,2 0 0 0 -1.4375,0.5859375 L 25,22.172104 7.3730469,4.5451505 A 2,2 0 0 0 5.9843749,3.959213 Z"
    });
  },
  Customer: function Customer(_ref37) {
    var color = _ref37.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 26.75,44.18 H 3 v -3.5 C 3,38.91 6.16,37.19 8.87,36.26 15.25,34 17.3,31.74 17.3,27 A 4.63,4.63 0 0 0 16.36,24.19 L 16.28,24.07 A 7.09,7.09 0 0 1 15.09,20.89 2.78,2.78 0 0 0 13.7,18.94 L 13.5,18.8 13.32,18.72 c -0.15,0 -0.44,-0.11 -0.52,-1.62 A 1.3,1.3 0 0 1 12.92,16.51 1.33,1.33 0 0 0 13.7,15 17.41,17.41 0 0 0 13.29,12.42 c -0.56,-3.29 -0.54,-6.57 3.39,-8.35 4,-1.54 6.84,-0.51 7.17,-0.11 a 2.71,2.71 0 0 0 1,0.62 h 0.46 a 3.71,3.71 0 0 1 3,1.24 c 1.51,1.69 1.29,6.29 0.78,9 a 1.52,1.52 0 0 0 0.73,1.62 0.66,0.66 0 0 1 0.17,0.49 c -0.26,1.44 -0.41,1.67 -0.53,1.7 l -0.15,0.06 a 2.76,2.76 0 0 0 -1.62,2.13 7.2,7.2 0 0 1 -1.17,3.18 4,4 0 0 0 -1,2.92 c 0,2.51 0.12,3 1.11,4.56 l 0.06,0.09 a 1.64,1.64 0 0 0 2.21,0 1.57,1.57 0 0 0 0.45,-1.11 1.53,1.53 0 0 0 -0.39,-1 C 28.65,28.82 28.62,28.71 28.62,26.85 A 1.5,1.5 0 0 1 29,25.6 8.71,8.71 0 0 0 30.66,21.47 h 0.07 c 1.37,-0.62 2,-1.82 2.29,-4.46 A 4.38,4.38 0 0 0 32.26,14.49 C 32.67,12.39 33.16,6.66 30.71,3.8 A 6.62,6.62 0 0 0 26,1.49 C 24.35,-0.07 20.27,-0.72 15.72,1.12 9,3.8 10.13,10.48 10.5,12.58 A 6.87,6.87 0 0 0 10.75,14.39 4.22,4.22 0 0 0 10,17 c 0.19,2.33 0.81,3.57 2.14,4.24 a 0.28,0.28 0 0 0 0.09,0.1 10.09,10.09 0 0 0 1.53,4 l 0.15,0.24 a 1.35,1.35 0 0 1 0.39,1.18 c 0,2.92 -0.6,4.41 -6.37,6.44 C 2.52,35.23 0,37.57 0,40.58 v 5 a 1.5,1.5 0 0 0 1.5,1.5 H 27 c 1.15,0 1.34,-1 1.34,-1.54 A 1.59,1.59 0 0 0 26.75,44.18 Z M 38.9,27.8 A 11.1,11.1 0 1 0 50,38.9 11.14,11.14 0 0 0 38.9,27.8 Z m 0,19.2 A 8.1,8.1 0 1 1 47,38.9 8.07,8.07 0 0 1 38.9,47 Z M 40.5,36.9 V 36.8 L 38.9,32 37.3,36.9 h -5.1 l 4.1,3 -1.6,4.9 4.1,-3 4.1,3 -1.6,-4.9 c 0,0 4.1,-3 4.4,-3 z"
    });
  },
  Dashboard: function Dashboard(_ref38) {
    var color = _ref38.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 13.75,31.02 h 5.36 v 7.81 h -5.36 z m 8.57,-4.95 h 5.36 v 12.76 h -5.36 z m 8.569999,-4.949999 H 36.25 V 38.820002 H 30.889999 Z M 18.12,9.82 h -0.28 a 1.04,1.04 0 1 0 0,2.08 h 0.28 a 1.04,1.04 0 0 0 0,-2.08 z m -5.39,0 h -0.27 a 1.04,1.04 0 1 0 0,2.08 h 0.27 a 1.04,1.04 0 0 0 0,-2.08 z m -5.39,0 H 7.07 a 1.04,1.04 0 1 0 0,2.08 h 0.27 a 1.04,1.04 0 0 0 0,-2.08 z M 45.63,3.68 H 4.37 A 4.37,4.37 0 0 0 0,8.05 V 42 a 4.37,4.37 0 0 0 4.37,4.37 H 45.63 A 4.37,4.37 0 0 0 50,42 V 8.05 A 4.37,4.37 0 0 0 45.63,3.68 Z M 47.16,18 v 24 a 1.53,1.53 0 0 1 -1.53,1.53 H 4.37 A 1.53,1.53 0 0 1 2.84,42 V 18 Z m 0,-9.94 v 7.1 H 2.84 V 8.05 A 1.53,1.53 0 0 1 4.37,6.52 h 41.26 a 1.53,1.53 0 0 1 1.53,1.53 z"
    });
  },
  DeepOcean: function DeepOcean(_ref39) {
    var color = _ref39.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 45.8,18.1 C 44.986373,15.719946 43.731094,13.514727 42.1,11.6 41.903668,11.386816 41.665335,11.216578 41.4,11.1 41.681113,10.726704 41.822635,10.266757 41.8,9.8 41.755558,9.0454873 41.435234,8.3336561 40.9,7.8 38.741644,5.8678254 36.2284,4.3734641 33.5,3.4 33.2,3.4 32.8,3.3 32.6,3.3 32.621795,2.8023299 32.481425,2.3110358 32.2,1.9 31.787931,1.3166671 31.187644,0.89293541 30.5,0.7 27.279574,-0.00177657 23.957322,-0.10347817 20.7,0.4 19.93759,0.47525193 19.262698,0.92517997 18.9,1.6 18.529104,2.2331593 18.387834,2.9748288 18.5,3.7 l 1.8,7.4 c -0.3,0 -0.7,0.1 -0.7,0.3 -1.252175,0.416715 -2.432685,1.023835 -3.5,1.8 -0.257731,0.207589 -0.492411,0.442269 -0.7,0.7 -0.568602,-0.452287 -1.273453,-0.698985 -2,-0.7 -0.754513,0.04444 -1.466344,0.364766 -2,0.9 -1.181524,1.313189 -2.1590959,2.796402 -2.9,4.4 C 8.369965,18.789139 8.2694553,19.090668 8.2,19.4 7.4615336,19.13611 6.6408481,19.248022 6,19.7 5.2734657,20.021284 4.7765684,20.709296 4.7,21.5 4.5329738,22.659949 4.4328084,23.828546 4.4,25 c -0.014749,0.867849 0.018636,1.735848 0.1,2.6 -0.038873,0.378781 0.1106228,0.752519 0.4,1 -0.261098,0.241035 -0.4957572,0.509217 -0.7,0.8 -0.3903898,0.626839 -0.4992593,1.388926 -0.3,2.1 0.8283614,2.270873 2.0095252,4.396968 3.5,6.3 0.2410349,0.261098 0.5092168,0.495757 0.8,0.7 -0.078051,0.327337 -0.1116861,0.66369 -0.1,1 0.096435,0.800994 0.4073798,1.561082 0.9,2.2 2.108469,1.722932 4.514903,3.044776 7.1,3.9 0.294283,0.07285 0.596904,0.10647 0.9,0.1 l -0.1,0.4 c -0.249797,0.706904 -0.137738,1.491315 0.3,2.1 0.43322,0.561727 1.025631,0.9799 1.7,1.2 3.220817,0.698601 6.542483,0.800284 9.8,0.3 0.76241,-0.07525 1.437302,-0.52518 1.8,-1.2 0.370896,-0.633159 0.512166,-1.374829 0.4,-2.1 L 30.7,45 c 0.303595,0.02218 0.60868,-0.01172 0.9,-0.1 2.196201,-0.812633 4.253771,-1.959476 6.1,-3.4 0.510408,-0.469464 0.830674,-1.109996 0.9,-1.8 0.124239,-0.742524 -0.139834,-1.497018 -0.7,-2 l -2.9,-3 c 0.3,-0.1 0.5,-0.4 0.8,-0.7 0.801282,-0.86656 1.474743,-1.843078 2,-2.9 0.130035,-0.289139 0.230545,-0.590668 0.3,-0.9 l 1.4,0.347222 c 0.738466,0.26389 1.559152,-0.195244 2.2,-0.647222 0.691176,-0.312582 1.179432,-0.951071 1.3,-1.7 0.333075,-1.84926 0.366839,-3.740027 0.1,-5.6 -0.09788,-0.346445 -0.231948,-0.681625 -0.4,-1 l 0.9,-0.1 c 0.682061,-0.256938 1.273332,-0.709087 1.7,-1.3 0.525876,-0.562556 0.715939,-1.360822 0.5,-2.1 z M 31.9,5.8 c 0.0098,-0.161447 0.138553,-0.2901888 0.3,-0.3 h 0.5 c 2.426534,0.9792623 4.68668,2.3286031 6.7,4 0,0.1 0.1,0.3 0.1,0.4 0.01496,0.14096 -0.02046,0.282665 -0.1,0.4 l -8.2,7.4 c -0.729203,-0.680793 -1.576379,-1.222985 -2.5,-1.6 z m -7,12.8 c 5.613091,0 8.42312,6.785973 4.454546,10.754546 C 25.385973,33.32312 18.6,30.513091 18.6,24.9 c -0.01672,-3.486297 2.813703,-6.316721 6.3,-6.3 z M 21,2.5 c 2.99004,-0.5003962 6.04992,-0.3984002 9,0.3 0.303789,0.082801 0.482895,0.3962368 0.4,0.7 l -3.8,12.1 c -0.526041,-0.115771 -1.061648,-0.182722 -1.6,-0.2 -0.435801,-0.0205 -0.872462,0.01309 -1.3,0.1 L 20.7,3.1 C 20.4,2.8 20.7,2.5 21,2.5 Z m -4,12.2 c 0.921926,-0.668335 1.931382,-1.206712 3,-1.6 h 0.3 c 0.1,0 0.3,0.1 0.3,-0.1 0.1,0.1 0.3,0.3 0.3,0.4 l 0.6,2.7 c -0.885069,0.367596 -1.724103,0.837455 -2.5,1.4 l -2.1,-2.1 c -0.07954,-0.117335 -0.114964,-0.25904 -0.1,-0.4 0,-0.1 0.1,-0.2 0.2,-0.3 z m -6.5,4.4 c 0.641833,-1.41325 1.483804,-2.726726 2.5,-3.9 0.1,0 0.3,-0.1 0.4,-0.1 0.172229,-0.0067 0.343584,0.0276 0.5,0.1 l 3.6,3.8 c -0.560015,0.7058 -1.030275,1.478371 -1.4,2.3 l -5.3,-1.5 c -0.3,0 -0.4,-0.1 -0.4,-0.3 0,-0.2 0.1,-0.2 0.1,-0.4 z M 7,21.6 c 0.0192,-0.267787 0.232213,-0.4808 0.5,-0.5 h 0.1 l 5.2,1.4 2.6,0.8 c -0.1832,0.820566 -0.217074,1.667424 -0.1,2.5 l -7.8,1.8 c -0.1,0.1 -0.3,0 -0.4,0 C 7,27.6 6.8,27.5 6.8,27.2 6.716789,26.402858 6.6833908,25.601301 6.7,24.8 6.7261289,23.727694 6.8263679,22.658478 7,21.6 Z m 2.9,15 C 9.7590402,36.614964 9.6173345,36.579537 9.5,36.5 8.0586233,34.781916 6.9405555,32.816827 6.2,30.7 6.0981424,30.58612 6.0981424,30.41388 6.2,30.3 6.3,30.2 6.5,30 6.6,30 l 9.3,-2.1 c 0.2846,0.708621 0.653955,1.380174 1.1,2 0.1,0.1 0.1,0.2 0.2,0.3 v 0 l -6.9,6.1 c -0.2,0.3 -0.3,0.3 -0.4,0.3 z m 7.7,6.7 h -0.4 c -2.305934,-0.818788 -4.466433,-2.000311 -6.4,-3.5 -0.1,-0.1 -0.3,-0.3 -0.3,-0.4 -0.01496,-0.14096 0.02046,-0.282665 0.1,-0.4 l 7.9,-7 c 0.703136,0.591239 1.475453,1.094924 2.3,1.5 l -3.1,9.4 c 0.1,0.2 0,0.2 -0.1,0.4 z m 10.9,4.2 c -2.989932,0.502018 -6.050135,0.400011 -9,-0.3 -0.330041,-0.04656 -0.527443,-0.392017 -0.4,-0.7 L 23,34.2 c 0.627161,0.116027 1.262426,0.182897 1.9,0.2 h 0.9 l 3.1,12.5 c 0.1112,0.284639 -0.09449,0.593169 -0.4,0.6 z m 8,-8.5 c 0.133333,0.25 0.133333,0.55 0,0.8 -1.623237,1.344556 -3.490723,2.363184 -5.5,3 -0.3,0.1 -0.4,0.1 -0.5,0 -0.1,-0.1 -0.3,-0.3 -0.3,-0.4 0,-0.1 -1.8,-7 -2,-8.6 0.877552,-0.271655 1.693052,-0.713384 2.4,-1.3 z M 36,30.2 c -0.47333,0.893119 -1.043422,1.731489 -1.7,2.5 -0.1,0 -0.3,0.1 -0.4,0.1 -0.1,0 -0.3,0 -0.4,-0.1 L 32,31.1 c 0.592544,-0.645195 1.066489,-1.389965 1.4,-2.2 l 2.4,0.6 c 0.200963,0.172143 0.279686,0.447671 0.2,0.7 z m 4.8,-1.9 c -0.02853,0.174387 -0.140577,0.323783 -0.3,0.4 h -0.4 l -3.5,-1 c 0,-0.1 -0.1,-0.1 -0.5,-0.1 L 34.2,27 c 0.121073,-0.6601 0.187962,-1.328996 0.2,-2 v -0.8 l 5.9,-1.4 c 0.322502,-0.02085 0.615127,0.188168 0.7,0.5 0.183313,1.667305 0.115899,3.352663 -0.2,5 z m 2.3,-8.5 -9.2,2.2 c -0.270358,-0.908442 -0.711582,-1.756949 -1.3,-2.5 1.3,-1.2 6.9,-6.3 6.9,-6.1 0.25,-0.133333 0.55,-0.133333 0.8,0 1.426814,1.765168 2.542752,3.760329 3.3,5.9 0.1,0.1 -0.2,0.5 -0.5,0.5 z"
    });
  },
  Delete: function Delete(_ref40) {
    var color = _ref40.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M43.2,3H32.4V1.7c0-1-0.7-1.7-1.7-1.7H19.2c-1,0-1.7,0.7-1.7,1.7V3H6.8c-1.1,0-2,0.9-2,2v6.1c0,1.1,0.9,2,2,2h1.6V46  c0,2.2,1.8,4,4,4h25.1c2.2,0,4-1.8,4-4V13.1h1.6c1.1,0,2-0.9,2-2V5C45.2,3.9,44.3,3,43.2,3z M38.5,46c0,0.6-0.4,1-1,1H12.5  c-0.6,0-1-0.4-1-1V13.1h4.1v28.1h3V13.1h5v28.1h3V13.1h4.4v28.1h3V13.1h4.6V46z M42.2,10.1h-2.6H10.5H7.8V6h34.4V10.1z"
    });
  },
  Dot: function Dot(_ref41) {
    var color = _ref41.color;
    return /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "5",
      fill: color,
      fillRule: "evenodd"
    });
  },
  // viewBox="0 0 12 12""
  DoubleArrow: function DoubleArrow(_ref42) {
    var color = _ref42.color;
    return /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L6.53033 5.46967C6.82322 5.76256 6.82322 6.23744 6.53033 6.53033L1.28033 11.7803C0.987437 12.0732 0.512563 12.0732 0.21967 11.7803C-0.0732233 11.4874 -0.0732233 11.0126 0.21967 10.7197L4.93934 6L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967ZM5.46967 0.21967C5.76256 -0.0732233 6.23744 -0.0732233 6.53033 0.21967L11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L6.53033 11.7803C6.23744 12.0732 5.76256 12.0732 5.46967 11.7803C5.17678 11.4874 5.17678 11.0126 5.46967 10.7197L10.1893 6L5.46967 1.28033C5.17678 0.987437 5.17678 0.512563 5.46967 0.21967Z",
      fill: color
    });
  },
  DownArrowCircle: function DownArrowCircle(_ref43) {
    var color = _ref43.color,
      secColor = _ref43.secColor;
    return /*#__PURE__*/React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "25",
      cy: "25",
      r: "24",
      fill: secColor || '#F7F8F9'
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "m 3.926115,12.379716 a 2.3850835,2.3850835 0 0 0 -1.704962,0.722047 2.3850835,2.3850835 0 0 0 0.046584,3.372657 l 21.020878,20.424607 0.04892,0.04892 a 2.3850835,2.3850835 0 0 0 0.05124,0.04658 2.3850835,2.3850835 0 0 0 0.0047,0.0047 2.3850835,2.3850835 0 0 0 0.08152,0.07221 2.3850835,2.3850835 0 0 0 0.04892,0.03727 2.3850835,2.3850835 0 0 0 0.06987,0.05357 2.3850835,2.3850835 0 0 0 0.03494,0.02562 2.3850835,2.3850835 0 0 0 0.06987,0.04658 2.3850835,2.3850835 0 0 0 0.06755,0.04193 2.3850835,2.3850835 0 0 0 0.03959,0.02329 2.3850835,2.3850835 0 0 0 0.107138,0.05823 2.3850835,2.3850835 0 0 0 0.0792,0.03959 2.3850835,2.3850835 0 0 0 0.09084,0.03959 2.3850835,2.3850835 0 0 0 0.02562,0.01169 2.3850835,2.3850835 0 0 0 0.06755,0.02563 2.3850835,2.3850835 0 0 0 0.109475,0.03727 2.3850835,2.3850835 0 0 0 0.04193,0.01169 2.3850835,2.3850835 0 0 0 0.09317,0.02563 2.3850835,2.3850835 0 0 0 0.04425,0.01169 2.3850835,2.3850835 0 0 0 0.104813,0.02096 2.3850835,2.3850835 0 0 0 0.03494,0.0047 2.3850835,2.3850835 0 0 0 0.07221,0.01169 2.3850835,2.3850835 0 0 0 0.09083,0.01169 2.3850835,2.3850835 0 0 0 0.10015,0.007 2.3850835,2.3850835 0 0 0 0.137421,0.0047 2.3850835,2.3850835 0 0 0 0.142081,-0.0047 2.3850835,2.3850835 0 0 0 0.10015,-0.0093 2.3850835,2.3850835 0 0 0 0.111801,-0.01398 2.3850835,2.3850835 0 0 0 0.139751,-0.02562 2.3850835,2.3850835 0 0 0 0.128105,-0.03028 2.3850835,2.3850835 0 0 0 0.0093,-0.0024 2.3850835,2.3850835 0 0 0 0.0093,-0.0024 2.3850835,2.3850835 0 0 0 0.102487,-0.03028 2.3850835,2.3850835 0 0 0 0.02562,-0.0093 2.3850835,2.3850835 0 0 0 0.06288,-0.02329 2.3850835,2.3850835 0 0 0 0.121116,-0.04892 2.3850835,2.3850835 0 0 0 0.01169,-0.0047 2.3850835,2.3850835 0 0 0 0.06522,-0.03028 2.3850835,2.3850835 0 0 0 0.06056,-0.03028 2.3850835,2.3850835 0 0 0 0.06522,-0.03494 2.3850835,2.3850835 0 0 0 0.02096,-0.01398 2.3850835,2.3850835 0 0 0 0.100149,-0.06056 2.3850835,2.3850835 0 0 0 0.05823,-0.03727 2.3850835,2.3850835 0 0 0 0.06056,-0.04193 2.3850835,2.3850835 0 0 0 0.05357,-0.03959 2.3850835,2.3850835 0 0 0 0.05823,-0.04658 2.3850835,2.3850835 0 0 0 0.01169,-0.01169 2.3850835,2.3850835 0 0 0 0.0792,-0.06755 2.3850835,2.3850835 0 0 0 0.0163,-0.01398 2.3850835,2.3850835 0 0 0 0.04193,-0.03959 2.3850835,2.3850835 0 0 0 0.04892,-0.04892 L 47.731062,16.47442 a 2.3850835,2.3850835 0 0 0 0.04892,-3.372657 2.3850835,2.3850835 0 0 0 -3.372658,-0.04892 L 25.000564,31.912246 5.5938108,13.05285 A 2.3850835,2.3850835 0 0 0 3.926115,12.379716 Z"
    }));
  },
  DownArrow: function DownArrow(_ref44) {
    var color = _ref44.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 3.926115,12.379716 a 2.3850835,2.3850835 0 0 0 -1.704962,0.722047 2.3850835,2.3850835 0 0 0 0.046584,3.372657 l 21.020878,20.424607 0.04892,0.04892 a 2.3850835,2.3850835 0 0 0 0.05124,0.04658 2.3850835,2.3850835 0 0 0 0.0047,0.0047 2.3850835,2.3850835 0 0 0 0.08152,0.07221 2.3850835,2.3850835 0 0 0 0.04892,0.03727 2.3850835,2.3850835 0 0 0 0.06987,0.05357 2.3850835,2.3850835 0 0 0 0.03494,0.02562 2.3850835,2.3850835 0 0 0 0.06987,0.04658 2.3850835,2.3850835 0 0 0 0.06755,0.04193 2.3850835,2.3850835 0 0 0 0.03959,0.02329 2.3850835,2.3850835 0 0 0 0.107138,0.05823 2.3850835,2.3850835 0 0 0 0.0792,0.03959 2.3850835,2.3850835 0 0 0 0.09084,0.03959 2.3850835,2.3850835 0 0 0 0.02562,0.01169 2.3850835,2.3850835 0 0 0 0.06755,0.02563 2.3850835,2.3850835 0 0 0 0.109475,0.03727 2.3850835,2.3850835 0 0 0 0.04193,0.01169 2.3850835,2.3850835 0 0 0 0.09317,0.02563 2.3850835,2.3850835 0 0 0 0.04425,0.01169 2.3850835,2.3850835 0 0 0 0.104813,0.02096 2.3850835,2.3850835 0 0 0 0.03494,0.0047 2.3850835,2.3850835 0 0 0 0.07221,0.01169 2.3850835,2.3850835 0 0 0 0.09083,0.01169 2.3850835,2.3850835 0 0 0 0.10015,0.007 2.3850835,2.3850835 0 0 0 0.137421,0.0047 2.3850835,2.3850835 0 0 0 0.142081,-0.0047 2.3850835,2.3850835 0 0 0 0.10015,-0.0093 2.3850835,2.3850835 0 0 0 0.111801,-0.01398 2.3850835,2.3850835 0 0 0 0.139751,-0.02562 2.3850835,2.3850835 0 0 0 0.128105,-0.03028 2.3850835,2.3850835 0 0 0 0.0093,-0.0024 2.3850835,2.3850835 0 0 0 0.0093,-0.0024 2.3850835,2.3850835 0 0 0 0.102487,-0.03028 2.3850835,2.3850835 0 0 0 0.02562,-0.0093 2.3850835,2.3850835 0 0 0 0.06288,-0.02329 2.3850835,2.3850835 0 0 0 0.121116,-0.04892 2.3850835,2.3850835 0 0 0 0.01169,-0.0047 2.3850835,2.3850835 0 0 0 0.06522,-0.03028 2.3850835,2.3850835 0 0 0 0.06056,-0.03028 2.3850835,2.3850835 0 0 0 0.06522,-0.03494 2.3850835,2.3850835 0 0 0 0.02096,-0.01398 2.3850835,2.3850835 0 0 0 0.100149,-0.06056 2.3850835,2.3850835 0 0 0 0.05823,-0.03727 2.3850835,2.3850835 0 0 0 0.06056,-0.04193 2.3850835,2.3850835 0 0 0 0.05357,-0.03959 2.3850835,2.3850835 0 0 0 0.05823,-0.04658 2.3850835,2.3850835 0 0 0 0.01169,-0.01169 2.3850835,2.3850835 0 0 0 0.0792,-0.06755 2.3850835,2.3850835 0 0 0 0.0163,-0.01398 2.3850835,2.3850835 0 0 0 0.04193,-0.03959 2.3850835,2.3850835 0 0 0 0.04892,-0.04892 L 47.731062,16.47442 a 2.3850835,2.3850835 0 0 0 0.04892,-3.372657 2.3850835,2.3850835 0 0 0 -3.372658,-0.04892 L 25.000564,31.912246 5.5938108,13.05285 A 2.3850835,2.3850835 0 0 0 3.926115,12.379716 Z"
    });
  },
  Down: function Down(_ref45) {
    var color = _ref45.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11,15.5857864 L11,6 C11,5.44771525 11.4477153,5 12,5 C12.5522847,5 13,5.44771525 13,6 L13,15.5857864 L16.2928932,12.2928932 C16.6834175,11.9023689 17.3165825,11.9023689 17.7071068,12.2928932 C18.0976311,12.6834175 18.0976311,13.3165825 17.7071068,13.7071068 L12.7071068,18.7071068 C12.3165825,19.0976311 11.6834175,19.0976311 11.2928932,18.7071068 L6.29289322,13.7071068 C5.90236893,13.3165825 5.90236893,12.6834175 6.29289322,12.2928932 C6.68341751,11.9023689 7.31658249,11.9023689 7.70710678,12.2928932 L11,15.5857864 Z"
    });
  },
  Download: function Download(_ref46) {
    var color = _ref46.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 23.9,40.9 a 1.5,1.5 0 0 0 1.1,0.4 2.1,2.1 0 0 0 1.1,-0.4 L 38,29 a 1.4849242,1.4849242 0 1 0 -2.1,-2.1 l -9.4,9.4 V 1.5 a 1.5,1.5 0 0 0 -3,0 V 36.2 L 14.1,26.8 A 1.4849242,1.4849242 0 0 0 12,28.9 Z M 48.5,31.8 A 1.54,1.54 0 0 0 47,33.3 V 47 H 3 V 33.3 A 1.54,1.54 0 0 0 1.5,31.8 1.54,1.54 0 0 0 0,33.3 V 48.5 A 1.54,1.54 0 0 0 1.5,50 h 47 A 1.54,1.54 0 0 0 50,48.5 V 33.3 a 1.54,1.54 0 0 0 -1.5,-1.5 z"
    });
  },
  // viewBox="0 0 14 14"
  Download2: function Download2(_ref47) {
    var color = _ref47.color;
    return /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 0C7.3866 0 7.7 0.313401 7.7 0.7V7.41005L10.005 5.10503C10.2784 4.83166 10.7216 4.83166 10.995 5.10503C11.2683 5.37839 11.2683 5.82161 10.995 6.09497L7.49497 9.59497C7.22161 9.86834 6.77839 9.86834 6.50503 9.59497L3.00503 6.09497C2.73166 5.82161 2.73166 5.37839 3.00503 5.10503C3.27839 4.83166 3.72161 4.83166 3.99497 5.10503L6.3 7.41005V0.7C6.3 0.313401 6.6134 0 7 0ZM0.7 8.4C1.0866 8.4 1.4 8.7134 1.4 9.1V11.9C1.4 12.0857 1.47375 12.2637 1.60503 12.395C1.7363 12.5263 1.91435 12.6 2.1 12.6H11.9C12.0857 12.6 12.2637 12.5263 12.395 12.395C12.5263 12.2637 12.6 12.0857 12.6 11.9V9.1C12.6 8.7134 12.9134 8.4 13.3 8.4C13.6866 8.4 14 8.7134 14 9.1V11.9C14 12.457 13.7788 12.9911 13.3849 13.3849C12.9911 13.7788 12.457 14 11.9 14H2.1C1.54305 14 1.0089 13.7788 0.615076 13.3849C0.221249 12.9911 0 12.457 0 11.9V9.1C0 8.7134 0.313401 8.4 0.7 8.4Z",
      fill: color
    });
  },
  // viewBox="0 0 50 50"
  Edit: function Edit(_ref48) {
    var color = _ref48.color;
    return /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M 45.5,5.1 H 22.7 l 3,3 H 45.5 A 1.54,1.54 0 0 1 47,9.6 V 45.5 A 1.54,1.54 0 0 1 45.5,47 H 9.6 A 1.54,1.54 0 0 1 8.1,45.5 V 25.3 l -3,-3 V 45.5 A 4.48,4.48 0 0 0 9.6,50 H 45.5 A 4.48,4.48 0 0 0 50,45.5 V 9.6 A 4.48,4.48 0 0 0 45.5,5.1 Z m -16.6,22 a 1.61,1.61 0 0 0 0.9,-0.3 1.35,1.35 0 0 0 0,-1.7 L 12.9,8.2 a 1.15,1.15 0 0 0 -1.7,0 1.35,1.35 0 0 0 0,1.7 L 28,26.8 a 1.22,1.22 0 0 0 0.9,0.3 z m -3.9,9.2 14.4,5.1 a 0.9,0.9 0 0 0 0.5,0.1 1.67,1.67 0 0 0 1.1,-0.4 1.83,1.83 0 0 0 0.3,-1.6 L 36.3,25 A 0.85,0.85 0 0 0 36,24.5 L 13.4,1.9 a 6.4,6.4 0 0 0 -9.1,0 L 3.1,3.1 1.9,4.3 A 6.36,6.36 0 0 0 0,8.8 6.6,6.6 0 0 0 1.9,13.4 L 24.5,36 a 2.19,2.19 0 0 0 0.5,0.3 z m 11.4,-1.9 -2,2 -6.3,-2.2 6.1,-6.1 z M 2.9,8.8 A 3.41,3.41 0 0 1 4,6.3 L 6.3,4 a 3.69,3.69 0 0 1 5,0 L 32.7,25.6 25.4,32.9 4,11.3 A 3.58,3.58 0 0 1 2.9,8.8 Z",
      fill: color
    });
  },
  Email: function Email(_ref49) {
    var color = _ref49.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 25,10.29 a 14.71,14.71 0 0 0 0,29.42 1.5,1.5 0 1 0 0,-3 A 11.74,11.74 0 1 1 36.74,25 v 3.93 a 2.44,2.44 0 0 1 -4.88,0 V 25 A 6.86,6.86 0 1 0 25,31.86 6.77,6.77 0 0 0 29.12,30.46 5.4,5.4 0 0 0 39.71,28.93 V 25 A 14.73,14.73 0 0 0 25,10.29 Z M 28.89,25 A 3.89,3.89 0 1 1 25,21.11 3.9,3.9 0 0 1 28.89,25 Z M 48.51,9.86 A 1.49,1.49 0 0 0 50,8.37 V 1.49 A 1.49,1.49 0 0 0 48.51,0 h -47 A 1.49,1.49 0 0 0 0,1.49 v 6.88 a 1.49,1.49 0 0 0 1.49,1.49 2,2 0 0 1 0,4 1.49,1.49 0 0 0 -1.49,1.5 v 6.15 A 1.49,1.49 0 0 0 1.49,23 2,2 0 1 1 1.49,27 1.49,1.49 0 0 0 0,28.49 v 6.15 a 1.49,1.49 0 0 0 1.49,1.49 2,2 0 0 1 0,4 A 1.49,1.49 0 0 0 0,41.62 v 6.89 A 1.49,1.49 0 0 0 1.49,50 h 47 A 1.49,1.49 0 0 0 50,48.51 v -6.89 a 1.49,1.49 0 0 0 -1.49,-1.48 2,2 0 0 1 0,-4 1.49,1.49 0 0 0 1.49,-1.5 V 28.49 A 1.49,1.49 0 0 0 48.51,27 a 2,2 0 1 1 0,-4 1.49,1.49 0 0 0 1.49,-1.49 v -6.15 a 1.49,1.49 0 0 0 -1.49,-1.49 2,2 0 0 1 0,-4 z m -5,2 A 5,5 0 0 0 47,16.62 v 3.63 a 5,5 0 0 0 0,9.5 v 3.63 a 5,5 0 0 0 0,9.5 V 47 H 3 V 42.88 A 5,5 0 0 0 6.49,38.13 5,5 0 0 0 3,33.38 v -3.63 a 5,5 0 0 0 0,-9.5 V 16.62 A 5,5 0 0 0 6.49,11.86 5,5 0 0 0 3,7.12 V 3 h 44 v 4.12 a 5,5 0 0 0 -3.47,4.74 z"
    });
  },
  Expand: function Expand(_ref50) {
    var color = _ref50.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 32.53285,6.1017979 3.832502,3.8325026 -8.405074,8.3522115 c -1.030811,1.030811 -1.030811,2.722398 0,3.753209 1.030811,1.030812 2.722398,1.030812 3.753209,0 l 8.352212,-8.405074 3.832502,3.832503 c 0.819364,0.819362 2.24664,0.237879 2.24664,-0.951518 V 5.1767111 c 0,-0.7400695 -0.581483,-1.3215526 -1.321552,-1.3215526 H 33.484368 c -1.189397,0 -1.770881,1.4272768 -0.951518,2.2466394 z M 17.467151,43.898201 13.634648,40.065699 22.039722,31.713486 c 1.030812,-1.030811 1.030812,-2.722398 0,-3.753209 -1.030811,-1.030811 -2.722399,-1.030811 -3.75321,0 L 9.9343008,36.365352 6.1017981,32.532849 C 5.2824355,31.713486 3.8551587,32.294971 3.8551587,33.484368 v 11.338921 c 0,0.740068 0.5814831,1.321552 1.3215526,1.321552 H 16.515633 c 1.189397,0 1.770879,-1.427276 0.951518,-2.24664 z"
    });
  },
  External: function External(_ref51) {
    var color = _ref51.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M18.5857864,4 L15,4 C14.4477153,4 14,3.55228475 14,3 C14,2.44771525 14.4477153,2 15,2 L21,2 C21.5522847,2 22,2.44771525 22,3 L22,9 C22,9.55228475 21.5522847,10 21,10 C20.4477153,10 20,9.55228475 20,9 L20,5.41421356 L12.7071068,12.7071068 C12.3165825,13.0976311 11.6834175,13.0976311 11.2928932,12.7071068 C10.9023689,12.3165825 10.9023689,11.6834175 11.2928932,11.2928932 L18.5857864,4 Z M18,13 C18,12.4477153 18.4477153,12 19,12 C19.5522847,12 20,12.4477153 20,13 L20,19.5 C20,20.8807119 18.8807119,22 17.5,22 L4.5,22 C3.11928813,22 2,20.8807119 2,19.5 L2,6.5 C2,5.11928813 3.11928813,4 4.5,4 L11,4 C11.5522847,4 12,4.44771525 12,5 C12,5.55228475 11.5522847,6 11,6 L4.5,6 C4.22385763,6 4,6.22385763 4,6.5 L4,19.5 C4,19.7761424 4.22385763,20 4.5,20 L17.5,20 C17.7761424,20 18,19.7761424 18,19.5 L18,13 Z"
    });
  },
  Eye: function Eye(_ref52) {
    var color = _ref52.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25.1,21.2 A 3.8,3.8 0 1 0 28.9,25 3.8,3.8 0 0 0 25.1,21.2 Z M 25,14.5 A 10.5,10.5 0 1 0 35.5,25 10.5,10.5 0 0 0 25,14.5 Z m 0,18 A 7.5,7.5 0 1 1 32.5,25 7.55,7.55 0 0 1 25,32.5 Z M 49.7,24.3 A 28.84,28.84 0 0 0 25,9.7 C 7.6,9.2 0.4,24.2 0.3,24.4 L 0,25.1 0.4,25.8 c 0.3,0.6 8.1,14 24.6,14.6 h 1 c 15.9,0 23.4,-14 23.7,-14.6 L 50,25 Z m -24.6,13 C 12.3,36.8 5.2,27.5 3.4,24.9 A 23.77,23.77 0 0 1 25,12.7 25.64,25.64 0 0 1 46.6,25 c -1.7,2.7 -8.7,12.8 -21.5,12.3 z"
    });
  },
  Facebook: function Facebook(_ref53) {
    var color = _ref53.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16,9.57483963 L13.2754811,9.57483963 L13.2754811,7.78795438 C13.2754811,7.11689237 13.7202423,6.96044191 14.0334996,6.96044191 C14.3460442,6.96044191 15.9561654,6.96044191 15.9561654,6.96044191 L15.9561654,4.010335 L13.308268,4 C10.3688525,4 9.69992872,6.2002851 9.69992872,7.60833927 L9.69992872,9.57483963 L8,9.57483963 L8,12.6147541 L9.69992872,12.6147541 C9.69992872,16.5160371 9.69992872,21.2166785 9.69992872,21.2166785 L13.2754811,21.2166785 C13.2754811,21.2166785 13.2754811,16.4697078 13.2754811,12.6147541 L15.6881682,12.6147541 L16,9.57483963 Z"
    });
  },
  Feedback: function Feedback(_ref54) {
    var color = _ref54.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M47,3V32H27.91a3,3,0,0,0-2,.79L14.6,43.16V35a3,3,0,0,0-3-3H3V3H47m1-3H2A2,2,0,0,0,0,2V33a2,2,0,0,0,2,2h9.6V50L27.91,35H48a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Z"
    });
  },
  // viewBox: 0 0 17 16
  Filter: function Filter(_ref55) {
    var color = _ref55.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M6.42724 16C6.34567 16 6.26409 15.9801 6.18592 15.9403C6.01598 15.8508 5.91062 15.6783 5.91741 15.4893L6.12474 7.49762L0.180188 0.822383C0.0476336 0.676477 0.0170441 0.467565 0.098616 0.291813C0.183587 0.112746 0.363725 0 0.564256 0H16.3246C16.5218 0 16.7019 0.112746 16.7869 0.285181C16.8718 0.460933 16.8447 0.666529 16.7155 0.815751L11.0055 7.50093L10.9273 12.7403C10.9273 12.8995 10.8457 13.0454 10.7132 13.1382L6.71954 15.9072C6.63117 15.9668 6.5292 16 6.42384 16H6.42724ZM1.68247 0.994819L7.02543 6.99026C7.1104 7.08311 7.15459 7.2058 7.15119 7.3285L6.96425 14.521L9.91784 12.475L9.99261 7.3086C9.99261 7.19586 10.0368 7.08642 10.1116 6.99689L15.237 0.994819H1.68247Z"
    });
  },
  Fingerprint: function Fingerprint(_ref56) {
    var color = _ref56.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25,0 A 25,25 0 1 0 50,25 25,25 0 0 0 25,0 Z m 0,47.62 A 22.62,22.62 0 1 1 40.11,8.21 l -3.58,3.58 a 17.43,17.43 0 0 0 -21.92,-0.91 3.44,3.44 0 0 0 -4.61,5 17.5,17.5 0 0 0 11.67,26.35 3.44,3.44 0 0 0 6.66,0 17.52,17.52 0 0 0 9.88,-28.76 L 41.79,9.9 A 22.58,22.58 0 0 1 25,47.62 Z M 16,12.84 a 15.09,15.09 0 0 1 18.9,0.63 l -3.59,3.59 a 10.22,10.22 0 1 0 1.68,1.69 l 3.59,-3.6 a 15.16,15.16 0 0 1 -8.44,24.71 3.43,3.43 0 0 0 -6.18,0 A 15.21,15.21 0 0 1 9.82,25 a 15,15 0 0 1 2.25,-7.91 3.31,3.31 0 0 0 0.55,0.05 3.4,3.4 0 0 0 3.38,-4.3 z m 9,16.21 a 4,4 0 0 0 3.57,-5.93 l 2.67,-2.68 a 7.77,7.77 0 1 1 -1.68,-1.68 l -2.68,2.67 A 4,4 0 1 0 25,29.05 Z"
    });
  },
  Folder: function Folder(_ref57) {
    var color = _ref57.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 43.574897,13.455034 20.075016,13.502322 14.940987,7.708341 6.0203412,7.6610531 6.167391,36.575048 43.67293,36.433184 Z m 1.170639,-3.7556292 c 1.573847,0 2.849702,1.2758552 2.849702,2.8497022 v 25.073732 c 0,1.573847 -1.275855,2.849702 -2.849702,2.849702 H 4.8497024 C 3.2758552,40.472541 2,39.196686 2,37.622839 V 6.8497024 C 2,5.2758552 3.2758552,4 4.8497024,4 H 15.667833 c 0.821748,0 1.603495,0.3547322 2.14462,0.9731602 l 4.135464,4.7262446 z"
    });
  },
  Github: function Github(_ref58) {
    var color = _ref58.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M17.1663776,4.59746853 C16.3436643,3.18784615 15.2277063,2.07184615 13.8182098,1.24921678 C12.4085035,0.426545455 10.8695245,0.0153146853 9.20018182,0.0153146853 C7.53104895,0.0153146853 5.99156643,0.426671329 4.58215385,1.24921678 C3.17253147,2.0718042 2.05661538,3.18784615 1.2339021,4.59746853 C0.411314685,6.00704895 0,7.54632168 0,9.21524476 C0,11.22 0.584895105,13.0227273 1.75497902,14.6238881 C2.92493706,16.2251748 4.43634965,17.3332028 6.28909091,17.9480979 C6.50475524,17.9881259 6.66440559,17.959972 6.76820979,17.8643497 C6.87205594,17.7686014 6.92391608,17.6486853 6.92391608,17.5051049 C6.92391608,17.4811469 6.92186014,17.2656084 6.91787413,16.8582378 C6.91376224,16.4508671 6.91183217,16.0954825 6.91183217,15.7922517 L6.63629371,15.8399161 C6.46061538,15.8720979 6.23899301,15.8857343 5.97142657,15.8818741 C5.70398601,15.8781399 5.42634965,15.8501119 5.1388951,15.798 C4.85131469,15.7463497 4.58383217,15.6265594 4.33623776,15.4388811 C4.08876923,15.2512028 3.91309091,15.0055385 3.80924476,14.7022657 L3.68945455,14.4266014 C3.60960839,14.2430769 3.4839021,14.0392028 3.31216783,13.8157343 C3.14043357,13.5920559 2.96676923,13.4404196 2.79109091,13.3605734 L2.70721678,13.3005315 C2.65132867,13.2606294 2.59946853,13.2125035 2.55151049,13.1566573 C2.50359441,13.1008112 2.46772028,13.0449231 2.44376224,12.988951 C2.41976224,12.9329371 2.43965035,12.886993 2.50363636,12.850951 C2.56762238,12.8149091 2.68325874,12.7974126 2.85104895,12.7974126 L3.09054545,12.8332028 C3.25027972,12.8652168 3.44786014,12.9608392 3.68353846,13.1206573 C3.91909091,13.2803497 4.11272727,13.487958 4.26448951,13.7433986 C4.44826573,14.0709231 4.66967832,14.3204895 4.92935664,14.4922238 C5.18882517,14.663958 5.45043357,14.7496783 5.71393007,14.7496783 C5.97742657,14.7496783 6.20500699,14.7297063 6.39675524,14.689972 C6.58829371,14.650028 6.768,14.589986 6.93579021,14.5101818 C7.00766434,13.9748811 7.20335664,13.5636503 7.5226993,13.2761958 C7.06753846,13.2283636 6.65832168,13.1563217 6.29483916,13.0605315 C5.93156643,12.9646154 5.55616783,12.808951 5.1688951,12.5931189 C4.78141259,12.3775804 4.45997203,12.1099301 4.20448951,11.7906294 C3.94896503,11.4711608 3.73925874,11.0517483 3.57566434,10.5327692 C3.41198601,10.0135804 3.33012587,9.41467133 3.33012587,8.73587413 C3.33012587,7.76937063 3.64565035,6.94690909 4.27657343,6.26802797 C3.98102098,5.5413986 4.00892308,4.72682517 4.36036364,3.82439161 C4.59197203,3.75243357 4.93544056,3.80643357 5.3906014,3.98605594 C5.84584615,4.16576224 6.17916084,4.31970629 6.39088112,4.44734266 C6.6026014,4.57493706 6.77223776,4.68306294 6.90004196,4.77075524 C7.64290909,4.56318881 8.40952448,4.45938462 9.2000979,4.45938462 C9.99067133,4.45938462 10.7574545,4.56318881 11.5003636,4.77075524 L11.9555664,4.48338462 C12.2668531,4.29163636 12.6344476,4.11591608 13.0574685,3.95618182 C13.4807413,3.79653147 13.8044056,3.75255944 14.0281259,3.82451748 C14.3873706,4.72699301 14.4193846,5.54152448 14.1237483,6.26815385 C14.7546294,6.94703497 15.0702797,7.76970629 15.0702797,8.736 C15.0702797,9.4147972 14.9881259,10.0155944 14.8246993,10.5387692 C14.6610629,11.062028 14.4495524,11.481021 14.1900839,11.7966294 C13.9303217,12.1121958 13.6068252,12.3777483 13.2195524,12.5932448 C12.8321958,12.8089091 12.4566713,12.9645734 12.0933986,13.0604895 C11.729958,13.1564056 11.3207413,13.2284895 10.8655804,13.2764056 C11.2807133,13.6356503 11.4883217,14.2027133 11.4883217,14.9773427 L11.4883217,17.5047692 C11.4883217,17.6483497 11.5382517,17.7682238 11.6381958,17.864014 C11.738014,17.9596364 11.8956503,17.9877902 12.1113147,17.9477203 C13.9643077,17.3329091 15.4757203,16.2248392 16.6456364,14.6235524 C17.8154266,13.0223916 18.4005315,11.2196643 18.4005315,9.21490909 C18.4001119,7.5461958 17.9885874,6.00704895 17.1663776,4.59746853 Z",
      transform: "translate(3 2.85)"
    });
  },
  Grid: function Grid(_ref59) {
    var color = _ref59.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 1.21875 0 C 0.54801833 -4.4408921e-16 0 0.54801829 0 1.21875 L 0 9.7558594 C 0 10.426591 0.54801833 10.976562 1.21875 10.976562 L 9.7558594 10.976562 C 10.426592 10.976563 10.976562 10.426591 10.976562 9.7558594 L 10.976562 1.21875 C 10.976563 0.54801829 10.426592 0 9.7558594 0 L 1.21875 0 z M 20.732422 0 C 20.06169 0 19.511719 0.54801829 19.511719 1.21875 L 19.511719 9.7558594 C 19.511719 10.426591 20.06169 10.976563 20.732422 10.976562 L 29.267578 10.976562 C 29.938309 10.976562 30.488281 10.426591 30.488281 9.7558594 L 30.488281 1.21875 C 30.488281 0.54801829 29.938309 -1.3322676e-15 29.267578 0 L 20.732422 0 z M 40.244141 0 C 39.57341 0 39.023438 0.54801829 39.023438 1.21875 L 39.023438 9.7558594 C 39.023438 10.426591 39.57341 10.976563 40.244141 10.976562 L 48.78125 10.976562 C 49.451982 10.976562 50 10.426591 50 9.7558594 L 50 1.21875 C 50 0.54801829 49.451982 -1.3322676e-15 48.78125 0 L 40.244141 0 z M 1.21875 19.511719 C 0.54801833 19.511719 0 20.06169 0 20.732422 L 0 29.267578 C 0 29.93831 0.54801833 30.488281 1.21875 30.488281 L 9.7558594 30.488281 C 10.426592 30.488281 10.976563 29.93831 10.976562 29.267578 L 10.976562 20.732422 C 10.976562 20.06169 10.426592 19.511719 9.7558594 19.511719 L 1.21875 19.511719 z M 20.732422 19.511719 C 20.06169 19.511719 19.511719 20.06169 19.511719 20.732422 L 19.511719 29.267578 C 19.511719 29.93831 20.06169 30.488281 20.732422 30.488281 L 29.267578 30.488281 C 29.938309 30.488281 30.488281 29.93831 30.488281 29.267578 L 30.488281 20.732422 C 30.488281 20.06169 29.938309 19.511719 29.267578 19.511719 L 20.732422 19.511719 z M 40.244141 19.511719 C 39.57341 19.511719 39.023438 20.06169 39.023438 20.732422 L 39.023438 29.267578 C 39.023438 29.93831 39.57341 30.488281 40.244141 30.488281 L 48.78125 30.488281 C 49.451982 30.488281 50 29.93831 50 29.267578 L 50 20.732422 C 50 20.06169 49.451982 19.511719 48.78125 19.511719 L 40.244141 19.511719 z M 1.21875 39.023438 C 0.54801833 39.023438 0 39.573409 0 40.244141 L 0 48.78125 C 0 49.451981 0.54801833 50 1.21875 50 L 9.7558594 50 C 10.426592 50 10.976563 49.451981 10.976562 48.78125 L 10.976562 40.244141 C 10.976562 39.573409 10.426592 39.023438 9.7558594 39.023438 L 1.21875 39.023438 z M 20.732422 39.023438 C 20.06169 39.023438 19.511719 39.573409 19.511719 40.244141 L 19.511719 48.78125 C 19.511719 49.451981 20.06169 50 20.732422 50 L 29.267578 50 C 29.938309 50 30.488281 49.451981 30.488281 48.78125 L 30.488281 40.244141 C 30.488281 39.573409 29.938309 39.023438 29.267578 39.023438 L 20.732422 39.023438 z M 40.244141 39.023438 C 39.57341 39.023438 39.023438 39.573409 39.023438 40.244141 L 39.023438 48.78125 C 39.023438 49.451981 39.57341 50 40.244141 50 L 48.78125 50 C 49.451982 50 50 49.451981 50 48.78125 L 50 40.244141 C 50 39.573409 49.451982 39.023438 48.78125 39.023438 L 40.244141 39.023438 z "
    });
  },
  HeatMap: function HeatMap(_ref60) {
    var color = _ref60.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 48.5,47 H 4.5 A 1.54,1.54 0 0 1 3,45.5 V 1.5 A 1.54,1.54 0 0 0 1.5,0 1.54,1.54 0 0 0 0,1.5 v 44 A 4.48,4.48 0 0 0 4.5,50 h 44 a 1.5,1.5 0 0 0 0,-3 z M 42.37,33.57 a 4.34,4.34 0 1 0 4.33,4.34 4.34,4.34 0 0 0 -4.33,-4.34 z m 0,3.18 a 1.16,1.16 0 1 1 -1.16,1.16 1.16,1.16 0 0 1 1.16,-1.16 z M 41.21,6.66 A 4.34,4.34 0 1 0 45.55,11 4.34,4.34 0 0 0 41.21,6.66 Z m 0,3.18 A 1.16,1.16 0 1 1 40.06,11 1.16,1.16 0 0 1 41.21,9.84 Z M 12,27.05 A 4.34,4.34 0 1 0 7.66,22.71 4.34,4.34 0 0 0 12,27.05 Z m 0,-3.19 A 1.15,1.15 0 1 1 13.15,22.71 1.15,1.15 0 0 1 12,23.86 Z m 3.17,7.03 a 6.37,6.37 0 1 0 6.37,6.37 6.38,6.38 0 0 0 -6.37,-6.37 z m 3.18,6.37 a 3.18,3.18 0 1 1 -3.18,-3.19 3.18,3.18 0 0 1 3.18,3.19 z M 29.52,18.37 a 7.94,7.94 0 1 0 7.94,7.94 7.94,7.94 0 0 0 -7.94,-7.94 z m 4.75,7.94 a 4.75,4.75 0 1 1 -4.75,-4.75 4.75,4.75 0 0 1 4.75,4.75 z M 21,16.24 A 6.37,6.37 0 1 0 14.6,9.87 6.38,6.38 0 0 0 21,16.24 Z M 21,6.69 A 3.18,3.18 0 1 1 17.82,9.87 3.18,3.18 0 0 1 21,6.69 Z"
    });
  },
  Help: function Help(_ref61) {
    var color = _ref61.color;
    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      className: "hilite",
      d: "m20.891 35.506 0.0012 9.8727c1.328 0.26836 2.7017 0.40922 4.1077 0.40922 1.4056 0 2.7789-0.14078 4.1065-0.40899l3.13e-4 -9.8662c-1.2904 0.50813-2.6783 0.77401-4.1073 0.77401-1.4496 0-2.8358-0.27696-4.1084-0.78074zm24.401-14.51-9.8649-0.0012c0.50477 1.2874 0.76852 2.6716 0.76798 4.0958 5.49e-4 1.434-0.26707 2.8271-0.77905 4.122l9.8712-3.1e-4c0.27007-1.3316 0.41186-2.7092 0.41186-4.1193 0-1.4022-0.14009-2.7723-0.407-4.0969zm-30.714-5.07e-4 -9.87 5.07e-4c-0.26691 1.3247-0.407 2.6947-0.407 4.0969 0 1.4101 0.14179 2.7877 0.41186 4.1193l9.8764-5.82e-4c-0.50712-1.2761-0.78613-2.6666-0.7864-4.1211 0-1.4446 0.2749-2.8262 0.77511-4.0952zm10.422-16.605c-1.4064 0-2.7804 0.141-4.1088 0.40961l-1.75e-4 9.8725c1.2727-0.5039 2.6589-0.78093 4.1085-0.78093 1.429 0 2.8169 0.26588 4.1073 0.77413l-3.14e-4 -9.8662c-1.3277-0.26831-2.7009-0.40914-4.1065-0.40914z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m25 2.2651c12.537 0 22.735 10.2 22.735 22.739 0 12.534-10.199 22.731-22.735 22.731s-22.735-10.196-22.735-22.731c0-12.539 10.199-22.739 22.735-22.739zm-4.1088 33.152 0.0012 9.8727c1.328 0.26836 2.7017 0.40922 4.1077 0.40922 1.4056 0 2.7789-0.14078 4.1065-0.40899l3.13e-4 -9.8662c-1.2904 0.50813-2.6783 0.77401-4.1073 0.77401-1.4496 0-2.8358-0.27696-4.1084-0.78074zm23.873-4.2576-10.41 0.0011c-0.41392 0.6259-0.89409 1.2146-1.4369 1.7574-0.54732 0.54732-1.1414 1.0311-1.7732 1.4475l-7.42e-4 10.403c6.4772-2.0167 11.6-7.1351 13.621-13.609zm-29.111 4.54e-4 -10.418-4.54e-4c2.0211 6.4737 7.1431 11.592 13.62 13.609l-0.0021-10.412c-1.2703-0.83754-2.3608-1.9267-3.1999-3.1959zm9.3464-15.319c-5.0512 0-9.1605 4.1093-9.1605 9.1616 0.0012 5.05 4.1105 9.1582 9.1605 9.1582 2.4482 0 4.7483-0.95219 6.4783-2.681 1.73-1.73 2.6822-4.0302 2.681-6.4772 0.0012-2.4482-0.95104-4.7495-2.681-6.4795s-4.0302-2.6822-6.4783-2.6822zm20.293 5.067-9.8649-0.0012c0.50477 1.2874 0.76852 2.6716 0.76798 4.0958 5.49e-4 1.434-0.26707 2.8271-0.77905 4.122l9.8712-3.1e-4c0.27007-1.3316 0.41186-2.7092 0.41186-4.1193 0-1.4022-0.14009-2.7723-0.407-4.0969zm-30.714-5.07e-4 -9.87 5.07e-4c-0.26691 1.3247-0.407 2.6947-0.407 4.0969 0 1.4101 0.14179 2.7877 0.41186 4.1193l9.8764-5.82e-4c-0.50712-1.2761-0.78613-2.6666-0.7864-4.1211 0-1.4446 0.2749-2.8262 0.77511-4.0952zm16.566-15.674 7.42e-4 10.403c0.63182 0.41657 1.2259 0.90053 1.7732 1.4481 0.55126 0.55096 1.0379 1.1496 1.4562 1.7865l10.398 4.21e-4c-2.016-6.488-7.1432-11.619-13.628-13.638zm-25.916 13.638 10.406-8.34e-4c0.8417-1.2817 1.9391-2.381 3.219-3.2249l7.93e-4 -10.412c-6.4841 2.0204-11.61 7.1505-13.626 13.638zm19.772-14.569c-1.4064 0-2.7804 0.141-4.1088 0.40961l-1.75e-4 9.8725c1.2727-0.5039 2.6589-0.78093 4.1085-0.78093 1.429 0 2.8169 0.26588 4.1073 0.77413l-3.14e-4 -9.8662c-1.3277-0.26831-2.7009-0.40914-4.1065-0.40914z"
    }));
  },
  History: function History(_ref62) {
    var color = _ref62.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M12.9825,18.54 C12.6225,18.82 12.1125,18.82 11.7525,18.54 L5.6025,13.76 C5.2425,13.48 4.7425,13.48 4.3825,13.76 L4.3825,13.76 C3.8725,14.16 3.8725,14.93 4.3825,15.33 L11.1425,20.59 C11.8625,21.15 12.8725,21.15 13.6025,20.59 L20.3625,15.33 C20.8725,14.93 20.8725,14.16 20.3625,13.76 L20.3525,13.75 C19.9925,13.47 19.4925,13.47 19.1325,13.75 L12.9825,18.54 Z M13.6125,15.52 L20.3725,10.26 C20.8825,9.86 20.8825,9.08 20.3725,8.68 L13.6125,3.42 C12.8925,2.86 11.8825,2.86 11.1525,3.42 L4.3925,8.69 C3.8825,9.09 3.8825,9.87 4.3925,10.27 L11.1525,15.53 C11.8725,16.09 12.8925,16.09 13.6125,15.52 Z"
    });
  },
  HomeSolid2: function HomeSolid2(_ref63) {
    var color = _ref63.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M10.197852,19.655 L10.197852,14.655 L14.197852,14.655 L14.197852,19.655 C14.197852,20.205 14.647852,20.655 15.197852,20.655 L18.197852,20.655 C18.747852,20.655 19.197852,20.205 19.197852,19.655 L19.197852,12.655 L20.897852,12.655 C21.357852,12.655 21.577852,12.085 21.227852,11.785 L12.867852,4.255 C12.487852,3.915 11.907852,3.915 11.527852,4.255 L3.16785197,11.785 C2.82785197,12.085 3.03785197,12.655 3.49785197,12.655 L5.19785197,12.655 L5.19785197,19.655 C5.19785197,20.205 5.64785197,20.655 6.19785197,20.655 L9.19785197,20.655 C9.74785197,20.655 10.197852,20.205 10.197852,19.655 Z"
    });
  },
  HomeSolid: function HomeSolid(_ref64) {
    var color = _ref64.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M15,22 L15,16 C15,14.3431458 13.6568542,13 12,13 C10.3431458,13 9,14.3431458 9,16 L9,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,10.4806248 C2,10.1768411 2.13808972,9.88952822 2.37530495,9.69975604 L11.375305,2.49975604 C11.7405236,2.20758112 12.2594764,2.20758112 12.624695,2.49975604 L21.624695,9.69975604 C21.8619103,9.88952822 22,10.1768411 22,10.4806248 L22,21 C22,21.5522847 21.5522847,22 21,22 L15,22 Z"
    });
  },
  Home: function Home(_ref65) {
    var color = _ref65.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M2.37530495,9.69975604 L11.375305,2.49975604 C11.7405236,2.20758112 12.2594764,2.20758112 12.624695,2.49975604 L21.624695,9.69975604 C21.8619103,9.88952822 22,10.1768411 22,10.4806248 L22,21 C22,21.5522847 21.5522847,22 21,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,10.4806248 C2,10.1768411 2.13808972,9.88952822 2.37530495,9.69975604 Z M16,20 L20,20 L20,10.9612497 L12,4.56124969 L4,10.9612497 L4,20 L8,20 L8,16 C8,13.790861 9.790861,12 12,12 C14.209139,12 16,13.790861 16,16 L16,20 L16,20 Z M14,20 L14,16 C14,14.8954305 13.1045695,14 12,14 C10.8954305,14 10,14.8954305 10,16 L10,20 L14,20 L14,20 Z"
    });
  },
  InfoSolid: function InfoSolid(_ref66) {
    var color = _ref66.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z M12,10.5 C11.4477153,10.5 11,10.9477153 11,11.5 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,11.5 C13,10.9477153 12.5522847,10.5 12,10.5 Z M12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 Z"
    });
  },
  Info: function Info(_ref67) {
    var color = _ref67.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25,43.606602 C 35.276143,43.606602 43.606602,35.276143 43.606602,25 43.606602,14.723858 35.276143,6.3933984 25,6.3933984 14.723858,6.3933984 6.3933984,14.723858 6.3933984,25 6.3933984,35.276143 14.723858,43.606602 25,43.606602 Z m 0,4.65165 C 12.154822,48.258252 1.741748,37.845178 1.741748,25 1.741748,12.154822 12.154822,1.741748 25,1.741748 37.845178,1.741748 48.258252,12.154822 48.258252,25 48.258252,37.845178 37.845178,48.258252 25,48.258252 Z m 0,-26.74699 c -1.284518,0 -2.325825,1.041308 -2.325825,2.325826 v 9.3033 c 0,1.284518 1.041307,2.325826 2.325825,2.325826 1.284518,0 2.325825,-1.041308 2.325825,-2.325826 v -9.3033 c 0,-1.284518 -1.041307,-2.325826 -2.325825,-2.325826 z m 0,-8.140388 c -1.284518,0 -2.325825,1.041307 -2.325825,2.325825 0,1.284518 1.041307,2.325825 2.325825,2.325825 1.284518,0 2.325825,-1.041307 2.325825,-2.325825 0,-1.284518 -1.041307,-2.325825 -2.325825,-2.325825 z"
    });
  },
  InfoSerif: function InfoSerif(_ref68) {
    var color = _ref68.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 24 24
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "M12 1.55a10.45 10.45 0 1 0 0 20.9 10.45 10.45 0 0 0 0-20.9ZM0 12a12 12 0 1 1 24 0 12 12 0 0 1-24 0Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "M10.03 11.06c0-.57.46-1.03 1.03-1.03H12c.57 0 1.03.46 1.03 1.03v5.53a1.03 1.03 0 0 1-.1 2.06H12c-.57 0-1.03-.47-1.03-1.04V12.1a1.03 1.03 0 0 1-.94-1.03Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M11.77 8.26a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z"
      }))
    );
  },
  InProcess: function InProcess(_ref69) {
    var color = _ref69.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20,0 C30.4808148,0 39.1040701,8.10380826 39.9345012,18.3735615 L43.2760286,13.7763 C43.5717429,13.3713 44.1631714,13.2663 44.5960286,13.5403 C45.0321,13.8153 45.1446,14.3673 44.8499571,14.7723 L40.0885286,21.3173 C39.9471,21.5133 39.7274571,21.6463 39.4810286,21.6913 C39.4210286,21.7013 39.3621,21.7073 39.3021,21.7073 C39.1124571,21.7073 38.9260286,21.6543 38.7674571,21.5543 L31.7560286,17.1073 C31.3221,16.8323 31.2085286,16.2793 31.5042429,15.8743 C31.7999571,15.4713 32.3913857,15.3643 32.8253143,15.6393 L38.1835663,19.0373727 C37.6814015,9.44278227 29.7174848,1.79231002 20,1.79231002 C9.95963266,1.79231002 1.79130084,9.95963266 1.79130084,20 C1.79130084,30.0403673 9.95963266,38.2086992 20,38.2086992 C26.058129,38.2086992 31.7024927,35.2073872 35.0994046,30.1806439 C35.3759209,29.7699061 35.931981,29.6629327 36.3427187,29.939449 C36.7534565,30.2169745 36.8604299,30.7730346 36.5839136,31.1837723 C32.852962,36.7029973 26.6535473,40 20,40 C8.97164194,40 1.24344979e-13,31.0273489 1.24344979e-13,20 C1.24344979e-13,8.97265113 8.97164194,0 20,0 Z M19.1484,7.0913 C19.6384,7.0913 20.0354,7.4883 20.0354,7.9783 L20.0354,19.4983 L25.7314,26.3773 C26.0434,26.7543 25.9904,27.3133 25.6124,27.6263 C25.4474,27.7633 25.2474,27.8303 25.0484,27.8303 C24.7924,27.8303 24.5394,27.7213 24.3634,27.5083 L18.4644,20.3833 C18.3324,20.2253 18.2604,20.0243 18.2604,19.8173 L18.2604,7.9783 C18.2604,7.4883 18.6574,7.0913 19.1484,7.0913 Z"
    });
  },
  Instagram: function Instagram(_ref70) {
    var color = _ref70.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.0000179,3 C14.4442532,3 14.7507428,3.01036041 15.7106885,3.05415994 C16.6686336,3.0978523 17.3228757,3.25000744 17.895342,3.47250621 C18.4871715,3.70247161 18.9890799,4.01021155 19.489452,4.51054797 C19.9897884,5.01092011 20.2975284,5.51282845 20.5275295,6.10465802 C20.7499926,6.67712433 20.9021477,7.33136644 20.9458401,8.28931151 C20.9896396,9.24925721 21,9.55574675 21,12.0000179 C21,14.4442532 20.9896396,14.7507428 20.9458401,15.7106885 C20.9021477,16.6686336 20.7499926,17.3228757 20.5275295,17.895342 C20.2975284,18.4871715 19.9897884,18.9890799 19.489452,19.489452 C18.9890799,19.9897884 18.4871715,20.2975284 17.895342,20.5275295 C17.3228757,20.7499926 16.6686336,20.9021477 15.7106885,20.9458401 C14.7507428,20.9896396 14.4442532,21 12.0000179,21 C9.55574675,21 9.24925721,20.9896396 8.28931151,20.9458401 C7.33136644,20.9021477 6.67712433,20.7499926 6.10465802,20.5275295 C5.51282845,20.2975284 5.01092011,19.9897884 4.51054797,19.489452 C4.01021155,18.9890799 3.70247161,18.4871715 3.47250621,17.895342 C3.25000744,17.3228757 3.0978523,16.6686336 3.05415994,15.7106885 C3.01036041,14.7507428 3,14.4442532 3,12.0000179 C3,9.55574675 3.01036041,9.24925721 3.05415994,8.28931151 C3.0978523,7.33136644 3.25000744,6.67712433 3.47250621,6.10465802 C3.70247161,5.51282845 4.01021155,5.01092011 4.51054797,4.51054797 C5.01092011,4.01021155 5.51282845,3.70247161 6.10465802,3.47250621 C6.67712433,3.25000744 7.33136644,3.0978523 8.28931151,3.05415994 C9.24925721,3.01036041 9.55574675,3 12.0000179,3 Z M12.0000179,4.62161872 C9.59690259,4.62161872 9.31224136,4.63080019 8.36322768,4.67409957 C7.48573657,4.71411219 7.00919338,4.86072987 6.69205761,4.98398304 C6.2719608,5.14724883 5.97215193,5.34227465 5.65723115,5.65723115 C5.34227465,5.97215193 5.14724883,6.2719608 4.98398304,6.69205761 C4.86072987,7.00919338 4.71411219,7.48573657 4.67409957,8.36322768 C4.63080019,9.31224136 4.62161872,9.59690259 4.62161872,12.0000179 C4.62161872,14.4030974 4.63080019,14.6877586 4.67409957,15.6367723 C4.71411219,16.5142634 4.86072987,16.9908066 4.98398304,17.3079424 C5.14724883,17.7280392 5.34231037,18.0278481 5.65723115,18.3427688 C5.97215193,18.6577254 6.2719608,18.8527512 6.69205761,19.016017 C7.00919338,19.1392701 7.48573657,19.2858878 8.36322768,19.3259004 C9.31213419,19.3691998 9.59672397,19.3783813 12.0000179,19.3783813 C14.403276,19.3783813 14.6879015,19.3691998 15.6367723,19.3259004 C16.5142634,19.2858878 16.9908066,19.1392701 17.3079424,19.016017 C17.7280392,18.8527512 18.0278481,18.6577254 18.3427688,18.3427688 C18.6577254,18.0278481 18.8527512,17.7280392 19.016017,17.3079424 C19.1392701,16.9908066 19.2858878,16.5142634 19.3259004,15.6367723 C19.3691998,14.6877586 19.3783813,14.4030974 19.3783813,12.0000179 C19.3783813,9.59690259 19.3691998,9.31224136 19.3259004,8.36322768 C19.2858878,7.48573657 19.1392701,7.00919338 19.016017,6.69205761 C18.8527512,6.2719608 18.6577254,5.97215193 18.3427688,5.65723115 C18.0278481,5.34227465 17.7280392,5.14724883 17.3079424,4.98398304 C16.9908066,4.86072987 16.5142634,4.71411219 15.6367723,4.67409957 C14.6877586,4.63080019 14.4030974,4.62161872 12.0000179,4.62161872 Z M12.0000179,7.37838128 C14.552466,7.37838128 16.6216187,9.44753404 16.6216187,12.0000179 C16.6216187,14.552466 14.552466,16.6216187 12.0000179,16.6216187 C9.44753404,16.6216187 7.37838128,14.552466 7.37838128,12.0000179 C7.37838128,9.44753404 9.44753404,7.37838128 12.0000179,7.37838128 Z M12.0000179,15 C13.656862,15 15,13.656862 15,12.0000179 C15,10.343138 13.656862,9 12.0000179,9 C10.343138,9 9,10.343138 9,12.0000179 C9,13.656862 10.343138,15 12.0000179,15 Z M17.8842313,7.19578796 C17.8842313,7.79226184 17.4006859,8.27577152 16.804212,8.27577152 C16.2077739,8.27577152 15.7242285,7.79226184 15.7242285,7.19578796 C15.7242285,6.59931407 16.2077739,6.11576867 16.804212,6.11576867 C17.4006859,6.11576867 17.8842313,6.59931407 17.8842313,7.19578796 Z"
    });
  },
  LeftArrow: function LeftArrow(_ref71) {
    var color = _ref71.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 32.501065,34.688875 c 0.975138,0.975139 0.950134,2.575366 0,3.550504 -0.975139,0.975138 -2.550362,0.975138 -3.525501,0 L 17.498936,26.762751 c -0.975139,-0.975139 -0.975139,-2.550362 0,-3.525501 L 28.975564,11.760622 c 0.975139,-0.975139 2.550362,-0.975139 3.525501,0 0.975138,0.975138 0.975138,2.550361 0,3.5255 l -9.701377,9.701377 z"
    });
  },
  LeftUp: function LeftUp(_ref72) {
    var color = _ref72.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M9,10.4142136 L9,15 C9,15.5522847 8.55228475,16 8,16 C7.44771525,16 7,15.5522847 7,15 L7,8 C7,7.44771525 7.44771525,7 8,7 L15,7 C15.5522847,7 16,7.44771525 16,8 C16,8.55228475 15.5522847,9 15,9 L10.4142136,9 L16.7071068,15.2928932 C17.0976311,15.6834175 17.0976311,16.3165825 16.7071068,16.7071068 C16.3165825,17.0976311 15.6834175,17.0976311 15.2928932,16.7071068 L9,10.4142136 Z"
    });
  },
  LineChart: function LineChart(_ref73) {
    var color = _ref73.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "m5.3 45.5a1.61 1.61 0 0 0 0.9 0.3 1.43 1.43 0 0 0 1.2-0.6l9-12.3 7 6.5a1.59 1.59 0 0 0 1.2 0.4 1.74 1.74 0 0 0 1.1-0.6l8.3-11.2 3.6 7.4a1.35 1.35 0 0 0 1.5 0.8 1.63 1.63 0 0 0 1.3-1.1l9.7-33.1a1.58 1.58 0 0 0-1-1.9 1.58 1.58 0 0 0-1.9 1l-8.6 29.4-3-6.2a1.3 1.3 0 0 0-1.2-0.8 1.61 1.61 0 0 0-1.3 0.6l-8.7 11.8-7-6.5a1.59 1.59 0 0 0-1.2-0.4 1.74 1.74 0 0 0-1.1 0.6l-10.1 13.8a1.46 1.46 0 0 0 0.3 2.1zm43.2 1.5h-44a1.54 1.54 0 0 1-1.5-1.5v-44a1.54 1.54 0 0 0-1.5-1.5 1.54 1.54 0 0 0-1.5 1.5v44a4.48 4.48 0 0 0 4.5 4.5h44a1.5 1.5 0 0 0 0-3z"
    });
  },
  Link: function Link(_ref74) {
    var color = _ref74.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 6.4018968,23.566569 c 0.6473559,-3.398618 3.8378962,-5.733724 7.3058742,-5.733724 h 6.774117 c 1.202233,0 2.196386,-0.994153 2.196386,-2.196386 v 0 c 0,-1.202232 -0.994153,-2.196386 -2.196386,-2.196386 h -6.542919 c -6.0342817,0 -11.4212077,4.415892 -11.9992041,10.427054 -0.6704757,6.889717 4.7395701,12.6928 11.4905681,12.6928 h 7.051555 c 1.202233,0 2.196386,-0.994154 2.196386,-2.196386 v 0 c 0,-1.202232 -0.994153,-2.196386 -2.196386,-2.196386 h -7.051555 c -4.4158927,0 -7.9069907,-4.022855 -7.0284362,-8.600586 z m 11.6524062,3.745416 h 13.871913 c 1.271592,0 2.311985,-1.040393 2.311985,-2.311985 v 0 c 0,-1.271592 -1.040393,-2.311985 -2.311985,-2.311985 H 18.054303 c -1.271592,0 -2.311985,1.040393 -2.311985,2.311985 v 0 c 0,1.271592 1.040393,2.311985 2.311985,2.311985 z M 36.04155,13.440073 h -6.542919 c -1.202232,0 -2.196386,0.994154 -2.196386,2.196386 v 0 c 0,1.202233 0.994154,2.196386 2.196386,2.196386 h 6.774118 c 3.467978,0 6.658518,2.335106 7.305873,5.733724 0.878555,4.577731 -2.612543,8.600586 -7.028435,8.600586 h -7.051556 c -1.202232,0 -2.196386,0.994154 -2.196386,2.196386 v 0 c 0,1.202232 0.994154,2.196386 2.196386,2.196386 h 7.051556 c 6.750997,0 12.161043,-5.803083 11.513687,-12.6928 C 47.485878,17.855965 42.075832,13.440073 36.04155,13.440073 Z"
    });
  },
  Linkedin: function Linkedin(_ref75) {
    var color = _ref75.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M7.53439798,19.9999996 L7.53439798,9.56759745 L4.32438473,9.56759745 L4.32438473,19.9999996 L7.53439798,19.9999996 L7.53439798,19.9999996 Z M12.7713547,20 L9.54495313,20 C9.54495313,20 9.59135892,10.503372 9.54495313,9.50464178 L12.7710411,9.50464178 L12.7478383,10.899932 C13.2109556,10.1736399 14.0450059,9.1065638 15.9451357,9.1065638 C18.2626042,9.1065638 20,10.6278087 20,13.8970679 L20,20 L16.7683223,19.9999999 L16.7683223,14.0561214 C16.7683223,12.6255842 15.9689657,11.8989773 14.6943738,11.8989773 C13.7214195,11.8989773 13.1419741,12.5572385 12.8873692,13.1931378 C12.7942441,13.4199071 12.7713547,13.7380143 12.7713547,14.0561215 L12.7713547,20 Z M5.91549304,7.83098607 C4.85759544,7.83098607 4,6.97339063 4,5.91549304 C4,4.85759544 4.85759544,4 5.91549304,4 C6.97339063,4 7.83098607,4.85759544 7.83098607,5.91549304 C7.83098607,6.97339063 6.97339063,7.83098607 5.91549304,7.83098607 Z"
    });
  },
  // viewBox="0 0 40 40"
  ListView: function ListView(_ref76) {
    var color = _ref76.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 12.603516 -0.08984375 L 12.603516 11.431641 L 40.089844 11.431641 L 40.089844 -0.08984375 L 12.603516 -0.08984375 z M 0.17773438 -0.044921875 L 0.17773438 11.476562 L 11.382812 11.476562 L 11.382812 -0.044921875 L 0.17773438 -0.044921875 z M 12.603516 14.224609 L 12.603516 25.746094 L 40.089844 25.746094 L 40.089844 14.224609 L 12.603516 14.224609 z M 0.17773438 14.269531 L 0.17773438 25.791016 L 11.382812 25.791016 L 11.382812 14.269531 L 0.17773438 14.269531 z M 12.648438 28.539062 L 12.648438 40.060547 L 40.132812 40.060547 L 40.132812 28.539062 L 12.648438 28.539062 z M 0.22265625 28.582031 L 0.22265625 40.105469 L 11.427734 40.105469 L 11.427734 28.582031 L 0.22265625 28.582031 z"
    });
  },
  Loading: function Loading(_ref77) {
    var color = _ref77.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 3.0924955,25 c 0,-1.344354 1.0898138,-2.434167 2.4341672,-2.434167 1.3443534,0 2.4341672,1.089813 2.4341672,2.434167 0,4.582754 1.8142368,8.872092 4.9906571,12.048513 C 16.127908,40.224933 20.417245,42.03917 25,42.03917 34.410474,42.03917 42.03917,34.410474 42.03917,25 42.03917,15.589526 34.410474,7.9608299 25,7.9608299 c -2.269744,0 -4.473578,0.4426883 -6.521456,1.2918659 -1.241824,0.5149373 -2.66596,-0.07432 -3.180897,-1.316144 C 14.782709,6.6947283 15.371967,5.2705922 16.613791,4.755655 19.250243,3.6624177 22.087486,3.0924955 25,3.0924955 c 12.099181,0 21.907505,9.8083235 21.907505,21.9075045 0,12.099181 -9.808324,21.907505 -21.907504,21.907505 -5.887189,0 -11.410586,-2.3362 -15.4909459,-6.416559 C 5.4286953,36.410585 3.0924955,30.887188 3.0924955,25 Z"
    }, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 25 25",
      to: "360 25 25",
      dur: "0.8s",
      repeatCount: "indefinite"
    }));
  },
  Loading2: function Loading2(_ref78) {
    var color = _ref78.color;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
      cx: "5",
      cy: "12",
      r: "2",
      fill: color
    }, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      dur: "1s",
      type: "translate",
      values: "0 4 ; 0 -4; 0 4",
      repeatCount: "indefinite",
      begin: "0.1"
    })), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "2",
      fill: color
    }, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      dur: "1s",
      type: "translate",
      values: "0 3 ; 0 -3; 0 3",
      repeatCount: "indefinite",
      begin: "0.2"
    })), /*#__PURE__*/React.createElement("circle", {
      cx: "19",
      cy: "12",
      r: "2",
      fill: color
    }, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      dur: "1s",
      type: "translate",
      values: "0 2 ; 0 -2; 0 2",
      repeatCount: "indefinite",
      begin: "0.3"
    })));
  },
  Loading3: function Loading3(_ref79) {
    var color = _ref79.color;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
      cx: "5",
      cy: "12",
      r: "2",
      fill: color
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.1"
    })), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "2",
      fill: color
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.2"
    })), /*#__PURE__*/React.createElement("circle", {
      cx: "19",
      cy: "12",
      r: "2",
      fill: color
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.3"
    })));
  },
  Loading4: function Loading4(_ref80) {
    var color = _ref80.color;
    return (
      /*#__PURE__*/
      // viewBox="0 0 18 4"
      React.createElement("g", {
        fill: color
      }, /*#__PURE__*/React.createElement("circle", {
        cx: "2",
        cy: "2",
        r: "2"
      }, /*#__PURE__*/React.createElement("animate", {
        attributeName: "opacity",
        dur: "1s",
        values: "0;1;0",
        repeatCount: "indefinite",
        begin: "0.1"
      })), /*#__PURE__*/React.createElement("circle", {
        cx: "9",
        cy: "2",
        r: "2"
      }, /*#__PURE__*/React.createElement("animate", {
        attributeName: "opacity",
        dur: "1s",
        values: "0;1;0",
        repeatCount: "indefinite",
        begin: "0.2"
      })), /*#__PURE__*/React.createElement("circle", {
        cx: "16",
        cy: "2",
        r: "2"
      }, /*#__PURE__*/React.createElement("animate", {
        attributeName: "opacity",
        dur: "1s",
        values: "0;1;0",
        repeatCount: "indefinite",
        begin: "0.3"
      })))
    );
  },
  LocationSolid: function LocationSolid(_ref81) {
    var color = _ref81.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.7190978,22.811 C5.90636593,18.8635961 3,14.5932627 3,9.99999987 C3.00000007,5.02943717 7.0294373,1 12,1 C16.9705627,1 20.9999999,5.02943717 21,9.99999987 C21,14.5932656 18.0936304,18.8636014 12.2808913,22.8110074 C12.1113248,22.9261486 11.8886593,22.9261485 11.7190978,22.811 Z M12,13 C13.6568542,13 15,11.6568542 15,10 C15,8.34314575 13.6568542,7 12,7 C10.3431458,7 9,8.34314575 9,10 C9,11.6568542 10.3431458,13 12,13 Z"
    });
  },
  Location: function Location(_ref82) {
    var color = _ref82.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 25,25.110832 c 2.499301,0 4.525382,-1.93385 4.525382,-4.319377 0,-2.385525 -2.026081,-4.319376 -4.525382,-4.319376 -2.499297,0 -4.525381,1.933851 -4.525381,4.319376 0,2.385527 2.026084,4.319377 4.525381,4.319377 z M 24.364406,48.459221 C 11.211991,39.934059 4.635784,30.71147 4.635784,20.791455 4.6357842,10.05659 13.753154,1.3542623 25,1.3542623 c 11.246847,0 20.364216,8.7023277 20.364216,19.4371927 0,9.920022 -6.576216,19.142616 -19.728647,27.667781 -0.383674,0.248671 -0.887499,0.248671 -1.271163,-1.5e-5 z M 40.838834,20.791455 C 40.838834,12.442115 33.747547,5.6736387 25,5.6736387 c -8.747546,0 -15.8388345,6.7684763 -15.8388347,15.1178163 0,7.82783 5.1142197,15.425938 15.8388347,22.820287 C 35.724616,36.217393 40.838834,28.619285 40.838834,20.791455 Z M 25,29.43021 c -4.998598,0 -9.050762,-3.867704 -9.050762,-8.638755 0,-4.771051 4.052164,-8.638752 9.050762,-8.638752 4.998599,0 9.050763,3.867701 9.050763,8.638752 0,4.771051 -4.052164,8.638755 -9.050763,8.638755 z"
    });
  },
  LoFreq: function LoFreq(_ref83) {
    var color = _ref83.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 12 10
      React.createElement("g", {
        fill: "rgba(0,0,0,0)"
      }, /*#__PURE__*/React.createElement("rect", {
        width: "11.3",
        height: "9.3",
        x: ".35",
        y: ".35",
        stroke: color,
        strokeWidth: ".7",
        rx: ".65"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.85 2.94c-.31.35-.7 1.02-1.14 2.17a.37.37 0 0 1-.47.2c-.19-.06-.29-.25-.22-.42A8.22 8.22 0 0 1 3.3 2.52c.2-.23.42-.4.67-.47a.97.97 0 0 1 .74.06c.2.1.38.28.53.46.14.2.28.42.4.66.25.49.48 1.08.7 1.65h.01c.23.59.45 1.15.68 1.6.12.23.23.41.35.56.11.15.2.23.28.27.06.03.1.03.16.01a.85.85 0 0 0 .34-.26c.31-.35.7-1.02 1.14-2.17a.37.37 0 0 1 .47-.2c.19.06.29.25.22.42A8.22 8.22 0 0 1 8.7 7.48c-.2.23-.42.4-.67.47a.97.97 0 0 1-.74-.06c-.2-.1-.38-.28-.53-.46a4.28 4.28 0 0 1-.4-.66 18.8 18.8 0 0 1-.7-1.65h-.01c-.23-.59-.45-1.15-.68-1.6a3.64 3.64 0 0 0-.35-.56.94.94 0 0 0-.28-.27.18.18 0 0 0-.16-.01.85.85 0 0 0-.34.26z"
      }))
    );
  },
  HiFreq: function HiFreq(_ref84) {
    var color = _ref84.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 12 10
      React.createElement("g", {
        fill: "rgba(0,0,0,0)"
      }, /*#__PURE__*/React.createElement("path", {
        fill: color,
        clipRule: "evenodd",
        fillRule: "evenodd",
        d: "M2.96 3.23c-.09.4-.19 1-.3 1.81A.33.33 0 0 1 2 4.96c.16-1.16.3-1.9.42-2.33l.1-.28a.74.74 0 0 1 .16-.23.41.41 0 0 1 .4-.1c.14.04.22.14.26.2.08.12.13.3.18.46a44.51 44.51 0 0 1 .37 2.27 44.09 44.09 0 0 0 .26 1.82c.1-.4.19-1 .3-1.81.15-1.16.29-1.9.41-2.33l.1-.28a.74.74 0 0 1 .16-.23.41.41 0 0 1 .4-.1c.14.04.22.14.26.2a4.5 4.5 0 0 1 .31 1.1c.09.48.16 1.06.24 1.63a44.11 44.11 0 0 0 .27 1.82c.09-.4.18-1 .3-1.81.14-1.16.28-1.9.4-2.33l.11-.28a.74.74 0 0 1 .16-.23.41.41 0 0 1 .4-.1c.14.04.22.14.26.2.08.12.13.3.18.46l.13.64c.08.48.16 1.06.23 1.63a44.11 44.11 0 0 0 .27 1.82c.09-.4.19-1 .3-1.81a.33.33 0 0 1 .66.08c-.16 1.16-.3 1.9-.42 2.33l-.1.28a.74.74 0 0 1-.16.23.41.41 0 0 1-.4.1.48.48 0 0 1-.26-.2c-.08-.12-.13-.3-.18-.46-.05-.18-.09-.4-.13-.64l-.24-1.63a44.09 44.09 0 0 0-.26-1.82c-.1.4-.19 1-.3 1.81-.15 1.16-.29 1.9-.41 2.33l-.1.28a.74.74 0 0 1-.16.23.41.41 0 0 1-.4.1.48.48 0 0 1-.26-.2 4.5 4.5 0 0 1-.31-1.1c-.09-.48-.16-1.06-.24-1.63a44.11 44.11 0 0 0-.27-1.82c-.09.4-.18 1-.3 1.81-.14 1.16-.28 1.9-.4 2.33l-.11.28a.74.74 0 0 1-.16.23.41.41 0 0 1-.4.1.48.48 0 0 1-.26-.2c-.08-.12-.13-.3-.18-.46l-.13-.64c-.08-.48-.16-1.06-.23-1.63a44.11 44.11 0 0 0-.27-1.82zm-.18-.64zm2.45 0zm2.44 0zM9.22 7.4zm-2.45 0zm-2.44 0z"
      }), /*#__PURE__*/React.createElement("rect", {
        width: "11.3",
        height: "9.3",
        x: ".35",
        y: ".35",
        stroke: color,
        strokeWidth: ".7",
        rx: ".65"
      }))
    );
  },
  Logout: function Logout(_ref85) {
    var color = _ref85.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 4.15625,0 C 1.8757181,-0.00865486 -0.00865486,1.8757181 0,4.15625 v 6.462891 a 1.5,1.5 0 0 0 1.5,1.5 1.5,1.5 0 0 0 1.5,-1.5 V 4.1503906 a 1.50015,1.50015 0 0 0 0,-0.00586 C 2.9975287,3.4933577 3.4933577,2.9975287 4.1445312,3 a 1.50015,1.50015 0 0 0 0.00586,0 H 45.849609 a 1.50015,1.50015 0 0 0 0.0059,0 C 46.506642,2.9975287 47.002471,3.4933577 47,4.1445312 a 1.50015,1.50015 0 0 0 0,0.00586 V 45.849609 a 1.50015,1.50015 0 0 0 0,0.0059 C 47.002471,46.506642 46.506642,47.002471 45.855469,47 a 1.50015,1.50015 0 0 0 -0.0059,0 H 4.1503906 a 1.50015,1.50015 0 0 0 -0.00586,0 C 3.4933577,47.002471 2.9975287,46.506642 3,45.855469 a 1.50015,1.50015 0 0 0 0,-0.0059 v -6.46875 a 1.5,1.5 0 0 0 -1.5,-1.5 1.5,1.5 0 0 0 -1.5,1.5 V 45.84375 C -0.00865486,48.124282 1.8757181,50.008655 4.15625,50 h 41.6875 C 48.124282,50.008655 50.008655,48.124282 50,45.84375 V 4.15625 C 50.008655,1.8757181 48.124282,-0.00865486 45.84375,0 Z M 17.751953,9.1308594 A 1.5,1.5 0 0 0 16.748047,9.5703125 1.5,1.5 0 0 0 16.75,11.691406 L 28.566406,23.5 H 1.5 A 1.5,1.5 0 0 0 0,25 1.5,1.5 0 0 0 1.5,26.5 H 28.568359 L 16.75,38.320312 a 1.5,1.5 0 0 0 0,2.121094 1.5,1.5 0 0 0 2.121094,0 L 33.21875,26.091797 a 1.5,1.5 0 0 0 0.03125,-0.03125 1.5,1.5 0 0 0 0.06055,-0.0625 1.5,1.5 0 0 0 0.0098,-0.01172 1.50015,1.50015 0 0 0 0.03711,-0.04492 1.50015,1.50015 0 0 0 0.05078,-0.06641 1.50015,1.50015 0 0 0 0.01172,-0.01563 1.5,1.5 0 0 0 0.02539,-0.03906 1.50015,1.50015 0 0 0 0.0039,-0.0039 1.5,1.5 0 0 0 0.04687,-0.08008 1.5,1.5 0 0 0 0.002,-0.0039 1.50015,1.50015 0 0 0 0.02734,-0.05078 1.5,1.5 0 0 0 0.01953,-0.03906 1.50015,1.50015 0 0 0 0.002,-0.0059 1.5,1.5 0 0 0 0.03906,-0.08984 1.5,1.5 0 0 0 0.03125,-0.08398 1.5,1.5 0 0 0 0.0039,-0.01367 1.50015,1.50015 0 0 0 0.01563,-0.05469 1.5,1.5 0 0 0 0.002,-0.0078 1.50015,1.50015 0 0 0 0.02148,-0.0918 1.50015,1.50015 0 0 0 0.01758,-0.0957 1.50015,1.50015 0 0 0 0,-0.0059 1.5,1.5 0 0 0 0,-0.0039 1.50015,1.50015 0 0 0 0.0078,-0.08398 1.50015,1.50015 0 0 0 0.002,-0.01563 1.5,1.5 0 0 0 0.002,-0.04492 1.50015,1.50015 0 0 0 0,-0.04492 1.50015,1.50015 0 0 0 -0.0039,-0.103516 1.50015,1.50015 0 0 0 -0.0078,-0.08398 1.50015,1.50015 0 0 0 -0.002,-0.01758 1.5,1.5 0 0 0 -0.0098,-0.05664 1.5,1.5 0 0 0 -0.01758,-0.08398 1.5,1.5 0 0 0 -0.0039,-0.01758 1.50015,1.50015 0 0 0 -0.01172,-0.04297 1.5,1.5 0 0 0 0,-0.002 1.50015,1.50015 0 0 0 -0.03125,-0.09375 1.50015,1.50015 0 0 0 0,-0.0039 1.5,1.5 0 0 0 -0.01953,-0.05273 1.50015,1.50015 0 0 0 -0.01758,-0.04297 1.5,1.5 0 0 0 -0.02344,-0.05078 1.50015,1.50015 0 0 0 -0.02148,-0.04102 1.5,1.5 0 0 0 -0.02734,-0.05078 1.50015,1.50015 0 0 0 -0.02344,-0.03906 1.5,1.5 0 0 0 -0.03125,-0.04883 1.50015,1.50015 0 0 0 -0.02539,-0.03711 1.5,1.5 0 0 0 -0.0059,-0.0078 1.50015,1.50015 0 0 0 -0.05078,-0.06836 1.50015,1.50015 0 0 0 -0.0059,-0.0059 1.5,1.5 0 0 0 -0.03711,-0.04297 1.50015,1.50015 0 0 0 -0.03125,-0.0332 1.5,1.5 0 0 0 -0.07227,-0.07422 L 18.871094,9.5683594 a 1.5,1.5 0 0 0 -1.119141,-0.4375 z"
    });
  },
  LongLeft: function LongLeft(_ref86) {
    var color = _ref86.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 22.214844 6.3359375 A 2 2 0 0 0 20.880859 6.890625 L 3.6308594 23.375 A 2.0002 2.0002 0 0 0 3.6210938 23.384766 A 2 2 0 0 0 3.6152344 23.390625 A 2.0002 2.0002 0 0 0 3.5488281 23.460938 A 2 2 0 0 0 3.5332031 23.476562 A 2.0002 2.0002 0 0 0 3.4707031 23.548828 A 2 2 0 0 0 3.4199219 23.615234 A 2.0002 2.0002 0 0 0 3.3964844 23.644531 A 2 2 0 0 0 3.3847656 23.662109 A 2.0002 2.0002 0 0 0 3.328125 23.746094 A 2 2 0 0 0 3.3007812 23.789062 A 2.0002 2.0002 0 0 0 3.2578125 23.863281 A 2.0002 2.0002 0 0 0 3.2109375 23.955078 A 2 2 0 0 0 3.1875 24.003906 A 2.0002 2.0002 0 0 0 3.1640625 24.056641 A 2 2 0 0 0 3.15625 24.078125 A 2.0002 2.0002 0 0 0 3.1230469 24.169922 A 2 2 0 0 0 3.0957031 24.255859 A 2.0002 2.0002 0 0 0 3.0859375 24.291016 A 2 2 0 0 0 3.0742188 24.332031 A 2.0002 2.0002 0 0 0 3.0585938 24.398438 A 2 2 0 0 0 3.0546875 24.419922 A 2.0002 2.0002 0 0 0 3.0351562 24.521484 A 2 2 0 0 0 3.0273438 24.59375 A 2.0002 2.0002 0 0 0 3.0214844 24.644531 A 2 2 0 0 0 3.0175781 24.6875 A 2.0002 2.0002 0 0 0 3.0136719 24.773438 A 2 2 0 0 0 3.0117188 24.822266 A 2 2 0 0 0 3.0136719 24.869141 A 2 2 0 0 0 3.0195312 24.974609 A 2.0002 2.0002 0 0 0 3.0253906 25.03125 A 2 2 0 0 0 3.0292969 25.074219 A 2.0002 2.0002 0 0 0 3.0449219 25.177734 A 2.0002 2.0002 0 0 0 3.0625 25.265625 A 2 2 0 0 0 3.0761719 25.322266 A 2.0002 2.0002 0 0 0 3.0859375 25.359375 A 2 2 0 0 0 3.1152344 25.453125 A 2 2 0 0 0 3.15625 25.5625 A 2.0002 2.0002 0 0 0 3.1582031 25.568359 A 2 2 0 0 0 3.1953125 25.65625 A 2.0002 2.0002 0 0 0 3.2246094 25.716797 A 2 2 0 0 0 3.2382812 25.744141 A 2.0002 2.0002 0 0 0 3.2929688 25.841797 A 2.0002 2.0002 0 0 0 3.3398438 25.917969 A 2 2 0 0 0 3.3691406 25.962891 A 2.0002 2.0002 0 0 0 3.4121094 26.019531 A 2 2 0 0 0 3.4511719 26.072266 A 2.0002 2.0002 0 0 0 3.4570312 26.078125 A 2 2 0 0 0 3.5195312 26.152344 A 2.0002 2.0002 0 0 0 3.5664062 26.203125 A 2 2 0 0 0 3.59375 26.230469 A 2.0002 2.0002 0 0 0 3.6035156 26.242188 A 2 2 0 0 0 3.6660156 26.302734 L 20.587891 43.083984 A 2 2 0 0 0 23.416016 43.070312 A 2 2 0 0 0 23.404297 40.242188 L 9.8710938 26.822266 L 44.986328 26.822266 A 2 2 0 0 0 46.986328 24.822266 A 2 2 0 0 0 44.986328 22.822266 L 9.9980469 22.822266 L 23.644531 9.78125 A 2 2 0 0 0 23.708984 6.9550781 A 2 2 0 0 0 22.214844 6.3359375 z"
    });
  },
  LongRight: function LongRight(_ref87) {
    var color = _ref87.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 27.783203,6.3359375 A -2,2 0 0 1 29.117188,6.890625 L 46.367187,23.375 a -2.0002,2.0002 0 0 1 0.0098,0.0098 -2,2 0 0 1 0.0059,0.0059 -2.0002,2.0002 0 0 1 0.06641,0.07031 -2,2 0 0 1 0.01563,0.01562 -2.0002,2.0002 0 0 1 0.0625,0.07227 -2,2 0 0 1 0.05078,0.06641 -2.0002,2.0002 0 0 1 0.02344,0.0293 -2,2 0 0 1 0.01172,0.01758 -2.0002,2.0002 0 0 1 0.05664,0.08398 -2,2 0 0 1 0.02734,0.04297 -2.0002,2.0002 0 0 1 0.04297,0.07422 -2.0002,2.0002 0 0 1 0.04687,0.0918 -2,2 0 0 1 0.02344,0.04883 -2.0002,2.0002 0 0 1 0.02344,0.05273 -2,2 0 0 1 0.0078,0.02148 -2.0002,2.0002 0 0 1 0.0332,0.0918 -2,2 0 0 1 0.02734,0.08594 -2.0002,2.0002 0 0 1 0.0098,0.03516 -2,2 0 0 1 0.01172,0.04102 -2.0002,2.0002 0 0 1 0.01563,0.06641 -2,2 0 0 1 0.0039,0.02148 -2.0002,2.0002 0 0 1 0.01953,0.101562 -2,2 0 0 1 0.0078,0.07227 -2.0002,2.0002 0 0 1 0.0059,0.05078 -2,2 0 0 1 0.0039,0.04297 -2.0002,2.0002 0 0 1 0.0039,0.08594 -2,2 0 0 1 0.002,0.04883 -2,2 0 0 1 -0.002,0.04687 -2,2 0 0 1 -0.0059,0.105468 -2.0002,2.0002 0 0 1 -0.0059,0.05664 -2,2 0 0 1 -0.0039,0.04297 -2.0002,2.0002 0 0 1 -0.01563,0.103515 -2.0002,2.0002 0 0 1 -0.01758,0.08789 -2,2 0 0 1 -0.01367,0.05664 -2.0002,2.0002 0 0 1 -0.0098,0.03711 -2,2 0 0 1 -0.0293,0.09375 -2,2 0 0 1 -0.04102,0.109375 -2.0002,2.0002 0 0 1 -0.002,0.0059 -2,2 0 0 1 -0.03711,0.08789 -2.0002,2.0002 0 0 1 -0.0293,0.06055 -2,2 0 0 1 -0.01367,0.02734 -2.0002,2.0002 0 0 1 -0.05469,0.09766 -2.0002,2.0002 0 0 1 -0.04687,0.07617 -2,2 0 0 1 -0.0293,0.04492 -2.0002,2.0002 0 0 1 -0.04297,0.05664 -2,2 0 0 1 -0.03906,0.05273 -2.0002,2.0002 0 0 1 -0.0059,0.0059 -2,2 0 0 1 -0.0625,0.07422 -2.0002,2.0002 0 0 1 -0.04687,0.05078 -2,2 0 0 1 -0.02734,0.02734 -2.0002,2.0002 0 0 1 -0.0098,0.01172 -2,2 0 0 1 -0.0625,0.06055 l -16.921875,16.78125 a -2,2 0 0 1 -2.828125,-0.01367 -2,2 0 0 1 0.01172,-2.828124 L 40.126953,26.822266 H 5.0117188 a -2,2 0 0 1 -2,-2 -2,2 0 0 1 2,-2 H 40 L 26.353516,9.78125 a -2,2 0 0 1 -0.06445,-2.8261719 -2,2 0 0 1 1.49414,-0.6191406 z"
    });
  },
  Mail: function Mail(_ref88) {
    var color = _ref88.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M21.99,10 C21.99,9.28 21.62,8.65 21.05,8.3 L12,3 L2.95,8.3 C2.38,8.65 2,9.28 2,10 L2,20 C2,21.1 2.9,22 4,22 L20,22 C21.1,22 22,21.1 22,20 L21.99,10 Z M12,15 L3.74,9.84 L12,5 L20.26,9.84 L12,15 Z"
    });
  },
  MasterCard: function MasterCard() {
    return /*#__PURE__*/React.createElement("g", {
      fill: "none",
      transform: "translate(1 5)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#F79F1A",
      d: "M21.97667,6.78219639 C21.97667,10.5278996 18.9338906,13.5643924 15.1804314,13.5643924 C11.4269722,13.5643924 8.3841919,10.5278996 8.3841919,6.78219639 C8.3841919,3.03649264 11.4269722,0 15.1804314,0 C18.9338906,0 21.97667,3.03649264 21.97667,6.78219639 L21.97667,6.78219639 Z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#EA001B",
      d: "M13.5924781,6.78219639 C13.5924781,10.5278996 10.5496988,13.5643924 6.79623948,13.5643924 C3.04278026,13.5643924 0,10.5278996 0,6.78219639 C0,3.03649264 3.04278026,0 6.79623948,0 C10.5496988,0 13.5924781,3.03649264 13.5924781,6.78219639 L13.5924781,6.78219639 Z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FF5F01",
      d: "M10.9883492,1.44320186 C9.40261474,2.68480141 8.3847202,4.61417194 8.3847202,6.78156091 C8.3847202,8.94894985 9.40261474,10.879793 10.9883492,12.1213926 C12.5740836,10.879793 13.5919782,8.94894985 13.5919782,6.78156091 C13.5919782,4.61417194 12.5740836,2.68480141 10.9883492,1.44320186 L10.9883492,1.44320186 Z"
    }));
  },
  Menu: function Menu(_ref89) {
    var color = _ref89.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 3.6560098,27.667998 C 2.1825147,27.667998 0.988011,26.473495 0.988011,25 c 0,-1.473495 1.1945037,-2.667999 2.6679988,-2.667999 H 46.343991 c 1.473495,0 2.667998,1.194504 2.667998,2.667999 0,1.473495 -1.194503,2.667998 -2.667998,2.667998 z m 0,-16.007992 c -1.4734951,0 -2.6679988,-1.194504 -2.6679988,-2.6679987 0,-1.4734951 1.1945037,-2.6679988 2.6679988,-2.6679988 H 46.343991 c 1.473495,0 2.667998,1.1945037 2.667998,2.6679988 0,1.4734947 -1.194503,2.6679987 -2.667998,2.6679987 z m 0,32.015986 c -1.4734951,0 -2.6679988,-1.194505 -2.6679988,-2.668 0,-1.473495 1.1945037,-2.667997 2.6679988,-2.667997 H 46.343991 c 1.473495,0 2.667998,1.194502 2.667998,2.667997 0,1.473495 -1.194503,2.668 -2.667998,2.668 z"
    });
  },
  Message: function Message(_ref90) {
    var color = _ref90.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 43.556285,8.4623901 H 6.4437148 V 38.528663 l 6.3082822,-5.164748 c 0.833711,-0.682581 1.884612,-1.05639 2.96986,-1.05639 H 43.556285 Z M 45.279369,37.618296 H 15.456768 L 5.0550843,46.286366 C 4.0428411,47.129902 2.5384347,46.993137 1.6948988,45.980894 1.3375942,45.552129 1.1419192,45.011664 1.1419192,44.453538 V 6.7393065 c 0,-1.976468 1.602244,-3.578712 3.578712,-3.578712 H 45.279369 c 1.976467,0 3.578712,1.602244 3.578712,3.578712 V 34.039584 c 0,1.976468 -1.602245,3.578712 -3.578712,3.578712 z"
    });
  },
  Minus: function Minus(_ref91) {
    var color = _ref91.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M6,13 C5.44771525,13 5,12.5522847 5,12 C5,11.4477153 5.44771525,11 6,11 L18,11 C18.5522847,11 19,11.4477153 19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 Z"
    });
  },
  // viewBox 0 0 50 50. color: #D21C1C
  Negative: function Negative(_ref92) {
    var color = _ref92.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M 25,50 C 11.2,50 0,38.8 0,25 0,11.2 11.2,0 25,0 38.8,0 50,11.2 50,25 50,38.8 38.8,50 25,50 Z M 25,2 C 12.3,2 2,12.3 2,25 2,37.7 12.3,48 25,48 37.7,48 48,37.7 48,25 48,12.3 37.7,2 25,2 Z m 14.5,20.4 -28.9,0.1 c -0.5,-0.1 -1,0.3 -1.1,0.9 0,0.1 0,0.1 0,0.2 v 2.7 c -0.1,0.5 0.3,1 0.9,1.1 0.1,0 0.1,0 0.2,0 h 28.9 c 0.5,0.1 1,-0.3 1.1,-0.9 0,-0.1 0,-0.1 0,-0.2 v -2.7 c 0.1,-0.6 -0.4,-1.2 -1.1,-1.2 0,0 0,0 0,0 z"
    });
  },
  NewWindow: function NewWindow(_ref93) {
    var color = _ref93.color;
    return (
      /*#__PURE__*/
      // ViewBox: 0 0 32 40
      React.createElement("path", {
        fill: color,
        d: "M 48.189563,25.000014 V 39.907599 A 8.2819917,8.2819917 0 0 1 39.907572,48.18959 H 10.092402 A 8.2819917,8.2819917 0 0 1 1.8104095,39.907599 V 10.092429 A 8.2819917,8.2819917 0 0 1 10.092402,1.8104375 h 14.907585 a 1.6563983,1.6563983 0 0 1 0,3.3127966 H 10.092402 A 4.969195,4.969195 0 0 0 5.1232062,10.092429 v 29.81517 a 4.969195,4.969195 0 0 0 4.9691958,4.969195 h 29.81517 a 4.969195,4.969195 0 0 0 4.969195,-4.969195 V 25.000014 a 1.6563983,1.6563983 0 0 1 3.312796,0 z M 34.938377,5.1232341 h 7.602868 L 23.823944,23.823971 a 1.6563983,1.6563983 0 0 0 0,2.352085 1.6563983,1.6563983 0 0 0 2.352086,0 L 44.876767,7.4753198 v 7.5863042 a 1.6563983,1.6563983 0 0 0 1.656398,1.656398 v 0 a 1.6563983,1.6563983 0 0 0 1.656398,-1.656398 V 3.4668358 A 1.6563983,1.6563983 0 0 0 47.709208,2.290793 1.6563983,1.6563983 0 0 0 46.533165,1.8104375 H 34.938377 a 1.6563983,1.6563983 0 0 0 0,3.3127966 z"
      })
    );
  },
  // viewBox: 0 0 12 12
  NewWindow2: function NewWindow2(_ref94) {
    var color = _ref94.color;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M11.004 12H.996C.4464 12 0 11.5536 0 11.004V.996C0 .4464.4464 0 .996 0h5.9832c.1992 0 .36.1608.36.36s-.1608.36-.36.36H.996C.8448.72.72.8424.72.996v10.008c0 .1512.1224.276.276.276h10.008c.1512 0 .276-.1224.276-.276V5.0616c0-.1992.1608-.36.36-.36s.36.1608.36.36v5.9448c0 .5496-.4464.996-.996.996V12Zm.636-8.1696c-.1992 0-.36-.1608-.36-.36V.996c0-.1512-.1224-.276-.276-.276H8.65919c-.1992 0-.36-.1608-.36-.36s.1608-.36.36-.36H11.004c.5496 0 .996.4464.996.996v2.4744c0 .1992-.1608.36-.36.36Z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M4.9032 7.5792c-.0912 0-.1848-.036-.2544-.1056-.1416-.1416-.1416-.3696 0-.5088L11.2536.357604c.1416-.1416.3696-.1416.5088 0 .1392.1416.1416.3696 0 .5088L5.1576 7.4736c-.0696.0696-.1632.1056-.2544.1056Z"
    }));
  },
  Next: function Next(_ref95) {
    var color = _ref95.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 25,34.688875 c -0.975138,0.975139 -0.950134,2.575366 0,3.550504 0.975139,0.975138 2.550362,0.975138 3.525501,0 L 40.002128,26.762751 c 0.975139,-0.975139 0.975139,-2.550362 0,-3.525501 L 28.525501,11.760622 c -0.975139,-0.975139 -2.550362,-0.975139 -3.525501,0 -0.975138,0.975138 -0.975138,2.550361 0,3.5255 l 9.701377,9.701377 z m -15.0021284,0 c -0.975139,0.975139 -0.950135,2.575366 0,3.550504 0.9751384,0.975138 2.5503624,0.975138 3.5255004,0 L 25,26.762751 c 0.975139,-0.975139 0.975139,-2.550362 0,-3.525501 L 13.523372,11.760622 c -0.975138,-0.975139 -2.550362,-0.975139 -3.5255004,0 -0.975139,0.975138 -0.975139,2.550361 0,3.5255 l 9.7013764,9.701377 z"
    });
  },
  Notification: function Notification(_ref96) {
    var color = _ref96.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 45.16,36.66 c -5.58,0 -6.5,-9.11 -6.5,-9.17 V 17.66 A 15.89,15.89 0 0 0 38.21,13.53 7.79,7.79 0 0 0 39.7,11.22 8.16,8.16 0 0 0 39.92,5.15 7.59,7.59 0 0 0 35.92,0.69 8,8 0 0 0 25.55,4.3 H 25 c -0.64,0 -6.37,0.11 -10.2,3.94 a 12.81,12.81 0 0 0 -3.46,9.32 v 9.7 c 0,0.09 -1,9.2 -6.51,9.2 a 1.47,1.47 0 0 0 -1.46,1.46 v 5.21 a 1.46,1.46 0 0 0 1.46,1.46 H 16.49 A 9.33,9.33 0 0 0 25,50 9.56,9.56 0 0 0 33.5,44.79 h 11.66 a 1.47,1.47 0 0 0 1.46,-1.46 v -5.21 a 1.45,1.45 0 0 0 -1.46,-1.46 z m -15,8 A 6.74,6.74 0 0 1 25,47.18 6.63,6.63 0 0 1 19.82,44.69 Z M 25.55,11.63 a 7.78,7.78 0 0 0 4.65,4 7.65,7.65 0 0 0 5.55,-0.33 4.79,4.79 0 0 1 0,2.29 v 10.1 0.17 c 0.41,3.15 2,10.49 7.85,11.5 v 2.55 H 6.1 V 39.32 C 13.12,38.09 14,27.6 14,27.49 v -9.83 a 9.62,9.62 0 0 1 2.74,-7.22 c 2.67,-2.75 6.74,-3.16 8,-3.22 a 7.37,7.37 0 0 0 0.81,4.41 z"
    });
  },
  Onboard: function Onboard(_ref97) {
    var color = _ref97.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 31.7,27.7 20.6,20.3 C 20.5,20.2 20.2,20.2 20,20.2 a 1.11,1.11 0 0 0 -1.1,1.1 V 35.9 A 1.11,1.11 0 0 0 20,37 1.49,1.49 0 0 0 20.6,36.9 l 11.1,-7.4 c 0.1,0 0.1,-0.1 0.3,-0.3 A 1.21,1.21 0 0 0 31.7,27.7 Z M 21.1,34 V 23.3 c 0,0 8.1,5.4 8.2,5.3 z M 48,12.5 H 22.2 a 2.06,2.06 0 0 1 -1.7,-1 L 17.1,6 A 2.06,2.06 0 0 0 15.4,5 H 2 A 2,2 0 0 0 0,7 v 36 a 2,2 0 0 0 2,2 h 46 a 2,2 0 0 0 2,-2 V 14.5 a 2,2 0 0 0 -2,-2 z M 47,41 a 0.94,0.94 0 0 1 -1,1 H 4 A 0.94,0.94 0 0 1 3,41 V 9 A 0.94,0.94 0 0 1 4,8 h 10.8 l 3.1,5.1 a 5,5 0 0 0 4.3,2.4 H 46 a 0.94,0.94 0 0 1 1,1 z"
    });
  },
  OnboardingLog: function OnboardingLog(_ref98) {
    var color = _ref98.color;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M34.9482 17.0528H10.0518C9.51425 17.0528 9.08031 16.5672 9.08031 15.9657C9.08031 15.3642 9.51425 14.8786 10.0518 14.8786H34.9482C35.4857 14.8786 35.9197 15.3642 35.9197 15.9657C35.9197 16.5672 35.4857 17.0528 34.9482 17.0528Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M34.9482 24.1406H10.0518C9.51425 24.1406 9.08031 23.655 9.08031 23.0535C9.08031 22.452 9.51425 21.9664 10.0518 21.9664H34.9482C35.4857 21.9664 35.9197 22.452 35.9197 23.0535C35.9197 23.655 35.4857 24.1406 34.9482 24.1406Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M34.9482 31.2284H10.0518C9.51425 31.2284 9.08031 30.7428 9.08031 30.1413C9.08031 29.5398 9.51425 29.0542 10.0518 29.0542H34.9482C35.4857 29.0542 35.9197 29.5398 35.9197 30.1413C35.9197 30.7428 35.4857 31.2284 34.9482 31.2284Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M34.9482 38.309H10.0518C9.51425 38.309 9.08031 37.8234 9.08031 37.2219C9.08031 36.6204 9.51425 36.1348 10.0518 36.1348H34.9482C35.4857 36.1348 35.9197 36.6204 35.9197 37.2219C35.9197 37.8234 35.4857 38.309 34.9482 38.309Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M24.5013 45.3968H10.0518C9.51425 45.3968 9.08031 44.9112 9.08031 44.3097C9.08031 43.7082 9.51425 43.2226 10.0518 43.2226H24.5013C25.0389 43.2226 25.4728 43.7082 25.4728 44.3097C25.4728 44.9112 25.0389 45.3968 24.5013 45.3968Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.2772 60C2.40933 60 1.58679 59.6231 0.971503 58.9347C0.343264 58.2389 0 57.3113 0 56.3256V4.07296C0 2.06547 1.45725 0.420341 3.2513 0.398599L41.6904 0H41.7228C42.5907 0 43.4132 0.376857 44.0285 1.06535C44.6567 1.76108 45 2.68873 45 3.67436V55.927C45 57.9345 43.5427 59.5797 41.7487 59.5942L3.30959 59.9927H3.2772V60ZM41.7228 2.17418H41.7098L3.26425 2.57277C2.53238 2.58002 1.94301 3.25402 1.94301 4.06571V56.3256C1.94301 56.7242 2.08549 57.1011 2.33808 57.3837C2.59067 57.6664 2.91451 57.8403 3.29016 57.8186L41.7293 57.42C42.4611 57.42 43.0505 56.7387 43.0505 55.927V3.66711C43.0505 3.26851 42.908 2.88441 42.6554 2.60176C42.4028 2.31912 42.0725 2.16693 41.7163 2.16693L41.7228 2.17418Z",
      fill: color
    }));
  },
  OptionsVertical: function OptionsVertical(_ref99) {
    var color = _ref99.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 Z M12,21 C10.8954305,21 10,20.1045695 10,19 C10,17.8954305 10.8954305,17 12,17 C13.1045695,17 14,17.8954305 14,19 C14,20.1045695 13.1045695,21 12,21 Z M12,7 C10.8954305,7 10,6.1045695 10,5 C10,3.8954305 10.8954305,3 12,3 C13.1045695,3 14,3.8954305 14,5 C14,6.1045695 13.1045695,7 12,7 Z"
    });
  },
  Options: function Options(_ref100) {
    var color = _ref100.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 Z M19,14 C17.8954305,14 17,13.1045695 17,12 C17,10.8954305 17.8954305,10 19,10 C20.1045695,10 21,10.8954305 21,12 C21,13.1045695 20.1045695,14 19,14 Z M5,14 C3.8954305,14 3,13.1045695 3,12 C3,10.8954305 3.8954305,10 5,10 C6.1045695,10 7,10.8954305 7,12 C7,13.1045695 6.1045695,14 5,14 Z"
    });
  },
  Percent: function Percent(_ref101) {
    var color = _ref101.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 12 12
      React.createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "M2.33 1.33a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM0 2.33a2.33 2.33 0 1 1 4.67 0 2.33 2.33 0 0 1-4.67 0ZM10.2.86a.67.67 0 1 1 .94.94L1.8 11.14a.67.67 0 0 1-.94-.94L10.2.86Zm-.53 7.8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2.34 1a2.33 2.33 0 1 1 4.67 0 2.33 2.33 0 0 1-4.67 0Z",
        clipRule: "evenodd"
      })
    );
  },
  Photo: function Photo(_ref102) {
    var color = _ref102.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 42.311974,21.502453 V 10.161165 c 0,-1.3658766 -1.107262,-2.4731387 -2.473139,-2.4731387 h -29.67767 c -1.3658766,0 -2.4731387,1.1072621 -2.4731387,2.4731387 V 31.39501 L 13.35867,25.724366 c 0.833607,-0.833607 2.139722,-0.962938 3.120624,-0.309003 l 5.57034,3.71356 10.943004,-13.131605 c 0.93101,-1.117212 2.620358,-1.193842 3.648692,-0.165509 z m 0,6.995094 -7.253226,-7.253227 -10.631969,12.758363 c -0.809124,0.970949 -2.220147,1.175592 -3.271769,0.474511 l -5.732444,-3.82163 -7.7345397,7.73454 v 1.448731 c 0,1.365877 1.1072621,2.473139 2.4731387,2.473139 h 29.67767 c 1.365877,0 2.473139,-1.107262 2.473139,-2.473139 z M 10.161165,2.741748 h 29.67767 c 4.097631,0 7.419417,3.3217863 7.419417,7.419417 v 29.67767 c 0,4.097631 -3.321786,7.419417 -7.419417,7.419417 h -29.67767 c -4.0976307,0 -7.419417,-3.321786 -7.419417,-7.419417 v -29.67767 c 0,-4.0976307 3.3217863,-7.419417 7.419417,-7.419417 z m 8.655987,17.311974 c -2.048815,0 -3.709708,-1.660893 -3.709708,-3.709709 0,-2.048815 1.660893,-3.709708 3.709708,-3.709708 2.048816,0 3.709709,1.660893 3.709709,3.709708 0,2.048816 -1.660893,3.709709 -3.709709,3.709709 z"
    });
  },
  Play: function Play(_ref103) {
    var color = _ref103.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 40.799495,27.5595 12.491157,45.757717 C 11.077483,46.666508 9.1947521,46.257218 8.2859611,44.843544 7.9704316,44.35272 7.8026712,43.781527 7.8026712,43.198032 V 6.8015975 c 0,-1.6805885 1.3623862,-3.0429747 3.0429748,-3.0429747 0.583495,0 1.154688,0.1677603 1.645511,0.4832898 L 40.799495,22.44013 c 1.413675,0.908791 1.822964,2.791522 0.914173,4.205196 -0.235727,0.366687 -0.547486,0.678447 -0.914173,0.914174 z"
    });
  },
  Plus: function Plus(_ref104) {
    var color = _ref104.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25,8.2324219 A 1.81039,1.81039 0 0 0 23.189453,10.042969 V 39.957031 A 1.81039,1.81039 0 0 0 25,41.767578 1.81039,1.81039 0 0 0 26.810547,39.957031 V 10.042969 A 1.81039,1.81039 0 0 0 25,8.2324219 Z M 10.042969,23.189453 A 1.81039,1.81039 0 0 0 8.2324219,25 1.81039,1.81039 0 0 0 10.042969,26.810547 H 39.957031 A 1.81039,1.81039 0 0 0 41.767578,25 1.81039,1.81039 0 0 0 39.957031,23.189453 Z"
    });
  },
  Positive: function Positive(_ref105) {
    var color = _ref105.color;
    return /*#__PURE__*/React.createElement("path", {
      d: "M 25,50 C 11.2,50 0,38.8 0,25 0,11.2 11.2,0 25,0 38.8,0 50,11.2 50,25 50,38.8 38.8,50 25,50 Z M 25,2 C 12.3,2 2,12.3 2,25 2,37.7 12.3,48 25,48 37.7,48 48,37.7 48,25 48,12.3 37.7,2 25,2 Z m 14.5,20.4 h -12 V 10.5 c 0.1,-0.5 -0.3,-1 -0.9,-1.1 -0.1,0 -0.1,0 -0.2,0 h -2.7 c -0.5,-0.1 -1,0.3 -1.1,0.9 0,0.1 0,0.1 0,0.2 v 12 h -12 c -0.5,-0.1 -1,0.3 -1.1,0.9 0,0.1 0,0.1 0,0.2 v 2.7 c -0.1,0.5 0.3,1 0.9,1.1 0.1,0 0.1,0 0.2,0 h 12 v 12 c -0.1,0.5 0.3,1 0.9,1.1 0.1,0 0.1,0 0.2,0 h 2.7 c 0.5,0.1 1,-0.3 1.1,-0.9 0,-0.1 0,-0.1 0,-0.2 v -12 h 12 c 0.5,0.1 1,-0.3 1.1,-0.9 0,-0.1 0,-0.1 0,-0.2 v -2.7 c 0.1,-0.6 -0.4,-1.2 -1.1,-1.2 0,0 0,0 0,0 z",
      fill: color
    });
  },
  PushPin: function PushPin(_ref106) {
    var color = _ref106.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M50,16.6L33.4,0L22.5,14.6c-1.2-0.3-2.4-0.4-3.6-0.4c-4.5,0-8.8,1.8-12,5l-1.4,1.4l10.7,10.6L0,47.3V50h2.7l16.2-16.2  l10.7,10.6l1.3-1.4c3.2-3.2,4.9-7.4,4.9-11.9c0-1.2-0.1-2.4-0.4-3.6L50,16.6z M29.5,38.9L11,20.6c2.3-1.7,5-2.6,7.9-2.6  c1.3,0,2.6,0.2,3.8,0.6L24,19l9.9-13.1l10.4,10.4L31.1,26l0.4,1.3c0.4,1.2,0.6,2.5,0.6,3.8C32,34,31.1,36.7,29.5,38.9z"
    });
  },
  QuestionMark: function QuestionMark(_ref107) {
    var color = _ref107.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M24.9,0c-13.8,0-25,11.2-25,25c0,4.9,1.4,9.7,4.2,13.8l-2.8,9.5c-0.1,0.3,0,0.7,0.2,1c0.2,0.2,0.6,0.3,1,0.2l9.8-2.9  c3.8,2.2,8.2,3.4,12.6,3.4c13.8,0,25-11.2,25-25C49.9,11.2,38.7,0,24.9,0z M24.9,46.8c-4,0-7.9-1.1-11.3-3.2  c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0-0.2,0-0.3,0l-8,2.4l2.3-7.8c0.1-0.3,0-0.5-0.1-0.8C4.5,33.7,3.1,29.4,3.1,25  c0-12,9.8-21.8,21.8-21.8c12,0,21.8,9.8,21.8,21.8C46.7,37,36.9,46.8,24.9,46.8z M24.9,8.1c-6.2,0-11.2,5-11.2,11.2  c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9c0-3,2.4-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5c0,3-2.5,5.5-5.5,5.5c-1.6,0-2.9,1.3-2.9,2.9  v3.7c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9v-1.2c4.9-1.3,8.3-5.7,8.3-10.8C36.1,13.1,31.1,8.1,24.9,8.1z M26.6,28.4  c-0.5,0.1-0.8,0.5-0.8,0.9v2c0,0.5-0.4,1-1,1s-1-0.4-1-1v-3.7c0-0.5,0.4-1,1-1c4.1,0,7.4-3.3,7.4-7.4c0-4.1-3.3-7.4-7.4-7.4  c-4.1,0-7.4,3.3-7.4,7.4c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-1-0.4-1-0.9c0-5.1,4.2-9.3,9.3-9.3c5.1,0,9.3,4.2,9.3,9.3  C34.2,23.8,31,27.6,26.6,28.4z M24.2,36.5c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.3-0.5,0.5  c-0.2,0.2-0.3,0.4-0.4,0.5c-0.1,0.2-0.2,0.4-0.4,0.7c-0.1,0.2-0.1,0.4-0.2,0.7c0,0.2-0.1,0.5-0.1,0.7c0,1,0.4,1.9,1.1,2.6  c0.2,0.2,0.4,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.4c0.2,0.1,0.4,0.1,0.7,0.2c0.2,0,0.5,0.1,0.7,0.1c1,0,1.9-0.4,2.6-1.1  c0.7-0.7,1.1-1.6,1.1-2.6c0-0.9-0.4-1.9-1.1-2.6C26.6,36.7,25.4,36.3,24.2,36.5z M26.1,41.3c-0.3,0.3-0.7,0.5-1.2,0.5  c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.3-0.3-0.5-0.8-0.5-1.2  c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.3,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2  c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2  C26.6,40.5,26.4,40.9,26.1,41.3z"
    });
  },
  Radar: function Radar(_ref108) {
    var color = _ref108.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 25,8.5 -17.2,13 6.6,21.2 h 21.1 l 6.6,-21.2 z m 8.3,31 H 16.6 L 11.4,22.7 25,12.4 38.5,22.7 Z m -8.2,-21.3 -8.6,6.6 3.2,10.6 h 10.6 l 3.2,-10.6 z m 3,14.1 H 22 L 20.1,26 25.1,22.1 30,26 Z M 25,0 0,19.1 9.6,50 H 40.4 L 50,19.1 Z M 38.2,46.8 H 11.8 L 3.5,20.3 25,3.9 46.5,20.3 Z"
    });
  },
  RankedList: function RankedList(_ref109) {
    var color = _ref109.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 40.92,0 H 9.08 a 4.41,4.41 0 0 0 -4.4,4.4 v 41.2 a 4.41,4.41 0 0 0 4.4,4.4 h 31.84 a 4.41,4.41 0 0 0 4.4,-4.4 V 4.4 A 4.41,4.41 0 0 0 40.92,0 Z m 1.42,4.4 V 45.6 A 1.43,1.43 0 0 1 40.92,47 H 9.08 A 1.43,1.43 0 0 1 7.66,45.6 V 4.4 A 1.43,1.43 0 0 1 9.08,3 h 31.84 a 1.43,1.43 0 0 1 1.42,1.4 z"
    });
  },
  ReportIcon: function ReportIcon(_ref110) {
    var color = _ref110.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M29.746,31.808 L8.786,31.808 C8.031,31.808 7.417,31.194 7.417,30.439 L7.417,3.144 C7.417,2.389 8.031,1.776 8.786,1.776 L23.249,1.776 L23.249,8.968 C23.249,9.458 23.646,9.856 24.137,9.856 L31.115,9.856 L31.115,30.439 C31.115,31.194 30.501,31.808 29.746,31.808 L29.746,31.808 Z M25.474,33.824 L25.474,36.492 C25.474,37.246 24.859,37.861 24.104,37.861 L3.144,37.861 C2.39,37.861 1.775,37.246 1.775,36.492 L1.775,9.197 C1.775,8.442 2.39,7.829 3.144,7.829 L5.642,7.829 L5.642,30.439 C5.642,32.172 7.053,33.583 8.786,33.583 L25.522,33.583 C25.5,33.662 25.474,33.739 25.474,33.824 L25.474,33.824 Z M25.024,3.073 L29.9,8.08 L25.024,8.08 L25.024,3.073 Z M32.864,8.838 C32.854,8.77 32.85,8.702 32.823,8.636 C32.792,8.557 32.74,8.492 32.688,8.426 C32.669,8.401 32.661,8.371 32.639,8.349 L32.632,8.341 C32.631,8.34 32.63,8.34 32.63,8.34 L24.772,0.269 C24.771,0.268 24.769,0.267 24.768,0.266 C24.678,0.174 24.566,0.108 24.443,0.063 C24.347,0.027 24.246,0.002 24.144,0.002 C24.142,0.002 24.14,-1.77635684e-14 24.137,-1.77635684e-14 L8.786,-1.77635684e-14 C7.053,-1.77635684e-14 5.642,1.411 5.642,3.144 L5.642,6.053 L3.144,6.053 C1.411,6.053 3.19744231e-14,7.463 3.19744231e-14,9.197 L3.19744231e-14,36.492 C3.19744231e-14,38.225 1.411,39.636 3.144,39.636 L24.104,39.636 C25.838,39.636 27.249,38.225 27.249,36.492 L27.249,33.824 C27.249,33.739 27.223,33.662 27.2,33.583 L29.746,33.583 C31.479,33.583 32.891,32.172 32.891,30.439 L32.891,8.968 C32.891,8.922 32.871,8.883 32.864,8.838 L32.864,8.838 Z"
    });
  },
  RiskIcon: function RiskIcon(_ref111) {
    var color = _ref111.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M25,0A22.87,22.87,0,0,0,2.1,20.91a1.49,1.49,0,0,0,2.51,1.21,7.86,7.86,0,0,1,5.47-2.2,8,8,0,0,1,6.34,3.17,1.63,1.63,0,0,0,.36.3l.14.08a1.39,1.39,0,0,0,1.24,0,.83.83,0,0,0,.16-.09,1.08,1.08,0,0,0,.28-.24l.12-.11a7.87,7.87,0,0,1,4.79-3v24A2.85,2.85,0,0,1,20.77,47,2.85,2.85,0,0,1,18,44.1a1.49,1.49,0,1,0-3,0,5.72,5.72,0,1,0,11.44,0v-24a7.87,7.87,0,0,1,4.79,3l.07.07a1.35,1.35,0,0,0,.33.27l.16.1a1.16,1.16,0,0,0,.47.12l.09,0h.12a1.33,1.33,0,0,0,.57-.14l.13-.08a.91.91,0,0,0,.3-.25l.12-.11a7.9,7.9,0,0,1,11.75-.91,1.48,1.48,0,0,0,1.67.27,1.5,1.5,0,0,0,.84-1.47A22.87,22.87,0,0,0,25,0Zm5.69,18.56a10.86,10.86,0,0,0-11.38,0c.5-3.89,1.88-10.25,5.69-14.85C28.8,8.3,30.18,14.66,30.69,18.56Zm13.68-.66A10.82,10.82,0,0,0,39.92,17a10.67,10.67,0,0,0-6.19,1.94C33.31,15,32.07,8.54,28.41,3.28A19.94,19.94,0,0,1,44.37,17.9ZM21.6,3.28C17.93,8.54,16.69,15,16.27,18.89A10.67,10.67,0,0,0,10.08,17a10.78,10.78,0,0,0-4.45.95A20,20,0,0,1,21.6,3.28ZM32,23.1Z"
    });
  },
  RightArrowSolid: function RightArrowSolid(_ref112) {
    var color = _ref112.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M16.7071068,11.2928932 L12.7071068,7.29289322 C12.3165825,6.90236893 11.6834175,6.90236893 11.2928932,7.29289322 C10.9023689,7.68341751 10.9023689,8.31658249 11.2928932,8.70710678 L13.5857864,11 L8,11 C7.44771525,11 7,11.4477153 7,12 C7,12.5522847 7.44771525,13 8,13 L13.5857864,13 L11.2928932,15.2928932 C10.9023689,15.6834175 10.9023689,16.3165825 11.2928932,16.7071068 C11.6834175,17.0976311 12.3165825,17.0976311 12.7071068,16.7071068 L16.7071068,12.7071068 C16.8880712,12.5261424 17,12.2761424 17,12 C17,11.7238576 16.8880712,11.4738576 16.7071068,11.2928932 Z M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z"
    });
  },
  RightArrow: function RightArrow(_ref113) {
    var color = _ref113.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 17.498935,34.688875 c -0.975138,0.975139 -0.950134,2.575366 0,3.550504 0.975139,0.975138 2.550362,0.975138 3.525501,0 L 32.501064,26.762751 c 0.975139,-0.975139 0.975139,-2.550362 0,-3.525501 L 21.024436,11.760622 c -0.975139,-0.975139 -2.550362,-0.975139 -3.525501,0 -0.975138,0.975138 -0.975138,2.550361 0,3.5255 l 9.701377,9.701377 z"
    });
  },
  RightArrow2: function RightArrow2(_ref114) {
    var color = _ref114.color;
    return /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9393 0.93934C14.5251 0.353553 15.4749 0.353553 16.0607 0.93934L25.0607 9.93934C25.6464 10.5251 25.6464 11.4749 25.0607 12.0607L16.0607 21.0607C15.4749 21.6464 14.5251 21.6464 13.9393 21.0607C13.3536 20.4749 13.3536 19.5251 13.9393 18.9393L20.3787 12.5H2C1.17157 12.5 0.5 11.8284 0.5 11C0.5 10.1716 1.17157 9.5 2 9.5H20.3787L13.9393 3.06066C13.3536 2.47487 13.3536 1.52513 13.9393 0.93934Z",
      fill: color
    });
  },
  RightUp: function RightUp(_ref115) {
    var color = _ref115.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.5857864,9 L9,9 C8.44771525,9 8,8.55228475 8,8 C8,7.44771525 8.44771525,7 9,7 L16,7 C16.5522847,7 17,7.44771525 17,8 L17,15 C17,15.5522847 16.5522847,16 16,16 C15.4477153,16 15,15.5522847 15,15 L15,10.4142136 L8.70710678,16.7071068 C8.31658249,17.0976311 7.68341751,17.0976311 7.29289322,16.7071068 C6.90236893,16.3165825 6.90236893,15.6834175 7.29289322,15.2928932 L13.5857864,9 Z"
    });
  },
  Search: function Search(_ref116) {
    var color = _ref116.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 34.208984,32.564453 a 2.2315099,2.2315099 0 0 0 -1.558593,0.6875 2.2315099,2.2315099 0 0 0 0.06836,3.154297 l 12.763672,12.232422 a 2.2315099,2.2315099 0 0 0 3.15625,-0.06836 2.2315099,2.2315099 0 0 0 -0.06836,-3.154296 L 35.804688,33.183594 A 2.2315099,2.2315099 0 0 0 34.208984,32.564453 Z M 20.896484,0.06835937 C 9.5953574,0.0683595 0.42382795,9.4053704 0.42382812,20.835938 c 1e-8,11.430566 9.17152948,20.765624 20.47265588,20.765624 11.301127,0 20.47461,-9.335057 20.47461,-20.765624 0,-11.4305677 -9.173483,-20.76757863 -20.47461,-20.76757863 z m 0,3.82226563 c 9.202953,0 16.652344,7.548234 16.652344,16.945313 0,9.397078 -7.449391,16.943359 -16.652344,16.943359 -9.202952,0 -16.6503902,-7.546281 -16.6503902,-16.943359 -2e-7,-9.397079 7.4474382,-16.9453129 16.6503902,-16.945313 z"
    });
  },
  // viewBox="0 0 10.29 12"
  Security: function Security(_ref117) {
    var color = _ref117.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M5.2416167 12h-.1449251l-.072462-.02405C4.9759207 11.951904.00015847 10.052104.00015847 4.3527054V1.7074148a.30434274.30300601 0 0 1 .3140044-.3126253c1.78740973 0 3.38158603-.4569137 4.56514113-1.29859712.024154-.0240481.048308-.0480962.072463-.0480962A.35506653.35350701 0 0 1 5.0483835 0h.1449251c-.024154 0 .048308 0 .072463.0480962l.072463.0721443c1.1835545.7935872 2.8260395 1.250501 4.6376035 1.250501a.30434274.30300601 0 0 1 .3140039.3126252v2.6693387c0 4.9058116-3.8405149 7.0701406-5.02407 7.6232466zM.67647567 2.0440882v2.3086172c0 4.3046092 3.14004413 6.3006016 4.51683273 6.9498996.7970881-.360721 4.4685247-2.2124246 4.4685247-6.9498996V2.0440882C7.1256431 1.995992 5.6763921 1.1302605 5.145.72144289 4.5894537 1.1302605 3.1402026 1.995992.67647567 2.0440882ZM4.4686828 7.1182365a.34540485.34388778 0 0 1-.265696-.1202405L2.6329647 5.4348697a.31158899.31022044 0 0 1-.096617-.2885771.33574318.33426854 0 0 1 .1207709-.240481.38405155.38236473 0 0 1 .2898502-.0961924.33574318.33426854 0 0 1 .2415419.1202405L4.492837 6.2284569l2.6811141-2.6933868a.36231278.36072144 0 0 1 .265697-.096192.38888239.38717435 0 0 1 .265696.1202404.40095948.3991984 0 0 1 0 .5050101L4.7343789 6.997996a.38888239.38717435 0 0 1-.2656961.1202405Z"
    });
  },
  Segment: function Segment(_ref118) {
    var color = _ref118.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 26,0 V 24 H 50 A 24.14,24.14 0 0 0 26,0 Z m 3.2,20.8 V 3.5 a 20.8,20.8 0 0 1 17.2,17.3 z m -5.7,5.7 V 3 3 A 23.5,23.5 0 1 0 47,26.5 Z m 0,20.3 A 20.32,20.32 0 0 1 20.4,6.4 V 29.7 H 43.7 A 20.44,20.44 0 0 1 23.5,46.8 Z"
    });
  },
  Settings: function Settings(_ref119) {
    var color = _ref119.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11.4113948,4 L11.1449265,5.30792041 C11.0303224,5.87043808 10.6795242,6.35658722 10.1818028,6.64265305 L8.13242012,7.82053767 C7.63938589,8.10390955 7.04903358,8.16400171 6.50901407,7.98578471 L5.12282813,7.52831624 L4.57751802,8.44852705 L5.54738534,9.27861215 C5.99134314,9.65858448 6.24691358,10.2137162 6.24691358,10.7980769 L6.24691358,13.2019231 C6.24691358,13.7862838 5.99134314,14.3414155 5.54738534,14.7213879 L4.57751802,15.5514729 L5.12282813,16.4716838 L6.50901407,16.0142153 C7.04903358,15.8359983 7.63938589,15.8960904 8.13242012,16.1794623 L10.1818028,17.3573469 C10.6795242,17.6434128 11.0303224,18.1295619 11.1449265,18.6920796 L11.4113948,20 L12.5886052,20 L12.8550735,18.6920796 C12.9696776,18.1295619 13.3204758,17.6434128 13.8181972,17.3573469 L15.8675799,16.1794623 C16.3606141,15.8960904 16.9509664,15.8359983 17.4909859,16.0142153 L18.8771719,16.4716838 L19.422482,15.5514729 L18.4526147,14.7213879 C18.0086569,14.3414155 17.7530864,13.7862838 17.7530864,13.2019231 L17.7530864,10.7980769 C17.7530864,10.2137162 18.0086569,9.65858448 18.4526147,9.27861215 L19.422482,8.44852705 L18.8771719,7.52831624 L17.4909859,7.98578471 C16.9509664,8.16400171 16.3606141,8.10390955 15.8675799,7.82053767 L13.8181972,6.64265305 C13.3204758,6.35658722 12.9696776,5.87043808 12.8550735,5.30792041 L12.5886052,4 L11.4113948,4 Z M9.77777778,2 L14.2222222,2 L14.8148148,4.90865385 L16.8641975,6.08653846 L19.7777778,5.125 L22,8.875 L19.7530864,10.7980769 L19.7530864,13.2019231 L22,15.125 L19.7777778,18.875 L16.8641975,17.9134615 L14.8148148,19.0913462 L14.2222222,22 L9.77777778,22 L9.18518519,19.0913462 L7.13580247,17.9134615 L4.22222222,18.875 L2,15.125 L4.24691358,13.2019231 L4.24691358,10.7980769 L2,8.875 L4.22222222,5.125 L7.13580247,6.08653846 L9.18518519,4.90865385 L9.77777778,2 Z M11,12 C11,11.4445695 11.4445695,11 12,11 C12.5554305,11 13,11.4445695 13,12 C13,12.5554305 12.5554305,13 12,13 C11.4445695,13 11,12.5554305 11,12 Z M9,12 C9,13.66 10.34,15 12,15 C13.66,15 15,13.66 15,12 C15,10.34 13.66,9 12,9 C10.34,9 9,10.34 9,12 Z"
    });
  },
  StarSolid: function StarSolid(_ref120) {
    var color = _ref120.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25 2.3300781 C 23.532738 2.3300781 22.066119 3.0589339 21.351562 4.5175781 L 16.259766 14.910156 L 4.8027344 16.541016 C 1.5866087 16.998692 0.21594322 21.221762 2.5488281 23.482422 L 10.859375 31.535156 L 8.8691406 42.935547 C 8.310578 46.135695 11.902522 48.744734 14.773438 47.224609 L 25 41.808594 L 35.226562 47.224609 C 38.097479 48.744733 41.689422 46.135695 41.130859 42.935547 L 39.140625 31.535156 L 47.451172 23.482422 C 49.784057 21.221763 48.413391 16.998692 45.197266 16.541016 L 33.740234 14.910156 L 28.648438 4.5175781 C 27.933881 3.0589339 26.467262 2.3300782 25 2.3300781 z M 24.943359 6.2773438 C 25.023932 6.1128677 24.976068 6.1128677 25.056641 6.2773438 L 31.080078 18.572266 L 44.632812 20.501953 C 44.814137 20.527757 44.799498 20.481918 44.667969 20.609375 L 34.837891 30.136719 L 37.191406 43.623047 C 37.222898 43.803469 37.261471 43.775158 37.099609 43.689453 L 25 37.283203 L 12.900391 43.689453 C 12.73853 43.775157 12.777102 43.803469 12.808594 43.623047 L 15.162109 30.136719 L 5.3320312 20.609375 C 5.2005026 20.481918 5.1858624 20.527757 5.3671875 20.501953 L 18.919922 18.572266 L 24.943359 6.2773438 z"
    });
  },
  Status: function Status(_ref121) {
    var color = _ref121.color;
    return /*#__PURE__*/React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
      id: "online-copy-b",
      cx: "12",
      cy: "12",
      r: "12"
    }), /*#__PURE__*/React.createElement("filter", {
      id: "online-copy-a",
      width: "237.5%",
      height: "250%",
      x: "-68.8%",
      y: "-43.8%",
      filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/React.createElement("feMorphology", {
      "in": "SourceAlpha",
      radius: "1.5",
      result: "shadowSpreadOuter1"
    }), /*#__PURE__*/React.createElement("feOffset", {
      dy: "9",
      "in": "shadowSpreadOuter1",
      result: "shadowOffsetOuter1"
    }), /*#__PURE__*/React.createElement("feGaussianBlur", {
      "in": "shadowOffsetOuter1",
      result: "shadowBlurOuter1",
      stdDeviation: "4.5"
    }), /*#__PURE__*/React.createElement("feColorMatrix", {
      "in": "shadowBlurOuter1",
      result: "shadowMatrixOuter1",
      values: "0 0 0 0 0.0392156863   0 0 0 0 0.0862745098   0 0 0 0 0.274509804  0 0 0 0.1 0"
    }), /*#__PURE__*/React.createElement("feOffset", {
      "in": "SourceAlpha",
      result: "shadowOffsetOuter2"
    }), /*#__PURE__*/React.createElement("feGaussianBlur", {
      "in": "shadowOffsetOuter2",
      result: "shadowBlurOuter2",
      stdDeviation: "1.5"
    }), /*#__PURE__*/React.createElement("feColorMatrix", {
      "in": "shadowBlurOuter2",
      result: "shadowMatrixOuter2",
      values: "0 0 0 0 0.0392156863   0 0 0 0 0.0862745098   0 0 0 0 0.274509804  0 0 0 0.06 0"
    }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
      "in": "shadowMatrixOuter1"
    }), /*#__PURE__*/React.createElement("feMergeNode", {
      "in": "shadowMatrixOuter2"
    })))), /*#__PURE__*/React.createElement("use", {
      fill: "#000",
      filter: "url(#online-copy-a)",
      xlinkHref: "#online-copy-b"
    }), /*#__PURE__*/React.createElement("use", {
      fill: "#FFF",
      xlinkHref: "#online-copy-b"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      fill: color
    }));
  },
  Store: function Store(_ref122) {
    var color = _ref122.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M20.16,7.8 C20.07,7.34 19.66,7 19.18,7 L4.82,7 C4.34,7 3.93,7.34 3.84,7.8 L3,12 L3,13 C3,13.55 3.45,14 4,14 L4,19 C4,19.55 4.45,20 5,20 L13,20 C13.55,20 14,19.55 14,19 L14,14 L18,14 L18,19 C18,19.55 18.45,20 19,20 C19.55,20 20,19.55 20,19 L20,14 C20.55,14 21,13.55 21,13 L21,12 L20.16,7.8 Z M12,18 L6,18 L6,14 L12,14 L12,18 Z M5,6 C4.45,6 4,5.55 4,5 C4,4.45 4.45,4 5,4 L19,4 C19.55,4 20,4.45 20,5 C20,5.55 19.55,6 19,6 L5,6 Z"
    });
  },
  Success: function Success(_ref123) {
    var color = _ref123.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z M15.3141427,8.79289322 L10.0212495,14.0857864 L8.20710678,12.2716438 C7.81658249,11.8811195 7.18341751,11.8811195 6.79289322,12.2716438 C6.40236893,12.6621681 6.40236893,13.295333 6.79289322,13.6858573 L9.31414268,16.2071068 C9.70466697,16.5976311 10.3378319,16.5976311 10.7283562,16.2071068 L16.7283562,10.2071068 C17.1188805,9.81658249 17.1188805,9.18341751 16.7283562,8.79289322 C16.3378319,8.40236893 15.704667,8.40236893 15.3141427,8.79289322 Z"
    });
  },
  Target: function Target(_ref124) {
    var color = _ref124.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M25.1 43.5c-.6 0-1.2-.5-1.2-1.2v-.9c-8.2-.6-14.7-7.1-15.3-15.3H7.2c-.7.1-1.2-.5-1.2-1.1s.5-1.2 1.2-1.2h1.5c.6-8.2 7-14.7 15.3-15.3v-.8c0-.6.5-1.2 1.2-1.2s1.2.5 1.2 1.2v.9c8.2.6 14.7 7 15.3 15.3H43c.6 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-1.3c-.6 8.2-7 14.7-15.3 15.3v.9c-.2.5-.7 1-1.3 1zm1.1-9.3v4.9c6.9-.6 12.4-6 12.9-12.9h-4.9c-.5 4.1-3.8 7.4-8 8zm-15.2-8c.6 6.9 6 12.4 12.9 12.9v-4.9c-4.2-.5-7.5-3.8-8-8H11zm15.2 0v5.6c2.9-.5 5.1-2.8 5.6-5.6h-5.6zm-7.9 0c.5 2.9 2.8 5.1 5.6 5.6v-5.6h-5.6zm15.9-2.4h4.9c-.6-6.9-6-12.4-12.9-12.9v4.9c4.2.6 7.5 3.9 8 8zm-8 0h5.6c-.5-2.9-2.8-5.1-5.6-5.6v5.6zm-7.9 0h5.6v-5.6c-2.8.5-5.1 2.8-5.6 5.6zm-7.3 0h4.9c.5-4.2 3.8-7.5 8-8v-4.9c-6.9.6-12.4 6-12.9 12.9z"
    });
  },
  // viewBox = 0 0 50 50
  TargetNew: function TargetNew(_ref125) {
    var color = _ref125.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M25 50c-.78534 0-1.570681-.675675-1.570681-1.621621v-1.216217c-10.732984-.81081-19.2408373-9.594594-20.0261776-20.675676H1.5706806C.65445026 26.621622 0 25.810811 0 25.000001c0-.810812.65445026-1.621623 1.5706806-1.621623h1.9633508C4.3193717 12.297298 12.696335 3.5135136 23.560209 2.7027027V1.6216216C23.560209.81081085 24.21466 0 25.13089 0s1.570681.67567572 1.570681 1.6216216v1.2162163c10.732984.8108108 19.240837 9.4594601 20.026178 20.6756761h1.70157c.785341 0 1.570681.675675 1.570681 1.621622 0 .945945-.65445 1.621621-1.570681 1.621621h-1.70157c-.785341 11.081081-9.162304 19.864865-20.026178 20.675675v1.216217C26.439791 49.324325 25.78534 50 25 50Zm1.439791-12.567567v6.621621c9.031413-.81081 16.230366-8.108108 16.884816-17.432432h-6.413612c-.65445 5.54054-4.973822 10-10.471204 10.810811zM6.5445026 26.621622c.7853403 9.324324 7.8534034 16.756757 16.8848164 17.432432v-6.621621c-5.497382-.675676-9.816754-5.135135-10.471204-10.810811Zm19.8952884 0v7.567567c3.795811-.675675 6.675392-3.783783 7.329843-7.567567zm-10.340315 0c.654451 3.918919 3.664922 6.891892 7.329843 7.567567v-7.567567zm20.811519-3.243244h6.413612c-.78534-9.324324-7.853403-16.7567563-16.884816-17.432432v6.621622c5.497382.81081 9.816754 5.27027 10.471204 10.81081zm-10.471204 0h7.329843c-.654451-3.918918-3.664922-6.891892-7.329843-7.567567Zm-10.340315 0h7.329843v-7.567567c-3.664921.675675-6.675392 3.783784-7.329843 7.567567zm-9.5549734 0h6.4136124c.65445-5.675675 4.973822-10.135135 10.471204-10.81081V5.945946c-9.031413.8108108-16.2303661 8.108108-16.8848164 17.432432Z"
    });
  },
  Text: function Text(_ref126) {
    var color = _ref126.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 33.959314,49.999919 H 16.040926 A 2.4687557,2.4798967 0 0 1 13.552261,47.500023 V 43.00021 a 2.4687557,2.4798967 0 0 1 2.488665,-2.499896 h 3.085945 v -30.49873 h -5.773703 v 4.599809 a 2.4687557,2.4798967 0 0 1 -2.488665,2.499896 H 5.4889868 A 2.4687557,2.4798967 0 0 1 3.0003218,14.601393 V 2.6018924 A 2.548393,2.5598934 0 0 1 5.4889868,0.00200075 H 44.411707 A 2.488665,2.4998959 0 0 1 46.999919,2.5018966 V 14.501397 a 2.4687557,2.4798967 0 0 1 -2.488665,2.499896 h -5.27597 A 2.4687557,2.4798967 0 0 1 36.746619,14.501397 V 10.001584 H 30.87337 v 30.49873 h 3.185491 a 2.4687557,2.4798967 0 0 1 2.488665,2.499896 v 4.499813 a 2.6180756,2.6298905 0 0 1 -2.588212,2.499896 z M 16.538659,47.000044 H 33.461581 V 43.500189 H 30.27609 A 2.4687557,2.4798967 0 0 1 27.787425,41.000293 V 9.5016051 A 2.4687557,2.4798967 0 0 1 30.27609,7.0017092 h 6.868715 a 2.4687557,2.4798967 0 0 1 2.488665,2.4998959 v 4.4998129 h 4.380051 V 3.0018758 H 5.9867198 V 14.001418 H 10.267223 V 9.5016051 a 2.4687557,2.4798967 0 0 1 2.488665,-2.4998959 h 6.868716 a 2.4687557,2.4798967 0 0 1 2.488665,2.4998959 V 41.000293 a 2.4687557,2.4798967 0 0 1 -2.488665,2.499896 h -3.085945 z"
    });
  },
  Thinkalike: function Thinkalike(_ref127) {
    var color = _ref127.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "m 37.59,15.74 a 7.87,7.87 0 1 1 7.86,-7.87 7.88,7.88 0 0 1 -7.86,7.87 z M 37.59,3 A 4.86,4.86 0 1 0 42.45,7.86 4.87,4.87 0 0 0 37.59,3 Z m 5.92,47 H 31.66 A 1.51,1.51 0 0 1 30.15,48.5 V 35.3 a 4.65,4.65 0 0 1 -4,-4.57 v -9.25 a 4.62,4.62 0 0 1 4.62,-4.62 H 44.39 A 4.62,4.62 0 0 1 49,21.48 v 9.25 A 4.65,4.65 0 0 1 45,35.3 V 48.5 A 1.51,1.51 0 0 1 43.51,50 Z M 33.16,47 H 42 V 33.84 a 1.5,1.5 0 0 1 1.5,-1.5 h 0.88 A 1.61,1.61 0 0 0 46,30.73 V 21.48 A 1.61,1.61 0 0 0 44.39,19.87 H 30.78 a 1.61,1.61 0 0 0 -1.61,1.61 v 9.25 a 1.61,1.61 0 0 0 1.61,1.61 h 0.88 a 1.5,1.5 0 0 1 1.5,1.5 z M 12.41,15.74 a 7.87,7.87 0 1 1 7.87,-7.87 7.88,7.88 0 0 1 -7.87,7.87 z M 12.41,3 A 4.86,4.86 0 1 0 17.28,7.86 4.87,4.87 0 0 0 12.41,3 Z m 5.93,47 H 6.49 A 1.51,1.51 0 0 1 5,48.5 V 35.3 A 4.65,4.65 0 0 1 1,30.73 v -9.25 a 4.62,4.62 0 0 1 4.62,-4.62 h 13.6 a 4.62,4.62 0 0 1 4.62,4.62 v 9.25 a 4.65,4.65 0 0 1 -4,4.57 V 48.5 A 1.51,1.51 0 0 1 18.34,50 Z M 8,47 h 8.85 V 33.84 a 1.5,1.5 0 0 1 1.5,-1.5 h 0.88 a 1.61,1.61 0 0 0 1.61,-1.61 V 21.48 A 1.61,1.61 0 0 0 19.23,19.87 H 5.61 A 1.61,1.61 0 0 0 4,21.48 v 9.25 a 1.61,1.61 0 0 0 1.61,1.61 H 6.49 A 1.5,1.5 0 0 1 8,33.84 Z"
    });
  },
  ThinkalikeModel: function ThinkalikeModel(_ref128) {
    var color = _ref128.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m 28.124978,49.421275 a 2.4055648,2.2746716 0 0 0 0.418359,-1.087887 46.448319,43.920943 0 0 1 1.882616,-6.824015 l 0.522949,-1.285684 h 4.079001 c 4.079001,0 5.647848,-0.395595 6.066207,-1.483481 a 42.327481,40.024331 0 0 0 0.10459,-4.450445 v -4.153748 l 2.091795,-0.0989 c 2.823924,-0.0989 3.137694,-0.494494 1.568847,-3.461457 A 39.064281,36.93869 0 0 1 41.303289,15.894593 18.470554,17.465522 0 0 0 38.583955,7.7848933 17.937146,16.961139 0 0 0 9.0896394,7.3892982 C 6.6840742,10.45516 5.9519458,13.026528 5.847356,16.982479 a 18.460095,17.455632 0 0 0 0.8367182,6.032825 c 0.7321285,2.571368 0.8367182,3.461457 0.8367182,7.714104 0,4.549343 -0.1045897,5.241634 -0.941308,8.0108 l -0.9413079,3.065862 0.7321284,0.79119 c 1.6734368,1.780178 9.2039011,4.846039 14.8517491,6.032825 4.28818,1.087886 6.484565,1.384582 6.902924,0.79119 z M 20.803694,46.355413 A 58.831748,55.630557 0 0 1 10.344717,42.498361 C 8.6712803,41.707171 8.357511,41.410475 8.4621007,40.915981 A 36.313569,34.337652 0 0 0 9.9263576,29.74042 46.4274,43.901163 0 0 0 9.1942292,23.213101 C 8.0437417,18.564859 7.729972,17.180276 8.2529213,15.103402 A 15.866269,15.002943 0 0 1 23.523028,2.4443599 15.688466,14.834815 0 0 1 39.002315,15.894593 a 36.459995,34.47611 0 0 0 2.719333,9.395382 c 0.522949,1.384583 0.941308,2.373571 0.941308,2.373571 a 13.157394,12.441465 0 0 1 -1.673435,0.0989 c -2.091796,0 -1.987206,-0.0989 -2.091796,5.736128 v 4.351546 l -4.915719,0.0989 -4.81113,0.0989 -1.255077,3.461457 a 26.147444,24.724692 0 0 0 -1.255078,4.252647 1.8826159,1.7801778 0 0 1 -0.313769,1.087887 c -0.31377,0.593392 -2.196385,0.296696 -5.543258,-0.494494 z m 5.647847,-25.911477 a 3.3782497,3.1944302 0 0 0 0.732129,-2.175773 c 0,-1.384583 -0.104589,-1.483482 -4.079001,-5.241635 C 17.456821,7.7848933 14.737487,5.5102216 14.632897,5.7080192 14.319128,6.0047155 21.117463,20.14724 21.849592,20.641733 a 4.1835909,3.9559507 0 0 0 2.300975,0.494494 2.2695981,2.1461033 0 0 0 2.300974,-0.692291 z m -4.28818,-3.758153 -1.150487,-2.274672 1.882615,1.879077 c 1.987206,1.879076 2.300976,2.769165 0.836718,2.769165 -0.209179,-0.0989 -0.627538,-0.593393 -1.568846,-2.37357 z M 36.38757,18.861556 C 36.805929,18.46596 36.805929,17.971467 36.49216,16.191289 35.341673,9.2683748 29.275466,4.4223352 22.47713,5.2135253 c -2.823923,0.2966963 -4.39277,0.8900889 -4.39277,1.9779754 0,1.0878864 0.522949,1.1867852 2.823924,0.6922914 a 9.7059309,9.1778056 0 0 1 9.726849,2.5713679 10.730911,10.147014 0 0 1 3.242282,6.42842 9.245736,8.742651 0 0 0 0.732129,2.373571 c 0.732129,0.296696 1.150488,0.0989 1.778026,-0.395595 z m -23.637289,0.0989 c 0.31377,-0.197797 0.418359,-0.890089 0.418359,-1.384582 a 11.724513,11.086552 0 0 1 1.882616,-5.439433 c 1.150488,-1.58238 0.941309,-2.6702667 -0.10459,-2.6702667 -1.673436,0 -4.079,4.5493437 -4.079,8.0108007 0,1.186785 0.104589,1.780178 0.522948,1.879076 a 1.6420594,1.5527106 0 0 0 1.359667,-0.395595 z"
    });
  },
  Twitter: function Twitter(_ref129) {
    var color = _ref129.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M20.4240011,6.75697057 C19.7837813,7.05498022 19.0944711,7.25651193 18.3714114,7.34655801 C19.1098119,6.88346388 19.6763962,6.14915952 19.9433249,5.27442615 C19.2519693,5.70321702 18.488001,6.01516237 17.6718741,6.18239081 C17.0214272,5.45451832 16.0917789,5 15.0629273,5 C13.0901094,5 11.48956,6.67764426 11.48956,8.74656019 C11.48956,9.04028193 11.5202414,9.32542786 11.5816043,9.59985401 C8.6106163,9.44334534 5.97712432,7.95329709 4.21294038,5.68392143 C3.90510307,6.2392056 3.72919603,6.88346388 3.72919603,7.56952926 C3.72919603,8.86876558 4.36021139,10.0157812 5.31951837,10.6879108 C4.7345252,10.6696872 4.18225892,10.4992429 3.69953729,10.2205288 L3.69953729,10.2666238 C3.69953729,12.0825531 4.93190926,13.5972569 6.56825378,13.9402895 C6.26859819,14.0281917 5.95257916,14.0721427 5.62633297,14.0721427 C5.39622202,14.0721427 5.17122464,14.0496312 4.95338628,14.0056802 C5.4084946,15.4935845 6.72779738,16.5773534 8.29255183,16.6062968 C7.0693843,17.6118113 5.52712958,18.2110466 3.85294458,18.2110466 C3.56453886,18.2110466 3.27920128,18.1938949 3,18.1595917 C4.58214061,19.2208491 6.46189139,19.8415238 8.47970874,19.8415238 C15.0557683,19.8415238 18.6506127,14.1332454 18.6506127,9.18178292 C18.6506127,9.01884239 18.6475445,8.85590186 18.6414083,8.69617726 C19.3399228,8.16769252 19.946393,7.50842656 20.4240011,6.75697057"
    });
  },
  UpArrowSolid: function UpArrowSolid(_ref130) {
    var color = _ref130.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M12.7071068,7.29289322 C12.5261424,7.11192881 12.2761424,7 12,7 C11.7238576,7 11.4738576,7.11192881 11.2928932,7.29289322 L7.29289322,11.2928932 C6.90236893,11.6834175 6.90236893,12.3165825 7.29289322,12.7071068 C7.68341751,13.0976311 8.31658249,13.0976311 8.70710678,12.7071068 L11,10.4142136 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,10.4142136 L15.2928932,12.7071068 C15.6834175,13.0976311 16.3165825,13.0976311 16.7071068,12.7071068 C17.0976311,12.3165825 17.0976311,11.6834175 16.7071068,11.2928932 L12.7071068,7.29289322 L12.7071068,7.29289322 Z M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z"
    });
  },
  UpArrow: function UpArrow(_ref131) {
    var color = _ref131.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 3.926115,37.620284 A 2.3850835,-2.3850835 0 0 1 2.221153,36.898237 2.3850835,-2.3850835 0 0 1 2.267737,33.52558 l 21.020878,-20.424607 0.04892,-0.04892 a 2.3850835,-2.3850835 0 0 1 0.05124,-0.04658 2.3850835,-2.3850835 0 0 1 0.0047,-0.0047 2.3850835,-2.3850835 0 0 1 0.08152,-0.07221 2.3850835,-2.3850835 0 0 1 0.04892,-0.03727 2.3850835,-2.3850835 0 0 1 0.06987,-0.05357 2.3850835,-2.3850835 0 0 1 0.03494,-0.02562 2.3850835,-2.3850835 0 0 1 0.06987,-0.04658 2.3850835,-2.3850835 0 0 1 0.06755,-0.04193 2.3850835,-2.3850835 0 0 1 0.03959,-0.02329 2.3850835,-2.3850835 0 0 1 0.107138,-0.05823 2.3850835,-2.3850835 0 0 1 0.0792,-0.03959 2.3850835,-2.3850835 0 0 1 0.09084,-0.03959 2.3850835,-2.3850835 0 0 1 0.02562,-0.01169 2.3850835,-2.3850835 0 0 1 0.06755,-0.02563 2.3850835,-2.3850835 0 0 1 0.109475,-0.03727 2.3850835,-2.3850835 0 0 1 0.04193,-0.01169 2.3850835,-2.3850835 0 0 1 0.09317,-0.02563 2.3850835,-2.3850835 0 0 1 0.04425,-0.01169 2.3850835,-2.3850835 0 0 1 0.104813,-0.02096 2.3850835,-2.3850835 0 0 1 0.03494,-0.0047 2.3850835,-2.3850835 0 0 1 0.07221,-0.01169 2.3850835,-2.3850835 0 0 1 0.09083,-0.01169 2.3850835,-2.3850835 0 0 1 0.10015,-0.007 2.3850835,-2.3850835 0 0 1 0.137421,-0.0047 2.3850835,-2.3850835 0 0 1 0.142081,0.0047 2.3850835,-2.3850835 0 0 1 0.10015,0.0093 2.3850835,-2.3850835 0 0 1 0.111801,0.01398 2.3850835,-2.3850835 0 0 1 0.139751,0.02562 2.3850835,-2.3850835 0 0 1 0.128105,0.03028 2.3850835,-2.3850835 0 0 1 0.0093,0.0024 2.3850835,-2.3850835 0 0 1 0.0093,0.0024 2.3850835,-2.3850835 0 0 1 0.102487,0.03028 2.3850835,-2.3850835 0 0 1 0.02562,0.0093 2.3850835,-2.3850835 0 0 1 0.06288,0.02329 2.3850835,-2.3850835 0 0 1 0.121116,0.04892 2.3850835,-2.3850835 0 0 1 0.01169,0.0047 2.3850835,-2.3850835 0 0 1 0.06522,0.03028 2.3850835,-2.3850835 0 0 1 0.06056,0.03028 2.3850835,-2.3850835 0 0 1 0.06522,0.03494 2.3850835,-2.3850835 0 0 1 0.02096,0.01398 2.3850835,-2.3850835 0 0 1 0.100149,0.06056 2.3850835,-2.3850835 0 0 1 0.05823,0.03727 2.3850835,-2.3850835 0 0 1 0.06056,0.04193 2.3850835,-2.3850835 0 0 1 0.05357,0.03959 2.3850835,-2.3850835 0 0 1 0.05823,0.04658 2.3850835,-2.3850835 0 0 1 0.01169,0.01169 2.3850835,-2.3850835 0 0 1 0.0792,0.06755 2.3850835,-2.3850835 0 0 1 0.0163,0.01398 2.3850835,-2.3850835 0 0 1 0.04193,0.03959 2.3850835,-2.3850835 0 0 1 0.04892,0.04892 l 21.02077,20.424717 a 2.3850835,-2.3850835 0 0 1 0.04892,3.372657 2.3850835,-2.3850835 0 0 1 -3.372658,0.04892 L 25.000564,18.087754 5.5938108,36.94715 A 2.3850835,-2.3850835 0 0 1 3.926115,37.620284 Z"
    });
  },
  Up: function Up(_ref132) {
    var color = _ref132.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11,8.41421356 L7.70710678,11.7071068 C7.31658249,12.0976311 6.68341751,12.0976311 6.29289322,11.7071068 C5.90236893,11.3165825 5.90236893,10.6834175 6.29289322,10.2928932 L11.2928932,5.29289322 C11.6834175,4.90236893 12.3165825,4.90236893 12.7071068,5.29289322 L17.7071068,10.2928932 C18.0976311,10.6834175 18.0976311,11.3165825 17.7071068,11.7071068 C17.3165825,12.0976311 16.6834175,12.0976311 16.2928932,11.7071068 L13,8.41421356 L13,18 C13,18.5522847 12.5522847,19 12,19 C11.4477153,19 11,18.5522847 11,18 L11,8.41421356 Z"
    });
  },
  Upload: function Upload(_ref133) {
    var color = _ref133.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M11,5.41421356 L7.70710678,8.70710678 C7.31658249,9.09763107 6.68341751,9.09763107 6.29289322,8.70710678 C5.90236893,8.31658249 5.90236893,7.68341751 6.29289322,7.29289322 L11.2928932,2.29289322 C11.6834175,1.90236893 12.3165825,1.90236893 12.7071068,2.29289322 L17.7071068,7.29289322 C18.0976311,7.68341751 18.0976311,8.31658249 17.7071068,8.70710678 C17.3165825,9.09763107 16.6834175,9.09763107 16.2928932,8.70710678 L13,5.41421356 L13,15 C13,15.5522847 12.5522847,16 12,16 C11.4477153,16 11,15.5522847 11,15 L11,5.41421356 Z M20,16 C20,15.4477153 20.4477153,15 21,15 C21.5522847,15 22,15.4477153 22,16 L22,19.5 C22,20.8807119 20.8807119,22 19.5,22 L4.5,22 C3.11928813,22 2,20.8807119 2,19.5 L2,16 C2,15.4477153 2.44771525,15 3,15 C3.55228475,15 4,15.4477153 4,16 L4,19.5 C4,19.7761424 4.22385763,20 4.5,20 L19.5,20 C19.7761424,20 20,19.7761424 20,19.5 L20,16 Z"
    });
  },
  // viewBox = 0 0 14 16
  UploadForward: function UploadForward(_ref134) {
    var color = _ref134.color;
    return /*#__PURE__*/React.createElement("g", {
      id: "Symbol"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.7 10.4C1.0866 10.4 1.4 10.7134 1.4 11.1V13.9C1.4 14.0857 1.47375 14.2637 1.60503 14.395C1.7363 14.5263 1.91435 14.6 2.1 14.6H11.9C12.0857 14.6 12.2637 14.5263 12.395 14.395C12.5263 14.2637 12.6 14.0857 12.6 13.9V11.1C12.6 10.7134 12.9134 10.4 13.3 10.4C13.6866 10.4 14 10.7134 14 11.1V13.9C14 14.457 13.7788 14.9911 13.3849 15.3849C12.9911 15.7788 12.457 16 11.9 16H2.1C1.54305 16 1.0089 15.7788 0.615076 15.3849C0.221249 14.9911 0 14.457 0 13.9V11.1C0 10.7134 0.313401 10.4 0.7 10.4Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.5286 0.195262C9.78895 -0.0650874 10.2111 -0.0650874 10.4714 0.195262L13.8047 3.5286C14.0651 3.78894 14.0651 4.21106 13.8047 4.4714L10.4714 7.80474C10.2111 8.06509 9.78895 8.06509 9.5286 7.80474C9.26825 7.54439 9.26825 7.12228 9.5286 6.86193L11.7239 4.66667H7.33333C6.8029 4.66667 6.29419 4.87738 5.91912 5.25245C5.54405 5.62753 5.33333 6.13623 5.33333 6.66667V11.3333C5.33333 11.7015 5.03486 12 4.66667 12C4.29848 12 4 11.7015 4 11.3333V6.66667C4 5.78261 4.35119 4.93477 4.97631 4.30964C5.60143 3.68452 6.44928 3.33333 7.33333 3.33333H11.7239L9.5286 1.13807C9.26825 0.877722 9.26825 0.455612 9.5286 0.195262Z",
      fill: color
    }));
  },
  UserCircle: function UserCircle(_ref135) {
    var color = _ref135.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25,0 A 25,25 0 0 0 10.45,45.3 l 0.23,0.16 c 0.34,0.24 0.68,0.46 1,0.68 l 0.83,0.5 1,0.56 1,0.51 0.27,0.12 0.62,0.28 q 1,0.42 2,0.72 l 0.34,0.1 L 18,49 c 0.58,0.16 1.11,0.3 1.62,0.41 l 0.62,0.13 h 0.13 c 0.52,0.09 1.05,0.18 1.59,0.24 h 0.19 l 0.51,0.05 c 0.86,0.08 1.61,0.12 2.3,0.12 0.69,0 1.44,0 2.3,-0.12 l 0.5,-0.05 h 0.2 q 0.81,-0.09 1.59,-0.24 h 0.12 l 0.63,-0.13 c 0.51,-0.11 1,-0.25 1.62,-0.41 l 0.23,-0.07 0.34,-0.1 a 20.46,20.46 0 0 0 2,-0.72 l 0.64,-0.28 0.26,-0.12 1.05,-0.51 1,-0.56 0.83,-0.5 c 0.35,-0.22 0.69,-0.44 1,-0.68 l 0.15,-0.1 0.07,-0.06 A 25,25 0 0 0 25,0 Z m -4.71,35.92 a 4.58,4.58 0 0 0 -1,-3 A 7.9,7.9 0 0 1 18,29.4 2.62,2.62 0 0 0 16.37,27.32 c -0.29,-0.14 -0.6,-0.29 -0.74,-2 a 1.86,1.86 0 0 1 0.21,-1 1.37,1.37 0 0 0 0.7,-1.45 c 0,0 -0.22,-1.23 -0.42,-2.63 -0.61,-3.73 -0.58,-7.42 3.77,-9.18 4.55,-1.84 7.67,-0.54 8,-0.15 a 1.49,1.49 0 0 0 0.88,0.65 h 0.18 a 0.62,0.62 0 0 0 0.34,0 v 0 A 4.62,4.62 0 0 1 32.6,13 c 1.81,2.11 1.21,8 0.86,9.85 a 1.24,1.24 0 0 0 0.65,1.43 c 0,0 0.26,0.21 0.26,0.88 -0.14,1.85 -0.45,2 -0.74,2.14 a 2.62,2.62 0 0 0 -1.63,2.11 7.74,7.74 0 0 1 -1.34,3.53 4.66,4.66 0 0 0 -0.95,3 c 0,4.25 1.57,6.54 6,8.58 l -0.5,0.27 -1.1,0.53 -0.22,0.1 -0.33,0.15 c -0.5,0.21 -1,0.41 -1.68,0.61 l -0.57,0.18 c -0.56,0.16 -1.08,0.3 -1.59,0.41 l -0.28,0.06 c -0.59,0.12 -1.21,0.22 -1.92,0.3 h -0.48 a 19.48,19.48 0 0 1 -4,0 h -0.48 c -0.71,-0.08 -1.33,-0.18 -1.92,-0.3 l -0.28,-0.06 c -0.51,-0.11 -1,-0.25 -1.61,-0.42 l -0.56,-0.17 c -0.62,-0.2 -1.17,-0.4 -1.66,-0.61 l -0.34,-0.15 -0.22,-0.1 -1.1,-0.53 -0.5,-0.27 c 4.35,-2.06 5.92,-4.35 5.92,-8.6 z m 12.64,-1.44 a 10.29,10.29 0 0 0 1.76,-4.57 0.64,0.64 0 0 1 0,-0.07 l 0.1,-0.05 c 1.29,-0.62 2.08,-1.55 2.3,-4.51 a 4.14,4.14 0 0 0 -0.83,-2.66 c 0.29,-2.07 0.95,-8.41 -1.61,-11.39 a 7.06,7.06 0 0 0 -5,-2.32 C 27.9,7.29 23.56,6.61 18.82,8.53 c -7,2.82 -5.87,9.59 -5.45,12.14 0.11,0.75 0.22,1.46 0.31,2 a 4.23,4.23 0 0 0 -0.82,2.76 c 0.21,2.87 1,3.78 2.29,4.4 l 0.1,0.05 c 0,0 0,0 0,0.06 a 10.38,10.38 0 0 0 1.77,4.59 1.93,1.93 0 0 1 0.48,1.43 c 0,3.26 -0.91,4.79 -6,6.77 A 22.07,22.07 0 0 1 2.74,25 22.26,22.26 0 0 1 47.26,25 22.07,22.07 0 0 1 38.45,42.69 c -5.09,-2 -6,-3.51 -6,-6.77 a 2,2 0 0 1 0.48,-1.44 z"
    });
  },
  UserSolid: function UserSolid(_ref136) {
    var color = _ref136.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 46.847222,44.61063 H 3.1527775 c 0,-10.901204 8.4605255,-16.149932 21.8472215,-16.149932 13.386697,0 21.847223,5.248728 21.847223,16.149932 z M 24.999999,23.846433 c -5.340432,0 -9.709876,-4.15284 -9.709876,-9.228531 1e-6,-5.0756932 4.369444,-9.2285325 9.709876,-9.2285325 5.340431,0 9.709877,4.1528393 9.709877,9.2285325 0,5.075691 -4.369446,9.228531 -9.709877,9.228531 z"
    });
  },
  User: function User(_ref137) {
    var color = _ref137.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25,0 A 25,25 0 0 0 10.45,45.3 l 0.23,0.16 c 0.34,0.24 0.68,0.46 1,0.68 l 0.83,0.5 1,0.56 1,0.51 0.27,0.12 0.62,0.28 q 1,0.42 2,0.72 l 0.34,0.1 L 18,49 c 0.58,0.16 1.11,0.3 1.62,0.41 l 0.62,0.13 h 0.13 c 0.52,0.09 1.05,0.18 1.59,0.24 h 0.19 l 0.51,0.05 c 0.86,0.08 1.61,0.12 2.3,0.12 0.69,0 1.44,0 2.3,-0.12 l 0.5,-0.05 h 0.2 q 0.81,-0.09 1.59,-0.24 h 0.12 l 0.63,-0.13 c 0.51,-0.11 1,-0.25 1.62,-0.41 l 0.23,-0.07 0.34,-0.1 a 20.46,20.46 0 0 0 2,-0.72 l 0.64,-0.28 0.26,-0.12 1.05,-0.51 1,-0.56 0.83,-0.5 c 0.35,-0.22 0.69,-0.44 1,-0.68 l 0.15,-0.1 0.07,-0.06 A 25,25 0 0 0 25,0 Z m -4.71,35.92 a 4.58,4.58 0 0 0 -1,-3 A 7.9,7.9 0 0 1 18,29.4 2.62,2.62 0 0 0 16.37,27.32 c -0.29,-0.14 -0.6,-0.29 -0.74,-2 a 1.86,1.86 0 0 1 0.21,-1 1.37,1.37 0 0 0 0.7,-1.45 c 0,0 -0.22,-1.23 -0.42,-2.63 -0.61,-3.73 -0.58,-7.42 3.77,-9.18 4.55,-1.84 7.67,-0.54 8,-0.15 a 1.49,1.49 0 0 0 0.88,0.65 h 0.18 a 0.62,0.62 0 0 0 0.34,0 v 0 A 4.62,4.62 0 0 1 32.6,13 c 1.81,2.11 1.21,8 0.86,9.85 a 1.24,1.24 0 0 0 0.65,1.43 c 0,0 0.26,0.21 0.26,0.88 -0.14,1.85 -0.45,2 -0.74,2.14 a 2.62,2.62 0 0 0 -1.63,2.11 7.74,7.74 0 0 1 -1.34,3.53 4.66,4.66 0 0 0 -0.95,3 c 0,4.25 1.57,6.54 6,8.58 l -0.5,0.27 -1.1,0.53 -0.22,0.1 -0.33,0.15 c -0.5,0.21 -1,0.41 -1.68,0.61 l -0.57,0.18 c -0.56,0.16 -1.08,0.3 -1.59,0.41 l -0.28,0.06 c -0.59,0.12 -1.21,0.22 -1.92,0.3 h -0.48 a 19.48,19.48 0 0 1 -4,0 h -0.48 c -0.71,-0.08 -1.33,-0.18 -1.92,-0.3 l -0.28,-0.06 c -0.51,-0.11 -1,-0.25 -1.61,-0.42 l -0.56,-0.17 c -0.62,-0.2 -1.17,-0.4 -1.66,-0.61 l -0.34,-0.15 -0.22,-0.1 -1.1,-0.53 -0.5,-0.27 c 4.35,-2.06 5.92,-4.35 5.92,-8.6 z m 12.64,-1.44 a 10.29,10.29 0 0 0 1.76,-4.57 0.64,0.64 0 0 1 0,-0.07 l 0.1,-0.05 c 1.29,-0.62 2.08,-1.55 2.3,-4.51 a 4.14,4.14 0 0 0 -0.83,-2.66 c 0.29,-2.07 0.95,-8.41 -1.61,-11.39 a 7.06,7.06 0 0 0 -5,-2.32 C 27.9,7.29 23.56,6.61 18.82,8.53 c -7,2.82 -5.87,9.59 -5.45,12.14 0.11,0.75 0.22,1.46 0.31,2 a 4.23,4.23 0 0 0 -0.82,2.76 c 0.21,2.87 1,3.78 2.29,4.4 l 0.1,0.05 c 0,0 0,0 0,0.06 a 10.38,10.38 0 0 0 1.77,4.59 1.93,1.93 0 0 1 0.48,1.43 c 0,3.26 -0.91,4.79 -6,6.77 A 22.07,22.07 0 0 1 2.74,25 22.26,22.26 0 0 1 47.26,25 22.07,22.07 0 0 1 38.45,42.69 c -5.09,-2 -6,-3.51 -6,-6.77 a 2,2 0 0 1 0.48,-1.44 z"
    });
  },
  User2: function User2() {
    return /*#__PURE__*/React.createElement("g", {
      id: "Symbols",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "FPO-Person-Icon",
      transform: "translate(1.000000, 0.000000)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M24.3473,12.3896 C24.3473,19.0166 18.9753,24.3896 12.3473,24.3896 C5.7203,24.3896 0.3473,19.0166 0.3473,12.3896 C0.3473,5.7626 5.7203,0.3896 12.3473,0.3896 C18.9753,0.3896 24.3473,5.7626 24.3473,12.3896",
      id: "Fill-1",
      fill: "#C2D500"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M24.3473,12.3896 C24.3473,19.0166 18.9753,24.3896 12.3473,24.3896 C5.7203,24.3896 0.3473,19.0166 0.3473,12.3896 C0.3473,5.7626 5.7203,0.3896 12.3473,0.3896 C18.9753,0.3896 24.3473,5.7626 24.3473,12.3896 Z",
      id: "Stroke-3",
      stroke: "#514051",
      strokeWidth: "0.75",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.4352,17.9365 C15.4352,16.6655 16.1572,17.0815 16.5862,14.7535 C16.7652,13.7885 17.6322,14.7375 17.7992,12.5345 C17.7992,11.6535 17.3272,11.4365 17.3272,11.4365 C17.4972,10.5315 17.8942,7.2025 16.7322,5.8505 C15.9482,4.9375 14.7572,4.9045 14.4712,4.9105 C14.4432,4.9025 14.4172,4.8955 14.3892,4.8885 C14.0642,4.3305 12.0972,3.6155 9.4932,4.6695 C6.7892,5.7645 6.8302,8.1315 7.1492,10.0895 C7.2512,10.8085 7.3672,11.4365 7.3672,11.4365 C7.3672,11.4365 6.8942,11.6535 6.8942,12.5345 C7.0612,14.7375 7.9292,13.7885 8.1072,14.7535 C8.5382,17.0815 9.2592,16.6655 9.2592,17.9365 C9.2592,20.0245 8.5092,21.0155 5.4032,22.1645 C7.3652,23.5605 9.7562,24.3895 12.3472,24.3895 C14.9382,24.3895 17.3302,23.5605 19.2912,22.1645 C16.1852,21.0155 15.4352,20.0245 15.4352,17.9365",
      id: "Fill-5",
      fill: "#FFFFFF"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.4352,17.9365 C15.4352,16.6655 16.1572,17.0815 16.5862,14.7535 C16.7652,13.7885 17.6322,14.7375 17.7992,12.5345 C17.7992,11.6535 17.3272,11.4365 17.3272,11.4365 C17.4972,10.5315 17.8942,7.2025 16.7322,5.8505 C15.9482,4.9375 14.7572,4.9045 14.4712,4.9105 C14.4432,4.9025 14.4172,4.8955 14.3892,4.8885 C14.0642,4.3305 12.0972,3.6155 9.4932,4.6695 C6.7892,5.7645 6.8302,8.1315 7.1492,10.0895 C7.2512,10.8085 7.3672,11.4365 7.3672,11.4365 C7.3672,11.4365 6.8942,11.6535 6.8942,12.5345 C7.0612,14.7375 7.9292,13.7885 8.1072,14.7535 C8.5382,17.0815 9.2592,16.6655 9.2592,17.9365 C9.2592,20.0245 8.5092,21.0155 5.4032,22.1645 C7.3652,23.5605 9.7562,24.3895 12.3472,24.3895 C14.9382,24.3895 17.3302,23.5605 19.2912,22.1645 C16.1852,21.0155 15.4352,20.0245 15.4352,17.9365 Z",
      id: "Stroke-7",
      stroke: "#514051",
      strokeWidth: "0.75",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })));
  },
  VerticalBarChart: function VerticalBarChart(_ref138) {
    var color = _ref138.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 48,0 H 37.2 a 2,2 0 0 0 -2,2 v 6.2 h -9.8 a 2,2 0 0 0 -2,2 V 27.9 H 2 a 2,2 0 0 0 -2,2 V 48 a 2,2 0 0 0 2,2 h 10.8 a 2,2 0 0 0 2,-2 v -3.1 h 9.8 a 2,2 0 0 0 2,-2 v -12 H 48 a 2,2 0 0 0 2,-2 V 2 A 2,2 0 0 0 48,0 Z M 11.8,47 H 3 V 30.9 h 8.8 z m 11.7,-5.1 h -8.8 v -11 h 8.8 z m 3,-30.7 h 8.8 V 27.9 H 26.5 Z M 47,27.9 H 38.2 V 3 H 47 Z",
      fillRule: "evenodd",
      clipRule: "evenodd"
    });
  },
  Visa: function Visa() {
    return /*#__PURE__*/React.createElement("g", {
      fill: "none",
      transform: "translate(2 6)"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "20",
      height: "10.4",
      y: "1.17",
      fill: "#F6F6F6"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#265697",
      d: "M18.5,1.31490693e-07 C17.5,2.29637964e-07 6.91259765,-2.08413885e-07 1,1.31490693e-07 C0.5,1.60234792e-07 4.61852779e-14,0.520000131 7.10542736e-14,1.04000013 L7.10542736e-14,2.60000013 L20,2.60000013 C20,2.60000013 19.9999998,5.01435234 20,1.56000013 C20,0.520000131 19.5,1.31490693e-07 18.5,1.31490693e-07 Z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#D97B16",
      d: "M0,10.4 C0,10.4 0,10.4 0,11.4400001 C-5.78549837e-08,12.48 0.5,13 1.5,13 C7.0779012,13 17.5,13 18.5,13 C19.5,13 20,12.48 20,11.4400001 L20,10.4 L0,10.4 Z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#265697",
      d: "M13.9518181 3.87167409C13.6715 3.75992276 13.232303 3.64 12.6837841 3.64 11.2857992 3.64 10.301053 4.38816473 10.2926477 5.46036886 10.2847727 6.25296926 10.9956704 6.69509991 11.5323371 6.95898069 12.0830568 7.22934226 12.2681856 7.40178759 12.2655341 7.64321103 12.2620606 8.01295409 11.8257538 8.18187724 11.4191174 8.18187724 10.8528333 8.18187724 10.5519924 8.09827507 10.0873409 7.8923269L9.90502272 7.8046672 9.70645076 9.03948276C10.0368826 9.19344374 10.6479773 9.32686344 11.2824583 9.3337669 12.7696666 9.3337669 13.7351364 8.59419626 13.7461136 7.44921005 13.7514431 6.82170069 13.3744772 6.34417931 12.5582614 5.9505137 12.0637273 5.6953397 11.7608712 5.52506404 11.7640795 5.26667783 11.7640795 5.03739882 12.020428 4.79222778 12.574303 4.79222778 13.0369659 4.78459172 13.3720909 4.8918065 13.6332386 5.00355783L13.7600076 5.06721045 13.9518181 3.87167409M17.5798069 3.74112847L16.4865606 3.74112847C16.1479091 3.74112847 15.8944508 3.83935468 15.7457273 4.1985594L13.6445076 9.25365871 15.130178 9.25365871C15.130178 9.25365871 15.3730834 8.57396493 15.4280228 8.42473774 15.590375 8.42473774 17.0336478 8.42710463 17.2399621 8.42710463 17.2823069 8.62020394 17.4120985 9.25365871 17.4120985 9.25365871L18.7249166 9.25365871 17.5798069 3.74112847 17.5798069 3.74112847zM15.8351894 7.29648886C15.9522007 6.97867665 16.398875 5.75451211 16.398875 5.75451211 16.3905227 5.76919251 16.5150114 5.43515015 16.5864697 5.22804669L16.6820834 5.70362385C16.6820834 5.70362385 16.9529886 7.02032276 17.009625 7.29643251L15.8351894 7.29648886 15.8351894 7.29648886 15.8351894 7.29648886 15.8351894 7.29648886z"
    }), /*#__PURE__*/React.createElement("polygon", {
      fill: "#265697",
      points: "7.406 9.252 8.291 3.736 9.706 3.736 8.82 9.252"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#265697",
      d: "M6.21960228,3.73988867 L4.83445076,7.50142266 L4.68686743,6.73699961 C4.42900758,5.85580966 3.62559849,4.90107684 2.72742424,4.42310463 L3.99397349,9.24714976 L5.49088636,9.24534641 L7.71826515,3.73988867 L6.21960228,3.73988867"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#D97B16",
      d: "M3.54944698,3.73647921 L1.26805681,3.73647921 L1.25,3.85124551 C3.02489773,4.30783114 4.19933334,5.41122759 4.68684091,6.73699961 L4.19076894,4.20216611 C4.105125,3.8528798 3.85673106,3.74865183 3.54944698,3.73647921"
    }));
  },
  Visualize: function Visualize(_ref139) {
    var color = _ref139.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25.1,21.2 A 3.8,3.8 0 1 0 28.9,25 3.8,3.8 0 0 0 25.1,21.2 Z M 25,14.5 A 10.5,10.5 0 1 0 35.5,25 10.5,10.5 0 0 0 25,14.5 Z m 0,18 A 7.5,7.5 0 1 1 32.5,25 7.55,7.55 0 0 1 25,32.5 Z M 49.7,24.3 A 28.84,28.84 0 0 0 25,9.7 C 7.6,9.2 0.4,24.2 0.3,24.4 L 0,25.1 0.4,25.8 c 0.3,0.6 8.1,14 24.6,14.6 h 1 c 15.9,0 23.4,-14 23.7,-14.6 L 50,25 Z m -24.6,13 C 12.3,36.8 5.2,27.5 3.4,24.9 A 23.77,23.77 0 0 1 25,12.7 25.64,25.64 0 0 1 46.6,25 c -1.7,2.7 -8.7,12.8 -21.5,12.3 z"
    });
  },
  WebEngagement: function WebEngagement(_ref140) {
    var color = _ref140.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M40.1289,0.0005 C42.2639,0.0005 43.9999,1.7365 43.9999,3.8715 L43.9999,3.8715 L43.9999,33.5675 C43.9999,35.7025 42.2639,37.4385 40.1289,37.4385 L40.1289,37.4385 L3.8709,37.4385 C1.7359,37.4385 -0.0001,35.7025 -0.0001,33.5675 L-0.0001,33.5675 L-0.0001,3.8715 C-0.0001,1.7365 1.7359,0.0005 3.8709,0.0005 L3.8709,0.0005 Z M41.9999,10.7775 L1.9999,10.7775 L1.9999,33.5675 C1.9999,34.5985 2.8399,35.4385 3.8709,35.4385 L3.8709,35.4385 L40.1289,35.4385 C41.1599,35.4385 41.9999,34.5985 41.9999,33.5675 L41.9999,33.5675 L41.9999,10.7775 Z M18.9561,15.9893 L27.7361,23.5333 L23.4801,23.5333 L26.3861,29.5803 L24.3891,30.4993 L21.4741,24.4323 L18.9561,27.4813 L18.9561,15.9893 Z M40.1289,2.0005 L3.8709,2.0005 C2.8399,2.0005 1.9999,2.8395 1.9999,3.8715 L1.9999,3.8715 L1.9999,8.7775 L41.9999,8.7775 L41.9999,3.8715 C41.9999,2.8395 41.1599,2.0005 40.1289,2.0005 L40.1289,2.0005 Z M6.2772,5.127 C6.8302,5.127 7.2772,5.574 7.2772,6.127 C7.2772,6.68 6.8302,7.127 6.2772,7.127 L6.2772,7.127 L6.0312,7.127 C5.4782,7.127 5.0312,6.68 5.0312,6.127 C5.0312,5.574 5.4782,5.127 6.0312,5.127 L6.0312,5.127 Z M11.0771,5.127 C11.6301,5.127 12.0771,5.574 12.0771,6.127 C12.0771,6.68 11.6301,7.127 11.0771,7.127 L11.0771,7.127 L10.8301,7.127 C10.2771,7.127 9.8301,6.68 9.8301,6.127 C9.8301,5.574 10.2771,5.127 10.8301,5.127 L10.8301,5.127 Z M15.8749,5.127 C16.4279,5.127 16.8749,5.574 16.8749,6.127 C16.8749,6.68 16.4279,7.127 15.8749,7.127 L15.8749,7.127 L15.6289,7.127 C15.0759,7.127 14.6289,6.68 14.6289,6.127 C14.6289,5.574 15.0759,5.127 15.6289,5.127 L15.6289,5.127 Z"
    });
  },
  ZipCode: function ZipCode(_ref141) {
    var color = _ref141.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M39.953,0.0729965339 C40.229,-0.0460034661 40.544,-0.0180034661 40.793,0.145996534 C41.043,0.309996534 41.193,0.588996534 41.193,0.887996534 L41.193,0.887996534 L41.193,33.2029965 C41.193,33.5569965 40.982,33.8769965 40.658,34.0169965 L40.658,34.0169965 L27.519,39.7019965 C27.506,39.7079965 27.492,39.7059965 27.479,39.7099965 C27.378,39.7489965 27.273,39.7749965 27.166,39.7749965 C27.059,39.7749965 26.955,39.7489965 26.854,39.7099965 C26.841,39.7059965 26.826,39.7079965 26.814,39.7019965 L26.814,39.7019965 L17.609,35.7229965 C16.084,37.8029965 14.842,39.2959965 14.706,39.4569965 C14.537,39.6589965 14.288,39.7749965 14.025,39.7749965 C13.763,39.7749965 13.514,39.6589965 13.345,39.4569965 C13.209,39.2959965 11.967,37.8019965 10.44,35.7209965 L10.44,35.7209965 L1.24,39.7019965 C1.127,39.7509965 1.007,39.7749965 0.888,39.7749965 C0.717,39.7749965 0.548,39.7249965 0.4,39.6289965 C0.15,39.4649965 9.9475983e-14,39.1859965 9.9475983e-14,38.8879965 L9.9475983e-14,38.8879965 L9.9475983e-14,6.56799653 C9.9475983e-14,6.21499653 0.211,5.89399653 0.535,5.75399653 L0.535,5.75399653 L13.673,0.0729965339 C13.736,0.0459965339 13.801,0.0439965339 13.866,0.0319965339 C13.904,0.0239965339 13.939,0.0109965339 13.979,0.00899653391 C14.112,0.000996533906 14.244,0.0199965339 14.365,0.0709965339 C14.369,0.0729965339 14.374,0.0709965339 14.378,0.0729965339 L14.378,0.0729965339 L27.166,5.60099653 Z M39.418,2.23799653 L28.054,7.15099653 L28.054,37.5369965 L39.418,32.6199965 L39.418,2.23799653 Z M14.913,2.23799653 L14.913,13.5659965 C19.901,14.0159965 23.825,18.2189965 23.825,23.3229965 C23.825,26.2019965 21.129,30.7199965 18.666,34.2449965 L18.666,34.2449965 L26.278,37.5369965 L26.278,7.15099653 L14.913,2.23799653 Z M13.138,2.23799653 L1.775,7.15099653 L1.775,37.5369965 L9.383,34.2439965 C6.921,30.7189965 4.225,26.2019965 4.225,23.3229965 C4.225,18.2189965 8.148,14.0159965 13.138,13.5659965 L13.138,13.5659965 L13.138,2.23799653 Z M14.025,15.2969965 C9.6,15.2969965 6,18.8969965 6,23.3229965 C6,26.7799965 11.28,34.0679965 14.025,37.4869965 C16.771,34.0679965 22.05,26.7799965 22.05,23.3229965 C22.05,18.8969965 18.45,15.2969965 14.025,15.2969965 Z M14.0254,18.4989965 C16.6844,18.4989965 18.8484,20.6629965 18.8484,23.3229965 C18.8484,25.9829965 16.6844,28.1479965 14.0254,28.1479965 C11.3654,28.1479965 9.2014,25.9829965 9.2014,23.3229965 C9.2014,20.6629965 11.3654,18.4989965 14.0254,18.4989965 Z M14.0254,20.2739965 C12.3434,20.2739965 10.9764,21.6419965 10.9764,23.3229965 C10.9764,25.0049965 12.3434,26.3729965 14.0254,26.3729965 C15.7064,26.3729965 17.0734,25.0049965 17.0734,23.3229965 C17.0734,21.6419965 15.7064,20.2739965 14.0254,20.2739965 Z"
    });
  },
  // viewBox = 0 0 50 50
  ZipCodeRank: function ZipCodeRank(_ref142) {
    var color = _ref142.color;
    return /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: color,
      d: "M 38.9,27.8 A 11.1,11.1 0 1 0 50,38.9 11.14,11.14 0 0 0 38.9,27.8 Z m 0,19.2 A 8.1,8.1 0 1 1 47,38.9 8.07,8.07 0 0 1 38.9,47 Z M 40.5,36.8 38.9,32 37.3,36.9 h -5.1 l 4.1,3 -1.6,4.9 4.1,-3 4.1,3 -1.6,-4.9 c 0,0 4.1,-3 4.4,-3 H 40.5 Z M 16.5,0 A 16.65,16.65 0 0 0 0,16.8 c 0,7.7 12.3,24.1 16.1,28.9 l 0.4,0.5 0.4,-0.5 C 19.6,42.3 32.9,24.9 33,16.8 A 16.65,16.65 0 0 0 16.5,0 Z m 0,41 C 13.6,37.1 3.4,23.3 3.4,17 A 13.39,13.39 0 0 1 16.5,3.4 13.39,13.39 0 0 1 29.6,17 c 0,6.3 -10.2,20.1 -13.1,24 z m 0,-32.7 a 8.11,8.11 0 0 0 -8.2,8.2 8.11,8.11 0 0 0 8.2,8.2 8.11,8.11 0 0 0 8.2,-8.2 8.24,8.24 0 0 0 -8.2,-8.2 z m 0,13 a 4.8,4.8 0 0 1 0,-9.6 4.8,4.8 0 0 1 0,9.6 z"
    });
  },
  // viewBox="0 0 50 50"
  CBUnselected: function CBUnselected(_ref143) {
    var color = _ref143.color;
    return /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      fill: color,
      d: "m47 3v44h-44v-44h44m0-3h-44c-1.7 0-3 1.3-3 3v44c0 1.7 1.3 3 3 3h44c1.7 0 3-1.3 3-3v-44c0-1.7-1.3-3-3-3z"
    });
  },
  CBChecked: function CBChecked(_ref144) {
    var color = _ref144.color;
    return /*#__PURE__*/React.createElement("g", {
      id: "chkbx"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "tabSelected",
      fillRule: "evenodd",
      d: "m47 3v44h-44v-44h44m0-3h-44c-1.7 0-3 1.3-3 3v44c0 1.7 1.3 3 3 3h44c1.7 0 3-1.3 3-3v-44c0-1.7-1.3-3-3-3z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "9.6",
      y: "9.6",
      width: "30.8",
      height: "30.8",
      fill: color
    }));
  },
  CBDisabled: function CBDisabled(_ref145) {
    var color = _ref145.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M47,3V47H3V3H47m0-3H3A3,3,0,0,0,0,3V47a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z"
    });
  },
  CBIndetermine: function CBIndetermine(_ref146) {
    var color = _ref146.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M47,3V47H3V3H47m0-3H3A3,3,0,0,0,0,3V47a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z"
    });
  },
  CBUnchecked: function CBUnchecked(_ref147) {
    var color = _ref147.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M47,3V47H3V3H47m0-3H3A3,3,0,0,0,0,3V47a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z"
    });
  },
  RBChecked: function RBChecked(_ref148) {
    var color = _ref148.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M 25 1.84375 C 12.235119 1.8437499 1.8437499 12.235119 1.84375 25 C 1.84375 37.764881 12.235119 48.15625 25 48.15625 C 37.764881 48.15625 48.15625 37.764881 48.15625 25 C 48.15625 12.235119 37.764881 1.84375 25 1.84375 z M 25 5.84375 C 35.60312 5.84375 44.15625 14.39688 44.15625 25 C 44.15625 35.60312 35.60312 44.15625 25 44.15625 C 14.39688 44.15625 5.84375 35.60312 5.84375 25 C 5.8437499 14.39688 14.39688 5.8437499 25 5.84375 z M 25 13.513672 C 18.65667 13.513672 13.513672 18.65667 13.513672 25 C 13.513672 31.34333 18.65667 36.486328 25 36.486328 C 31.34333 36.486328 36.486328 31.34333 36.486328 25 C 36.486328 18.65667 31.34333 13.513672 25 13.513672 z"
    });
  },
  RBUnchecked: function RBUnchecked(_ref149) {
    var color = _ref149.color;
    return /*#__PURE__*/React.createElement("path", {
      fill: color,
      d: "M 25,1.84375 C 12.235119,1.8437499 1.8437499,12.235119 1.84375,25 1.84375,37.764881 12.235119,48.15625 25,48.15625 37.764881,48.15625 48.15625,37.764881 48.15625,25 48.15625,12.235119 37.764881,1.84375 25,1.84375 Z m 0,4 C 35.60312,5.84375 44.15625,14.39688 44.15625,25 44.15625,35.60312 35.60312,44.15625 25,44.15625 14.39688,44.15625 5.84375,35.60312 5.84375,25 5.8437499,14.39688 14.39688,5.8437499 25,5.84375 Z"
    });
  },
  ApiDocs: function ApiDocs(_ref150) {
    var color = _ref150.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 15 18
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M5.584 11.293h.957l.3-.896h1.578l.304.896h.957L8.047 6.941h-.834l-1.625 4.352h-.004Zm2.59-1.623H7.083l.542-1.628.549 1.628ZM12.652 7.12a1.988 1.988 0 0 0-.863-.18h-1.701v4.353h.9V9.76h.787c.516 0 .924-.123 1.217-.371.292-.245.44-.583.44-1.008a1.346 1.346 0 0 0-.777-1.264l-.003.004Zm-.321 1.747c-.127.111-.307.165-.545.165h-.802V7.668h.823c.22.004.397.072.52.202s.188.302.188.518c0 .216-.061.367-.188.479h.004ZM15 6.94h-.9v4.353h.9V6.941Z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M14.993 4.046s0-.01-.004-.018V4.01c-.007-.025-.01-.054-.022-.082-.018-.044-.043-.076-.072-.116-.003-.007-.007-.018-.018-.028L11.305.13a.415.415 0 0 0-.162-.101.447.447 0 0 0-.145-.029h-6.97c-.813 0-1.47.655-1.47 1.465v1.271H1.47C.657 2.736 0 3.395 0 4.201v12.334C0 17.345.661 18 1.47 18h9.503c.813 0 1.47-.659 1.47-1.465v-1.206c0-.022 0-.043-.007-.065h1.094c.813 0 1.47-.659 1.47-1.465v-1.134h-.896v1.134a.573.573 0 0 1-.574.572H4.027a.572.572 0 0 1-.574-.572V1.462c0-.317.256-.573.574-.573h6.512v3.204a.45.45 0 0 0 .448.447h3.117v1.443H15v-1.89a.16.16 0 0 0-.007-.047ZM4.027 15.26h7.527c-.003.022-.007.04-.007.065v1.206a.573.573 0 0 1-.574.573H1.47a.575.575 0 0 1-.574-.573V4.198c0-.317.256-.573.574-.573h1.087v10.17c0 .81.661 1.465 1.47 1.465Zm7.361-11.566V1.429l2.21 2.265h-2.21Z"
      }))
    );
  },
  Key: function Key(_ref151) {
    var color = _ref151.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 21 10
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M4.97 10c-1.258 0-2.57-.473-3.514-1.467-1.941-1.94-1.941-5.136 0-7.075C3.188-.272 5.914-.482 7.91.934c.21.158.263.524.105.733-.16.21-.474.263-.734.105C5.708.619 3.556.775 2.19 2.19.667 3.71.667 6.226 2.19 7.746c1.521 1.52 4.038 1.52 5.56 0a.745.745 0 0 0 .159-.21c.21-.209.524-.263.734-.053.21.21.264.524.054.733-.054.105-.159.159-.21.21-.998 1.101-2.256 1.57-3.514 1.57L4.97 10Z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M4.97 7.276c-.578 0-1.153-.21-1.572-.682-.42-.42-.683-.997-.683-1.572 0-.575.21-1.152.683-1.571.42-.42.997-.683 1.573-.683.575 0 1.153.21 1.573.683.21.21.21.524 0 .733a.507.507 0 0 1-.734 0c-.474-.473-1.259-.473-1.678 0-.21.21-.369.524-.369.838 0 .314.105.629.369.838.473.473 1.258.473 1.678 0 .21-.21.524-.21.734 0 .21.21.21.524 0 .734-.42.472-.998.682-1.573.682Zm13.957.629c-.734 0-1.103-.42-1.364-.683-.26-.263-.368-.368-.629-.368-.26 0-.368.105-.629.368-.264.314-.63.683-1.363.683-.734 0-1.103-.42-1.364-.683-.26-.263-.368-.368-.629-.368-.26 0-.368.105-.629.368-.264.314-.629.683-1.363.683s-1.103-.42-1.363-.683c-.21-.21-.315-.314-.474-.368-.263-.054-.473-.368-.42-.629.055-.26.37-.473.63-.419.473.105.788.42.998.629.263.263.368.368.629.368.26 0 .368-.105.63-.368.263-.314.628-.683 1.362-.683.734 0 1.103.42 1.364.683.26.263.368.368.629.368.26 0 .368-.105.629-.368.264-.314.63-.683 1.363-.683.734 0 1.103.42 1.363.683.16.159.264.263.369.314l1.207-1.78-1.207-1.835H8.749c-.315 0-.525-.21-.525-.524 0-.315.21-.524.525-.524h10.178c.159 0 .314.105.42.21l1.572 2.358a.57.57 0 0 1 0 .578L19.346 7.59c-.105.264-.264.315-.42.315Z"
      }))
    );
  },
  Usage: function Usage(_ref152) {
    var color = _ref152.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 17 17
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
        fill: color,
        clipPath: "url(#a)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8.502 0A8.5 8.5 0 0 0 0 8.502a8.5 8.5 0 0 0 8.502 8.502 8.5 8.5 0 0 0 8.502-8.502A8.502 8.502 0 0 0 8.502 0Zm0 15.815a7.312 7.312 0 0 1-7.313-7.313 7.315 7.315 0 0 1 7.313-7.317 7.312 7.312 0 0 1 7.313 7.313 7.312 7.312 0 0 1-7.313 7.314v.003Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M7.317 4.188a.591.591 0 0 0-.657.179L4.682 6.74a.595.595 0 0 0 .076.835c.25.21.626.175.835-.075l.927-1.113v4.69a.593.593 0 0 0 1.184 0v-6.33c0-.251-.155-.471-.39-.559h.003ZM11.407 9.504l-.926 1.113v-4.69a.593.593 0 0 0-1.185 0v6.326a.594.594 0 0 0 1.048.38l1.978-2.373a.595.595 0 0 0-.076-.835.595.595 0 0 0-.835.075l-.004.004Z"
      })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
        id: "a"
      }, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M0 0h17v17H0z"
      }))))
    );
  },
  PresentationScreen: function PresentationScreen(_ref153) {
    var color = _ref153.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 18 16
      React.createElement("path", {
        fill: color,
        d: "M17.338 9.896h-1.075v-8.8h1.078a.546.546 0 0 0 .545-.548.546.546 0 0 0-.545-.548H.545A.546.546 0 0 0 0 .548c0 .303.243.548.545.548h1.194v8.8H.545a.546.546 0 0 0-.545.548c0 .303.243.548.545.548H7.94l-2.945 4.142A.548.548 0 0 0 5.44 16a.54.54 0 0 0 .443-.23l2.57-3.617v2.466a.546.546 0 1 0 1.09 0v-2.466l2.57 3.617a.54.54 0 0 0 .76.128.551.551 0 0 0 .127-.764l-2.945-4.142h7.28a.546.546 0 0 0 .545-.548.546.546 0 0 0-.545-.548h.004Zm-2.164-.007H2.829V1.12h12.345V9.89Z"
      })
    );
  },
  RTTest: function RTTest(_ref154) {
    var color = _ref154.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 10 10
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0Zm0 9.3A4.3 4.3 0 1 1 5 .7a4.3 4.3 0 0 1 0 8.6Z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "m7.48 4.72-3.7-2.44a.34.34 0 0 0-.34-.01.33.33 0 0 0-.18.3v4.87a.33.33 0 0 0 .34.33c.06 0 .13-.01.18-.05l3.7-2.44a.34.34 0 0 0 0-.56Zm-3.54 2.1V3.19L6.69 5 3.94 6.82Z"
      }))
    );
  },
  Copy: function Copy(_ref155) {
    var color = _ref155.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 14 14
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M1 8.5a.5.5 0 0 0 .5.5H2v1h-.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0h7A1.5 1.5 0 0 1 10 1.5V2H9v-.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v7Z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v7A1.5 1.5 0 0 0 5.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 12.5 4h-7ZM5 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7Z",
        clipRule: "evenodd"
      }))
    );
  },
  WrapLines: function WrapLines(_ref156) {
    var color = _ref156.color;
    return (
      /*#__PURE__*/
      // viewBox 0 0 14 14
      React.createElement("path", {
        fill: color,
        d: "M14 1H0V0h14v1ZM11 6H0V5h11a3 3 0 1 1 0 6H8.707l1.647 1.646-.707.708L6.792 10.5l2.853-2.854.708.708L8.707 10H11a2 2 0 1 0 0-4ZM0 11h5v-1H0v1Z"
      })
    );
  },
  TotalUsage: function TotalUsage(_ref157) {
    var color = _ref157.color;
    return (
      /*#__PURE__*/
      // viewBox '0 0 10 10'
      React.createElement("path", {
        fill: color,
        d: "M.56 14.29h10.97c.05 0 .1 0 .15-.03.03.03.06.03.13.03h3.35c.33 0 .61-.3.61-.64V.64a.63.64 0 0 0-.62-.64h-3.38a.63.64 0 0 0-.62.64v2.22H8.06a.56.57 0 0 0-.57.57v3.59H4.32a.48.49 0 0 0-.48.47V9.2H.56a.4.4 0 0 0-.4.4v4.27c0 .22.18.4.4.4zM12.09.95h2.75v12.39h-2.75ZM8.44 3.81h2.75v9.53H8.43V3.8ZM4.78 7.97h2.75v5.37H4.78Zm-3.69 2.2h2.75v3.17H1.1v-3.18Zm14.37 4.88H.54a.47.48 0 1 0 0 .95h14.92a.47.48 0 1 0 0-.95z"
      })
    );
  },
  Reset: function Reset(_ref158) {
    var color = _ref158.color;
    return (
      /*#__PURE__*/
      // viewBox '0 0 72 72'
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "m4 28 6.6 9.6.2.2c.1.1.2.2.4.2.1.1.2.1.3.1 0 0 .1.1.2.1.4.1.7 0 1.1-.1l.4-.2 9.4-6.4c.5-.3.8-.8.9-1.3.1-.5 0-1.1-.3-1.6-.7-.9-2-1.2-2.9-.6l-5.8 4c2-12 12.3-20.8 24.7-20.8 13.8 0 25 11.2 25 25s-11.2 25-25 25c-8.3 0-16.1-4.1-20.8-11-.6-1-1.9-1.2-2.9-.6s-1.2 1.9-.6 2.9c5.4 8.1 14.5 12.9 24.2 12.9 16.1 0 29.2-13.1 29.2-29.2C68.4 20.1 55.3 7 39.2 7c-13.9 0-25.8 9.9-28.6 23.3l-3.2-4.7c-.7-1-2-1.2-2.9-.6-.5.3-.8.8-.9 1.3-.1.7.1 1.3.4 1.7zm7.3 9.2z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: color,
        d: "M38.6 19.1c-1.2 0-2.1.9-2.1 2.1v17c0 .5.2 1 .5 1.3l8.5 10.2c.4.5 1 .8 1.6.8.5 0 1-.2 1.3-.5.4-.4.7-.9.7-1.4.1-.6-.1-1.1-.5-1.5l-8-9.6V21.2c.1-1.1-.9-2.1-2-2.1z"
      }))
    );
  }
};

function slightlyGoodSignal () {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-s1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D84438",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66120E",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Slightly",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.712747,135 C99.7500923,135 86,150.199408 86,168.966406 L86,268.032778 C86,286.785081 99.7500923,302 116.712747,302 L121.287253,302 C138.249908,302 152,286.792429 152,268.033594 L152,168.966406 C152,150.206755 138.24917,135 121.287253,135 L116.712747,135 Z",
    id: "Path",
    fill: "#D6D6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.713091,302 L207.286909,302 C224.249754,302 238,286.834163 238,268.126809 L238,112.873191 C238,94.173164 224.249016,79 207.286909,79 L202.713091,79 C185.750246,79 172,94.1658367 172,112.873191 L172,268.126809 C171.999262,286.826836 185.750246,302 202.713091,302 Z",
    id: "Path",
    fill: "#D6D6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,268.130856 L324,33.8691437 C324,15.171351 310.249323,0 293.286858,0 L288.706498,0 C271.750677,0 258,15.1640246 258,33.8691437 L258,268.130042 C258,286.827835 271.750677,302 288.706498,302 L293.286858,302 C310.249323,302 324,286.835975 324,268.130856 Z",
    id: "Path",
    fill: "#D6D6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2899496,176 L30.7159552,176 C13.7559355,176 0,191.154983 0,209.849763 L0,268.150237 C0,286.837695 13.7559355,302 30.7166933,302 L35.2906877,302 C52.2440645,302 66,286.845017 66,268.151051 L66,209.849763 C66,191.154983 52.2440645,176 35.2899496,176 Z",
    id: "Path",
    fill: "url(#linearGradient-s1)",
    fillRule: "nonzero"
  })));
}

/* eslint-disable react/prop-types */

function actuarialModel (_ref) {
  var color = _ref.color;
  // viewBox 0 0 12 12
  return /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9.72C.78.72.7.8.7.9v8.37c0 .1.09.18.2.18h3.26c.2 0 .35.16.35.36 0 .2-.15.36-.35.36H.89a.9.9 0 0 1-.89-.9V.9C0 .4.4 0 .9 0h10.2c.5 0 .9.4.9.9v8.37c0 .5-.4.9-.9.9H7.94a.36.36 0 0 1-.36-.36c0-.2.16-.36.36-.36h3.18c.1 0 .18-.08.18-.18V.9c0-.1-.08-.18-.18-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.73a2.48 2.48 0 0 0-2.46 2.5 2.46 2.46 0 1 0 4.92-.02c0-1.38-1.1-2.48-2.46-2.48zm-3.03 2.5c0-1.7 1.36-3.07 3.03-3.07s3.03 1.37 3.03 3.06S7.67 9.3 6 9.3 2.97 7.9 2.97 6.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.8c.26 0 .47.21.47.48v2.24c0 .27-.2.48-.47.48a.48.48 0 0 1-.47-.48V9.28c0-.27.2-.48.47-.48zM2.78 5.92H2.2v2.56h1.32v-.17a3.29 3.29 0 0 1-.74-2.4zm1.45-.59v2.3c.32.41.78.72 1.3.84V5.33Zm2.02-.68v3.82c.5-.06.96-.28 1.31-.62v-3.2H6.25Zm3.33-1.2h-1.3v.45a3.28 3.28 0 0 1 .05 4.59h1.25zm2.07-.99H.35V1.9h11.3ZM10.4 1.6c.18 0 .32-.15.32-.33a.32.32 0 0 0-.32-.32.32.32 0 0 0-.32.32c0 .18.15.32.32.32zm-1.2 0c.19 0 .33-.15.33-.33A.32.32 0 0 0 9.2.95a.32.32 0 0 0-.32.32c0 .18.14.32.32.32zM8 1.6c.19 0 .33-.15.33-.33A.32.32 0 0 0 8 .95a.32.32 0 0 0-.32.32c0 .18.14.32.32.32z"
  }));
}

/* eslint-disable react/prop-types */
function closedEye (_ref) {
  var color = _ref.color;
  // viewBox="3 33 66 29"
  return /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M68.2 46.6 63 41.3c2.3-2.3 3.7-4.3 4.3-5.1.6-.9.4-2.1-.5-2.7-.9-.6-2.1-.4-2.7.5C62.4 36.5 53 49 36 49S9.6 36.5 7.8 34c-.6-.9-1.8-1.1-2.7-.5-.9.6-1.1 1.8-.5 2.7.6.9 2.1 2.8 4.4 5.1l-5.1 5.3c-.8.8-.8 2.1 0 2.8.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6l5.2-5.4c2.2 1.9 5 3.7 8.2 5.3l-2.8 6c-.5 1 0 2.2.9 2.7.3.1.6.2.9.2.7 0 1.5-.4 1.8-1.1l2.9-6.2c3 1.1 6.4 1.8 10.2 2v6.8c0 1.1.9 2 2 2s2-.9 2-2v-6.8c3.7-.2 7.1-.9 10.1-2l2.9 6.2c.3.7 1.1 1.1 1.8 1.1.3 0 .6-.1.9-.2a2 2 0 0 0 .9-2.7l-2.8-6c3.2-1.5 6-3.4 8.2-5.3l5.2 5.4c.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6.9-.8.9-2 .2-2.8z"
  });
}

/* eslint-disable react/prop-types */
function reload (_ref) {
  var color = _ref.color;
  // viewBox="0 0 12 11.75"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m1.12.4-.06 2.34.01.05.03.08a.4.4 0 0 0 .04.07l.04.04c.05.05.11.1.2.11l.1.02 2.32.06c.12 0 .23-.03.31-.11a.42.42 0 0 0 .13-.3.43.43 0 0 0-.41-.43L2.4 2.3A5.21 5.21 0 0 1 9 1.8a4.95 4.95 0 0 1 1.16 7A5.23 5.23 0 0 1 3 9.95 4.99 4.99 0 0 1 .86 5.71a.42.42 0 0 0-.42-.43.42.42 0 0 0-.44.4 5.81 5.81 0 0 0 2.49 4.94 6.1 6.1 0 0 0 8.38-1.32A5.78 5.78 0 0 0 9.5 1.12a6.13 6.13 0 0 0-7.56.44L1.98.43A.42.42 0 0 0 1.56 0a.44.44 0 0 0-.3.11.42.42 0 0 0-.14.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.12.4 3 .08-3-.08zm-.06 2.34-3-.08c-.06.26.05.37.31.29l2.69-.21Zm.01.05 2.9-.74c.02-.31-.22-.19-.4-.11l-2.5.85Zm.03.08 2.68-1.36c-.09-.24-.32.07-.48.11L1.1 2.87Zm.04.07 2.67-1.37c-.09-.13-.19-.48-.34-.42L1.14 2.94Zm.04.04L3.32.88c-.14-.08-.28.25-.42.33L1.18 2.98Zm.2.11L.67 6.01c.27.14.26-.12.29-.32l.42-2.6Zm.1.02-.5 2.96c.18.02.49.12.4-.17l.1-2.79Zm2.32.06-.08 3c.05-.2.02-.5.03-.74l.05-2.26Zm.44-.4 3 .07-3-.07zm-.41-.44.1-3c-.07.14-.02.41-.04.6l-.06 2.4ZM2.4 2.3.3.14-4.82 5.1l7.13.2.09-3zM9 1.8 7.28 4.25 9 1.8Zm1.16 7-2.4-1.77 2.4 1.77zM3 9.95 1.27 12.4 3 9.95ZM.86 5.71l-3-.1 3 .1zm-.42-.43.1-3-.1 3zm-.44.4 3 .1c-.14-.07-.41-.02-.6-.04L0 5.68Zm2.49 4.94L.76 13.07l1.73-2.45zm7.02-9.5 1.73-2.45-1.73 2.45zm-7.56.44-3-.08-.2 6.98 5.2-4.67-2-2.23ZM1.98.43l-3-.1c.2.05.5.02.74.04l2.26.06ZM1.56 0l.1-3c-.07.14-.02.41-.04.6L1.56 0Zm-.3.11-2.03-2.2c-.06.1.25.3.34.43L1.26.11Zm-3.14.22-.06 2.33 6 .15.06-2.33-6-.15zm2.94 2.4-2.99.24c.05.35.04 1 .5.67l5.34-1.82.14.67c-.98.1-2 .16-2.99.25Zm-2.9.8c.12.34.23 1.08.66.65L3.7 1.39c.18.3.44.77-.09.75l-5.45 1.39Zm.27.71c.14.32.35.68.63.3L3.52 1.1c.35.29.23.5-.13.6l-4.96 2.53Zm2.71-1.3L-1.52 4.3l.08.15.52.66L3.28.83c.27.28.8.77.2.9L1.14 2.95ZM-.97 5.07c.41.4 1.18.99 1.66.84L2.1.18l.66.26.57.44-4.29 4.19Zm1.87.98c.21.06.1-.34.18-.48L1.96.15c-.21-.06-.1.34-.18.48L.9 6.05Zm.5.06 2.32.06.17-6L1.56.11l-.16 6zm2.34.06c.89.02 1.78-.32 2.43-.93L2.05.88C2.5.45 3.35.05 3.87.25l-.13 5.92Zm2.43-.93a3.2 3.2 0 0 0 1.04-2.4l-5.97-.15c.01-.6.34-1.56.86-1.76l4.07 4.31Zm1.07-2.4c.1-1.8-1.57-3.55-3.32-3.47l-.2 5.97C2.42 5.44.95 3.8 1.35 2.7l5.89.14ZM3.91-.67 2.48-.7l-.17 6 1.43.03.17-6zm.57 5.11c.73-.76 2.01-.75 2.82-.23l3.44-4.87C7.7-2.94 2.82-2.56.34.19l4.14 4.25Zm2.8-.2c.9.58 1.14 1.92.48 2.77l4.82 3.57a7.98 7.98 0 0 0-.09-9.55C12 .43 11.35-.35 10.7-.6L7.28 4.24Zm.48 2.78c-.69 1.01-2.2 1.02-3.08.51l-3.41 4.85c3.39 2.6 9.1 1.66 11.23-1.86l-4.74-3.5Zm-3.04.46c-.64-.31-.78-1.2-.93-1.7l-5.93-.17c-.11 2.58 1.3 5.53 3.46 6.69l3.4-4.82ZM3.86 5.8C4.01 4 2.24 2.15.54 2.35l-.2 5.93c-1.32.1-2.8-1.56-2.38-2.68l5.9.2ZM.54 2.28c-1.8-.17-3.68 1.63-3.47 3.33L3 5.75C3.06 7.12 1.6 8.48.35 8.21l.19-5.93ZM-3 5.59c-.12 2.87 1.4 6 3.8 7.43l3.42-4.85c-.87-.47-1.15-1.63-1.29-2.4L-3 5.59Zm3.76 7.48c3.76 2.87 10.03 1.85 12.44-2.05l-4.75-3.5c-.95 1.39-3.02 1.46-4.27.7L.76 13.07Zm12.52-1.99A8.81 8.81 0 0 0 13.43.86C12.83.1 12-1 11.18-1.24l-3.4 4.81a2.8 2.8 0 0 1 .9 3.59c-.28.28-.2.46.12.62l4.48 3.3ZM11.24-1.33C7.98-3.76 2.7-3.46.01-.6l3.94 4.4c1.04-1.03 2.79-.89 3.88-.27l3.41-4.85Zm-6.3 2.98L4.98.52l-6-.17-.03 1.13 5.99.17zM4.98.54c.16-1.81-1.61-3.67-3.32-3.47L1.46 3C.1 3.03-1.23 1.57-.95.33l5.93.21ZM1.63-3a3.2 3.2 0 0 0-2.38.92l4.03 4.41c-.43.4-1.35.84-1.79.57L1.63-3Zm-2.44.93A3.2 3.2 0 0 0-1.85.33l5.97.15c0 .6-.33 1.56-.85 1.77L-.8-2.07Z",
    mask: "url(#b)"
  })));
}

/* eslint-disable react/prop-types */
function roi (_ref) {
  var color = _ref.color;
  // viewBox="0 0 16 16"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M14.45 16H1.55C.7 16 0 15.3 0 14.44V1.56C0 .7.7 0 1.56 0h12.89C15.3 0 16 .7 16 1.56v12.89c0 .85-.7 1.55-1.55 1.55ZM1.55 1.04a.51.51 0 0 0-.5.51v12.9c0 .27.23.5.5.5h12.9a.5.5 0 0 0 .5-.5V1.54a.51.51 0 0 0-.5-.5H1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12.8 2.84H3.2c-.3 0-.54.25-.54.54v1.9c0 .3.24.53.54.53h9.6c.3 0 .55-.24.55-.54V3.38c0-.3-.24-.54-.54-.54ZM4.95 7.02H3.07a.42.42 0 0 0-.41.41v1.89c0 .23.18.41.41.41h1.88a.4.4 0 0 0 .42-.41V7.43a.42.42 0 0 0-.42-.41Zm3.99 0H7.06a.42.42 0 0 0-.42.41v1.89c0 .23.19.41.42.41h1.88c.23 0 .42-.18.42-.41V7.43a.42.42 0 0 0-.42-.41Zm-3.99 3.42H3.07a.42.42 0 0 0-.41.42v1.88c0 .23.18.42.41.42h1.88c.24 0 .42-.2.42-.42v-1.88a.42.42 0 0 0-.42-.42Zm3.99 0H7.06a.42.42 0 0 0-.42.42v1.88c0 .23.19.42.42.42h1.88c.23 0 .42-.2.42-.42v-1.88a.42.42 0 0 0-.42-.42Zm3.99-3.42h-1.88a.42.42 0 0 0-.42.41v5.3c0 .24.19.43.42.43h1.88c.23 0 .42-.2.42-.42v-5.3a.42.42 0 0 0-.42-.42Z"
  }));
}

/* eslint-disable react/prop-types */
function barChartEnclosed (_ref) {
  var color = _ref.color;
  // viewBox="0 0 16 17"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.52 15.9957H1.44C1.184 15.9957 0.96 15.7717 0.96 15.5157V1.43569C0.96 1.17969 0.736 0.955688 0.48 0.955688C0.224 0.955688 0 1.17969 0 1.43569V15.5157C0 16.3157 0.64 16.9557 1.44 16.9557H15.52C15.776 16.9557 16 16.7317 16 16.4757C16 16.2197 15.776 15.9957 15.52 15.9957Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 7.32367H9.37603C9.1993 7.32367 9.05603 7.46694 9.05603 7.64367V13.3397C9.05603 13.5164 9.1993 13.6597 9.37603 13.6597H10.496C10.6728 13.6597 10.816 13.5164 10.816 13.3397V7.64367C10.816 7.46694 10.6728 7.32367 10.496 7.32367Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.576 13.7236H13.696C13.888 13.7236 14.016 13.5956 14.016 13.4036V5.24365C14.016 5.05165 13.888 4.92365 13.696 4.92365H12.576C12.384 4.92365 12.256 5.05165 12.256 5.24365V13.3716C12.256 13.5636 12.416 13.6916 12.576 13.7236Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29595 9.17969H6.17596C5.99923 9.17969 5.85596 9.32296 5.85596 9.49969V13.3397C5.85596 13.5164 5.99923 13.6597 6.17596 13.6597H7.29595C7.47268 13.6597 7.61595 13.5164 7.61595 13.3397V9.49969C7.61595 9.32296 7.47268 9.17969 7.29595 9.17969Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00799 13.6597H4.12798C4.31998 13.6597 4.44798 13.5317 4.44798 13.3397V11.3237C4.44798 11.1317 4.31998 11.0037 4.12798 11.0037H3.00799C2.81599 11.0037 2.68799 11.1317 2.68799 11.3237V13.3397C2.68799 13.5317 2.81599 13.6597 3.00799 13.6597Z",
    fill: color
  }));
}

/* eslint-disable react/prop-types */
function barChartHorizontalEnclosed (_ref) {
  var color = _ref.color;
  // viewBox="0 0 16 17"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.37386 4.73136H3.9533C3.66358 4.73136 3.42993 4.49772 3.42993 4.208C3.42993 3.91828 3.66358 3.68463 3.9533 3.68463H6.37386C6.66358 3.68463 6.89722 3.91828 6.89722 4.208C6.89722 4.49772 6.66358 4.73136 6.37386 4.73136Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63554 6.59122H3.9533C3.66358 6.59122 3.42993 6.35758 3.42993 6.06786C3.42993 5.77814 3.66358 5.54449 3.9533 5.54449H7.63554C7.92526 5.54449 8.15891 5.77814 8.15891 6.06786C8.15891 6.35758 7.92526 6.59122 7.63554 6.59122Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85984 8.46036H3.9533C3.66358 8.46036 3.42993 8.22672 3.42993 7.937C3.42993 7.64728 3.66358 7.41364 3.9533 7.41364H8.85984C9.14956 7.41364 9.3832 7.64728 9.3832 7.937C9.3832 8.22672 9.14956 8.46036 8.85984 8.46036Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.3295H3.9533C3.66358 10.3295 3.42993 10.0959 3.42993 9.80614C3.42993 9.51642 3.66358 9.28278 3.9533 9.28278H10C10.2897 9.28278 10.5234 9.51642 10.5234 9.80614C10.5234 10.0959 10.2897 10.3295 10 10.3295Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0748 12.1894H3.9533C3.66358 12.1894 3.42993 11.9557 3.42993 11.666C3.42993 11.3763 3.66358 11.1426 3.9533 11.1426H11.0748C11.3645 11.1426 11.5982 11.3763 11.5982 11.666C11.5982 11.9557 11.3645 12.1894 11.0748 12.1894Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0468 14.0585H3.9533C3.66358 14.0585 3.42993 13.8248 3.42993 13.5351C3.42993 13.2454 3.66358 13.0117 3.9533 13.0117H12.0468C12.3365 13.0117 12.5701 13.2454 12.5701 13.5351C12.5701 13.8248 12.3365 14.0585 12.0468 14.0585Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4393 16.9557H1.56075C0.700934 16.9557 0 16.2548 0 15.3949V2.51644C0 1.65662 0.700934 0.955688 1.56075 0.955688H14.4393C15.2991 0.955688 16 1.65662 16 2.51644V15.3949C16 16.2548 15.2991 16.9557 14.4393 16.9557ZM1.56075 2.00242C1.28037 2.00242 1.04673 2.23606 1.04673 2.51644V15.3949C1.04673 15.6753 1.28037 15.909 1.56075 15.909H14.4393C14.7196 15.909 14.9533 15.6753 14.9533 15.3949V2.51644C14.9533 2.23606 14.7196 2.00242 14.4393 2.00242H1.56075Z",
    fill: color
  }));
}

/* eslint-disable react/prop-types */
function distributionChartEnclosed (_ref) {
  var color = _ref.color;
  // viewBox="0 0 16 16"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.52 15.04H1.44C1.184 15.04 0.96 14.816 0.96 14.56V0.48C0.96 0.224 0.736 0 0.48 0C0.224 0 0 0.224 0 0.48V14.56C0 15.36 0.64 16 1.44 16H15.52C15.776 16 16 15.776 16 15.52C16 15.264 15.776 15.04 15.52 15.04Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4398 10.3139C15.331 10.3139 15.2222 10.2787 15.1326 10.2019C15.0686 10.1507 13.5582 8.88026 11.795 6.13146C11.5486 5.74746 11.3438 5.32506 11.1486 4.91546C10.483 3.53626 10.051 2.76506 8.84457 2.96666C8.15977 3.08186 7.59657 3.96506 6.81897 5.19386C6.58537 5.56186 6.31977 5.98106 6.02857 6.41306C4.76457 8.27866 2.65577 9.93306 2.56617 10.0035C2.35497 10.1667 2.05417 10.1283 1.89097 9.92026C1.72777 9.71226 1.76617 9.40826 1.97417 9.24506C1.99337 9.22906 4.05417 7.60986 5.23177 5.87226C5.51657 5.44986 5.77257 5.04986 6.00617 4.67546C6.91817 3.23866 7.57737 2.19866 8.68457 2.01626C10.659 1.68666 11.4078 3.24506 12.0094 4.49626C12.195 4.88026 12.3838 5.27706 12.5982 5.60986C14.275 8.22106 15.7278 9.44986 15.7406 9.46266C15.9454 9.63226 15.971 9.93626 15.8014 10.1379C15.7054 10.2531 15.571 10.3107 15.4334 10.3107L15.4398 10.3139Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91214 13.792C2.73614 13.792 2.59214 13.648 2.59214 13.472V12.1152C2.59214 11.9392 2.73614 11.7952 2.91214 11.7952C3.08814 11.7952 3.23214 11.9392 3.23214 12.1152V13.472C3.23214 13.648 3.08814 13.792 2.91214 13.792Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8114 13.8371C5.6354 13.8371 5.49139 13.6931 5.49139 13.5171V10.4451C5.49139 10.2691 5.6354 10.1251 5.8114 10.1251C5.9874 10.1251 6.13139 10.2691 6.13139 10.4451V13.5171C6.13139 13.6931 5.9874 13.8371 5.8114 13.8371Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71065 13.7918C8.53465 13.7918 8.39065 13.6478 8.39065 13.4718V9.02061C8.39065 8.84461 8.53465 8.70061 8.71065 8.70061C8.88665 8.70061 9.03065 8.84461 9.03065 9.02061V13.4718C9.03065 13.6478 8.88665 13.7918 8.71065 13.7918Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6127 13.7922C11.4367 13.7922 11.2927 13.6482 11.2927 13.4722V10.7522C11.2927 10.5762 11.4367 10.4322 11.6127 10.4322C11.7887 10.4322 11.9327 10.5762 11.9327 10.7522V13.4722C11.9327 13.6482 11.7887 13.7922 11.6127 13.7922Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.512 13.792C14.336 13.792 14.192 13.648 14.192 13.472V12.1152C14.192 11.9392 14.336 11.7952 14.512 11.7952C14.688 11.7952 14.832 11.9392 14.832 12.1152V13.472C14.832 13.648 14.688 13.792 14.512 13.792Z",
    fill: color
  }));
}

/* eslint-disable react/prop-types */
function calendarEmpty (_ref) {
  var color = _ref.color;
  // viewBox="0 0 19 15"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M17.188 1.454h-2.393V1.04a1.042 1.042 0 0 0-2.081 0v.414H5.669V1.04a1.042 1.042 0 0 0-2.08 0v.414H1.194C.537 1.454 0 1.99 0 2.649v11.156C0 14.463.537 15 1.195 15h15.993c.658 0 1.195-.537 1.195-1.195V2.649c0-.658-.537-1.195-1.195-1.195Zm-3.771-.414c0-.185.152-.337.337-.337.186 0 .338.152.338.337v1.533a.338.338 0 0 1-.338.338.338.338 0 0 1-.337-.338V1.04Zm-9.126 0a.338.338 0 0 1 .675 0v1.533a.338.338 0 0 1-.337.338.338.338 0 0 1-.338-.338V1.04Zm13.386 12.768c0 .27-.222.492-.492.492H1.195a.495.495 0 0 1-.492-.492V5.88H17.68v7.928h-.003Zm0-8.63H.703V2.648c0-.27.222-.492.492-.492h2.393v.413c0 .574.467 1.04 1.04 1.04.574 0 1.041-.466 1.041-1.04v-.413h7.045v.413a1.042 1.042 0 0 0 2.08 0v-.413h2.394c.27 0 .492.222.492.492v2.528h-.003Z"
  }));
}

/* eslint-disable react/prop-types */
function counterTower (_ref) {
  var color = _ref.color;
  // viewBox="0 0 19 16"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M17.234 12.064h-1.775v-.805h1.397a.46.46 0 0 0 .452-.47V9.048a.46.46 0 0 0-.452-.469h-1.397v-.904h1.397a.46.46 0 0 0 .452-.469V5.463a.46.46 0 0 0-.452-.469h-1.397V4.09h1.397a.46.46 0 0 0 .452-.469V1.878a.46.46 0 0 0-.452-.468h-1.397V.469A.46.46 0 0 0 15.007 0a.46.46 0 0 0-.453.469v.933h-1.4a.46.46 0 0 0-.452.469v1.743c0 .26.201.468.452.468h1.4v.905h-1.4a.46.46 0 0 0-.452.468v1.743c0 .26.201.469.452.469h1.4v.904h-1.4a.46.46 0 0 0-.452.469v1.743c0 .26.201.468.452.468h1.4v.806H9.91v-.806h1.4a.46.46 0 0 0 .453-.468V9.04a.46.46 0 0 0-.453-.469h-1.4v-.904h1.4a.46.46 0 0 0 .453-.469V5.455a.46.46 0 0 0-.453-.468h-1.4V.469A.46.46 0 0 0 9.457 0a.46.46 0 0 0-.453.469V4.99H7.608a.46.46 0 0 0-.453.469v1.743c0 .26.202.468.453.468h1.396v.905H7.608a.46.46 0 0 0-.453.468v1.743c0 .26.202.469.453.469h1.396v.805h-4.74v-.805H5.66a.46.46 0 0 0 .453-.469V9.043a.46.46 0 0 0-.453-.468H4.264V.469A.46.46 0 0 0 3.81 0a.46.46 0 0 0-.452.469v8.106h-1.4a.46.46 0 0 0-.453.468v1.743c0 .26.202.469.453.469h1.4v.805h-1.68c-.922 0-1.675.78-1.675 1.736v.469C.004 15.22.757 16 1.68 16h15.557c.923 0 1.676-.78 1.676-1.736v-.468c0-.956-.753-1.736-1.676-1.736l-.003.004ZM13.607 3.15v-.806h2.796v.806h-2.796Zm0 3.588V5.93h2.796v.806h-2.796Zm0 3.588v-.806h2.796v.806h-2.796Zm-5.55-3.588V5.93h2.796v.806H8.057Zm0 3.588v-.806h2.796v.806H8.057Zm-5.65 0v-.806h2.797v.806H2.408Zm15.594 3.943c0 .44-.347.798-.77.798H1.675c-.424 0-.77-.358-.77-.798V13.8c0-.439.346-.798.77-.798h15.558c.424 0 .77.36.77.799v.468h-.003Z"
  }));
}

/* eslint-disable react/prop-types */
function dollarsClock (_ref) {
  var color = _ref.color;
  // viewBox="0 0 19 17"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M8.702 3.376c.326 0 .59.267.59.597v4.851a.6.6 0 0 1-.136.382l-2.386 2.92a.592.592 0 0 1-.834.082.605.605 0 0 1-.08-.841l2.25-2.754V3.977c0-.33.263-.597.589-.597l.007-.004ZM14.495 17c-2.485 0-4.505-2.046-4.505-4.562 0-2.517 2.02-4.562 4.505-4.562S19 9.92 19 12.438C19 14.954 16.98 17 14.495 17Zm0-8.013c-1.877 0-3.407 1.55-3.407 3.45 0 1.902 1.53 3.451 3.407 3.451s3.407-1.549 3.407-3.45c0-1.902-1.53-3.45-3.407-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M10.506 15.57c-.67.203-1.38.318-2.111.318-4.022 0-7.293-3.313-7.293-7.386s3.267-7.39 7.29-7.39c3.666 0 6.703 2.757 7.212 6.334.406.092.794.237 1.156.422C16.438 3.476 12.808 0 8.391 0S0 3.814 0 8.498c0 4.685 3.766 8.498 8.391 8.498a8.257 8.257 0 0 0 2.972-.552 5.083 5.083 0 0 1-.857-.878v.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M14.495 13.82c-.358 0-.647-.256-.647-.574a.329.329 0 0 0-.326-.33.329.329 0 0 0-.326.33c0 .57.414 1.052.973 1.19v.222c0 .181.147.33.326.33.18 0 .326-.149.326-.33v-.223c.556-.137.973-.619.973-1.19 0-.677-.582-1.23-1.295-1.23-.359 0-.648-.256-.648-.574 0-.319.29-.575.648-.575.358 0 .648.256.648.575 0 .181.146.33.325.33.18 0 .326-.149.326-.33 0-.57-.414-1.053-.973-1.19v-.222a.328.328 0 0 0-.326-.33.328.328 0 0 0-.326.33v.222c-.556.137-.973.62-.973 1.19 0 .678.582 1.23 1.295 1.23.359 0 .648.256.648.575 0 .318-.29.574-.648.574Z"
  }));
}

/* eslint-disable react/prop-types */
function dollarsLoss (_ref) {
  var color = _ref.color;
  // viewBox="0 0 20 16"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M18.413 0H1.502C.673 0 0 .673 0 1.502v12.996C0 15.327.673 16 1.502 16h16.911c.829 0 1.502-.673 1.502-1.502V1.502C19.915.673 19.242 0 18.413 0Zm.608 14.498a.61.61 0 0 1-.608.608H1.502a.61.61 0 0 1-.608-.608V1.502a.61.61 0 0 1 .608-.608h16.911a.61.61 0 0 1 .608.608v12.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M9.57 7.928a.448.448 0 0 0-.617.14l-2.199 3.487V2.899a.446.446 0 1 0-.893 0v8.67l-2.232-3.5a.447.447 0 0 0-.754.48l3.057 4.793a.448.448 0 0 0 .754-.003L9.71 8.545a.448.448 0 0 0-.14-.617ZM13.857 11.211c-.781 0-1.416-.553-1.416-1.232a.707.707 0 0 0-.708-.704.704.704 0 0 0-.709.704c0 1.228.903 2.259 2.12 2.55v.473c0 .386.316.704.709.704a.704.704 0 0 0 .708-.704v-.473c1.218-.291 2.12-1.322 2.12-2.55 0-1.455-1.27-2.636-2.828-2.636-.782 0-1.417-.554-1.417-1.232 0-.679.635-1.233 1.417-1.233.781 0 1.416.554 1.416 1.233 0 .386.315.704.708.704a.704.704 0 0 0 .709-.704c0-1.228-.903-2.259-2.12-2.55v-.473a.707.707 0 0 0-.709-.704.704.704 0 0 0-.708.704v.472c-1.218.292-2.12 1.323-2.12 2.55 0 1.456 1.27 2.637 2.828 2.637.782 0 1.417.554 1.417 1.232 0 .679-.635 1.232-1.417 1.232Z"
  }));
}

/* eslint-disable react/prop-types */
function dollarsPremium (_ref) {
  var color = _ref.color;
  // viewBox="0 0 18 18"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M8.846 17.997a.475.475 0 0 1-.167-.03C-1.728 14.26.12 3.683.14 3.576c.036-.2.19-.357.386-.397 3.077-.653 5.71-1.67 8.057-3.106a.508.508 0 0 1 .524 0c2.867 1.76 5.49 2.776 8.017 3.1.213.026.386.19.426.403.02.103 1.84 10.25-8.52 14.387a.516.516 0 0 1-.187.037l.004-.003ZM1.072 4.083C.845 5.819.305 13.806 8.836 16.96c8.46-3.484 8.01-11.1 7.787-12.847-2.477-.38-5.03-1.374-7.78-3.027-2.29 1.363-4.84 2.347-7.774 3l.003-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M8.842 11.173c-.603 0-1.093-.43-1.093-.957a.547.547 0 0 0-1.093 0c0 .954.696 1.754 1.636 1.98v.367a.547.547 0 0 0 1.094 0v-.367c.94-.226 1.637-1.026 1.637-1.98 0-1.13-.98-2.046-2.184-2.046-.603 0-1.093-.43-1.093-.957 0-.527.49-.957 1.093-.957s1.093.43 1.093.957a.547.547 0 0 0 1.094 0c0-.954-.697-1.754-1.637-1.98v-.367a.547.547 0 0 0-1.093 0v.367c-.94.226-1.637 1.026-1.637 1.98 0 1.13.98 2.047 2.183 2.047.604 0 1.094.43 1.094.956 0 .527-.49.957-1.094.957Z"
  }));
}

/* eslint-disable react/prop-types */
function dollarsUmbrella (_ref) {
  var color = _ref.color;
  // viewBox="0 0 17 19"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M9.385 6.805a2.711 2.711 0 0 1 1.647 1.003l.027.024c.035.04.076.068.114.092.014.01.03.023.055.033a.39.39 0 0 0 .158.041l.03.01h.042a.591.591 0 0 0 .196-.047c.02-.01.034-.02.048-.03a.313.313 0 0 0 .103-.085l.038-.034a2.718 2.718 0 0 1 2.16-1.055c.7 0 1.371.265 1.88.746.151.146.382.18.574.092a.507.507 0 0 0 .289-.499C16.378 3.048 12.992 0 8.873 0 4.757 0 1.37 3.048.999 7.09a.5.5 0 0 0 .29.498.519.519 0 0 0 .573-.092 2.722 2.722 0 0 1 1.881-.746c.85 0 1.637.387 2.18 1.075.03.037.069.065.124.102l.048.03a.494.494 0 0 0 .426 0c.02-.01.038-.02.055-.033.031-.02.08-.051.1-.078l.041-.038a2.732 2.732 0 0 1 1.647-1.007c.485-.139 1.021 0 1.021 0v.004Zm-3.514-.4a3.72 3.72 0 0 0-2.128-.658c-.53 0-1.052.112-1.53.322.677-2.567 2.83-4.513 5.487-4.957-1.258 1.783-1.688 3.98-1.832 5.293h.003Zm3.002-.658c-.698 0-1.369.19-1.957.55.172-1.323.647-3.476 1.957-5.04 1.306 1.56 1.78 3.717 1.953 5.036a3.727 3.727 0 0 0-1.953-.546Zm5.13 0c-.77 0-1.5.227-2.125.658-.145-1.31-.575-3.506-1.833-5.293 2.658.444 4.813 2.39 5.487 4.957-.478-.21-1-.322-1.53-.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M8.873 15.61c-.647 0-1.173-.455-1.173-1.014a.584.584 0 0 0-.588-.58.581.581 0 0 0-.587.58c0 1.01.75 1.858 1.76 2.099v.729c0 .318.261.58.588.58a.581.581 0 0 0 .588-.58v-.73c1.01-.24 1.76-1.088 1.76-2.098 0-1.197-1.052-2.17-2.348-2.17-.647 0-1.173-.454-1.173-1.014S8.226 10.4 8.873 10.4c.646 0 1.172.454 1.172 1.013 0 .319.261.58.588.58a.581.581 0 0 0 .588-.58c0-1.01-.75-1.858-1.76-2.098v-.73a.584.584 0 0 0-.588-.58.581.581 0 0 0-.588.58v.73c-1.01.24-1.76 1.088-1.76 2.098 0 1.197 1.052 2.17 2.348 2.17.646 0 1.172.454 1.172 1.014S9.52 15.61 8.873 15.61Z"
  }));
}

/* eslint-disable react/prop-types */
function personUmbrella (_ref) {
  var color = _ref.color;
  // viewBox="0 0 16 19"
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M8.359 6.938c.65.125 1.23.484 1.64 1.024l.028.024c.034.041.075.069.113.093.014.01.031.024.055.035a.382.382 0 0 0 .158.041l.03.01h.042a.579.579 0 0 0 .195-.048c.02-.01.034-.02.048-.03A.314.314 0 0 0 10.77 8l.037-.035a2.687 2.687 0 0 1 4.026-.315.508.508 0 0 0 .86-.414C15.327 3.108 11.953 0 7.848 0 3.748 0 .372 3.108.002 7.229a.508.508 0 0 0 .86.415 2.68 2.68 0 0 1 1.874-.761c.847 0 1.631.394 2.173 1.096a.56.56 0 0 0 .123.104l.048.03a.483.483 0 0 0 .425 0c.02-.01.037-.02.054-.034.031-.02.08-.052.1-.08l.041-.037c.411-.54.99-.9 1.641-1.027.483-.142 1.018 0 1.018 0v.003ZM4.857 6.53a3.648 3.648 0 0 0-2.12-.67 3.72 3.72 0 0 0-1.525.328A6.86 6.86 0 0 1 6.68 1.134C5.426 2.952 4.998 5.193 4.854 6.53h.003Zm2.991-.67c-.695 0-1.363.193-1.95.56.172-1.348.645-3.544 1.95-5.137 1.302 1.59 1.775 3.789 1.946 5.133a3.65 3.65 0 0 0-1.946-.556Zm5.112 0c-.768 0-1.494.231-2.117.67-.144-1.334-.573-3.574-1.827-5.396a6.855 6.855 0 0 1 5.469 5.054 3.72 3.72 0 0 0-1.525-.328ZM9.335 11.543h-2.97c-.6 0-1.086.491-1.086 1.096v2.036c0 .522.37.972.87 1.075v2.839c0 .228.181.411.407.411h2.587a.408.408 0 0 0 .408-.411V15.75a1.1 1.1 0 0 0 .87-1.075V12.64c0-.605-.486-1.096-1.086-1.096Zm.27 3.132a.272.272 0 0 1-.27.273h-.192a.408.408 0 0 0-.407.412v2.814H6.964V15.36a.408.408 0 0 0-.408-.412h-.191a.272.272 0 0 1-.271-.273V12.64c0-.152.123-.273.27-.273h2.971c.15 0 .27.124.27.273v2.036Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M7.848 11.332c.99 0 1.795-.812 1.795-1.811 0-1-.805-1.812-1.795-1.812-.99 0-1.795.813-1.795 1.812 0 .999.805 1.811 1.795 1.811Zm0-2.803a.99.99 0 0 1 .983.992.987.987 0 0 1-.983.988.987.987 0 0 1-.983-.988.99.99 0 0 1 .983-.992Z"
  }));
}

/* eslint-disable react/prop-types */

function checklist (_ref) {
  var color = _ref.color;
  // viewBox 0 0 24 24
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: color,
    d: "M10.5 13.5c.3.3.3.8 0 1.1l-2.9 3c-.1.1-.3.2-.5.2s-.4-.1-.5-.2l-1.1-1.2c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l.6.6 2.3-2.4c.2-.3.7-.3 1 0zm0-7c.3.3.3.8 0 1.1l-2.9 3c-.1.1-.3.2-.5.2s-.4-.1-.5-.2L5.5 9.3c-.3-.3-.3-.8 0-1 .3-.3.8-.3 1 0l.6.6 2.3-2.4c.3-.3.8-.3 1.1 0zM12.2 9c0-.4.3-.8.8-.8h5c.4 0 .8.3.8.8s-.4.8-.8.8h-5c-.4 0-.8-.4-.8-.8zm0 7c0-.4.3-.8.8-.8h5c.4 0 .8.3.8.8s-.3.8-.8.8h-5c-.4 0-.8-.4-.8-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: color,
    d: "M22.6 6.4c-.2-1.4-.6-2.6-1.5-3.5-.9-.9-2-1.3-3.5-1.5-1.4-.2-3.3-.2-5.6-.2s-4.2 0-5.6.2C5 1.6 3.9 2 3 2.9c-.9.9-1.3 2.1-1.5 3.5-.2 1.4-.2 3.2-.2 5.5v.1c0 2.3 0 4.1.2 5.5.2 1.5.6 2.7 1.5 3.6.9.9 2 1.3 3.5 1.5 1.4.2 3.3.2 5.6.2s4.2 0 5.6-.2c1.4-.2 2.6-.6 3.5-1.5.9-.9 1.3-2 1.5-3.5.2-1.4.2-3.2.2-5.5V12c-.2-2.4-.2-4.2-.3-5.6zm-1.5 11c-.2 1.3-.5 2-1.1 2.6s-1.3.9-2.6 1.1c-1.3.2-3 .2-5.4.2s-4.1 0-5.4-.2c-1.3-.2-2-.5-2.6-1.1-.6-.6-.9-1.3-1.1-2.6-.2-1.3-.2-3-.2-5.4 0-2.4 0-4.1.2-5.4.2-1.3.6-2 1.1-2.6.6-.6 1.3-.9 2.6-1.1 1.3-.2 3-.2 5.4-.2s4.1 0 5.4.2c1.3.2 2 .5 2.6 1.1.6.6.9 1.3 1.1 2.6.2 1.3.2 3 .2 5.4-.1 2.4-.1 4.1-.2 5.4z"
  }));
}

/* eslint-disable react/prop-types */
function excel (_ref) {
  var color = _ref.color;
  // viewBox="0 0 21 22"
  return /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.83 2.05h-7.52v-.71l-.01-.1a.6.6 0 0 0-.68-.5L.5 2.49a.6.6 0 0 0-.51.6v15.85c0 .3.21.56.5.6l11.12 1.76h.09a.6.6 0 0 0 .39-.14.6.6 0 0 0 .2-.46v-2.03h7.53a.6.6 0 0 0 .6-.61V2.66a.6.6 0 0 0-.6-.61Zm-7.52 13.54h2.65v1.85h-2.65V15.6Zm-1.2 4.39L1.2 18.4V3.63l9.92-1.57v17.92Zm8.13-14.85h-3.09V3.27h3.09v1.86Zm-6.93 6.15V9.43h2.65v1.85h-2.65Zm2.65-3.07h-2.65V6.35h2.65v1.86Zm-2.65 4.3h2.65v1.85h-2.65v-1.85Zm3.84 0h3.08v1.85h-3.08v-1.85Zm0-1.23V9.43h3.08v1.85h-3.08Zm0-3.07V6.35h3.08v1.86h-3.08Zm-1.2-3.08H12.3V3.27h2.66v1.86Zm1.2 10.46h3.08v1.86h-3.08v-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.87 10.58 2.35-3.63a.62.62 0 0 0-.16-.82.58.58 0 0 0-.84.15l-2.06 3.2-2.09-3.23A.58.58 0 0 0 3.68 6a.58.58 0 0 0-.44.1.6.6 0 0 0-.24.4c-.03.17 0 .33.1.46l2.34 3.62-2.35 3.62a.6.6 0 0 0 .5.95c.2 0 .38-.1.5-.28l2.06-3.2 2.07 3.2a.59.59 0 0 0 .83.17.6.6 0 0 0 .25-.38.64.64 0 0 0-.09-.46l-2.34-3.62Z"
  }));
}

/* eslint-disable react/prop-types */
function rt_usage (_ref) {
  var color = _ref.color;
  // viewBox="0 0 18 18"
  return /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M14.83.67H6.5A2.5 2.5 0 0 0 4 3.17V4h-.83a2.5 2.5 0 0 0-2.5 2.5v8.33a2.5 2.5 0 0 0 2.5 2.5h8.33a2.5 2.5 0 0 0 2.5-2.5V14h.83a2.5 2.5 0 0 0 2.5-2.5V3.17a2.5 2.5 0 0 0-2.5-2.5Zm-2.5 14.16a.83.83 0 0 1-.83.84H3.17a.83.83 0 0 1-.84-.84V9h10v5.83Zm0-7.5h-10V6.5a.83.83 0 0 1 .84-.83h8.33a.83.83 0 0 1 .83.83v.83Zm3.34 4.17a.83.83 0 0 1-.84.83H14V6.5c0-.28-.05-.57-.15-.83h1.82v5.83Zm0-7.5h-10v-.83a.83.83 0 0 1 .83-.84h8.33a.83.83 0 0 1 .84.84V4Z"
  });
}

/* eslint-disable react/prop-types */
function rt_return_time (_ref) {
  var color = _ref.color;
  // viewBox="0 0 15 17"
  return /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9 9.55c0-.63-.4-1.15-.97-1.37A1.45 1.45 0 0 0 6 9.46a1.47 1.47 0 0 0 .8 1.39c.3.14.62.18.95.12A1.46 1.46 0 0 0 8.9 9.55c0-.29-.26-.56-.55-.55a.56.56 0 0 0-.54.55l-.01.12.02-.14-.07.23.06-.13a.87.87 0 0 1-.08.15c-.03.04-.08.06.03-.04l-.06.06-.06.06s.13-.1.03-.03l-.14.08.13-.05a.98.98 0 0 1-.23.06l.14-.02a.97.97 0 0 1-.25 0l.15.02a1.03 1.03 0 0 1-.24-.06l.13.05a.87.87 0 0 1-.14-.08c-.05-.03-.06-.07.03.03L7.2 9.8l-.06-.06.03.04-.08-.15.06.13a1.06 1.06 0 0 1-.07-.23l.02.14a.97.97 0 0 1 0-.25l-.02.15.07-.23a511.89 511.89 0 0 0 .02-.02c.03-.04.08-.06-.03.04l.06-.06.06-.06s-.13.1-.03.03l.14-.08-.13.05.24-.06-.15.02a.97.97 0 0 1 .25 0l-.14-.02c.08.01.15.03.23.06l-.13-.05.14.08c.05.03.06.07-.03-.03l.06.06.06.06-.03-.04.08.15-.06-.13.07.23-.02-.15v.13c.01.28.25.56.55.54.3 0 .55-.24.55-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.9v-4.45c0-.29-.25-.56-.54-.55a.55.55 0 0 0-.55.55v4.43c0 .29.25.56.55.55.3-.02.54-.24.54-.55Zm1.46-.28a5.48 5.48 0 0 0 2.94-7.35A5.48 5.48 0 0 0 7.46 4.1c-.29 0-.56.25-.55.54.01.3.24.55.55.55.21 0 .43.01.65.04l-.15-.02a5 5 0 0 1 1.25.34l-.13-.06a4.9 4.9 0 0 1 1 .56l.06.06c.08.05-.1-.08 0-.01l.13.11a4.73 4.73 0 0 1 .61.63l.05.06-.04-.05.04.05a4.6 4.6 0 0 1 .57 1l-.05-.13a5 5 0 0 1 .34 1.26l-.02-.14c.06.44.06.89 0 1.33l.02-.15a5 5 0 0 1-.34 1.25l.05-.14a5.1 5.1 0 0 1-.53.96l-.04.05-.12.14c-.15.19-.32.36-.5.51l-.13.11-.06.06c-.07.05.04-.04.04-.04l-.04.03a4.37 4.37 0 0 1-.9.54l-.05.02c-.14.06-.25.12-.32.25a.55.55 0 0 0 .2.75c.11.07.28.11.41.06ZM8 2.64V.55c0-.29-.25-.56-.54-.55a.55.55 0 0 0-.55.55v2.09c0 .29.25.56.55.54.3 0 .54-.23.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 0H5.6a.54.54 0 0 0 0 1.09h3.7c.29 0 .56-.25.55-.54A.56.56 0 0 0 9.3 0Zm4.52 9.55c0 .31-.02.63-.06.94 0-.05 0-.1.02-.15-.09.6-.25 1.2-.48 1.75l.05-.13a6.8 6.8 0 0 1-.76 1.35l-.08.1c0 .02-.02.04-.03.05l.04-.05-.17.2a7.16 7.16 0 0 1-.9.9l-.11.09c-.03.02-.08.06.04-.04l-.06.05a6.56 6.56 0 0 1-1.46.84l.13-.06a7 7 0 0 1-1.76.48l.14-.02a7 7 0 0 1-1.83 0l.14.02a6.9 6.9 0 0 1-1.76-.48l.13.06a7.13 7.13 0 0 1-1.35-.76l-.1-.08a.84.84 0 0 1-.05-.03l.05.03-.21-.16a6.97 6.97 0 0 1-.9-.91l-.08-.1c0-.02-.02-.03-.03-.05l.02.03a6.52 6.52 0 0 1-.84-1.46l.05.13a6.96 6.96 0 0 1-.48-1.75l.02.15a7.1 7.1 0 0 1 0-1.86l-.02.14c.08-.6.25-1.2.49-1.77l-.06.13a7.03 7.03 0 0 1 .75-1.33l.07-.1c.01-.01.1-.13.04-.04l.04-.05.08-.11a7.07 7.07 0 0 1 .89-.88l.09-.08-.05.04.11-.09a1.1 1.1 0 0 1 0 .01l.05-.04.1-.08a7.22 7.22 0 0 1 1.32-.73l-.13.05c.56-.24 1.15-.4 1.76-.48l-.15.02a7.15 7.15 0 0 1 1.85 0l-.15-.02c.6.08 1.2.24 1.76.48l-.13-.05a7.1 7.1 0 0 1 1.42.8l.1.07-.05-.03.11.09-.07-.06.2.17c.25.22.49.45.7.7l.17.2a4.48 4.48 0 0 1 .04.05l.04.06a6.48 6.48 0 0 1 1.26 3.07l-.02-.14a7 7 0 0 1 .06.92c0 .28.25.56.54.54.3 0 .55-.24.55-.54a7.46 7.46 0 0 0-2.7-5.73l-.1-.09c-.04-.03-.22-.18-.03-.02l-.13-.1a5.57 5.57 0 0 0-.69-.47 7.46 7.46 0 0 0-8.35.51l-.06.04.06-.05-.13.1a4.3 4.3 0 0 0-.29.25A7.08 7.08 0 0 0 .64 6.53a7.43 7.43 0 0 0 8.37 10.31 7.45 7.45 0 0 0 5.9-7.29c0-.28-.25-.56-.55-.54a.55.55 0 0 0-.54.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.58 3.72-.85-1.08-.12-.15a.55.55 0 0 0-.77 0 .5.5 0 0 0-.16.38c0 .16.06.27.16.39l.84 1.08.13.15c.08.1.26.16.38.16.14 0 .3-.06.39-.16.1-.1.16-.23.16-.38a.64.64 0 0 0-.16-.39ZM12.3 2.5l-.84 1.08-.13.16c-.09.11-.16.22-.16.38 0 .14.06.3.16.39.1.1.24.16.39.16.13 0 .3-.05.38-.16l.85-1.08.12-.16c.1-.12.16-.23.16-.39a.55.55 0 0 0-.16-.38.56.56 0 0 0-.38-.16c-.14 0-.3.05-.39.16Z"
  }));
}



var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SlightlyGoodSignal: slightlyGoodSignal,
  ActuarialModel: actuarialModel,
  ClosedEye: closedEye,
  Reload: reload,
  Roi: roi,
  BarChartEnclosed: barChartEnclosed,
  BarChartHorizontalEnclosed: barChartHorizontalEnclosed,
  DistributionChartEnclosed: distributionChartEnclosed,
  CalendarEmpty: calendarEmpty,
  CounterTower: counterTower,
  DollarsClock: dollarsClock,
  DollarsLoss: dollarsLoss,
  DollarsPremium: dollarsPremium,
  DollarsUmbrella: dollarsUmbrella,
  PersonUmbrella: personUmbrella,
  Checklist: checklist,
  Excel: excel,
  RtUsage: rt_usage,
  RtRetTime: rt_return_time
});

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var B = PropTypes.bool;
var S = PropTypes.string;
var OO = PropTypes.oneOf;
var O = PropTypes.oneOfType;
var RESP = O([PropTypes.shape({
  xs: S,
  sm: S,
  md: S,
  lg: S,
  xl: S
}), S]);
var DIR = PropTypes.shape({
  x: RESP,
  y: RESP,
  t: RESP,
  l: RESP,
  b: RESP,
  r: RESP
});
var ROUNDED_DIR = PropTypes.shape({
  t: RESP,
  l: RESP,
  b: RESP,
  r: RESP,
  tl: RESP,
  bl: RESP,
  tr: RESP,
  br: RESP
});
var TEXT_SIZES = OO(['tiny', 'caption', 'body', 'paragraph', 'subheader', 'title', 'heading', 'display1', 'display2', 'display3']);
var SHADOW = OO(['1', '2', '3', '4', '5']);
var FONT_FAMILY = OO(['primary', 'secondary', 'code']);
var PropTypesRepo = {
  // set the display property
  d: O([S, RESP]),
  pos: O([S, RESP]),
  top: O([S, RESP]),
  bottom: O([S, RESP]),
  left: O([S, RESP]),
  right: O([S, RESP]),
  justify: O([S, RESP]),
  align: O([S, RESP]),
  flexDir: O([S, RESP]),
  flexGrow: O([S, RESP]),
  flexWrap: O([S, RESP]),
  order: O([S, RESP]),
  m: O([S, DIR]),
  p: O([S, DIR]),
  rounded: O([S, RESP, ROUNDED_DIR]),
  border: O([S, DIR]),
  borderColor: S,
  h: O([S, RESP]),
  maxH: O([S, RESP]),
  minH: O([S, RESP]),
  w: O([S, RESP]),
  maxW: O([S, RESP]),
  minW: O([S, RESP]),
  cursor: O([S, RESP]),
  bg: S,
  bgImg: S,
  bgSize: O([S, RESP]),
  bgRepeat: O([S, RESP]),
  bgPos: O([S, RESP]),
  textSize: O(S, TEXT_SIZES),
  textColor: S,
  textWeight: O([S, RESP]),
  textAlign: O([S, RESP]),
  verticalAlign: O([S, RESP]),
  textTransform: O([S, RESP]),
  textDecor: O([S, RESP]),
  shadow: O([S, SHADOW]),
  transition: B,
  fontFamily: FONT_FAMILY,
  transform: O([S, RESP]),
  transformOrigin: O([S, RESP]),
  zIndex: O([S, RESP]),
  overflow: S,
  opacity: O([S, RESP]),
  // Hover
  hoverBg: S,
  hoverTextColor: S,
  hoverBorderColor: S,
  hoverShadow: O([S, SHADOW]),
  hoverColor: S,
  hoverTransform: O([S, RESP]),
  // Focus
  focusBg: S,
  focusTextColor: S,
  focusBorderColor: S,
  focusShadow: SHADOW,
  // Placeholder
  placeholderTextColor: S,
  // Grids
  size: O([S, RESP]),
  offset: O([S, RESP])
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var umd = createCommonjsModule(function (module, exports) {
(function (global, factory) {
	 module.exports = factory() ;
}(commonjsGlobal, function () {
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	return deepmerge_1;

}));
});

var createThemeProvider_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var React$1 = _interopRequireWildcard(React);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createThemeProvider(defaultTheme, ThemeContext) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(ThemeProvider, _React$Component);

    function ThemeProvider() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = ThemeProvider.prototype;

    _proto.render = function render() {
      return React$1.createElement(ThemeContext.Provider, {
        value: this.props.theme
      }, this.props.children);
    };

    return ThemeProvider;
  }(React$1.Component), _defineProperty(_class, "defaultProps", {
    theme: defaultTheme
  }), _temp;
}

var _default = createThemeProvider;
exports.default = _default;

});

unwrapExports(createThemeProvider_1);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var createWithTheme_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var React$1 = _interopRequireWildcard(React);

var _deepmerge = _interopRequireDefault(umd);

var _hoistNonReactStatics = _interopRequireDefault(hoistNonReactStatics_cjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createWithTheme = function createWithTheme(ThemeProvider, ThemeContext) {
  return function withTheme(Comp) {
    var ThemedComponent =
    /*#__PURE__*/
    function (_React$Component) {
      _inheritsLoose(ThemedComponent, _React$Component);

      function ThemedComponent() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

        _defineProperty(_assertThisInitialized(_this), "_previous", void 0);

        _defineProperty(_assertThisInitialized(_this), "_merge", function (a, b) {
          var previous = _this._previous;

          if (previous && previous.a === a && previous.b === b) {
            return previous.result;
          }

          var result = a && b && a !== b ? (0, _deepmerge.default)(a, b) : a || b;
          _this._previous = {
            a: a,
            b: b,
            result: result
          };
          return result;
        });

        return _this;
      }

      var _proto = ThemedComponent.prototype;

      _proto.render = function render() {
        var _this2 = this;

        var _this$props = this.props,
            _reactThemeProviderForwardedRef = _this$props._reactThemeProviderForwardedRef,
            rest = _objectWithoutPropertiesLoose(_this$props, ["_reactThemeProviderForwardedRef"]);

        return React$1.createElement(ThemeContext.Consumer, null, function (theme) {
          return React$1.createElement(Comp, _extends({}, rest, {
            theme: _this2._merge(theme, rest.theme),
            ref: _reactThemeProviderForwardedRef
          }));
        });
      };

      return ThemedComponent;
    }(React$1.Component);

    var ResultComponent = React$1.forwardRef(function (props, ref) {
      return React$1.createElement(ThemedComponent, _extends({}, props, {
        _reactThemeProviderForwardedRef: ref
      }));
    });
    ResultComponent.displayName = "withTheme(" + (Comp.displayName || Comp.name) + ")";
    (0, _hoistNonReactStatics.default)(ResultComponent, Comp);
    return ResultComponent;
  };
};

var _default = createWithTheme;
exports.default = _default;

});

unwrapExports(createWithTheme_1);

var createTheming_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = createTheming;

var React$1 = _interopRequireWildcard(React);

var _deepmerge = _interopRequireDefault(umd);

var _createThemeProvider = _interopRequireDefault(createThemeProvider_1);

var _createWithTheme = _interopRequireDefault(createWithTheme_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function createTheming(defaultTheme) {
  var ThemeContext = React$1.createContext(defaultTheme);
  var ThemeProvider = (0, _createThemeProvider.default)(defaultTheme, ThemeContext);
  var withTheme = (0, _createWithTheme.default)(ThemeProvider, ThemeContext);

  var useTheme = function useTheme(overrides) {
    var theme = React$1.useContext(ThemeContext);
    var result = React$1.useMemo(function () {
      return theme && overrides ? (0, _deepmerge.default)(theme, overrides) : theme || overrides;
    }, [theme, overrides]);
    return result;
  };

  return {
    ThemeContext: ThemeContext,
    ThemeProvider: ThemeProvider,
    withTheme: withTheme,
    useTheme: useTheme
  };
}

});

unwrapExports(createTheming_1);

var lib = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _createTheming = _interopRequireDefault(createTheming_1);

exports.createTheming = _createTheming.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

});

unwrapExports(lib);
var lib_1 = lib.createTheming;

var DefaultTheme = {
  colors: {
    black900: '#0A1F44',
    black800: '#14284B',
    black700: '#283A5B',
    black600: '#364766',
    black500: '#455571',
    black400: '#4E5D78',
    black300: '#596780',
    black200: '#627088',
    black100: '#717D92',
    gray900: '#8A94A6',
    gray800: '#98A1B1',
    gray700: '#A7AEBB',
    gray600: '#B0B7C3',
    gray500: '#C9CED6',
    gray400: '#E1E4E8',
    gray300: '#F1F2F4',
    gray200: '#F7F8F9',
    gray100: '#FAFBFB',
    grey900: '#666F75',
    grey800: '#717A80',
    grey700: '#7B868C',
    grey600: '#889197',
    grey500: '#949DA2',
    grey400: '#A1A8AD',
    grey300: '#ADB4B8',
    grey200: '#C8CCCF',
    grey100: '#D5D8DA',
    // brand500 is always primary
    // brand900: '#001221',
    // brand800: '#002a47',
    // brand700: '#00446e',
    // brand600: '#006094',
    // brand500: '#0080ba',
    // brand400: '#2098c7',
    // brand300: '#44b0d4',
    // brand200: '#6cc7e0',
    // brand100: '#98dded',

    brand900: '#C635A8',
    brand800: '#93278F',
    brand700: '#573c81',
    brand600: '#3AA6E8',
    brand500: '#0080BB',
    brand400: '#0FCEC9',
    brand300: '#00C08B',
    brand200: '#C2D500',
    brand100: '#FFBA00',
    success900: '#136A4A',
    success800: '#23825F',
    success700: '#36AB80',
    success600: '#6FCAA8',
    success500: '#A9DCC9',
    success400: '#D0EDDF',
    success300: '#EAF7F1',
    success200: '#F5FBF8',
    success100: '#FAFDFC',
    warning900: '#EF8511',
    warning800: '#F69D2C',
    warning700: '#F7AF22',
    warning600: '#FBC050',
    warning500: '#FBE0A1',
    warning400: '#FDEECB',
    warning300: '#FEF7E6',
    warning200: '#FEFAF1',
    warning100: '#FFFDF8',
    danger900: '#A32801',
    danger800: '#D13A06',
    danger700: '#F4541D',
    danger600: '#F7926F',
    danger500: '#FABEAA',
    danger400: '#FCD7CA',
    danger300: '#FDE8E1',
    danger200: '#FEF6F3',
    danger100: '#FFFBFA',
    info900: '#01408F',
    info800: '#026DD6',
    info700: '#0284FE',
    info600: '#4BA7FE',
    info500: '#83C3FE',
    info400: '#B3DAFF',
    info300: '#DCEEFF',
    info200: '#EEF7FF',
    info100: '#F8FBFF',
    black: '#000000',
    black50: 'rgba(0, 0, 0, 0.5)',
    black75: 'rgba(0, 0, 0, 0.75)',
    black95: 'rgba(0, 0, 0, 0.95)',
    shade19: '#191919',
    shade1A: '#1A1A1A',
    shade2D: '#2D2D2D',
    shade33: '#333333',
    shade4D: '#4D4D4D',
    shade66: '#666666',
    shade79: '#797979',
    shade99: '#999999',
    shadeA0: '#A0A0A0',
    shadeAF: '#AFAFAF',
    shadeBD: '#BDBDBD',
    shadecc: '#CCCCCC',
    shadeCC: '#CCCCCC',
    shadeD9: '#D9D9D9',
    shadeE6: '#E6E6E6',
    shadeF2: '#F2F2F2',
    white: '#FFFFFF',
    transparent: 'rgba(0,0,0,0)',
    disabled: '#C8CCCF',
    light: '#A7AAB0',
    medium: '#505256',
    dark: '#000000',
    selected: '#3AA6E8',
    tertiary: '#10CFC9',
    secondary: '#F2F2F2',
    tabSelected: '#666F75',
    tabRest: '#ADB4B8',
    tabDisabled: '#C8CCCF',
    shopify: '#F4F6F8',
    skyBlue: '#69BBED',
    skyBlue2: '#BFDFED',
    skyBlueLight: '#D9ECF5',
    skyBluePale: '#F5FBFE',
    blueLight: '#3AA6E8',
    blue: '#0080BB',
    blueDark: '#0D79AF',
    blueDark2: '#00496C',
    navyBlue: '#0075AE',
    navyBlueDark: '#085982',
    powderBluePale: '#E8ECEF',
    tealLight: '#3CCCA4',
    teal: '#0FCEC9',
    tealDark: '#3DB6B6',
    tealDark2: '#3DB7B7',
    greenLight: '#3DB688',
    green: '#00C08B',
    greenDark: '#2BAF83',
    greenDark2: '#168463',
    greenDarkPale: '#5CA992',
    powderGreenPale: '#E5EDEB',
    seaGreenPale: '#F4FCFA',
    rioGrande: '#C2D500',
    rioGrandeDark: '#B5C82B',
    rioGrandeDark2: '#95A72A',
    marigold: '#FFBA00',
    marigoldDark: '#EEAE13',
    marigoldDarkPale: '#E8EBCB',
    marigoldPale: '#F6F9D9',
    orange: '#F18A00',
    orangeDark: '#DF831F',
    ginger: '#FF671D',
    vividRed: '#DA3D1A',
    red: '#FE4438',
    redDark: '#E14434',
    redDark2: '#962920',
    fuchsia: '#C635A8',
    purple: '#93278F',
    purpleDark: '#892383',
    violet: '#573c81',
    grey: '#666F75',
    lightGrey: '#AFAFAF',
    radarBlue: '#0080BB',
    radarTeal: '#10CFC9',
    radarGold: '#F69627',
    radarOrange: '#FF671D',
    radarPeach: '#FF8F88',
    radarPurple: '#A952A5',
    radarViolet: '#786099',
    theme_light: '#10CFC9',
    theme_pinpoint: '#0080BB',
    theme_pinpoint1: '#10CFC9',
    theme_pinpoint2: '#F69627',
    theme_pinpoint3: '#FF671D',
    theme_pinpoint4: '#FF8F88',
    theme_pinpoint5: '#A952A5',
    theme_pinpoint6: '#786099',
    tableauBlue: '#085982',
    tableauOrange: '#BB372E',
    validation: '#00694D',
    target: '#C85520',
    talUnknown: '#C4C4C4',
    tagHit: '#A93027',
    tagMiss: '#085982',
    tagTarget: '#95A72A',
    tagValidation: '#239F78',
    tagActuarial: '#D79F1C',
    tagRtDemo: '#2CAF83',
    tagRtClassifier: '#C635A8',
    talLime: '#BDD027',
    progressTeal: '#26C9C2',
    actuarialFreq: '#246285',
    actuarialSev: '#8D390A',
    actuarialMult: '#217C7C',
    actuarialDir: '#5C0859',
    otherExposure: '#9E3D9A'
  },
  heatmap: ['#085982', '#115e85', '#256a8d', '#377493', '#4b809b', '#608ca2', '#7397a9', '#87a3b1', '#adb9bf', '#cccccc', '#d1c1c0', '#d0b6b4', '#cfa7a4', '#cc9490', '#c87d78', '#c4635d', '#bf463e', '#BB372E'],
  heatmapTransparent: ['#115e85', '#256a8d', '#377493', '#4b809b', '#608ca2', '#7397a9', '#87a3b1', '#99adb7', '#adb9bf', '#cccccc', '#d1c1c0', '#d0b6b4', '#cfa7a4', '#cc9490', '#c87d78', '#c4635d', '#bf463e', '#BB372E'],
  grid: {
    breakpoints: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200
    },
    containerMaxWidth: {
      xs: '540px',
      sm: '720px',
      md: '960px',
      lg: '1156px',
      xl: '1200px'
    },
    gutterWidth: '1rem',
    colCount: 12
  },
  shadows: {
    0: 'none',
    1: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 1px 1px 0 rgba(8, 11, 14, 0.1)',
    2: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 3px 3px -1px rgba(8, 11, 14, 0.1)',
    3: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 6px 6px -1px rgba(8, 11, 14, 0.1)',
    4: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 16px 16px -1px rgba(8, 11, 14, 0.1)',
    5: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 32px 40px -1px rgba(8, 11, 14, 0.1)',
    6: '0px 3px 15px rgba(0, 0, 0, 0.05)'
  },
  fontFamily: {
    primary: 'Roboto',
    secondary: 'Roboto',
    code: 'monospace'
  },
  rounded: {
    0: '0px',
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '12px',
    circle: '1000rem'
  },
  application: {
    menuWidth: '200px',
    miniMenuWidth: '50px',
    menuAdditionalWidth: '4px',
    menuHeight: '36px',
    hoveredMenuWidth: '204px',
    hoveredMiniMenuWidth: '54px',
    headerHeight: '65px',
    menuTransition: 'width 0.5s ease'
  },
  skeleton: {
    baseColor: '#F0F0F0',
    hightlightColor: '#E0E0E0',
    duration: '1.2'
  },
  transition: 'all 0.4s ease-in-out',
  // textSize's from Mehdi' system
  // * tiny
  // * caption
  // * body
  // * subtitle
  // * title

  textSize: {
    size: {
      half: '0.5rem',
      tiny: '0.5625rem',
      small: '0.625rem',
      caption: '0.6875rem',
      body: '0.75rem',
      input: '0.875rem',
      paragraph: '1rem',
      subtitle: '1rem',
      subheader: '1.25rem',
      title: '1.5rem',
      heading: '1.375rem',
      subheading: '1.25rem',
      display1: '2rem',
      display2: '2.5rem',
      display3: '2.875rem',
      display4: '3.5rem'
    },
    height: {
      half: '0.5rem',
      tiny: '0.625rem',
      small: '0.625rem',
      caption: '0.8125rem',
      body: '0.875rem',
      input: '.875rem',
      paragraph: '1.625rem',
      subtitle: '1.25rem',
      subheader: '1.875rem',
      title: '1.75rem',
      heading: '1.75rem',
      subheading: '1.5rem',
      display1: '3rem',
      display2: '3.25rem',
      display3: '3.5rem',
      display4: '4rem'
    }
  }
};

var _createTheming = lib_1(DefaultTheme),
  ThemeProvider = _createTheming.ThemeProvider,
  withTheme = _createTheming.withTheme;

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var DURATION = '0.3s';
var TIMING_FUNCTION = 'ease-in-out';
var DELAY = '0s';
var ITERATION_COUNT = 1;
var DIRECTION = 'normal';
var Shake = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 100% {\n    left: 0px;\n  }\n  20%, 60% {\n    left: 15px;\n  }\n  40%, 80% {\n    left: -15px;\n  }\n"])));
var rightShake = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0%, 100% {\n    left: 0px;\n  }\n  20%, 80% {\n    left: 2px;\n  }\n  40%, 60% {\n    left: 4px;\n  }\n"])));
var leftShake = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0%, 100% {\n    left: 0px;\n  }\n  20%, 80% {\n    left: -2px;\n  }\n  40%, 60% {\n    left: -4px;\n  }\n"])));
var getKeyFrames = function getKeyFrames(animation) {
  if (animation === 'shake') {
    return Shake;
  }
  if (animation === 'left-shake') {
    return leftShake;
  }
  if (animation === 'right-shake') {
    return rightShake;
  }
  return 'none';
};
var animation = function animation(props) {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  animation: ", " ", "\n    ", " ", "\n    ", " ", ";\n"])), getKeyFrames(props.animation), props.animationDuration || DURATION, props.animationTimingFunction || TIMING_FUNCTION, props.animationDelay || DELAY, props.animationIterationCount || ITERATION_COUNT, props.animationDirection || DIRECTION);
};
var hoverAnimation = function hoverAnimation(props) {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  animation: ", " ", "\n    ", " ", "\n    ", " ", ";\n"])), getKeyFrames(props.hoverAnimation), props.hoverAnimationDuration || DURATION, props.hoverAnimationTimingFunction || TIMING_FUNCTION, props.hoverAnimationDelay || DELAY, props.hoverAnimationIterationCount || ITERATION_COUNT, props.hoverAnimationDirection || DIRECTION);
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6;
var range = function range(start, stop, step) {
  return Array.from({
    length: (stop - start) / step + 1
  }, function (_, i) {
    return start + i * step;
  });
};
var makeResponsive = function makeResponsive(key, i) {
  return key && i ? css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n        ", ": ", ";\n        ", "\n        ", "\n    ", "\n    ", "\n      "])), key, typeof i === 'string' ? i : i.xs || null, i.sm && "@media (min-width: 576px) {\n        ".concat(key, ": ").concat(i.sm, ";\n      }"), i.md && "@media (min-width: 768px) {\n        ".concat(key, ": ").concat(i.md, ";\n      }"), i.lg && "@media (min-width: 992px) {\n        ".concat(key, ": ").concat(i.lg, ";\n      }"), i.xl && "@media (min-width: 1200px) {\n        ".concat(key, ": ").concat(i.xl, ";\n      }")) : '';
};
var findDirection = function findDirection(key, i) {
  if (typeof (i.x || i.y || i.b || i.t || i.l || i.r) === 'undefined') {
    return makeResponsive("".concat(key), i);
  }
  return css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), typeof i.x !== 'undefined' && makeResponsive("".concat(key, "-left"), i.x), typeof i.x !== 'undefined' && makeResponsive("".concat(key, "-right"), i.x), typeof i.y !== 'undefined' && makeResponsive("".concat(key, "-top"), i.y), typeof i.y !== 'undefined' && makeResponsive("".concat(key, "-bottom"), i.y), typeof i.t !== 'undefined' && makeResponsive("".concat(key, "-top"), i.t), typeof i.l !== 'undefined' && makeResponsive("".concat(key, "-left"), i.l), typeof i.r !== 'undefined' && makeResponsive("".concat(key, "-right"), i.r), typeof i.b !== 'undefined' && makeResponsive("".concat(key, "-bottom"), i.b));
};
var findRoundedDirection = function findRoundedDirection(i, themeRadius) {
  return css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' && typeof i === 'string' && makeResponsive('border-radius', themeRadius[i]), typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' && i.xs && makeResponsive('border-radius', {
    xs: themeRadius[i.xs]
  }), typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' && i.sm && makeResponsive('border-radius', {
    sm: themeRadius[i.sm]
  }), typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' && i.md && makeResponsive('border-radius', {
    md: themeRadius[i.md]
  }), typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' && i.lg && makeResponsive('border-radius', {
    lg: themeRadius[i.lg]
  }), typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' && i.xl && makeResponsive('border-radius', {
    xl: themeRadius[i.xl]
  }), typeof i.t !== 'undefined' && makeResponsive('border-top-left-radius', themeRadius[i.l]), typeof i.t !== 'undefined' && makeResponsive('border-top-right-radius', themeRadius[i.r]), typeof i.l !== 'undefined' && makeResponsive('border-top-left-radius', themeRadius[i.l]), typeof i.l !== 'undefined' && makeResponsive('border-bottom-left-radius', themeRadius[i.l]), typeof i.b !== 'undefined' && makeResponsive('border-bottom-left-radius', themeRadius[i.l]), typeof i.b !== 'undefined' && makeResponsive('border-bottom-right-radius', themeRadius[i.r]), typeof i.r !== 'undefined' && makeResponsive('border-top-right-radius', themeRadius[i.r]), typeof i.r !== 'undefined' && makeResponsive('border-bottom-right-radius', themeRadius[i.r]), typeof i.tl !== 'undefined' && makeResponsive('border-top-left-radius', themeRadius[i.tl]), typeof i.tr !== 'undefined' && makeResponsive('border-top-right-radius', themeRadius[i.tr]), typeof i.bl !== 'undefined' && makeResponsive('border-bottom-left-radius', themeRadius[i.bl]), typeof i.br !== 'undefined' && makeResponsive('border-bottom-right-radius', themeRadius[i.br]));
};
var makeResponsiveFontSize = function makeResponsiveFontSize(i, textSize) {
  return css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), typeof i === 'string' ? "font-size: ".concat(textSize.size[i], "; line-height:").concat(textSize.height[i], ";") : i.xs && "font-size: ".concat(textSize.size[i.xs], "; line-height:").concat(textSize.height[i.xs], ";"), i.sm && "@media (min-width: 576px) {\n      font-size: ".concat(textSize.size[i.sm], "; line-height:").concat(textSize.height[i.sm], ";\n    }"), i.md && "@media (min-width: 768px) {\n      font-size: ".concat(textSize.size[i.md], "; line-height:").concat(textSize.height[i.md], ";\n    }"), i.lg && "@media (min-width: 992px) {\n      font-size: ".concat(textSize.size[i.lg], "; line-height:").concat(textSize.height[i.lg], ";\n    }"), i.xl && "@media (min-width: 1200px) {\n      font-size: ".concat(textSize.size[i.xl], "; line-height:").concat(textSize.height[i.xl], ";\n    }"));
};
var makeResponsiveProperty = function makeResponsiveProperty(i, property, themeValues) {
  return css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), typeof i === 'string' || typeof i === 'number' ? "".concat(property, ": ").concat(themeValues[i], ";") : i.xs && "".concat(property, ": ").concat(themeValues[i.xs], ";"), i.sm && "@media (min-width: 576px) {\n      ".concat(property, ": ").concat(themeValues[i.sm], "};\n    }"), i.md && "@media (min-width: 768px) {\n      ".concat(property, ": ").concat(themeValues[i.md], "};\n    }"), i.lg && "@media (min-width: 992px) {\n      ".concat(property, ": ").concat(themeValues[i.lg], "};\n    }"), i.xl && "@media (min-width: 1200px) {\n      ".concat(property, ": ").concat(themeValues[i.xl], "};\n    }"));
};
var makeResponsiveShadow = function makeResponsiveShadow(i, themeShadow) {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), typeof i === 'string' || typeof i === 'number' ? "box-Shadow: ".concat(themeShadow[i], ";") : i.xs && "box-Shadow: ".concat(themeShadow[i.xs], ";"), i.sm && "@media (min-width: 576px) {\n        box-Shadow: ".concat(themeShadow[i.sm], "};\n      }"), i.md && "@media (min-width: 768px) {\n        box-Shadow: ".concat(themeShadow[i.md], "};\n      }"), i.lg && "@media (min-width: 992px) {\n        box-Shadow: ".concat(themeShadow[i.lg], "};\n      }"), i.xl && "@media (min-width: 1200px) {\n        box-Shadow: ".concat(themeShadow[i.xl], "};\n      }"));
};
var functions = {
  range: range,
  findDirection: findDirection,
  makeResponsive: makeResponsive,
  findRoundedDirection: findRoundedDirection,
  makeResponsiveFontSize: makeResponsiveFontSize,
  makeResponsiveShadow: makeResponsiveShadow,
  makeResponsiveProperty: makeResponsiveProperty
};

var _templateObject$2;
var _excluded = ["d", "pos", "top", "bottom", "left", "right", "justify", "align", "flexDir", "flexGrow", "flexWrap", "order", "m", "p", "rounded", "border", "borderColor", "h", "maxH", "minH", "w", "minW", "maxW", "cursor", "bg", "bgImg", "bgSize", "bgRepeat", "bgPos", "textSize", "textColor", "textWeight", "textAlign", "textTransform", "fontFamily", "shadow", "transition", "transform", "transformOrigin", "zIndex", "overflow", "opacity", "hoverBg", "hoverTextColor", "hoverBorderColor", "hoverShadow", "hoverTransform", "focusBorderColor", "isOpen", "hover", "offset", "size", "targetHover", "theme", "tag", "whiteSpace", "alignSelf", "children"];

/* eslint-disable react/prop-types */

var CustomTag = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var d = props.d,
    pos = props.pos,
    top = props.top,
    bottom = props.bottom,
    left = props.left,
    right = props.right,
    justify = props.justify,
    align = props.align,
    flexDir = props.flexDir,
    flexGrow = props.flexGrow,
    flexWrap = props.flexWrap,
    order = props.order,
    m = props.m,
    p = props.p,
    rounded = props.rounded,
    border = props.border,
    borderColor = props.borderColor,
    h = props.h,
    maxH = props.maxH,
    minH = props.minH,
    w = props.w,
    minW = props.minW,
    maxW = props.maxW,
    cursor = props.cursor,
    bg = props.bg,
    bgImg = props.bgImg,
    bgSize = props.bgSize,
    bgRepeat = props.bgRepeat,
    bgPos = props.bgPos,
    textSize = props.textSize,
    textColor = props.textColor,
    textWeight = props.textWeight,
    textAlign = props.textAlign,
    textTransform = props.textTransform,
    fontFamily = props.fontFamily,
    shadow = props.shadow,
    transition = props.transition,
    transform = props.transform,
    transformOrigin = props.transformOrigin,
    zIndex = props.zIndex,
    overflow = props.overflow,
    opacity = props.opacity,
    hoverBg = props.hoverBg,
    hoverTextColor = props.hoverTextColor,
    hoverBorderColor = props.hoverBorderColor,
    hoverShadow = props.hoverShadow,
    hoverTransform = props.hoverTransform,
    focusBorderColor = props.focusBorderColor,
    isOpen = props.isOpen,
    hover = props.hover,
    offset = props.offset,
    size = props.size,
    targetHover = props.targetHover,
    theme = props.theme,
    tag = props.tag,
    whiteSpace = props.whiteSpace,
    alignSelf = props.alignSelf,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("".concat(tag), _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref
  }), children);
});

/* eslint-enable react/prop-types */

var Div = styled(CustomTag)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  :hover {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.d && functions.makeResponsive('display', props.d);
}, function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.top && functions.makeResponsive('top', props.top);
}, function (props) {
  return props.bottom && functions.makeResponsive('bottom', props.bottom);
}, function (props) {
  return props.left && functions.makeResponsive('left', props.left);
}, function (props) {
  return props.right && functions.makeResponsive('right', props.right);
}, function (props) {
  return props.justify && functions.makeResponsive('justify-content', props.justify);
}, function (props) {
  return props.align && functions.makeResponsive('align-items', props.align);
}, function (props) {
  return props.flexDir && functions.makeResponsive('flex-direction', props.flexDir);
}, function (props) {
  return props.flexGrow && functions.makeResponsive('flex', props.flexGrow);
}, function (props) {
  return props.flexWrap && functions.makeResponsive('flex-wrap', props.flexWrap);
}, function (props) {
  return props.order && functions.makeResponsive('order', props.order);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return props.border && functions.findDirection('border', props.border);
}, function (props) {
  return props.borderColor && functions.makeResponsive('border-color', props.theme.colors[props.borderColor]);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return props.cursor && functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.bgImg && "background-image: url(".concat(props.bgImg, ")");
}, function (props) {
  return props.bgSize && functions.makeResponsive('background-size', props.bgSize);
}, function (props) {
  return props.bgRepeat && functions.makeResponsive('background-repeat', props.bgRepeat);
}, function (props) {
  return props.bgPos && functions.makeResponsive('background-position', props.bgPos);
}, function (props) {
  return props.textSize && functions.makeResponsiveFontSize(props.textSize, props.theme.textSize);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.textWeight && functions.makeResponsive('font-weight', props.textWeight);
}, function (props) {
  return props.textAlign && functions.makeResponsive('text-align', props.textAlign);
}, function (props) {
  return props.textTransform && functions.makeResponsive('text-transform', props.textTransform);
}, function (props) {
  return props.fontFamily && "font-family: ".concat(props.theme.fontFamily[props.fontFamily]);
}, function (props) {
  return props.transition && "transition: ".concat(props.theme.transition);
}, function (props) {
  return props.transform && functions.makeResponsive('transform', props.transform);
}, function (props) {
  return props.shadow && functions.makeResponsiveShadow(props.shadow, props.theme.shadows);
}, function (props) {
  return props.transformOrigin && functions.makeResponsive('transform-origin', props.transformOrigin);
}, function (props) {
  return props.zIndex && functions.makeResponsive('z-index', props.zIndex);
}, function (props) {
  return props.overflow && "overflow: ".concat(props.overflow);
}, function (props) {
  return props.opacity && functions.makeResponsive('opacity', props.opacity);
}, function (props) {
  return props.whiteSpace && "white-space: ".concat(props.whiteSpace);
}, function (props) {
  return props.alignSelf && "align-self: ".concat(props.alignSelf);
}, function (props) {
  return props.animation && animation(props);
}, function (props) {
  return props.hoverTransform && functions.makeResponsive('transform', props.hoverTransform);
}, function (props) {
  return props.hoverAnimation && hoverAnimation(props);
}, function (props) {
  return props.hoverBg && functions.makeResponsiveProperty(props.hoverBg, 'background', props.theme.colors);
}, function (props) {
  return props.hoverTextColor && functions.makeResponsive('color', props.theme.colors[props.hoverTextColor]);
}, function (props) {
  return props.hoverBorderColor && functions.makeResponsive('border-color', props.theme.colors[props.hoverBorderColor]);
}, function (props) {
  return props.hoverShadow && functions.makeResponsiveShadow(props.hoverShadow, props.theme.shadows);
});

/* eslint-disable react/require-default-props */

Div.propTypes = {
  tag: PropTypes.string,
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  justify: PropTypesRepo.justify,
  align: PropTypesRepo.align,
  flexDir: PropTypesRepo.flexDir,
  flexGrow: PropTypesRepo.flexGrow,
  flexWrap: PropTypesRepo.flexWrap,
  order: PropTypesRepo.order,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  rounded: PropTypesRepo.rounded,
  border: PropTypesRepo.border,
  borderColor: PropTypesRepo.borderColor,
  h: PropTypesRepo.h,
  maxH: PropTypesRepo.maxH,
  minH: PropTypesRepo.minH,
  w: PropTypesRepo.w,
  maxW: PropTypesRepo.maxW,
  minW: PropTypesRepo.minW,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  bgImg: PropTypesRepo.bgImg,
  bgSize: PropTypesRepo.bgSize,
  bgRepeat: PropTypesRepo.bgRepeat,
  bgPos: PropTypesRepo.bgPos,
  textSize: PropTypesRepo.textSize,
  textColor: PropTypesRepo.textColor,
  textWeight: PropTypesRepo.textWeight,
  textAlign: PropTypesRepo.textAlign,
  textTransform: PropTypesRepo.textTransform,
  fontFamily: PropTypesRepo.fontFamily,
  transition: PropTypesRepo.transition,
  shadow: PropTypesRepo.shadow,
  transformOrigin: PropTypesRepo.transformOrigin,
  zIndex: PropTypesRepo.zIndex,
  overflow: PropTypesRepo.overflow,
  opacity: PropTypesRepo.opacity,
  hoverBg: PropTypesRepo.hoverBg,
  hoverTextColor: PropTypesRepo.hoverTextColor,
  hoverBorderColor: PropTypesRepo.hoverBorderColor,
  hoverShadow: PropTypesRepo.hoverShadow,
  hoverTransform: PropTypesRepo.hoverTransform,
  whiteSpace: PropTypes.string,
  alignSelf: PropTypes.string
};

/* eslint-enable react/require-default-props */

Div.defaultProps = {
  tag: 'div',
  whiteSpace: 'normal',
  alignSelf: 'auto'
};
var Div$1 = withTheme(Div);

var _templateObject$3;
var _excluded$1 = ["d", "size", "order", "m", "p", "transform", "top", "bottom", "left", "right", "cursor", "name", "color", "hoverColor", "hoverTransform", "viewBox"];
var iconPaths$1 = _objectSpread2(_objectSpread2({}, icons), iconPaths);
/* eslint-disable react/prop-types */

var BaseIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var d = props.d,
    size = props.size,
    order = props.order,
    m = props.m,
    p = props.p,
    transform = props.transform,
    top = props.top,
    bottom = props.bottom,
    left = props.left,
    right = props.right,
    cursor = props.cursor,
    name = props.name,
    color = props.color,
    hoverColor = props.hoverColor,
    hoverTransform = props.hoverTransform,
    viewBox = props.viewBox,
    rest = _objectWithoutProperties(props, _excluded$1);
  var IconName = iconPaths$1[name];
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: viewBox
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(IconName, {
    color: rest.theme.colors[color]
  }));
});

/* eslint-enable react/prop-types */

var IconStyled = styled(BaseIcon)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  \n  ", ";\n\n  :hover {\n    ", ";\n    ", ";\n    ", "\n"])), function (props) {
  return props.d && functions.makeResponsive('display', props.d);
}, function (props) {
  return functions.makeResponsive('height', props.size);
}, function (props) {
  return functions.makeResponsive('width', props.size);
}, function (props) {
  return functions.makeResponsive('min-width', props.size);
}, function (props) {
  return functions.makeResponsive('min-height', props.size);
}, function (props) {
  return props.order && functions.makeResponsive('order', props.order);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.transform && functions.makeResponsive('transform', props.transform);
}, function (props) {
  return props.top && functions.makeResponsive('top', props.top);
}, function (props) {
  return props.bottom && functions.makeResponsive('bottom', props.bottom);
}, function (props) {
  return props.left && functions.makeResponsive('left', props.left);
}, function (props) {
  return props.right && functions.makeResponsive('right', props.right);
}, function (props) {
  return props.cursor && functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return props.animation && animation(props);
}, function (props) {
  return props.alignSelf && "align-self: ".concat(props.alignSelf);
}, function (props) {
  return props.hoverTransform && functions.makeResponsive('transform', props.hoverTransform);
}, function (props) {
  return props.hoverAnimation && hoverAnimation(props);
}, function (props) {
  return props.hoverColor && "\n        path {\n          transition: ".concat(props.theme.transition, ";\n          fill: ").concat(props.theme.colors[props.hoverColor], ";\n        }\n        circle {\n          transition: ").concat(props.theme.transition, ";\n          fill: ").concat(props.theme.colors[props.hoverColor], ";\n        }\n      ");
});
var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement(IconStyled, props);
};

/* eslint-disable react/require-default-props */

Icon.propTypes = {
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  cursor: PropTypesRepo.cursor,
  size: PropTypesRepo.d,
  color: PropTypes.string,
  order: PropTypesRepo.order,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  transform: PropTypesRepo.transform,
  hoverColor: PropTypesRepo.hoverColor,
  hoverTransform: PropTypesRepo.hoverTransform,
  viewBox: PropTypes.string,
  animation: PropTypes.string,
  alignSelf: PropTypes.string
};

/* eslint-enable react/require-default-props */

Icon.defaultProps = {
  size: '20px',
  color: 'tabSelected',
  viewBox: '0 0 50 50',
  animation: null,
  hoverTransform: null
};
var Icon$1 = withTheme(Icon);

var _templateObject$4;
var duration = 200;
var defaultAccordionBodyStyle = {
  transition: "height ".concat(duration, "ms ease-out"),
  height: 0
};
var transitionAccordionBodyStyles = function transitionAccordionBodyStyles(_ref) {
  var h = _ref.h;
  return {
    entering: {
      height: 0,
      overflow: 'hidden',
      border: 'none'
    },
    entered: {
      height: h,
      paddingTop: '12px'
    },
    exiting: {
      height: h,
      paddingTop: '12px'
    },
    exited: {
      height: 0,
      overflow: 'hidden',
      border: 'none'
    }
  };
};
var Title = styled(Div$1)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  return props.targetHover && ":hover { border-color: ".concat(props.theme.colors[props.focusBorderColor], "}");
}, function (props) {
  return props.targetHover && ':hover > div:last-child{ opacity: 1; transform: scaleY(1);}';
});
var AccordionSection = function AccordionSection(_ref2) {
  var isOpenProps = _ref2.isOpen,
    onOpen = _ref2.onOpen,
    openSuffix = _ref2.openSuffix,
    closeSuffix = _ref2.closeSuffix,
    title = _ref2.title,
    children = _ref2.children,
    titleStyle = _ref2.titleStyle,
    contentStyle = _ref2.contentStyle,
    titleStyleExtra = _ref2.titleStyleExtra,
    contentStyleExtra = _ref2.contentStyleExtra,
    titlePrefix = _ref2.titlePrefix,
    titleSuffix = _ref2.titleSuffix;
  var _useState = useState(isOpenProps),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    setIsOpen(isOpenProps);
  }, [isOpenProps]);
  return /*#__PURE__*/React.createElement(Transition, {
    "in": isOpen,
    timeout: duration,
    onExited: function onExited() {
      setIsOpen(false);
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Div$1, {
      border: {
        b: '1px solid'
      },
      borderColor: "gray400"
    }, /*#__PURE__*/React.createElement(Title, _extends({
      isOpen: isOpen,
      onClick: function onClick() {
        setIsOpen(!isOpen);
        onOpen();
      }
    }, titleStyle, titleStyleExtra, {
      bg: isOpen ? titleStyle.hoverBg : titleStyle.bg
    }), titlePrefix, title, /*#__PURE__*/React.createElement(Div$1, {
      d: "flex",
      align: "center"
    }, titleSuffix, isOpen ? openSuffix : closeSuffix)), /*#__PURE__*/React.createElement(Div$1, _extends({
      style: _objectSpread2(_objectSpread2({}, defaultAccordionBodyStyle), transitionAccordionBodyStyles({
        h: contentStyleExtra.h || contentStyle.h // eslint-disable-line react/prop-types
      })[state])
    }, contentStyle, contentStyleExtra), children));
  });
};
AccordionSection.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  openSuffix: PropTypes.node,
  closeSuffix: PropTypes.node,
  focusBorderColor: PropTypesRepo.focusBorderColor,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onOpen: PropTypes.func.isRequired,
  titleStyle: PropTypes.shape({
    bg: PropTypesRepo.bg,
    hoverBg: PropTypesRepo.hoverBg
  }).isRequired,
  contentStyle: PropTypes.shape({
    h: PropTypesRepo.h
  }).isRequired,
  titleStyleExtra: PropTypes.shape({}).isRequired,
  contentStyleExtra: PropTypes.shape({}).isRequired,
  titlePrefix: PropTypes.node,
  titleSuffix: PropTypes.node
};
AccordionSection.defaultProps = {
  isOpen: false,
  openSuffix: /*#__PURE__*/React.createElement(Icon$1, {
    name: "UpArrow",
    size: "18px",
    m: {
      l: '16px'
    },
    color: "medium"
  }),
  closeSuffix: /*#__PURE__*/React.createElement(Icon$1, {
    name: "DownArrow",
    size: "18px",
    m: {
      l: '16px'
    },
    color: "medium"
  }),
  focusBorderColor: 'gray800',
  children: null,
  titlePrefix: null,
  titleSuffix: null
};
var Accordion = /*#__PURE__*/function (_Component) {
  _inherits(Accordion, _Component);
  var _super = _createSuper(Accordion);
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _super.call(this, props);
    _this.state = {
      selectedIndex: props.selectedIndex
    };
    return _this;
  }
  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        sections = _this$props.sections,
        titleStyle = _this$props.titleStyle,
        contentStyle = _this$props.contentStyle,
        containerStyle = _this$props.containerStyle,
        titleStyleExtra = _this$props.titleStyleExtra,
        contentStyleExtra = _this$props.contentStyleExtra;
      var selectedIndex = this.state.selectedIndex;
      return /*#__PURE__*/React.createElement(Div$1, _extends({
        border: "1px solid",
        rounded: "md",
        borderColor: "gray400"
      }, containerStyle), sections.map(function (_ref3, index) {
        var titlePrefix = _ref3.titlePrefix,
          title = _ref3.title,
          titleSuffix = _ref3.titleSuffix,
          content = _ref3.content;
        return /*#__PURE__*/React.createElement(AccordionSection, {
          title: title,
          isOpen: selectedIndex === index,
          onOpen: function onOpen() {
            _this2.setState({
              selectedIndex: index
            });
          },
          titleStyle: titleStyle,
          titleStyleExtra: titleStyleExtra,
          contentStyle: contentStyle,
          contentStyleExtra: contentStyleExtra,
          titlePrefix: titlePrefix,
          titleSuffix: titleSuffix
        }, content);
      }));
    }
  }]);
  return Accordion;
}(Component);
Accordion.propTypes = {
  selectedIndex: PropTypes.number,
  sections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    titlePrefix: PropTypes.node,
    titleSuffix: PropTypes.node
  })).isRequired,
  titleStyle: PropTypes.shape({
    bg: PropTypesRepo.bg,
    hoverBg: PropTypesRepo.hoverBg
  }),
  contentStyle: PropTypes.shape({
    h: PropTypesRepo.h
  }),
  containerStyle: PropTypes.shape({}),
  titleStyleExtra: PropTypes.shape({}),
  contentStyleExtra: PropTypes.shape({})
};
Accordion.defaultProps = {
  selectedIndex: 0,
  contentStyle: {
    w: '100%',
    h: '100px',
    p: {
      x: '12px'
    },
    border: {
      t: '1px solid'
    },
    borderColor: 'gray200',
    rounded: '0',
    textSize: 'body',
    bg: 'white'
  },
  contentStyleExtra: {},
  titleStyle: {
    w: '100%',
    d: 'flex',
    align: 'center',
    textColor: 'medium',
    textWeight: '500',
    justify: 'space-between',
    p: {
      x: '12px'
    },
    h: '48px',
    textSize: 'title',
    bg: 'white',
    hoverBg: 'gray100',
    cursor: 'pointer'
  },
  titleStyleExtra: {},
  containerStyle: {}
};
var Accordion$1 = withTheme(Accordion);

var _excluded$2 = ["children", "iconProp", "status"];
var Avatar = function Avatar(_ref) {
  var children = _ref.children,
    iconProp = _ref.iconProp,
    status = _ref.status,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(Div$1, rest, !rest.bgImg && (children || /*#__PURE__*/React.createElement(Icon$1, _extends({
    name: "UserSolid",
    color: "white"
  }, iconProp))), status && /*#__PURE__*/React.createElement(Icon$1, _extends({
    name: "Status",
    pos: "absolute",
    bottom: rest.rounded === 'circle' && '2px',
    top: rest.rounded === 'circle' ? 'auto' : '-4px',
    right: rest.rounded === 'circle' ? '1px' : '-4px',
    size: "8px"
  }, status)));
};

/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

Avatar.propTypes = {
  children: PropTypes.any,
  iconProp: PropTypes.object,
  status: PropTypes.object,
  bg: PropTypesRepo.bg,
  textColor: PropTypesRepo.textColor,
  h: PropTypesRepo.h,
  w: PropTypesRepo.w,
  textWeight: PropTypesRepo.textWeight
};

/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Avatar.defaultProps = {
  bg: 'brand700',
  pos: 'relative',
  textColor: 'white',
  d: 'flex',
  align: 'center',
  justify: 'center',
  h: '40px',
  w: '40px',
  rounded: 'circle',
  textWeight: '500',
  bgSize: 'cover'
};

var _templateObject$5;
var _excluded$3 = ["d", "pos", "top", "bottom", "left", "right", "justify", "align", "flexDir", "flexGrow", "flexWrap", "order", "m", "p", "rounded", "border", "borderColor", "h", "maxH", "minH", "w", "minW", "maxW", "cursor", "textSize", "textColor", "textWeight", "textAlign", "textTransform", "fontFamily", "shadow", "transition", "transform", "transformOrigin", "zIndex", "overflow", "opacity", "hoverBg", "hoverTextColor", "hoverBorderColor", "hoverShadow", "focusBorderColor", "theme", "prefix", "isLoading", "suffix", "alignSelf", "letterSpacing", "children"];

/* eslint-disable react/prop-types */

var BaseButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var d = props.d,
    pos = props.pos,
    top = props.top,
    bottom = props.bottom,
    left = props.left,
    right = props.right,
    justify = props.justify,
    align = props.align,
    flexDir = props.flexDir,
    flexGrow = props.flexGrow,
    flexWrap = props.flexWrap,
    order = props.order,
    m = props.m,
    p = props.p,
    rounded = props.rounded,
    border = props.border,
    borderColor = props.borderColor,
    h = props.h,
    maxH = props.maxH,
    minH = props.minH,
    w = props.w,
    minW = props.minW,
    maxW = props.maxW,
    cursor = props.cursor,
    textSize = props.textSize,
    textColor = props.textColor,
    textWeight = props.textWeight,
    textAlign = props.textAlign,
    textTransform = props.textTransform,
    fontFamily = props.fontFamily,
    shadow = props.shadow,
    transition = props.transition,
    transform = props.transform,
    transformOrigin = props.transformOrigin,
    zIndex = props.zIndex,
    overflow = props.overflow,
    opacity = props.opacity,
    hoverBg = props.hoverBg,
    hoverTextColor = props.hoverTextColor,
    hoverBorderColor = props.hoverBorderColor,
    hoverShadow = props.hoverShadow,
    focusBorderColor = props.focusBorderColor,
    theme = props.theme,
    prefix = props.prefix,
    isLoading = props.isLoading,
    suffix = props.suffix,
    alignSelf = props.alignSelf,
    letterSpacing = props.letterSpacing,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$3);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "submit",
    ref: ref
  }, rest), isLoading && /*#__PURE__*/React.createElement(Icon$1, {
    name: "Loading",
    size: "16px",
    m: {
      r: '8px'
    },
    color: textColor
  }), prefix, children, suffix);
});

/* eslint-enable react/prop-types */

var ButtonStyled = styled(BaseButton)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  :focus {\n    outline: none;\n  }\n\n  :hover {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n\n  :disabled {\n    color: white;\n    border: none;\n    cursor: not-allowed;\n    box-shadow: none;\n    background: ", ";\n  }\n"])), function (props) {
  return functions.makeResponsive('display', props.d);
}, function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.top && functions.makeResponsive('top', props.top);
}, function (props) {
  return props.bottom && functions.makeResponsive('bottom', props.bottom);
}, function (props) {
  return props.left && functions.makeResponsive('left', props.left);
}, function (props) {
  return props.right && functions.makeResponsive('right', props.right);
}, function (props) {
  return functions.makeResponsive('justify-content', props.justify);
}, function (props) {
  return functions.makeResponsive('align-items', props.align);
}, function (props) {
  return props.flexDir && functions.makeResponsive('flex-direction', props.flexDir);
}, function (props) {
  return props.flexWrap && functions.makeResponsive('flex-wrap', props.flexWrap);
}, function (props) {
  return props.order && functions.makeResponsive('order', props.order);
}, function (props) {
  return props.flexGrow && functions.makeResponsive('flex-grow', props.flexGrow);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return functions.findDirection('padding', props.p);
}, function (props) {
  return functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return functions.findDirection('border', props.border);
}, function (props) {
  return props.borderColor && functions.makeResponsive('border-color', props.theme.colors[props.borderColor]);
}, function (props) {
  return functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return functions.makeResponsive('background', props.theme.colors[props.bg]);
}, function (props) {
  return functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.textWeight && functions.makeResponsive('font-weight', props.textWeight);
}, function (props) {
  return props.textAlign && functions.makeResponsive('align', props.textAlign);
}, function (props) {
  return props.textTransform && functions.makeResponsive('text-transform', props.textTransform);
}, function (props) {
  return props.shadow && "box-shadow: ".concat(props.theme.shadows[props.shadow]);
}, function (props) {
  return props.transition && "transition: ".concat(props.theme.transition);
}, function (props) {
  return props.textSize && functions.makeResponsiveFontSize(props.textSize, props.theme.textSize);
}, function (props) {
  return props.fontFamily && "font-family: ".concat(props.theme.fontFamily[props.fontFamily]);
}, function (props) {
  return props.transform && functions.makeResponsive('transform', props.transform);
}, function (props) {
  return props.transformOrigin && functions.makeResponsive('transform-origin', props.transformOrigin);
}, function (props) {
  return props.zIndex && functions.makeResponsive('z-index', props.zIndex);
}, function (props) {
  return props.overflow && "overflow: ".concat(props.overflow);
}, function (props) {
  return props.opacity && functions.makeResponsive('opacity', props.opacity);
}, function (props) {
  return props.alignSelf && "align-self: ".concat(props.alignSelf);
}, function (props) {
  return props.letterSpacing && "letter-spacing: ".concat(props.letterSpacing);
}, function (props) {
  return props.hoverBg && functions.makeResponsive('background', props.theme.colors[props.hoverBg]);
}, function (props) {
  return props.hoverTextColor && functions.makeResponsive('color', props.theme.colors[props.hoverTextColor]);
}, function (props) {
  return props.hoverBorderColor && functions.makeResponsive('border-color', props.theme.colors[props.hoverBorderColor]);
}, function (props) {
  return props.hoverShadow && "box-shadow: ".concat(props.theme.shadows[props.hoverShadow]);
}, function (props) {
  return props.theme.colors.tabDisabled;
});
var Button = function Button(props) {
  return /*#__PURE__*/React.createElement(ButtonStyled, props);
};
Button.propTypes = {
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  justify: PropTypesRepo.justify,
  align: PropTypesRepo.align,
  p: PropTypesRepo.p,
  rounded: PropTypesRepo.rounded,
  border: PropTypesRepo.border,
  h: PropTypesRepo.h,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  textColor: PropTypesRepo.textColor,
  textSize: PropTypesRepo.textSize,
  textWeight: PropTypesRepo.textWeight,
  fontFamily: PropTypesRepo.fontFamily,
  transition: PropTypesRepo.transition,
  alignSelf: PropTypes.string,
  letterSpacing: PropTypes.string
};
Button.defaultProps = {
  d: 'flex',
  top: 0,
  bottom: 0,
  justify: 'center',
  align: 'center',
  p: '1em 1.5em',
  pos: 'relative',
  rounded: 'sm',
  border: 'none',
  h: '38.4px',
  cursor: 'pointer',
  bg: 'black',
  textColor: 'white',
  textSize: 'body',
  textWeight: '400',
  fontFamily: 'primary',
  transition: true,
  alignSelf: 'auto',
  letterSpacing: '0.02px'
};
var Button$1 = withTheme(Button);

var themeVars = {
  transition: 'all 0.2s ease-in-out',
  rounded: {
    0: '0px',
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
    circle: '1000rem'
  },
  shadows: {
    1: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 1px 1px 0 rgba(8, 11, 14, 0.1)',
    2: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 3px 3px -1px rgba(8, 11, 14, 0.1)',
    3: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 6px 6px -1px rgba(8, 11, 14, 0.1)',
    4: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 16px 16px -1px rgba(8, 11, 14, 0.1)',
    5: '0 0 1px 0 rgba(8, 11, 14, 0.06), 0 32px 40px -1px rgba(8, 11, 14, 0.1)'
  },
  'font-family': {
    primary: '"SF Pro Text", -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
    secondary: 'SF Pro Text',
    code: 'monospace'
  }
};
var colorVar = {
  black900: '#0A1F44',
  black800: '#14284B',
  black700: '#283A5B',
  black600: '#364766',
  black500: '#455571',
  black400: '#4E5D78',
  black300: '#596780',
  black200: '#627088',
  black100: '#717D92',
  gray900: '#8A94A6',
  gray800: '#98A1B1',
  gray700: '#A7AEBB',
  gray600: '#B0B7C3',
  gray500: '#C9CED6',
  gray400: '#E1E4E8',
  gray300: '#F1F2F4',
  gray200: '#F7F8F9',
  gray100: '#FAFBFB',
  brand900: '#FF584A',
  brand800: '#FE6C61',
  brand700: '#FF867E',
  brand600: '#FFA29B',
  brand500: '#FFBDB8',
  brand400: '#FFCAC6',
  brand300: '#FFD7D4',
  brand200: '#FFE4E3',
  brand100: '#FFEEED',
  success900: '#136A4A',
  success800: '#23825F',
  success700: '#36AB80',
  success600: '#6FCAA8',
  success500: '#A9DCC9',
  success400: '#D0EDDF',
  success300: '#EAF7F1',
  success200: '#F5FBF8',
  success100: '#FAFDFC',
  warning900: '#EF8511',
  warning800: '#F69D2C',
  warning700: '#F7AF22',
  warning600: '#FBC050',
  warning500: '#FBE0A1',
  warning400: '#FDEECB',
  warning300: '#FEF7E6',
  warning200: '#FEFAF1',
  warning100: '#FFFDF8',
  danger900: '#A32801',
  danger800: '#D13A06',
  danger700: '#F4541D',
  danger600: '#F7926F',
  danger500: '#FABEAA',
  danger400: '#FCD7CA',
  danger300: '#FDE8E1',
  danger200: '#FEF6F3',
  danger100: '#FFFBFA',
  info900: '#01408F',
  info800: '#026DD6',
  info700: '#0284FE',
  info600: '#4BA7FE',
  info500: '#83C3FE',
  info400: '#B3DAFF',
  info300: '#DCEEFF',
  info200: '#EEF7FF',
  info100: '#F8FBFF',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'rgba(0,0,0,0)',
  disabled: '#B0B7C3',
  light: '#A7AAB0',
  medium: '#505256',
  dark: '#000000'
};

var _templateObject$6;
var BaseButtonGroup = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  button {\n    margin-left: -1px;\n    touch-action: manipulation;\n    border-radius: 0;\n\n    :hover {\n      z-index: 2;\n    }\n    :nth-child(1) {\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    }\n    :last-child {\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    }\n  }\n\n  :hover {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.d && functions.makeResponsive('display', props.d);
}, function (props) {
  return props.justify && functions.makeResponsive('justify-content', props.justify);
}, function (props) {
  return props.align && functions.makeResponsive('align-items', props.align);
}, function (props) {
  return props.flexDir && functions.makeResponsive('flex-direction', props.flexDir);
}, function (props) {
  return props.flexGrow && functions.makeResponsive('flex-grow', props.flexGrow);
}, function (props) {
  return props.flexWrap && functions.makeResponsive('flex-wrap', props.flexWrap);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded);
}, function (props) {
  return props.border && functions.findDirection('border', props.border);
}, function (props) {
  return props.borderColor && functions.makeResponsive('border-color', colorVar[props.borderColor]);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return props.cursor && functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return props.bg && functions.makeResponsive('background', colorVar[props.bg]);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', colorVar[props.textColor]);
}, function (props) {
  return props.textWeight && functions.makeResponsive('weight', props.textWeight);
}, function (props) {
  return props.textAlign && functions.makeResponsive('align', props.textAlign);
}, function (props) {
  return props.shadow && "box-shadow: ".concat(themeVars.shadows[props.shadow]);
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return props.hoverBg && functions.makeResponsive('background', colorVar[props.hoverBg]);
}, function (props) {
  return props.hoverTextColor && functions.makeResponsive('color', colorVar[props.hoverTextColor]);
}, function (props) {
  return props.hoverBorderColor && functions.makeResponsive('border-color', colorVar[props.hoverBorderColor]);
}, function (props) {
  return props.hoverShadow && "box-shadow: ".concat(themeVars.shadows[props.hoverShadow]);
});
var ButtonGroup = function ButtonGroup(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(BaseButtonGroup, rest, rest.children);
};
ButtonGroup.defaultProps = {
  flexWrap: 'wrap',
  rounded: 'md'
};

var _excluded$4 = ["disabled", "indeterminate", "m", "size", "color", "activeColor", "inactiveColor", "isLoading"];
var _templateObject$7;
var CheckboxInput = styled.input(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  display: none;\n\n  ~ div {\n    svg:nth-child(1) {\n      display: none;\n    }\n    svg:nth-child(2) {\n      display: block;\n    }\n  }\n\n  &:checked ~ div {\n    svg:nth-child(1) {\n      display: block;\n    }\n    svg:nth-child(2) {\n      display: none;\n    }\n  }\n"])));
var Checkbox = function Checkbox(_ref) {
  var disabled = _ref.disabled,
    indeterminate = _ref.indeterminate,
    m = _ref.m,
    size = _ref.size,
    color = _ref.color,
    activeColor = _ref.activeColor,
    inactiveColor = _ref.inactiveColor,
    isLoading = _ref.isLoading,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxInput, _extends({
    type: "checkbox",
    disabled: disabled,
    indeterminate: indeterminate
  }, rest)), !indeterminate && !disabled && /*#__PURE__*/React.createElement(Div$1, {
    m: m
  }, /*#__PURE__*/React.createElement(Icon$1, {
    d: "block",
    m: "0 auto",
    size: size,
    color: activeColor,
    name: isLoading ? 'Loading' : 'CBChecked'
  }), /*#__PURE__*/React.createElement(Icon$1, {
    d: "block",
    m: "0 auto",
    size: size,
    color: color,
    name: isLoading ? 'Loading' : 'CBUnchecked'
  })), indeterminate && /*#__PURE__*/React.createElement(Icon$1, {
    d: "block",
    m: "0 auto",
    size: size,
    color: activeColor,
    name: isLoading ? 'Loading' : 'CBIndetermine'
  }), disabled && /*#__PURE__*/React.createElement(Icon$1, {
    d: "block",
    m: "0 auto",
    size: size,
    color: inactiveColor,
    name: isLoading ? 'Loading' : 'CBDisabled'
  }));
};
Checkbox.propTypes = {
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  m: PropTypesRepo.m,
  size: PropTypesRepo.d,
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  isLoading: PropTypes.bool,
  cursor: PropTypesRepo.cursor,
  color: PropTypes.string
};
Checkbox.defaultProps = {
  disabled: false,
  indeterminate: false,
  isLoading: false,
  cursor: 'pointer',
  m: '2px',
  color: 'tabSelected',
  size: '18px',
  inactiveColor: 'tabRest',
  activeColor: 'brand500'
};

var _excluded$5 = ["p", "m", "theme", "size", "gutterWidth"];
var _templateObject$8, _templateObject2$2, _templateObject3$2;

/* eslint-disable indent */

var takeReqWidth = function takeReqWidth(i, colCount) {
  var flexAuto = 'flex-basis: 0; flex-grow: 1; max-width: 100%;';
  return css(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n    ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), (typeof parseInt(i, 10) === 'number' || i.xs) && (i.xs !== undefined || i.xs !== 'auto' ? "flex: 0 1 ".concat(100 * (parseInt(i.xs, 10) || parseInt(i, 10)) / colCount, "%;\n            max-width: ").concat(100 * (parseInt(i.xs, 10) || parseInt(i, 10)) / colCount, "%") : flexAuto), i.sm && "@media (min-width: 576px) {\n        ".concat(i.sm !== 'auto' ? "max-width: ".concat(100 * parseInt(i.sm, 10) / colCount, "%;\n              flex: 0 0 ").concat(100 * parseInt(i.sm, 10) / colCount, "%;") : flexAuto, "\n      }"), i.md && "@media (min-width: 768px) {\n        ".concat(i.md !== 'auto' ? "max-width: ".concat(100 * parseInt(i.md, 10) / colCount, "%;\n            flex: 0 0 ").concat(100 * parseInt(i.md, 10) / colCount, "%;") : flexAuto, "     \n      }"), i.lg && "@media (min-width: 992px) {\n        ".concat(i.lg !== 'auto' ? "max-width: ".concat(100 * parseInt(i.lg, 10) / colCount, "%;\n            flex: 0 0 ").concat(100 * parseInt(i.lg, 10) / colCount, "%;") : flexAuto, "  \n      }"), i.xl && "@media (min-width: 1200px) {\n        ".concat(i.xl !== 'auto' ? "max-width: ".concat(100 * parseInt(i.xl, 10) / colCount, "%;\n            flex: 0 0 ").concat(100 * parseInt(i.xl, 10) / colCount, "%;") : flexAuto, "\n      }"));
};
var takeReqOffset = function takeReqOffset(i, colCount) {
  return css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), (typeof parseInt(i, 10) === 'number' || i.xs) && "margin-left: ".concat(100 * (parseInt(i.xs, 10) || i) / colCount, "%;"), i.sm != null && "@media (min-width: 576px) {\n      margin-left: ".concat(100 * parseInt(i.sm, 10) / colCount, "%;\n    }"), i.md != null && "@media (min-width: 768px) {\n      margin-left: ".concat(100 * parseInt(i.md, 10) / colCount, "%;\n    }"), i.lg != null && "@media (min-width: 992px) {\n      margin-left: ".concat(100 * parseInt(i.lg, 10) / colCount, "%;\n    }"), i.xl != null && "@media (min-width: 1200px) {\n      margin-left: ".concat(100 * parseInt(i.xl, 10) / colCount, "%;\n    }"));
};

/* eslint-enable indent */
/* eslint-disable react/prop-types */

var BaseColumn = function BaseColumn(_ref) {
  var p = _ref.p,
    m = _ref.m,
    theme = _ref.theme,
    size = _ref.size,
    gutterWidth = _ref.gutterWidth,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/React.createElement(Div$1, _extends({
    p: {
      y: '0',
      x: "calc(".concat(gutterWidth || theme.grid.gutterWidth, "/2)")
    }
  }, rest));
};

/* eslint-enable react/prop-types */

var ColStyled = styled(BaseColumn)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), function (props) {
  return takeReqWidth(props.size, props.theme.grid.colCount);
}, function (props) {
  return props.offset && takeReqOffset(props.offset, props.theme.grid.colCount);
});
var Col = function Col(props) {
  return /*#__PURE__*/React.createElement(ColStyled, props);
};

/* eslint-disable react/require-default-props */

Col.propTypes = {
  size: PropTypesRepo.size,
  offset: PropTypesRepo.offset,
  gutterWidth: PropTypes.number
};
Col.defaultProps = {
  size: 'auto',
  offset: 0,
  gutterWidth: 0
};

/* eslint-enable react/require-default-props */

var Col$1 = withTheme(Col);

var _excluded$6 = ["p", "children", "isOpen"];
var Collapse = /*#__PURE__*/function (_Component) {
  _inherits(Collapse, _Component);
  var _super = _createSuper(Collapse);
  function Collapse() {
    var _this;
    _classCallCheck(this, Collapse);
    _this = _super.call(this);
    _this.state = {
      defaultHeight: 0
    };
    _this.innerDiv = /*#__PURE__*/React.createRef();
    _this.onEntering = _this.onEntering.bind(_assertThisInitialized(_this));
    _this.onExiting = _this.onExiting.bind(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * Set State for Height on Enter
   */
  _createClass(Collapse, [{
    key: "onEntering",
    value: function onEntering() {
      this.setState({
        defaultHeight: this.innerDiv.current.clientHeight
      });

      // Start Function if recieved a onEntering Props
      var onEntering = this.props.onEntering;
      if (onEntering) onEntering();
    }

    /**
     * Set State for Height on Exit
     */
  }, {
    key: "onExiting",
    value: function onExiting() {
      this.setState({
        defaultHeight: this.innerDiv.current.clientHeight
      });

      // Start Function if recieved a onExiting Props
      var onExiting = this.props.onExiting;
      if (onExiting) onExiting();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var defaultHeight = this.state.defaultHeight;
      var _this$props = this.props,
        p = _this$props.p,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        rest = _objectWithoutProperties(_this$props, _excluded$6);

      /**
       * Duration for the transition
       */
      var duration = 300;

      /**
       * Default Style for Backlayer
       */
      var defaultStyle = {
        transition: "all ".concat(duration, "ms ease-in-out"),
        height: 0,
        opacity: 0
      };

      /**
       * Trasition Styles for Backlayer
       */
      var transitionStyles = {
        entering: {
          opacity: 0,
          height: 0
        },
        entered: {
          opacity: 1,
          height: defaultHeight
        },
        exiting: {
          opacity: 1,
          height: defaultHeight
        },
        exited: {
          opacity: 0,
          height: 0
        }
      };
      return /*#__PURE__*/React.createElement(Transition, {
        "in": isOpen,
        timeout: duration,
        onEntering: this.onEntering,
        onExiting: this.onExiting
      }, function (state) {
        return /*#__PURE__*/React.createElement(Div$1, _extends({}, rest, {
          style: _objectSpread2(_objectSpread2({}, defaultStyle), transitionStyles[state]),
          transition: true
        }), /*#__PURE__*/React.createElement("div", {
          ref: _this2.innerDiv
        }, children));
      });
    }
  }]);
  return Collapse;
}(Component);
Collapse.propTypes = {
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  isOpen: PropTypes.bool,
  p: PropTypesRepo.p,
  m: PropTypesRepo.m,
  overflow: PropTypesRepo.overflow,
  children: PropTypes.node
};

/* eslint-enable react/require-default-props */

Collapse.defaultProps = {
  m: {
    y: 0
  },
  p: {
    y: 0
  },
  overflow: 'hidden',
  onEntering: null,
  onExiting: null,
  isOpen: false
};

var _excluded$7 = ["p", "m", "theme"];

/* eslint-disable react/prop-types */

var Container = function Container(_ref) {
  var p = _ref.p,
    m = _ref.m,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement(Div$1, _extends({
    w: "100%",
    m: {
      y: 0,
      x: 'auto'
    },
    p: {
      y: 0,
      x: '16px'
    },
    maxW: theme.grid.containerMaxWidth
  }, rest));
};

/* eslint-enable react/prop-types */

var Container$1 = withTheme(Container);

var _templateObject$9;
var _excluded$8 = ["d", "m", "w", "maxW", "minW", "flexGrow", "order", "p", "rounded", "pos", "border", "borderColor", "h", "maxH", "minH", "cursor", "bg", "textColor", "textWeight", "textAlign", "shadow", "transition", "textSize", "fontFamily", "hoverBg", "hoverBorder", "hoverBorderColor", "hoverShadow", "hoverTextColor", "focusBg", "focusBorder", "focusBorderColor", "focusShadow", "focusTextColor", "tag", "children"],
  _excluded2 = ["children", "prefix", "isLoading", "suffix", "order", "flexGrow", "loadingIcon", "d", "m", "w", "maxW", "minW", "h", "minH", "maxH"];

/* eslint-disable react/prop-types */

var CustomTag$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var d = props.d,
    m = props.m,
    w = props.w,
    maxW = props.maxW,
    minW = props.minW,
    flexGrow = props.flexGrow,
    order = props.order,
    p = props.p,
    rounded = props.rounded,
    pos = props.pos,
    border = props.border,
    borderColor = props.borderColor,
    h = props.h,
    maxH = props.maxH,
    minH = props.minH,
    cursor = props.cursor,
    bg = props.bg,
    textColor = props.textColor,
    textWeight = props.textWeight,
    textAlign = props.textAlign,
    shadow = props.shadow,
    transition = props.transition,
    textSize = props.textSize,
    fontFamily = props.fontFamily,
    hoverBg = props.hoverBg,
    hoverBorder = props.hoverBorder,
    hoverBorderColor = props.hoverBorderColor,
    hoverShadow = props.hoverShadow,
    hoverTextColor = props.hoverTextColor,
    focusBg = props.focusBg,
    focusBorder = props.focusBorder,
    focusBorderColor = props.focusBorderColor,
    focusShadow = props.focusShadow,
    focusTextColor = props.focusTextColor,
    tag = props.tag,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$8);
  return /*#__PURE__*/React.createElement("".concat(tag), _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref
  }), children);
});

/* eslint-enable react/prop-types */

var BaseInput = styled(CustomTag$1)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  :hover {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n\n  :focus {\n    outline: none;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n\n  ::placeholder {\n    ", ";\n  }\n\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n    background: ", ";\n  }\n"])), function (props) {
  return props.flexGrow && functions.makeResponsive('flex-grow', props.flexGrow);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return props.border && functions.findDirection('border', props.border);
}, function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.borderColor && functions.makeResponsive('border-color', props.theme.colors[props.borderColor]);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return props.cursor && functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return props.bg && functions.makeResponsive('background', props.theme.colors[props.bg]);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.textWeight && functions.makeResponsive('font-weight', props.textWeight);
}, function (props) {
  return props.textAlign && functions.makeResponsive('text-align', props.textAlign);
}, function (props) {
  return props.fontFamily && "font-family: ".concat(props.theme.fontFamily[props.fontFamily]);
}, function (props) {
  return props.shadow && "box-shadow: ".concat(props.theme.shadows[props.shadow]);
}, function (props) {
  return props.transition && "transition: ".concat(props.theme.transition);
}, function (props) {
  return "\n    font-size: ".concat(props.theme.textSize.size[props.textSize], ";\n    line-height: ").concat(props.theme.textSize.height[props.textSize], ";\n  ");
}, function (props) {
  return props.hoverBg && functions.makeResponsive('background', props.theme.colors[props.hoverBg]);
}, function (props) {
  return props.hoverTextColor && functions.makeResponsive('color', props.theme.colors[props.hoverTextColor]);
}, function (props) {
  return props.hoverBorder && functions.findDirection('border', props.hoverBorder);
}, function (props) {
  return props.hoverBorderColor && functions.makeResponsive('border-color', props.theme.colors[props.hoverBorderColor]);
}, function (props) {
  return props.hoverShadow && "box-shadow: ".concat(props.theme.shadows[props.hoverShadow]);
}, function (props) {
  return props.focusBg && functions.makeResponsive('background', props.theme.colors[props.focusBg]);
}, function (props) {
  return props.focusTextColor && functions.makeResponsive('color', props.theme.colors[props.focusTextColor]);
}, function (props) {
  return props.focusBorder && functions.findDirection('border', props.focusBorder);
}, function (props) {
  return props.focusBorderColor && functions.makeResponsive('border-color', props.theme.colors[props.focusBorderColor]);
}, function (props) {
  return props.focusShadow && "box-shadow: ".concat(props.theme.shadows[props.focusShadow]);
}, function (props) {
  return props.placeholderTextColor ? functions.makeResponsive('color', props.theme.colors[props.placeholderTextColor]) : "color: ".concat(props.theme.colors.light);
}, function (props) {
  return props.theme.colors.medium;
}, function (props) {
  return props.theme.colors.gray200;
});
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    prefix = _ref.prefix,
    isLoading = _ref.isLoading,
    suffix = _ref.suffix,
    order = _ref.order,
    flexGrow = _ref.flexGrow,
    loadingIcon = _ref.loadingIcon,
    d = _ref.d,
    m = _ref.m,
    w = _ref.w,
    maxW = _ref.maxW,
    minW = _ref.minW,
    h = _ref.h,
    minH = _ref.minH,
    maxH = _ref.maxH,
    rest = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/React.createElement(Div$1, {
    pos: "relative",
    d: d,
    m: m,
    w: w,
    maxW: maxW,
    minW: minW,
    h: h,
    minH: minH,
    maxH: maxH,
    order: order,
    flexGrow: flexGrow
  }, prefix, /*#__PURE__*/React.createElement(BaseInput, _extends({
    ref: ref,
    w: "100%",
    h: "100%"
  }, rest)), suffix, isLoading && loadingIcon);
});

/* eslint-disable react/require-default-props */

Input.propTypes = {
  children: PropTypes.node,
  // mostly Icon
  prefix: PropTypes.node,
  isLoading: PropTypes.bool,
  loadingIcon: PropTypes.node,
  // mostly Icon
  suffix: PropTypes.node,
  flexGrow: PropTypesRepo.flexGrow,
  order: PropTypesRepo.order,
  tag: PropTypes.string,
  pos: PropTypesRepo.pos,
  d: PropTypesRepo.d,
  p: PropTypesRepo.p,
  m: PropTypesRepo.m,
  rounded: PropTypesRepo.rounded,
  border: PropTypesRepo.border,
  borderColor: PropTypesRepo.borderColor,
  h: PropTypesRepo.h,
  w: PropTypesRepo.w,
  maxH: PropTypesRepo.maxH,
  minW: PropTypesRepo.minW,
  minH: PropTypesRepo.minH,
  maxW: PropTypesRepo.maxW,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  textColor: PropTypesRepo.textColor,
  textWeight: PropTypesRepo.textWeight,
  textAlign: PropTypesRepo.textAlign,
  textSize: PropTypesRepo.textSize,
  fontFamily: PropTypesRepo.fontFamily,
  shadow: PropTypesRepo.shadow,
  transition: PropTypesRepo.transition,
  hoverBg: PropTypesRepo.hoverBg,
  hoverTextColor: PropTypesRepo.hoverTextColor,
  hoverBorderColor: PropTypesRepo.hoverBorderColor,
  hoverShadow: PropTypesRepo.hoverShadow,
  focusBorderColor: PropTypesRepo.focusBorderColor
};

/* eslint-enable react/require-default-props */

Input.defaultProps = {
  tag: 'input',
  d: 'flex',
  p: {
    x: '12px'
  },
  m: {},
  textSize: 'body',
  rounded: 'md',
  border: '1px solid',
  borderColor: 'gray500',
  h: '35.2px',
  w: '100%',
  bg: 'white',
  textColor: 'dark',
  textWeight: '500',
  focusBorderColor: 'gray700',
  transition: true,
  loadingIcon: /*#__PURE__*/React.createElement(Icon$1, {
    name: "Loading",
    pos: "absolute",
    top: "12px",
    right: "12px",
    size: "16px"
  })
};
var Input$1 = withTheme(Input);

var _excluded$9 = ["children", "prefix", "suffix"];
var Tag = function Tag(_ref) {
  var children = _ref.children,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(Div$1, rest, prefix, children, suffix);
};
Tag.propTypes = {
  children: PropTypes.node,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  bg: PropTypesRepo.bg,
  textWeight: PropTypesRepo.textWeight,
  rounded: PropTypesRepo.rounded
};

/* eslint-disable react/default-props-match-prop-types */

Tag.defaultProps = {
  tag: 'span',
  d: 'inline-flex',
  align: 'center',
  textAlign: 'center',
  justify: 'center',
  bg: 'transparent',
  textWeight: '500',
  rounded: 'sm',
  p: {
    x: '1em',
    y: '.35em'
  },
  textColor: 'medium',
  textSize: 'caption',
  children: null,
  prefix: null,
  suffix: null
};

var _excluded$a = ["value", "menu", "menuOptions", "menuItemOptions", "menuItemPrefix", "menuItemSuffix", "inputStyle", "isOpen", "onClick", "targetHover", "prefix", "openSuffix", "closeSuffix", "defaultValue", "isLoading", "borderColor", "focusBorderColor", "bg", "focusBg", "hoverBg", "multiSelect", "cursor", "onSelection", "DropdownButtonOptions", "DivOptions"];
var _templateObject$a;
var findAutocompleteDir = function findAutocompleteDir(e) {
  switch (e) {
    case 'topright':
      return 'transform-origin: 100% 100%; bottom: calc(100% + 2px); right: 0;';
    case 'topleft':
      return 'transform-origin: 0 100%; bottom: calc(100% + 2px); left: 0;';
    case 'bottomright':
      return 'transform-origin: 50% 0; top: calc(100% + 2px); right: 0;';
    case 'righttop':
      return 'transform-origin: 0 0; top: 0; left: calc(100% + 2px);';
    case 'lefttop':
      return 'transform-origin: 0 0; top: 0; right: calc(100% + 2px);';
    default:
      return 'transform-origin: 50% 0; top: calc(100% + 2px); left: 0;';
  }
};
var BaseAutocomplete = styled(Div$1)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  > div:last-child {\n    position: absolute;\n    z-index: 10;\n    ", "\n    transition: all 0.2s ease-in-out;\n    opacity: ", ";\n    transform: scaleY(", ");\n  }\n\n  ", "\n  ", "\n"])), function (props) {
  return findAutocompleteDir(props.direction);
}, function (props) {
  return props.isOpen ? '1' : '0';
}, function (props) {
  return props.isOpen ? '1' : '0';
}, function (props) {
  return props.targetHover && ":hover { border-color: ".concat(props.theme.colors[props.focusBorderColor], "}");
}, function (props) {
  return props.targetHover && ':hover > div:last-child{ opacity: 1; transform: scaleY(1);}';
});
var Autocomplete = /*#__PURE__*/function (_Component) {
  _inherits(Autocomplete, _Component);
  var _super = _createSuper(Autocomplete);
  function Autocomplete(props) {
    var _this;
    _classCallCheck(this, Autocomplete);
    _this = _super.call(this, props);
    _this.state = {
      selectedValue: props.value || props.defaultValue,
      selectedIndex: props.menu.findIndex(function (item) {
        return (props.value || props.defaultValue) === item;
      }) > -1 ? props.menu.findIndex(function (item) {
        return (props.value || props.defaultValue) === item;
      }) : null,
      controlled: true,
      focussedMenuItemIndex: 0,
      selectedValues: props.valueIndices.map(function (index) {
        return props.menu[index];
      }),
      selectedIndices: _toConsumableArray(props.valueIndices)
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_assertThisInitialized(_this));
    _this.handleMenuClick = _this.handleMenuClick.bind(_assertThisInitialized(_this));
    _this.handleArrowNavigation = _this.handleArrowNavigation.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Autocomplete, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleOutsideClick, false);
      document.removeEventListener('keydown', this.handleArrowNavigation, false);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        onClick = _this$props.onClick;
      if (!isOpen) {
        // The dropdown is not open right now but it will be opened shortly
        // so we can think of this as the behavior when the dropdown is opened
        document.addEventListener('mousedown', this.handleOutsideClick, false);
        document.addEventListener('keydown', this.handleArrowNavigation, false);
      } else {
        // The dropdown is open at this point but we can think of this as the
        // behavior when the dropdown is closed shortly.
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
        document.removeEventListener('keydown', this.handleArrowNavigation, false);
        this.setState({
          controlled: true,
          focussedMenuItemIndex: 0
        });
      }
      onClick();
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(index) {
      var _this2 = this;
      var _this$props2 = this.props,
        menu = _this$props2.menu,
        onSelection = _this$props2.onSelection,
        multiSelect = _this$props2.multiSelect;
      if (multiSelect) {
        this.setState(function (prevState) {
          return {
            selectedValues: [].concat(_toConsumableArray(prevState.selectedValues), [menu[index]]),
            selectedIndices: [].concat(_toConsumableArray(prevState.selectedIndices), [index])
          };
        }, function () {
          var selectedIndices = _this2.state.selectedIndices;
          onSelection(selectedIndices);
        });
      } else {
        this.setState({
          selectedValue: menu[index],
          selectedIndex: index
        });
        onSelection(index);
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      // eslint-disable-next-line react/no-find-dom-node
      if (ReactDOM.findDOMNode(this).contains(e.target)) {
        return;
      }
      this.handleClick();
    }
  }, {
    key: "handleArrowNavigation",
    value: function handleArrowNavigation(e) {
      e.stopPropagation();
      var _this$state = this.state,
        selectedIndices = _this$state.selectedIndices,
        selectedValue = _this$state.selectedValue,
        controlled = _this$state.controlled,
        focussedMenuItemIndex = _this$state.focussedMenuItemIndex;
      var _this$props3 = this.props,
        menu = _this$props3.menu,
        isOpen = _this$props3.isOpen,
        multiSelect = _this$props3.multiSelect;
      var nextFocussedMenuItemIndex = focussedMenuItemIndex || 0;
      switch (e.code) {
        case 'ArrowDown':
          {
            for (var index = 0; index < menu.length; index += 1) {
              var item = menu[index];
              var isAlreadySelected = false;
              if (multiSelect) {
                isAlreadySelected = selectedIndices.includes(index);
              }
              var isCurrentlySelected = item.toLowerCase().includes(selectedValue.toLowerCase());
              if (!isAlreadySelected && (isCurrentlySelected || controlled)) {
                if (index > nextFocussedMenuItemIndex) {
                  nextFocussedMenuItemIndex = index;
                  break;
                }
              }
            }
            this.setState({
              focussedMenuItemIndex: nextFocussedMenuItemIndex
            });
            break;
          }
        case 'ArrowUp':
          {
            for (var _index2 = menu.length - 1; _index2 >= 0; _index2 -= 1) {
              var _item = menu[_index2];
              var _isAlreadySelected = false;
              if (multiSelect) {
                _isAlreadySelected = selectedIndices.includes(_index2);
              }
              var _isCurrentlySelected = _item.toLowerCase().includes(selectedValue.toLowerCase());
              if (!_isAlreadySelected && (_isCurrentlySelected || controlled)) {
                if (_index2 < nextFocussedMenuItemIndex) {
                  nextFocussedMenuItemIndex = _index2;
                  break;
                }
              }
            }
            this.setState({
              focussedMenuItemIndex: nextFocussedMenuItemIndex
            });
            break;
          }
        case 'ArrowRight':
          {
            for (var _index3 = menu.length - 1; _index3 >= 0; _index3 -= 1) {
              var _item2 = menu[_index3];
              var _isAlreadySelected2 = false;
              if (multiSelect) {
                _isAlreadySelected2 = selectedIndices.includes(_index3);
              }
              var _isCurrentlySelected2 = _item2.toLowerCase().includes(selectedValue.toLowerCase());
              if (!_isAlreadySelected2 && (_isCurrentlySelected2 || controlled)) {
                if (_index3 < nextFocussedMenuItemIndex) {
                  nextFocussedMenuItemIndex = _index3;
                  break;
                }
              }
            }
            this.setState({
              focussedMenuItemIndex: nextFocussedMenuItemIndex
            });
            break;
          }
        case 'Enter':
          {
            if (isOpen) {
              this.handleMenuClick(nextFocussedMenuItemIndex);
              this.handleClick();
            }
            break;
          }
        case 'Escape':
          {
            if (isOpen) this.handleClick();
            break;
          }
      }
    }

    /* eslint-disable no-nested-ternary */
    /* eslint-disable react/prop-types */
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        value = _this$props4.value,
        menu = _this$props4.menu,
        menuOptions = _this$props4.menuOptions,
        menuItemOptions = _this$props4.menuItemOptions,
        menuItemPrefix = _this$props4.menuItemPrefix,
        menuItemSuffix = _this$props4.menuItemSuffix,
        inputStyle = _this$props4.inputStyle,
        isOpen = _this$props4.isOpen,
        onClick = _this$props4.onClick,
        targetHover = _this$props4.targetHover,
        prefix = _this$props4.prefix,
        openSuffix = _this$props4.openSuffix,
        closeSuffix = _this$props4.closeSuffix,
        defaultValue = _this$props4.defaultValue,
        isLoading = _this$props4.isLoading,
        borderColor = _this$props4.borderColor,
        focusBorderColor = _this$props4.focusBorderColor,
        bg = _this$props4.bg,
        focusBg = _this$props4.focusBg,
        hoverBg = _this$props4.hoverBg,
        multiSelect = _this$props4.multiSelect,
        cursor = _this$props4.cursor,
        onSelection = _this$props4.onSelection,
        DropdownButtonOptions = _this$props4.DropdownButtonOptions,
        DivOptions = _this$props4.DivOptions,
        rest = _objectWithoutProperties(_this$props4, _excluded$a);
      var _this$state2 = this.state,
        selectedValues = _this$state2.selectedValues,
        focussedMenuItemIndex = _this$state2.focussedMenuItemIndex,
        selectedValue = _this$state2.selectedValue,
        selectedIndex = _this$state2.selectedIndex,
        controlled = _this$state2.controlled;
      return /*#__PURE__*/React.createElement(BaseAutocomplete, _extends({
        d: "flex",
        ref: function ref(node) {
          _this3.node = node;
        },
        onClick: !isLoading ? targetHover ? null : this.handleClick : function () {},
        targetHover: targetHover,
        pos: "relative",
        isOpen: isOpen,
        flexWrap: "wrap",
        cursor: cursor
      }, rest), prefix, /*#__PURE__*/React.createElement(Div$1, _extends({
        d: "flex",
        border: "1px solid",
        borderColor: "gray500",
        rounded: "md",
        flexGrow: "1",
        flexWrap: "wrap",
        align: "center",
        cursor: cursor,
        onClick: !isLoading ? targetHover ? null : this.handleClick : function () {},
        h: "1.875rem"
      }, DivOptions), multiSelect ? selectedValues.map(function (currentValue, index) {
        return /*#__PURE__*/React.createElement(Tag, {
          m: {
            x: '3.2px',
            y: '3.2px'
          },
          h: "24px",
          whiteSpace: "nowrap",
          onClick: function onClick(e) {
            e.stopPropagation();
          },
          suffix: /*#__PURE__*/React.createElement(Button$1, {
            bg: "transparent",
            border: "none",
            p: "1.6px",
            type: "button",
            onClick: function onClick(e) {
              _this3.setState(function (prevState) {
                return {
                  selectedValues: prevState.selectedValues.filter(function (_, _index) {
                    return _index !== index;
                  }),
                  selectedIndices: prevState.selectedIndices.filter(function (_, _index) {
                    return _index !== index;
                  })
                };
              }, function () {
                var selectedIndices = _this3.state.selectedIndices;
                onSelection(selectedIndices);
              });
              e.stopPropagation();
            }
          }, /*#__PURE__*/React.createElement(Icon$1, {
            size: "12px",
            name: "Cross"
          }))
        }, currentValue);
      }) : null, selectedValue && selectedValue === value && menuItemPrefix && menuItemPrefix(selectedIndex), /*#__PURE__*/React.createElement(Input$1, _extends({
        border: "0",
        value: selectedValue,
        onFocus: function onFocus() {
          _this3.setState({
            selectedValue: '',
            controlled: false
          });
        },
        onChange: function onChange(e) {
          _this3.setState({
            selectedValue: e.target.value,
            controlled: false
          });
          if (!isOpen) {
            _this3.handleClick();
          }
        }
      }, inputStyle)), selectedValue && selectedValue === value && menuItemSuffix && menuItemSuffix(selectedIndex)), isLoading ? /*#__PURE__*/React.createElement(Div$1, _extends({
        hoverBg: hoverBg,
        bg: isOpen ? focusBg : bg,
        borderColor: isOpen ? focusBorderColor : borderColor,
        alignSelf: "flex-start",
        type: "button"
      }, DropdownButtonOptions), /*#__PURE__*/React.createElement(Icon$1, {
        name: "Loading",
        color: "gray600",
        size: "1rem"
      })) : /*#__PURE__*/React.createElement(Button$1, _extends({
        hoverBg: hoverBg,
        bg: isOpen ? focusBg : bg,
        borderColor: isOpen ? focusBorderColor : borderColor,
        alignSelf: "flex-start",
        type: "button"
      }, DropdownButtonOptions), isOpen ? openSuffix : closeSuffix), /*#__PURE__*/React.createElement(Div$1, menuOptions, menu.map(function (item, index) {
        var text = item;
        return (text.toLowerCase().includes(selectedValue.toLowerCase()) || controlled) && !selectedValues.find(function (v) {
          return v === text;
        }) ? /*#__PURE__*/React.createElement(Div$1
        // eslint-disable-next-line react/no-array-index-key
        , _extends({
          key: "menu-".concat(text, "-").concat(index)
        }, menuItemOptions, {
          bg: focussedMenuItemIndex === index ? menuItemOptions.hoverBg : menuItemOptions.bg,
          onClick: function onClick() {
            return _this3.handleMenuClick(index);
          },
          onMouseEnter: function onMouseEnter() {
            return _this3.setState({
              focussedMenuItemIndex: index
            });
          },
          onMouseLeave: function onMouseLeave() {
            return _this3.setState({
              focussedMenuItemIndex: undefined
            });
          }
        }), menuItemPrefix && menuItemPrefix(index), text, menuItemSuffix && menuItemSuffix(index)) : null;
      }).filter(function (item) {
        return item;
      })));
    }

    /* eslint-enable react/prop-types */
    /* eslint-enable no-nested-ternary */
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      /**
       * If the component is controlled, it takes the value passed to the props
       * but once it regains the controll, it controls the state completely
       */
      if (props.value !== state.selectedValue && state.controlled) {
        return {
          selectedValue: props.value
        };
      }
      return null;
    }
  }]);
  return Autocomplete;
}(Component);
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
Autocomplete.propTypes = {
  value: PropTypes.string,
  valueIndices: PropTypes.array,
  defaultValue: PropTypes.string,
  // Must be wrapped around <AutocompleteMenu>
  menu: PropTypes.node,
  // Supports menu options of Div
  menuOptions: PropTypes.object,
  menuItemOptions: PropTypes.object,
  menuItemPrefix: PropTypes.func,
  menuItemSuffix: PropTypes.func,
  isOpen: PropTypes.bool,
  // change the target from click to hover
  targetHover: PropTypes.bool,
  direction: PropTypes.oneOf(['bottomleft', 'bottomright', 'topright', 'topleft', 'righttop', 'lefttop']),
  isLoading: PropTypes.bool,
  // Component typically icon placed before the component
  prefix: PropTypes.node,
  // Component (icon) placed at the end of the component when is open
  openSuffix: PropTypes.node,
  // Component (icon) placed at the end of the component when is closed
  closeSuffix: PropTypes.node,
  onClick: PropTypes.func,
  onSelection: PropTypes.func,
  multiSelect: PropTypes.bool,
  DropdownButtonOptions: PropTypes.shape({}),
  inputStyle: PropTypes.shape({})
};

/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Autocomplete.defaultProps = {
  tag: 'div',
  d: 'flex',
  align: 'center',
  textColor: 'medium',
  textWeight: '500',
  justify: 'space-between',
  p: '0',
  maxH: '100%',
  textSize: 'body',
  rounded: 'md',
  border: 'none',
  borderColor: 'gray500',
  w: '100%',
  bg: 'gray100',
  focusBg: 'gray200',
  focusBorderColor: 'gray800',
  hoverBg: 'gray100',
  cursor: 'pointer',
  onClick: function onClick() {},
  onSelection: function onSelection() {
    return null;
  },
  defaultValue: 'Please select a value',
  value: null,
  openSuffix: /*#__PURE__*/React.createElement(Icon$1, {
    name: "UpArrow",
    size: "18px"
  }),
  closeSuffix: /*#__PURE__*/React.createElement(Icon$1, {
    name: "DownArrow",
    size: "18px"
  }),
  menuOptions: {
    pos: 'absolute',
    shadow: '4',
    minW: '100%',
    rounded: 'md',
    bg: 'white'
  },
  DropdownButtonOptions: {
    p: '7px'
  },
  DivOptions: {},
  menuItemOptions: {
    p: {
      x: '16px',
      y: '8px'
    },
    hoverBg: 'gray100',
    bg: 'white'
  },
  menuItemPrefix: function menuItemPrefix() {
    return null;
  },
  menuItemSuffix: function menuItemSuffix() {
    return null;
  },
  multiSelect: false,
  valueIndices: [],
  inputStyle: {}
};

/* eslint-enable react/default-props-match-prop-types */

var Autocomplete$1 = withTheme(Autocomplete);

var adler32 = createCommonjsModule(function (module, exports) {
/* adler32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported ADLER32 */
var ADLER32;
(function (factory) {
	/*jshint ignore:start */
	/*eslint-disable */
	if(typeof DO_NOT_EXPORT_ADLER === 'undefined') {
		{
			factory(exports);
		}
	} else {
		factory(ADLER32 = {});
	}
	/*eslint-enable */
	/*jshint ignore:end */
}(function(ADLER32) {
ADLER32.version = '1.3.1';
function adler32_bstr(bstr, seed) {
	var a = 1, b = 0, L = bstr.length, M = 0;
	if(typeof seed === 'number') { a = seed & 0xFFFF; b = seed >>> 16; }
	for(var i = 0; i < L;) {
		M = Math.min(L-i, 2654)+i;
		for(;i<M;i++) {
			a += bstr.charCodeAt(i)&0xFF;
			b += a;
		}
		a = (15*(a>>>16)+(a&65535));
		b = (15*(b>>>16)+(b&65535));
	}
	return ((b%65521) << 16) | (a%65521);
}

function adler32_buf(buf, seed) {
	var a = 1, b = 0, L = buf.length, M = 0;
	if(typeof seed === 'number') { a = seed & 0xFFFF; b = (seed >>> 16) & 0xFFFF; }
	for(var i = 0; i < L;) {
		M = Math.min(L-i, 2654)+i;
		for(;i<M;i++) {
			a += buf[i]&0xFF;
			b += a;
		}
		a = (15*(a>>>16)+(a&65535));
		b = (15*(b>>>16)+(b&65535));
	}
	return ((b%65521) << 16) | (a%65521);
}

function adler32_str(str, seed) {
	var a = 1, b = 0, L = str.length, M = 0, c = 0, d = 0;
	if(typeof seed === 'number') { a = seed & 0xFFFF; b = seed >>> 16; }
	for(var i = 0; i < L;) {
		M = Math.min(L-i, 2918);
		while(M>0) {
			c = str.charCodeAt(i++);
			if(c < 0x80) { a += c; }
			else if(c < 0x800) {
				a += 192|((c>>6)&31);             b += a; --M;
				a += 128|(c&63);
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++) & 1023;
				a += 240|((c>>8)&7);              b += a; --M;
				a += 128|((c>>2)&63);             b += a; --M;
				a += 128|((d>>6)&15)|((c&3)<<4);  b += a; --M;
				a += 128|(d&63);
			} else {
				a += 224|((c>>12)&15);            b += a; --M;
				a += 128|((c>>6)&63);             b += a; --M;
				a += 128|(c&63);
			}
			b += a; --M;
		}
		a = (15*(a>>>16)+(a&65535));
		b = (15*(b>>>16)+(b&65535));
	}
	return ((b%65521) << 16) | (a%65521);
}
// $FlowIgnore
ADLER32.bstr = adler32_bstr;
// $FlowIgnore
ADLER32.buf = adler32_buf;
// $FlowIgnore
ADLER32.str = adler32_str;
}));
});

var _templateObject$b;
var _excluded$b = ["d", "pos", "top", "bottom", "left", "right", "h", "maxH", "minH", "justify", "align", "flexDir", "flexGrow", "flexWrap", "order", "rounded", "m", "p", "bg", "hoverBg", "textColor", "textWeight", "textAlign", "textTransform", "textDecor", "textSize", "transition", "w", "maxW", "minW", "fontFamily", "opacity", "hoverTextColor", "tag", "children", "theme"];

/* eslint-disable react/prop-types */

var CustomTag$2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var d = props.d,
    pos = props.pos,
    top = props.top,
    bottom = props.bottom,
    left = props.left,
    right = props.right,
    h = props.h,
    maxH = props.maxH,
    minH = props.minH,
    justify = props.justify,
    align = props.align,
    flexDir = props.flexDir,
    flexGrow = props.flexGrow,
    flexWrap = props.flexWrap,
    order = props.order,
    rounded = props.rounded,
    m = props.m,
    p = props.p,
    bg = props.bg,
    hoverBg = props.hoverBg,
    textColor = props.textColor,
    textWeight = props.textWeight,
    textAlign = props.textAlign,
    textTransform = props.textTransform,
    textDecor = props.textDecor,
    textSize = props.textSize,
    transition = props.transition,
    w = props.w,
    maxW = props.maxW,
    minW = props.minW,
    fontFamily = props.fontFamily,
    opacity = props.opacity,
    hoverTextColor = props.hoverTextColor,
    tag = props.tag,
    children = props.children,
    theme = props.theme,
    rest = _objectWithoutProperties(props, _excluded$b);
  return /*#__PURE__*/React.createElement("".concat(tag), _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref
  }), children);
});

/* eslint-enable react/prop-types */

/**
 * Style the Text
 */
var TextStyled = styled(CustomTag$2)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  :visited {\n    ", ";\n  }\n\n  :hover {\n    ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.d && functions.makeResponsive('display', props.d);
}, function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.top && functions.makeResponsive('top', props.top);
}, function (props) {
  return props.bottom && functions.makeResponsive('bottom', props.bottom);
}, function (props) {
  return props.left && functions.makeResponsive('left', props.left);
}, function (props) {
  return props.right && functions.makeResponsive('right', props.right);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return props.justify && functions.makeResponsive('justify-content', props.justify);
}, function (props) {
  return props.align && functions.makeResponsive('align-items', props.align);
}, function (props) {
  return props.flexDir && functions.makeResponsive('flex-direction', props.flexDir);
}, function (props) {
  return props.flexGrow && functions.makeResponsive('flex', props.flexGrow);
}, function (props) {
  return props.flexWrap && functions.makeResponsive('flex-wrap', props.flexWrap);
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.cursor && "cursor: ".concat(props.cursor, ";");
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.textSize && functions.makeResponsiveFontSize(props.textSize, props.theme.textSize);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.textWeight && functions.makeResponsive('font-weight', props.textWeight);
}, function (props) {
  return props.textAlign && functions.makeResponsive('text-align', props.textAlign);
}, function (props) {
  return props.verticalAlign && functions.makeResponsive('vertical-align', props.verticalAlign);
}, function (props) {
  return props.textTransform && functions.makeResponsive('text-transform', props.textTransform);
}, function (props) {
  return props.textDecor && functions.makeResponsive('text-decoration', props.textDecor);
}, function (props) {
  return props.transition && "transition: ".concat(props.theme.transition);
}, function (props) {
  return props.order && functions.makeResponsive('order', props.order);
}, function (props) {
  return props.fontFamily && "font-family: ".concat(props.theme.fontFamily[props.fontFamily]);
}, function (props) {
  return props.opacity && functions.makeResponsive('opacity', props.opacity);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.hoverBg && functions.makeResponsiveProperty(props.hoverBg, 'background', props.theme.colors);
}, function (props) {
  return props.hoverTextColor && functions.makeResponsive('color', props.theme.colors[props.hoverTextColor]);
});
var Text = function Text(props) {
  return /*#__PURE__*/React.createElement(TextStyled, props);
};

/* eslint-disable react/require-default-props */

Text.propTypes = {
  tag: PropTypes.string,
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  h: PropTypesRepo.h,
  maxH: PropTypesRepo.maxH,
  minH: PropTypesRepo.minH,
  w: PropTypesRepo.w,
  maxW: PropTypesRepo.maxW,
  minW: PropTypesRepo.minW,
  justify: PropTypesRepo.justify,
  align: PropTypesRepo.align,
  order: PropTypesRepo.order,
  flexDir: PropTypesRepo.flexDir,
  flexGrow: PropTypesRepo.flexGrow,
  flexWrap: PropTypesRepo.flexWrap,
  rounded: PropTypesRepo.rounded,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  textSize: PropTypesRepo.textSize,
  textColor: PropTypesRepo.textColor,
  textWeight: PropTypesRepo.textWeight,
  textAlign: PropTypesRepo.textAlign,
  textTransform: PropTypesRepo.textTransform,
  textDecor: PropTypesRepo.textDecor,
  verticalAlign: PropTypesRepo.verticalAlign,
  fontFamily: PropTypesRepo.fontFamily,
  transition: PropTypesRepo.transition,
  opacity: PropTypesRepo.opacity,
  hoverBg: PropTypesRepo.hoverBg,
  hoverTextColor: PropTypesRepo.hoverTextColor
};

/* eslint-enable react/require-default-props */

Text.defaultProps = {
  tag: 'p',
  fontFamily: 'primary'
};
var Text$1 = withTheme(Text);

var _excluded$c = ["menu", "menuOptions", "menuItemOptions", "isOpen", "onClick", "targetHover", "prefix", "openSuffix", "closeSuffix", "defaultValue", "isLoading", "borderColor", "focusBorderColor", "bg", "focusBg"];
var _templateObject$c;
var findDropdownDir = function findDropdownDir(e) {
  switch (e) {
    case 'topright':
      return 'transform-origin: 100% 100%; bottom: calc(100% + 2px); right: 0;';
    case 'topleft':
      return 'transform-origin: 0 100%; bottom: calc(100% + 2px); left: 0;';
    case 'bottomright':
      return 'transform-origin: 50% 0; top: calc(100% + 2px); right: 0;';
    case 'righttop':
      return 'transform-origin: 0 0; top: 0; left: calc(100% + 2px);';
    case 'lefttop':
      return 'transform-origin: 0 0; top: 0; right: calc(100% + 2px);';
    default:
      return 'transform-origin: 50% 0; top: calc(100% + 2px); left: 0;';
  }
};
var BaseDropdown = styled(Div$1)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  > div:last-child {\n    position: absolute;\n    z-index: 10;\n    ", "\n    transition: all 0.2s ease-in-out;\n    opacity: ", ";\n    transform: scaleY(", ");\n  }\n\n  ", "\n  ", "\n"])), function (props) {
  return findDropdownDir(props.direction);
}, function (props) {
  return props.isOpen ? '1' : '0';
}, function (props) {
  return props.isOpen ? '1' : '0';
}, function (props) {
  return props.targetHover && ":hover { border-color: ".concat(props.theme.colors[props.focusBorderColor], "}");
}, function (props) {
  return props.targetHover && ':hover > div:last-child{ opacity: 1; transform: scaleY(1);}';
});
var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);
  var _super = _createSuper(Dropdown);
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _super.call(this, props);
    _this.state = {
      selectedValue: null
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_assertThisInitialized(_this));
    _this.handleMenuClick = _this.handleMenuClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Dropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$resetValu = this.props.resetValue,
        resetValue = _this$props$resetValu === void 0 ? null : _this$props$resetValu;
      if (resetValue && prevProps.resetValue !== resetValue) {
        this.setState({
          selectedValue: null
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        onClick = _this$props.onClick;
      if (!isOpen) {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
      }
      onClick();
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(index) {
      var _this$props2 = this.props,
        menu = _this$props2.menu,
        onSelect = _this$props2.onSelect;
      this.setState({
        selectedValue: menu[index]
      });
      onSelect(index);
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      // eslint-disable-next-line react/no-find-dom-node
      if (ReactDOM.findDOMNode(this).contains(e.target)) {
        return;
      }
      this.handleClick();
    }

    /* eslint-disable no-nested-ternary */
    /* eslint-disable react/prop-types */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        menu = _this$props3.menu,
        menuOptions = _this$props3.menuOptions,
        menuItemOptions = _this$props3.menuItemOptions,
        isOpen = _this$props3.isOpen,
        onClick = _this$props3.onClick,
        targetHover = _this$props3.targetHover,
        prefix = _this$props3.prefix,
        openSuffix = _this$props3.openSuffix,
        closeSuffix = _this$props3.closeSuffix,
        defaultValue = _this$props3.defaultValue,
        isLoading = _this$props3.isLoading,
        borderColor = _this$props3.borderColor,
        focusBorderColor = _this$props3.focusBorderColor,
        bg = _this$props3.bg,
        focusBg = _this$props3.focusBg,
        rest = _objectWithoutProperties(_this$props3, _excluded$c);
      var selectedValue = this.state.selectedValue;
      return /*#__PURE__*/React.createElement(BaseDropdown, _extends({
        ref: function ref(node) {
          _this2.node = node;
        },
        onClick: !isLoading ? targetHover ? null : this.handleClick : function () {},
        targetHover: targetHover,
        pos: "relative",
        isOpen: isOpen,
        borderColor: isOpen ? focusBorderColor : borderColor,
        bg: isOpen ? focusBg : bg
      }, rest), prefix, selectedValue || defaultValue, isLoading ? /*#__PURE__*/React.createElement(Icon$1, {
        name: "Loading",
        color: "gray600",
        size: "18px"
      }) : isOpen ? openSuffix : closeSuffix, /*#__PURE__*/React.createElement(Div$1, menuOptions, menu.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Div$1, _extends({
          key: adler32.str("".concat(item))
        }, menuItemOptions, {
          onClick: function onClick() {
            return _this2.handleMenuClick(index);
          }
        }), item);
      })));
    }

    /* eslint-enable react/prop-types */
    /* eslint-enable no-nested-ternary */
  }]);
  return Dropdown;
}(Component);
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
Dropdown.propTypes = {
  resetValue: PropTypes.bool,
  defaultValue: PropTypes.node,
  // Must be wrapped around <DropdownMenu>
  menu: PropTypes.node,
  // Supports menu options of Div
  menuOptions: PropTypes.object,
  menuItemOptions: PropTypes.object,
  isOpen: PropTypes.bool,
  // change the target from click to hover
  targetHover: PropTypes.bool,
  direction: PropTypes.oneOf(['bottomleft', 'bottomright', 'topright', 'topleft', 'righttop', 'lefttop']),
  isLoading: PropTypes.bool,
  // Component typically icon placed before the component
  prefix: PropTypes.node,
  // Component (icon) placed at the end of the component when is open
  openSuffix: PropTypes.node,
  // Component (icon) placed at the end of the component when is closed
  closeSuffix: PropTypes.node,
  onClick: PropTypes.func,
  onSelect: PropTypes.func
};

/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Dropdown.defaultProps = {
  tag: 'div',
  d: 'flex',
  align: 'center',
  textColor: 'medium',
  textWeight: '500',
  justify: 'space-between',
  p: {
    x: '12px'
  },
  h: '38.4px',
  textSize: 'body',
  rounded: 'md',
  border: '1px solid',
  borderColor: 'tabDisabled',
  w: '100%',
  bg: 'white',
  focusBg: 'tabRest',
  focusBorderColor: 'tabSelected',
  cursor: 'pointer',
  onClick: function onClick() {},
  onSelect: function onSelect() {
    return null;
  },
  resetValue: false,
  defaultValue: /*#__PURE__*/React.createElement(Text$1, null, "Please select a value"),
  openSuffix: /*#__PURE__*/React.createElement(Icon$1, {
    name: "UpArrow",
    size: "12px",
    m: {
      l: '8px'
    },
    color: "medium",
    p: "2.08px"
  }),
  closeSuffix: /*#__PURE__*/React.createElement(Icon$1, {
    name: "DownArrow",
    size: "12px",
    m: {
      l: '8px'
    },
    color: "medium",
    p: "2.08px"
  }),
  menuOptions: {
    pos: 'absolute',
    shadow: '4',
    minW: '100%',
    rounded: 'md',
    bg: 'white'
  },
  menuItemOptions: {
    p: {
      x: '16px',
      y: '8px'
    },
    hoverBg: 'tabRest'
  }
};

/* eslint-enable react/default-props-match-prop-types */

var Dropdown$1 = withTheme(Dropdown);

var DropdownMenu = function DropdownMenu(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(Div$1, _extends({}, rest, {
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }));
};
DropdownMenu.defaultProps = {
  pos: 'absolute',
  shadow: '4',
  minW: '100%',
  p: {
    x: '16px',
    y: '8px'
  },
  rounded: 'md',
  bg: 'white'
};

var _templateObject$d;
var _excluded$d = ["d", "pos", "top", "bottom", "left", "right", "flexGrow", "order", "m", "p", "rounded", "border", "borderColor", "h", "maxH", "minH", "w", "minW", "maxW", "cursor", "shadow", "transition", "transform", "transformOrigin", "zIndex", "opacity", "hoverBorderColor", "hoverShadow", "theme"];

/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/alt-text */

var ImageTag = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var d = props.d,
    pos = props.pos,
    top = props.top,
    bottom = props.bottom,
    left = props.left,
    right = props.right,
    flexGrow = props.flexGrow,
    order = props.order,
    m = props.m,
    p = props.p,
    rounded = props.rounded,
    border = props.border,
    borderColor = props.borderColor,
    h = props.h,
    maxH = props.maxH,
    minH = props.minH,
    w = props.w,
    minW = props.minW,
    maxW = props.maxW,
    cursor = props.cursor,
    shadow = props.shadow,
    transition = props.transition,
    transform = props.transform,
    transformOrigin = props.transformOrigin,
    zIndex = props.zIndex,
    opacity = props.opacity,
    hoverBorderColor = props.hoverBorderColor,
    hoverShadow = props.hoverShadow,
    theme = props.theme,
    rest = _objectWithoutProperties(props, _excluded$d);
  return /*#__PURE__*/React.createElement("img", _extends({
    ref: ref
  }, rest));
});

/* eslint-enable jsx-a11y/alt-text */
/* eslint-enable react/prop-types */

var BaseImg = styled(ImageTag)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  :hover {\n    ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.d && functions.makeResponsive('display', props.d);
}, function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.top && functions.makeResponsive('top', props.top);
}, function (props) {
  return props.bottom && functions.makeResponsive('bottom', props.bottom);
}, function (props) {
  return props.left && functions.makeResponsive('left', props.left);
}, function (props) {
  return props.right && functions.makeResponsive('right', props.right);
}, function (props) {
  return props.flexGrow && functions.makeResponsive('flex-grow', props.flexGrow);
}, function (props) {
  return props.order && functions.makeResponsive('order', props.order);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return props.border && functions.findDirection('border', props.border);
}, function (props) {
  return props.borderColor && functions.makeResponsive('border-color', props.theme.colors[props.borderColor]);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return props.cursor && functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return props.shadow && functions.makeResponsive('box-shadow', props.theme.shadows[props.shadow]);
}, function (props) {
  return props.transform && functions.makeResponsive('transform', props.transform);
}, function (props) {
  return props.transformOrigin && functions.makeResponsive('transform-origin', props.transformOrigin);
}, function (props) {
  return props.zIndex && functions.makeResponsive('z-index', props.zIndex);
}, function (props) {
  return props.opacity && "opacity: ".concat(props.opacity);
}, function (props) {
  return props.transition && "transition: ".concat(props.theme.transition);
}, function (props) {
  return props.hoverBorderColor && functions.makeResponsive('border-color', props.theme.colors[props.hoverBorderColor]);
}, function (props) {
  return props.hoverShadow && "box-shadow: ".concat(props.theme.shadows[props.hoverShadow]);
});
var Image = function Image(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(BaseImg, rest, rest.children);
};

/* eslint-disable react/require-default-props */

Image.propTypes = {
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  flexGrow: PropTypesRepo.flexGrow,
  order: PropTypesRepo.order,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  rounded: PropTypesRepo.rounder,
  border: PropTypesRepo.border,
  borderColor: PropTypesRepo.borderColor,
  h: PropTypesRepo.h,
  maxH: PropTypesRepo.maxH,
  minH: PropTypesRepo.minH,
  w: PropTypesRepo.w,
  maxW: PropTypesRepo.maxW,
  minW: PropTypesRepo.minW,
  cursor: PropTypesRepo.cursor,
  shadow: PropTypesRepo.shadow,
  transform: PropTypesRepo.transform,
  transformOrigin: PropTypesRepo.transformOrigin,
  zIndex: PropTypesRepo.zIndex,
  opacity: PropTypesRepo.opacity,
  transition: PropTypesRepo.transition,
  hoverBorderColor: PropTypesRepo.hoverBorderColor,
  hoverShadow: PropTypesRepo.hoverShadow
};

/* eslint-enable react/require-default-props */

Image.defaultProps = {
  w: '100%'
};
var Image$1 = withTheme(Image);

var _templateObject$e;
var BaseInputGroup = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  div {\n    margin-left: -1px;\n    touch-action: manipulation;\n    border-radius: 0;\n\n    input {\n      border-radius: 0;\n    }\n    :nth-child(1) input {\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    }\n    :last-child input {\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    }\n  }\n\n  button {\n    margin-left: -1px;\n    touch-action: manipulation;\n    border-radius: 0;\n\n    :hover {\n      z-index: 2;\n    }\n    :nth-child(1) {\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    }\n    :last-child {\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    }\n  }\n\n  :hover {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.d && functions.makeResponsive('display', props.d);
}, function (props) {
  return props.justify && functions.makeResponsive('justify-content', props.justify);
}, function (props) {
  return props.align && functions.makeResponsive('align-items', props.align);
}, function (props) {
  return props.flexDir && functions.makeResponsive('flex-direction', props.flexDir);
}, function (props) {
  return props.flexGrow && functions.makeResponsive('flex-grow', props.flexGrow);
}, function (props) {
  return props.flexWrap && functions.makeResponsive('flex-wrap', props.flexWrap);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded);
}, function (props) {
  return props.border && functions.findDirection('border', props.border);
}, function (props) {
  return props.borderColor && functions.makeResponsive('border-color', colorVar[props.borderColor]);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.maxH && functions.makeResponsive('max-height', props.maxH);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.maxW && functions.makeResponsive('max-width', props.maxW);
}, function (props) {
  return props.minW && functions.makeResponsive('min-width', props.minW);
}, function (props) {
  return props.cursor && functions.makeResponsive('cursor', props.cursor);
}, function (props) {
  return props.bg && functions.makeResponsive('background', colorVar[props.bg]);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', colorVar[props.textColor]);
}, function (props) {
  return props.textWeight && functions.makeResponsive('weight', props.textWeight);
}, function (props) {
  return props.textAlign && functions.makeResponsive('align', props.textAlign);
}, function (props) {
  return props.shadow && "box-shadow: ".concat(themeVars.shadows[props.shadow]);
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return themeVars.rounded[props.rounded];
}, function (props) {
  return props.hoverBg && functions.makeResponsive('background', colorVar[props.hoverBg]);
}, function (props) {
  return props.hoverTextColor && functions.makeResponsive('color', colorVar[props.hoverTextColor]);
}, function (props) {
  return props.hoverBorderColor && functions.makeResponsive('border-color', colorVar[props.hoverBorderColor]);
}, function (props) {
  return props.hoverShadow && "box-shadow: ".concat(themeVars.shadows[props.hoverShadow]);
});
var InputGroup = function InputGroup(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(BaseInputGroup, rest, rest.children);
};
InputGroup.defaultProps = {
  flexWrap: 'wrap',
  rounded: 'default'
};

var Label = function Label(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(Div$1, rest, rest.children);
};

/* eslint-disable react/require-default-props */

Label.propTypes = {
  tag: PropTypes.string,
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  justify: PropTypesRepo.justify,
  align: PropTypesRepo.align,
  flexDir: PropTypesRepo.flexDir,
  flexGrow: PropTypesRepo.flexGrow,
  flexWrap: PropTypesRepo.flexWrap,
  order: PropTypesRepo.order,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  rounded: PropTypesRepo.rounder,
  border: PropTypesRepo.border,
  borderColor: PropTypesRepo.borderColor,
  h: PropTypesRepo.h,
  maxH: PropTypesRepo.maxH,
  minH: PropTypesRepo.minH,
  w: PropTypesRepo.w,
  maxW: PropTypesRepo.maxW,
  minW: PropTypesRepo.minW,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  bgImg: PropTypesRepo.bgImg,
  bgSize: PropTypesRepo.bgSize,
  bgRepeat: PropTypesRepo.bgRepeat,
  bgPos: PropTypesRepo.bgPos,
  textSize: PropTypesRepo.textSize,
  textColor: PropTypesRepo.textColor,
  textWeight: PropTypesRepo.textWeight,
  textAlign: PropTypesRepo.textAlign,
  textTransform: PropTypesRepo.textTransform,
  fontFamily: PropTypesRepo.fontFamily,
  transition: PropTypesRepo.transition,
  shadow: PropTypesRepo.shadow,
  transformOrigin: PropTypesRepo.transformOrigin,
  zIndex: PropTypesRepo.zIndex,
  overflow: PropTypesRepo.overflow,
  opacity: PropTypesRepo.opacity,
  hoverBg: PropTypesRepo.hoverBg,
  hoverTextColor: PropTypesRepo.hoverTextColor,
  hoverBorderColor: PropTypesRepo.hoverBorderColor,
  hoverShadow: PropTypesRepo.hoverShadow
};

/* eslint-enable react/require-default-props */

Label.defaultProps = {
  tag: 'label',
  flexWrap: 'wrap',
  textSize: 'body',
  d: 'flex',
  align: 'flex-start',
  cursor: 'pointer'
};

var Anchor = function Anchor(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    tag: "a"
  }, rest));
};
Anchor.defaultProps = {
  hoverTextColor: 'info800',
  textWeight: '500',
  textDecor: 'none',
  textColor: 'info700',
  cursor: 'pointer'
};

var _excluded$e = ["m", "size", "activeColor", "inactiveColor", "isLoading", "value", "selectedValue", "checked"];
var _templateObject$f;
var RadioboxInput = styled.input(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  display: none;\n\n  ~ div {\n    svg:nth-child(1) {\n      display: none;\n    }\n    svg:nth-child(2) {\n      display: block;\n    }\n  }\n\n  &:checked ~ div {\n    svg:nth-child(1) {\n      display: block;\n    }\n    svg:nth-child(2) {\n      display: none;\n    }\n  }\n"])));
var Radiobox = function Radiobox(_ref) {
  var m = _ref.m,
    size = _ref.size,
    activeColor = _ref.activeColor,
    inactiveColor = _ref.inactiveColor,
    isLoading = _ref.isLoading,
    value = _ref.value,
    selectedValue = _ref.selectedValue,
    checked = _ref.checked,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioboxInput, _extends({
    type: "radio"
  }, rest, {
    checked: value ? value === selectedValue : checked
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon$1, {
    m: m,
    name: isLoading ? 'Loading' : 'RBChecked',
    color: activeColor,
    size: size
  }), /*#__PURE__*/React.createElement(Icon$1, {
    m: m,
    name: isLoading ? 'Loading' : 'RBUnchecked',
    color: inactiveColor,
    size: size
  })));
};

/* eslint-disable react/forbid-prop-types */

Radiobox.propTypes = {
  m: PropTypesRepo.m,
  size: PropTypesRepo.d,
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  isLoading: PropTypes.bool,
  value: PropTypes.any,
  selectedValue: PropTypes.any,
  checked: PropTypes.bool,
  cursor: PropTypesRepo.cursor,
  disabled: PropTypes.bool,
  name: PropTypes.string
};

/* eslint-enable react/forbid-prop-types */

Radiobox.defaultProps = {
  cursor: 'pointer',
  m: {
    r: '8px'
  },
  size: '20px',
  inactiveColor: 'gray500',
  activeColor: 'info700',
  isLoading: false,
  value: undefined,
  selectedValue: undefined,
  checked: undefined,
  disabled: false,
  name: undefined
};

var _excluded$f = ["theme"];

/* eslint-disable react/prop-types */

var Row = function Row(_ref) {
  var theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  return /*#__PURE__*/React.createElement(Div$1, _extends({
    m: {
      y: 0,
      x: "calc(-".concat(theme.grid.gutterWidth, "/2)")
    }
  }, rest), rest.children);
};

/* eslint-enable react/prop-types */

Row.defaultProps = {
  d: 'flex',
  flexWrap: 'wrap'
};
var Row$1 = withTheme(Row);

var _templateObject$g;
var StyleReset = createGlobalStyle(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  html {\n    font-size: 16px;\n  }\n\n  ::selection {\n    color: #fff;\n    background: #444;\n  }\n\n  body {\n    font-size: ", ";\n    line-height: ", ";    \n    margin: 0;\n    font-family: ", ";\n    -webkit-font-smoothing: antialiased;\n    color: #000;\n  }\n\n  p, h1, h2, h3, h4, h5, h6 {\n    font-size: ", ";\n    line-height: ", "\n  }\n\n  a {\n    color: ", ";\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  input {\n    font-family: inherit;\n    border: none;\n  }\n\n  button {\n    border: none;\n  }\n\n  pre {\n    margin: 0;\n    padding: 1rem;\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n  }\n"])), function (props) {
  return props.theme.textSize.size.body;
}, function (props) {
  return props.theme.textSize.height.body;
}, function (props) {
  return props.theme.fontFamily.primary;
}, function (props) {
  return props.theme.textSize.size.body;
}, function (props) {
  return props.theme.textSize.height.body;
}, function (props) {
  return props.theme.colors.info700;
}, function (props) {
  return props.theme.textSize.size.caption;
}, function (props) {
  return props.theme.textSize.height.body;
}, function (props) {
  return props.theme.fontFamily.code;
});
var StyleReset$1 = withTheme(StyleReset);

var _excluded$g = ["checked", "m", "activeColor", "inactiveColor", "activeShadow", "inactiveShadow", "isLoading"];
var _templateObject$h;
var CheckboxInput$1 = styled.input(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  display: none;\n"])));
var Switch = function Switch(_ref) {
  var checked = _ref.checked,
    m = _ref.m,
    activeColor = _ref.activeColor,
    inactiveColor = _ref.inactiveColor,
    activeShadow = _ref.activeShadow,
    inactiveShadow = _ref.inactiveShadow,
    isLoading = _ref.isLoading,
    rest = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxInput$1, _extends({
    type: "checkbox"
  }, rest)), /*#__PURE__*/React.createElement(Div$1, {
    m: m,
    d: "flex",
    align: "center",
    justify: "center",
    shadow: checked ? activeShadow : inactiveShadow,
    bg: checked ? activeColor : inactiveColor,
    p: {
      y: '4px',
      x: '13px'
    },
    rounded: "circle",
    style: {
      transition: 'transform 0.1s ease-in-out'
    }
  }, isLoading ? /*#__PURE__*/React.createElement(Icon$1, {
    name: "Loading",
    size: "20px",
    color: "white"
  }) : /*#__PURE__*/React.createElement(Div$1, {
    style: {
      transition: 'transform 0.1s ease-in-out',
      transform: checked ? 'translateX(50%)' : 'translateX(-50%)'
    },
    h: "16px",
    w: "16px",
    shadow: "4",
    bg: "white",
    rounded: "circle"
  })));
};
Switch.propTypes = {
  checked: PropTypes.bool,
  m: PropTypesRepo.m,
  activeColor: PropTypesRepo.bg,
  inactiveColor: PropTypesRepo.bg,
  activeShadow: PropTypesRepo.shadow,
  inactiveShadow: PropTypesRepo.shadow,
  isLoading: PropTypes.bool,
  cursor: PropTypesRepo.cursor
};
Switch.defaultProps = {
  cursor: 'pointer',
  m: {
    r: '16px'
  },
  activeColor: 'info700',
  inactiveColor: 'gray500',
  activeShadow: '4',
  inactiveShadow: '0',
  checked: undefined,
  isLoading: false
};

var _excluded$h = ["activeColor", "hoverColor", "borderColor", "paneProps", "children", "selectedCode"];

/* eslint-disable react/prop-types */

var Tab = function Tab(_ref) {
  var activeColor = _ref.activeColor,
    hoverColor = _ref.hoverColor,
    borderColor = _ref.borderColor,
    paneProps = _ref.paneProps,
    children = _ref.children,
    selectedCode = _ref.selectedCode,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  var panes = useMemo(function () {
    return Children.toArray(children);
  }, [children]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, _extends({
    border: {
      y: '1px solid'
    },
    borderColor: borderColor,
    d: "flex"
  }, rest), panes.map(function (pane) {
    return /*#__PURE__*/React.createElement(Div$1, _extends({
      key: pane.props.code,
      p: {
        x: '8px',
        y: '12px'
      },
      borderColor: selectedCode === pane.props.code ? activeColor : 'transparent'
    }, paneProps, {
      cursor: "pointer",
      border: {
        b: '4px solid'
      },
      onClick: function onClick() {
        pane.props.onSelect();
      },
      hoverBorderColor: selectedCode === pane.props.code ? activeColor : hoverColor
    }), pane.props.name);
  })), /*#__PURE__*/React.createElement(React.Fragment, null, panes.filter(function (pane) {
    return selectedCode === pane.props.code;
  }).map(function (pane) {
    return /*#__PURE__*/React.createElement(Div$1, pane.props, pane.props.children);
  })));
};
Tab.propTypes = {
  borderColor: PropTypes.string,
  activeColor: PropTypes.string,
  hoverColor: PropTypes.string,
  bg: PropTypes.string,
  paneProps: PropTypes.shape({}),
  selectedCode: PropTypes.string
};
Tab.defaultProps = {
  borderColor: 'black50',
  activeColor: 'brand500',
  hoverColor: 'gray600',
  bg: 'gray200',
  paneProps: {},
  selectedCode: ''
};
var Tab$1 = withTheme(Tab);

var Textarea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Input$1, _extends({
    ref: ref,
    tag: "textarea"
  }, props));
});

/* eslint-disable react/require-default-props */

Textarea.propTypes = {
  children: PropTypes.node,
  // mostly Icon
  prefix: PropTypes.node,
  isLoading: PropTypes.bool,
  loadingIcon: PropTypes.node,
  // mostly Icon
  suffix: PropTypes.node,
  flexGrow: PropTypesRepo.flexGrow,
  order: PropTypesRepo.order,
  tag: PropTypes.string,
  pos: PropTypesRepo.pos,
  d: PropTypesRepo.d,
  p: PropTypesRepo.p,
  rounded: PropTypesRepo.rounded,
  border: PropTypesRepo.border,
  borderColor: PropTypesRepo.borderColor,
  h: PropTypesRepo.h,
  w: PropTypesRepo.w,
  maxH: PropTypesRepo.maxH,
  maxW: PropTypesRepo.maxW,
  minW: PropTypesRepo.minW,
  minH: PropTypesRepo.minH,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  textColor: PropTypesRepo.textColor,
  textWeight: PropTypesRepo.textWeight,
  textAlign: PropTypesRepo.textAlign,
  textSize: PropTypesRepo.textSize,
  fontFamily: PropTypesRepo.fontFamily,
  shadow: PropTypesRepo.shadow,
  transition: PropTypesRepo.transition,
  hoverBg: PropTypesRepo.hoverBg,
  hoverTextColor: PropTypesRepo.hoverTextColor,
  hoverBorderColor: PropTypesRepo.hoverBorderColor,
  hoverShadow: PropTypesRepo.hoverShadow,
  focusBorderColor: PropTypesRepo.focusBorderColor
};

/* eslint-enable react/require-default-props */

Textarea.defaultProps = {
  d: 'flex',
  p: {
    x: '12px',
    y: '8px'
  },
  textSize: 'body',
  rounded: 'md',
  border: '1px solid',
  borderColor: 'gray500',
  h: '104px',
  w: '100%',
  minW: '100%',
  bg: 'white',
  textColor: 'dark',
  textWeight: '500',
  focusBorderColor: 'gray700',
  loadingIcon: /*#__PURE__*/React.createElement(Icon$1, {
    name: "Loading",
    pos: "absolute",
    top: "12px",
    right: "12px",
    size: "16px"
  })
};

var _excluded$i = ["children", "isOpen", "onClose", "align"];

/**
 * Duration for the transition
 */
var duration$1 = 300;

/**
 * Default Style for Backlayer
 */
var defaultBackLayerStyle = {
  transition: "opacity ".concat(duration$1, "ms ease-in-out"),
  opacity: 0
};

/**
 * Trasition Styles for Backlayer
 */
var backLayerTransitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 0.4
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};

/**
 * Default Style for ModalContent
 */
var defaultModalContentStyle = {
  transition: "opacity ".concat(duration$1, "ms ease-in-out"),
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden'
};

/**
 * Trasition Styles for ModalContent
 */
var transitionModalContentStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);
  var _super = _createSuper(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _this.disableBodyScroll = _this.disableBodyScroll.bind(_assertThisInitialized(_this));
    _this.enableBodyScroll = _this.enableBodyScroll.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Modal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.querySelector('body').style.overflow = 'auto';
    }

    /**
     * Disable the body scroll when Opened
     */
  }, {
    key: "disableBodyScroll",
    value: function disableBodyScroll() {
      document.querySelector('body').style.overflow = 'hidden';

      // Start Function if recieved a onEntering Props
      var onEntering = this.props.onEntering;
      if (onEntering) onEntering();
    }

    /**
     * Enable the body scroll when Closed
     */
  }, {
    key: "enableBodyScroll",
    value: function enableBodyScroll() {
      document.querySelector('body').style.overflow = 'auto';

      // Start Function if recieved a onExiting Props
      var onExiting = this.props.onExiting;
      if (onExiting) onExiting();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        onClose = _this$props.onClose,
        align = _this$props.align,
        rest = _objectWithoutProperties(_this$props, _excluded$i);
      return /*#__PURE__*/React.createElement(Transition, {
        "in": isOpen,
        timeout: duration$1,
        onEntering: this.disableBodyScroll,
        onExiting: this.enableBodyScroll,
        unmountOnExit: true
      }, function (state) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, {
          style: _objectSpread2(_objectSpread2({}, defaultBackLayerStyle), backLayerTransitionStyles[state]),
          pos: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          bg: "black",
          opacity: "0.4",
          zIndex: "1000"
        }), /*#__PURE__*/React.createElement(Div$1, {
          style: _objectSpread2(_objectSpread2({}, defaultModalContentStyle), transitionModalContentStyles[state]),
          onClick: onClose,
          pos: "fixed",
          top: "0",
          left: "0",
          right: "0",
          h: "100vh",
          d: "flex",
          align: align,
          justify: "center",
          zIndex: "1001",
          cursor: "pointer"
        }, /*#__PURE__*/React.createElement(Div$1, _extends({
          onClick: function onClick(e) {
            e.stopPropagation();
          },
          bg: "white"
        }, rest, {
          zIndex: "1"
        }), children)));
      });
    }
  }]);
  return Modal;
}(Component);
/* eslint-disable react/require-default-props */
Modal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  align: PropTypesRepo.align
};

/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Modal.defaultProps = {
  m: {
    y: {
      xs: '16px',
      lg: '32px'
    },
    x: {
      xs: '16px',
      lg: 'auto'
    }
  },
  p: '32px',
  maxW: '512px',
  w: '100%',
  pos: 'relative',
  shadow: '4',
  cursor: 'default',
  align: 'start',
  onClose: function onClose() {},
  onEntering: null,
  onExiting: null,
  isOpen: false
};

var _excluded$j = ["children", "isOpen", "onClose", "overlay", "drawerStyle"];

/**
 * Duration for the transition
 */
var duration$2 = 300;

/**
 * Default Style for Backlayer
 */
var defaultBackLayerStyle$1 = {
  transition: "opacity ".concat(duration$2, "ms ease-in-out"),
  opacity: 0
};

/**
 * Trasition Styles for Backlayer
 */
var backLayerTransitionStyles$1 = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 0.2
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};

/**
 * Default Style for SideDrawerContent
 */
var defaultSideDrawerContentStyle = {
  transition: "all ".concat(duration$2, "ms ease-in-out"),
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden'
};

/**
 * Trasition Styles for SideDrawerContent
 */
var transitionSideDrawerContentStyles = {
  entering: {
    opacity: 1,
    transform: 'translateX(100%)'
  },
  entered: {
    opacity: 1,
    transform: 'translateX(0)'
  },
  exiting: {
    opacity: 0,
    transform: 'translateX(100%)'
  },
  exited: {
    opacity: 0,
    transform: 'translateX(100%)'
  }
};
var SideDrawer = /*#__PURE__*/function (_Component) {
  _inherits(SideDrawer, _Component);
  var _super = _createSuper(SideDrawer);
  function SideDrawer(props) {
    var _this;
    _classCallCheck(this, SideDrawer);
    _this = _super.call(this, props);
    _this.disableBodyScroll = _this.disableBodyScroll.bind(_assertThisInitialized(_this));
    _this.enableBodyScroll = _this.enableBodyScroll.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SideDrawer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.querySelector('body').style.overflow = 'auto';
    }

    /**
     * Disable the body scroll when Opened
     */
  }, {
    key: "disableBodyScroll",
    value: function disableBodyScroll() {
      document.querySelector('body').style.overflow = 'hidden';

      // Start Function if recieved a onEntering Props
      var onEntering = this.props.onEntering;
      if (onEntering) onEntering();
    }

    /**
     * Enable the body scroll when Closed
     */
  }, {
    key: "enableBodyScroll",
    value: function enableBodyScroll() {
      document.querySelector('body').style.overflow = 'auto';

      // Start Function if recieved a onExiting Props
      var onExiting = this.props.onExiting;
      if (onExiting) onExiting();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        onClose = _this$props.onClose,
        overlay = _this$props.overlay,
        drawerStyle = _this$props.drawerStyle,
        rest = _objectWithoutProperties(_this$props, _excluded$j);
      return /*#__PURE__*/React.createElement(Transition, {
        "in": isOpen,
        timeout: duration$2,
        onEntering: this.disableBodyScroll,
        onExiting: this.enableBodyScroll,
        unmountOnExit: true
      }, function (state) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, overlay ? /*#__PURE__*/React.createElement(Div$1, {
          style: _objectSpread2(_objectSpread2({}, defaultBackLayerStyle$1), backLayerTransitionStyles$1[state]),
          pos: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          bg: "black",
          opacity: "0.2",
          zIndex: "1000",
          cursor: "pointer",
          onClick: onClose
        }) : null, /*#__PURE__*/React.createElement(Div$1, _extends({
          style: _objectSpread2(_objectSpread2({}, defaultSideDrawerContentStyle), transitionSideDrawerContentStyles[state]),
          pos: "fixed",
          top: "0",
          right: "0",
          h: "100vh",
          d: "flex",
          bg: "white",
          zIndex: "1001",
          shadow: "5"
        }, drawerStyle), /*#__PURE__*/React.createElement(Div$1, _extends({
          onClick: function onClick(e) {
            e.stopPropagation();
          }
        }, rest, {
          zIndex: "1"
        }), children)));
      });
    }
  }]);
  return SideDrawer;
}(Component);
/* eslint-disable react/require-default-props */
SideDrawer.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  overlay: PropTypes.bool,
  drawerStyle: PropTypes.shape({})
};

/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

SideDrawer.defaultProps = {
  pos: 'relative',
  w: {
    xs: '100vw',
    sm: '384px'
  },
  bg: 'white',
  p: '24px',
  onClose: function onClose() {},
  isOpen: false,
  onEntering: function onEntering() {
    return null;
  },
  onExiting: function onExiting() {
    return null;
  },
  overlay: false,
  drawerStyle: {}
};

var _excluded$k = ["slides", "isOpen", "onClose", "align", "navProps", "navButtonProps", "contentProps", "firstSlideButtonText", "lastSlideButtonText", "forwardButtonText", "backwardButtonText"];

/* eslint-disable no-nested-ternary */

/**
 * Duration for the transition
 */
var duration$3 = 300;

/**
 * Default Style for Backlayer
 */
var defaultBackLayerStyle$2 = {
  transition: "opacity ".concat(duration$3, "ms ease-in-out"),
  opacity: 0
};

/**
 * Trasition Styles for Backlayer
 */
var backLayerTransitionStyles$2 = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 0.2
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};

/**
 * Default Style for SlideshowCanvas
 */
var defaultSlideshowCanvasStyle = {
  transition: "opacity ".concat(duration$3, "ms ease-in-out"),
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden'
};

/**
 * Trasition Styles for SlideshowCanvas
 */
var transitionSlideshowCanvasStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};

/**
 * Default Style for SlideshowContent
 */
var defaultSlideshowContentStyle = {
  transition: "all ".concat(duration$3, "ms ease-in-out"),
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden'
};

/**
 * Trasition Styles for SlideshowContent
 */
var transitionSlideshowContentStyles = {
  entering: {
    forward: {
      opacity: 0,
      transform: 'translateX(100%)'
    },
    backward: {
      opacity: 0,
      transform: 'translateX(-100%)'
    }
  },
  entered: {
    forward: {
      opacity: 1,
      transform: 'translateX(10%)'
    },
    backward: {
      opacity: 1,
      transform: 'translateX(10%)'
    }
  },
  exiting: {
    forward: {
      opacity: 1,
      transform: 'translateX(10%)'
    },
    backward: {
      opacity: 1,
      transform: 'translateX(10%)'
    }
  },
  exited: {
    forward: {
      opacity: 0,
      transform: 'translateX(-100%)'
    },
    backward: {
      opacity: 0,
      transform: 'translateX(100%)'
    }
  }
};
var Slideshow = /*#__PURE__*/function (_Component) {
  _inherits(Slideshow, _Component);
  var _super = _createSuper(Slideshow);
  function Slideshow(props) {
    var _this;
    _classCallCheck(this, Slideshow);
    _this = _super.call(this, props);
    _this.disableBodyScroll = _this.disableBodyScroll.bind(_assertThisInitialized(_this));
    _this.enableBodyScroll = _this.enableBodyScroll.bind(_assertThisInitialized(_this));
    _this.state = {
      slideIndex: 0,
      direction: 'forward'
    };
    return _this;
  }
  _createClass(Slideshow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.querySelector('body').style.overflow = 'auto';
    }

    /**
     * Disable the body scroll when Opened
     */
  }, {
    key: "disableBodyScroll",
    value: function disableBodyScroll() {
      document.querySelector('body').style.overflow = 'hidden';

      // Start Function if recieved a onEntering Props
      var onEntering = this.props.onEntering;
      if (onEntering) onEntering();
    }

    /**
     * Enable the body scroll when Closed
     */
  }, {
    key: "enableBodyScroll",
    value: function enableBodyScroll() {
      document.querySelector('body').style.overflow = 'auto';

      // Start Function if recieved a onExiting Props
      var onExiting = this.props.onExiting;
      if (onExiting) onExiting();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        slides = _this$props.slides,
        isOpen = _this$props.isOpen,
        onClose = _this$props.onClose,
        align = _this$props.align,
        navProps = _this$props.navProps,
        navButtonProps = _this$props.navButtonProps,
        contentProps = _this$props.contentProps,
        firstSlideButtonText = _this$props.firstSlideButtonText,
        lastSlideButtonText = _this$props.lastSlideButtonText,
        forwardButtonText = _this$props.forwardButtonText,
        backwardButtonText = _this$props.backwardButtonText,
        rest = _objectWithoutProperties(_this$props, _excluded$k);
      var _this$state = this.state,
        direction = _this$state.direction,
        slideIndex = _this$state.slideIndex;
      return /*#__PURE__*/React.createElement(Transition, {
        "in": isOpen,
        timeout: duration$3,
        onEntering: this.disableBodyScroll,
        onExiting: this.enableBodyScroll,
        onExited: function onExited() {
          _this2.setState({
            slideIndex: 0
          });
        },
        unmountOnExit: true
      }, function (state) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, {
          style: _objectSpread2(_objectSpread2({}, defaultBackLayerStyle$2), backLayerTransitionStyles$2[state]),
          pos: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          bg: "black",
          opacity: "0.4",
          zIndex: "1000"
        }), /*#__PURE__*/React.createElement(Div$1, {
          style: _objectSpread2(_objectSpread2({}, defaultSlideshowCanvasStyle), transitionSlideshowCanvasStyles[state]),
          onClick: onClose,
          pos: "fixed",
          top: "0",
          left: "0",
          right: "0",
          h: "100vh",
          d: "flex",
          align: align,
          justify: "center",
          zIndex: "1001",
          cursor: "pointer"
        }, /*#__PURE__*/React.createElement(Div$1, _extends({
          onClick: function onClick(e) {
            e.stopPropagation();
          },
          bg: "white"
        }, rest, {
          zIndex: "1"
        }), functions.range(0, slides.length - 1, 1).map(function (value) {
          return /*#__PURE__*/React.createElement(Transition, {
            "in": slideIndex === value,
            timeout: duration$3
          }, function (innerTransitionState) {
            return /*#__PURE__*/React.createElement(Div$1, _extends({
              d: "flex",
              w: "80%",
              pos: "absolute",
              align: "center",
              justify: "center",
              style: _objectSpread2(_objectSpread2({}, defaultSlideshowContentStyle), transitionSlideshowContentStyles[innerTransitionState][direction])
            }, contentProps), slides[value]);
          });
        }), /*#__PURE__*/React.createElement(Div$1, navProps, slideIndex > 0 ? /*#__PURE__*/React.createElement(Button$1, _extends({
          onClick: function onClick() {
            if (slideIndex > 0) {
              _this2.setState(function (prevState) {
                return {
                  slideIndex: (prevState.slideIndex - 1) % slides.length,
                  direction: 'backward'
                };
              });
            }
          }
        }, navButtonProps), backwardButtonText) : null, slideIndex < slides.length ? /*#__PURE__*/React.createElement(Button$1, _extends({
          onClick: function onClick() {
            if (slideIndex === slides.length - 1) {
              onClose();
            } else {
              _this2.setState(function (prevState) {
                return {
                  slideIndex: (prevState.slideIndex + 1) % slides.length,
                  direction: 'forward'
                };
              });
            }
          }
        }, navButtonProps), slideIndex === 0 ? firstSlideButtonText : slideIndex === slides.length - 1 ? lastSlideButtonText : forwardButtonText) : null))));
      });
    }
  }]);
  return Slideshow;
}(Component);
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
Slideshow.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.node),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  align: PropTypesRepo.align,
  navProps: PropTypes.object,
  navButtonProps: PropTypes.object,
  contentProps: PropTypes.object,
  forwardButtonText: PropTypes.string,
  backwardButtonText: PropTypes.string,
  firstSlideButtonText: PropTypes.string,
  lastSlideButtonText: PropTypes.string
};

/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Slideshow.defaultProps = {
  m: {
    y: {
      xs: '16px',
      lg: '32px'
    },
    x: {
      xs: '16px',
      lg: 'auto'
    }
  },
  maxW: '512px',
  w: '100%',
  pos: 'fixed',
  rounded: 'md',
  shadow: '4',
  cursor: 'default',
  align: 'start',
  onClose: function onClose() {},
  onEntering: null,
  onExiting: null,
  isOpen: false,
  navProps: {
    m: {
      t: '128px',
      b: '32px'
    },
    d: 'flex',
    flexDir: 'row',
    justify: 'center'
  },
  navButtonProps: {
    m: {
      x: '16px'
    },
    w: '80px'
  },
  contentProps: {
    top: '32px'
  },
  forwardButtonText: 'Next',
  backwardButtonText: 'Back',
  firstSlideButtonText: 'Next',
  lastSlideButtonText: 'Finish'
};

var duration$4 = 300;

/**
 * Default Style for SlideshowContent
 */
var defaultSlideshowContentStyle$1 = {
  transition: "all ".concat(duration$4, "ms ease-in-out"),
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden'
};

/**
 * Trasition Styles for SlideshowContent
 */
var transitionSlideshowContentStyles$1 = {
  entering: {
    forward: function forward() {
      return {
        opacity: 0,
        transform: 'translateX(100%)',
        height: '0'
      };
    },
    backward: function backward() {
      return {
        opacity: 0,
        transform: 'translateX(-100%)',
        height: '0'
      };
    }
  },
  entered: {
    forward: function forward(contentMinHeight) {
      return {
        opacity: 1,
        transform: 'translateX(0%)',
        height: 'auto',
        minHeight: contentMinHeight
      };
    },
    backward: function backward(contentMinHeight) {
      return {
        opacity: 1,
        transform: 'translateX(0%)',
        height: 'auto',
        minHeight: contentMinHeight
      };
    }
  },
  exiting: {
    forward: function forward(contentMinHeight) {
      return {
        opacity: 1,
        transform: 'translateX(0%)',
        height: 'auto',
        minHeight: contentMinHeight
      };
    },
    backward: function backward(contentMinHeight) {
      return {
        opacity: 1,
        transform: 'translateX(0%)',
        height: 'auto',
        minHeight: contentMinHeight
      };
    }
  },
  exited: {
    forward: function forward() {
      return {
        opacity: 0,
        transform: 'translateX(100%)',
        height: '0'
      };
    },
    backward: function backward() {
      return {
        opacity: 0,
        transform: 'translateX(-100%)',
        height: '0'
      };
    }
  }
};
var SimpleSlideshow = /*#__PURE__*/function (_Component) {
  _inherits(SimpleSlideshow, _Component);
  var _super = _createSuper(SimpleSlideshow);
  function SimpleSlideshow(props) {
    var _this;
    _classCallCheck(this, SimpleSlideshow);
    _this = _super.call(this, props);
    _this.state = {
      slideIndex: 0,
      direction: 'forward'
    };
    return _this;
  }
  _createClass(SimpleSlideshow, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        slides = _this$props.slides,
        containerStyle = _this$props.containerStyle,
        containerStyleOverride = _this$props.containerStyleOverride,
        navStyle = _this$props.navStyle,
        navStyleOverride = _this$props.navStyleOverride,
        navButtonStyle = _this$props.navButtonStyle,
        navButtonStyleOverride = _this$props.navButtonStyleOverride,
        contentStyle = _this$props.contentStyle,
        contentStyleOverride = _this$props.contentStyleOverride,
        contentMinHeight = _this$props.contentMinHeight,
        firstSlideButtonText = _this$props.firstSlideButtonText,
        lastSlideButtonText = _this$props.lastSlideButtonText,
        forwardButtonText = _this$props.forwardButtonText,
        backwardButtonText = _this$props.backwardButtonText,
        onComplete = _this$props.onComplete;
      var _this$state = this.state,
        direction = _this$state.direction,
        slideIndex = _this$state.slideIndex;
      return /*#__PURE__*/React.createElement(Div$1, _extends({
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }, containerStyle, containerStyleOverride), functions.range(0, slides.length - 1, 1).map(function (value) {
        return /*#__PURE__*/React.createElement(Transition, {
          "in": slideIndex === value,
          timeout: duration$4
        }, function (innerTransitionState) {
          return /*#__PURE__*/React.createElement(Div$1, _extends({
            style: _objectSpread2(_objectSpread2({}, defaultSlideshowContentStyle$1), transitionSlideshowContentStyles$1[innerTransitionState][direction](contentMinHeight))
          }, contentStyle, contentStyleOverride), slides[value]);
        });
      }), /*#__PURE__*/React.createElement(Div$1, _extends({}, navStyle, navStyleOverride), slideIndex > 0 ? /*#__PURE__*/React.createElement(Button$1, _extends({
        onClick: function onClick() {
          if (slideIndex > 0) {
            _this2.setState(function (prevState) {
              return {
                slideIndex: (prevState.slideIndex - 1) % slides.length,
                direction: 'backward'
              };
            });
          }
        }
      }, navButtonStyle, navButtonStyleOverride), backwardButtonText) : null, slideIndex < slides.length ? /*#__PURE__*/React.createElement(Button$1, _extends({
        onClick: function onClick() {
          if (slideIndex === slides.length - 1) {
            onComplete();
          } else {
            _this2.setState(function (prevState) {
              return {
                slideIndex: (prevState.slideIndex + 1) % slides.length,
                direction: 'forward'
              };
            });
          }
        }
      }, navButtonStyle, navButtonStyleOverride), slideIndex === 0 ? firstSlideButtonText : slideIndex === slides.length - 1 ? lastSlideButtonText : forwardButtonText) : null));
    }
  }]);
  return SimpleSlideshow;
}(Component);
SimpleSlideshow.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.node),
  containerStyle: PropTypes.shape({}),
  containerStyleOverride: PropTypes.shape({}),
  navStyle: PropTypes.shape({}),
  navButtonStyle: PropTypes.shape({}),
  contentStyle: PropTypes.shape({}),
  navStyleOverride: PropTypes.shape({}),
  navButtonStyleOverride: PropTypes.shape({}),
  contentStyleOverride: PropTypes.shape({}),
  contentMinHeight: PropTypes.string,
  forwardButtonText: PropTypes.string,
  backwardButtonText: PropTypes.string,
  firstSlideButtonText: PropTypes.string,
  lastSlideButtonText: PropTypes.string,
  onComplete: PropTypes.func
};
SimpleSlideshow.defaultProps = {
  slides: [],
  containerStyle: {
    bg: 'shopify',
    d: 'flex',
    w: '100%',
    flexDir: 'column',
    justify: {
      xs: 'start',
      md: 'center'
    },
    align: 'center'
  },
  containerStyleOverride: {},
  navStyle: {
    m: {
      t: '32px',
      b: '32px'
    },
    d: 'flex',
    flexDir: {
      xs: 'column',
      md: 'row'
    },
    justify: 'center'
  },
  navStyleOverride: {},
  navButtonStyle: {
    m: {
      x: '16px',
      y: '8px'
    },
    w: '160px',
    cursor: 'pointer'
  },
  navButtonStyleOverride: {},
  contentStyle: {
    top: '32px',
    d: 'flex',
    w: '100%',
    align: 'center',
    justify: 'center'
  },
  contentStyleOverride: {},
  contentMinHeight: '1024px',
  forwardButtonText: 'Next',
  backwardButtonText: 'Back',
  firstSlideButtonText: 'Next',
  lastSlideButtonText: 'Finish',
  onComplete: function onComplete() {
    return null;
  }
};

var _excluded$l = ["children", "isOpen", "onClose", "prefix", "suffix", "position", "top", "left", "bottom", "right", "opacity", "backdropFilter"];

/**
 * Duration for the transition
 */
var duration$5 = 300;

/**
 * Default Style for SideDrawerContent
 */
var defaultNotifationStyle = {
  transition: "all ".concat(duration$5, "ms ease-in-out"),
  opacity: 0
};

/**
 * Trasition Styles for SideDrawerContent
 */
var transitionNotifationStyles = {
  fromTopRight: {
    entering: function entering() {
      return {
        opacity: 0,
        transform: 'translateY(-100%)'
      };
    },
    entered: function entered(opacity, backdropFilter) {
      return {
        opacity: opacity,
        transform: 'translateX(0)',
        backdropFilter: backdropFilter
      };
    },
    exiting: function exiting() {
      return {
        opacity: 0,
        transform: 'translateX(100%)'
      };
    },
    exited: function exited() {
      return {
        opacity: 0,
        transform: 'translateY(-100%)'
      };
    }
  },
  fromBottomRight: {
    entering: function entering() {
      return {
        opacity: 0,
        transform: 'translateX(100%)'
      };
    },
    entered: function entered(opacity, backdropFilter) {
      return {
        opacity: opacity,
        transform: 'translateX(0)',
        backdropFilter: backdropFilter
      };
    },
    exiting: function exiting() {
      return {
        opacity: 0,
        transform: 'translateX(100%)'
      };
    },
    exited: function exited() {
      return {
        opacity: 0,
        transform: 'translateX(100%)'
      };
    }
  },
  fromBottomLeft: {
    entering: function entering() {
      return {
        opacity: 0,
        transform: 'translateX(-100%)'
      };
    },
    entered: function entered(opacity, backdropFilter) {
      return {
        opacity: opacity,
        transform: 'translateX(0)',
        backdropFilter: backdropFilter
      };
    },
    exiting: function exiting() {
      return {
        opacity: 0,
        transform: 'translateX(-100%)'
      };
    },
    exited: function exited() {
      return {
        opacity: 0,
        transform: 'translateY(-100%)'
      };
    }
  },
  fromTopLeft: {
    entering: function entering() {
      return {
        opacity: 0,
        transform: 'translateY(-100%)'
      };
    },
    entered: function entered(opacity, backdropFilter) {
      return {
        opacity: opacity,
        transform: 'translateX(0)',
        backdropFilter: backdropFilter
      };
    },
    exiting: function exiting() {
      return {
        opacity: 0,
        transform: 'translateX(-100%)'
      };
    },
    exited: function exited() {
      return {
        opacity: 0,
        transform: 'translateY(-100%)'
      };
    }
  }
};
var Notification = /*#__PURE__*/function (_React$Component) {
  _inherits(Notification, _React$Component);
  var _super = _createSuper(Notification);
  function Notification(props) {
    var _this;
    _classCallCheck(this, Notification);
    _this = _super.call(this, props);
    _this.setTimer = _this.setTimer.bind(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * SetTimerForClosing
   */
  _createClass(Notification, [{
    key: "setTimer",
    value: function setTimer() {
      var onClose = this.props.onClose;
      setTimeout(function () {
        onClose();
      }, 2000);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        onClose = _this$props.onClose,
        prefix = _this$props.prefix,
        suffix = _this$props.suffix,
        position = _this$props.position,
        top = _this$props.top,
        left = _this$props.left,
        bottom = _this$props.bottom,
        right = _this$props.right,
        opacity = _this$props.opacity,
        backdropFilter = _this$props.backdropFilter,
        rest = _objectWithoutProperties(_this$props, _excluded$l);
      var newTop;
      var newBottom;
      var newRight;
      var newLeft;
      switch (position) {
        case 'fromTopRight':
          {
            newBottom = 'auto';
            newLeft = 'auto';
            newTop = !top || top === 'auto' ? '32px' : top;
            newRight = !right || right === 'auto' ? '32px' : right;
            break;
          }
        case 'fromBottomRight':
          {
            newTop = 'auto';
            newLeft = 'auto';
            newBottom = !bottom || bottom === 'auto' ? '32px' : bottom;
            newRight = !right || right === 'auto' ? '32px' : right;
            break;
          }
        case 'fromBottomLeft':
          {
            newTop = 'auto';
            newRight = 'auto';
            newBottom = !bottom || bottom === 'auto' ? '32px' : bottom;
            newLeft = !left || left === 'auto' ? '32px' : left;
            break;
          }
        case 'fromTopLeft':
          {
            newBottom = 'auto';
            newRight = 'auto';
            newTop = !top || top === 'auto' ? '32px' : top;
            newLeft = !left || left === 'auto' ? '32px' : left;
            break;
          }
      }
      return /*#__PURE__*/React.createElement(Transition, {
        "in": isOpen,
        timeout: duration$5,
        onEntering: this.setTimer,
        unmountOnExit: true
      }, function (state) {
        return /*#__PURE__*/React.createElement(Div$1, _extends({
          style: _objectSpread2(_objectSpread2({}, defaultNotifationStyle), transitionNotifationStyles[position][state](opacity, backdropFilter)),
          top: newTop,
          bottom: newBottom,
          left: newLeft,
          right: newRight
        }, rest), prefix, /*#__PURE__*/React.createElement(Div$1, {
          flexGrow: "1"
        }, children), suffix);
      });
    }
  }]);
  return Notification;
}(React.Component);
/* eslint-disable react/require-default-props */
Notification.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  isOpen: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  position: PropTypes.string,
  top: PropTypes.string,
  left: PropTypes.string,
  bottom: PropTypes.string,
  right: PropTypes.string,
  opacity: PropTypes.number,
  backdropFilter: PropTypes.string
};

/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Notification.defaultProps = {
  pos: 'fixed',
  top: '32px',
  right: '32px',
  d: 'flex',
  align: 'center',
  bg: 'gray900',
  rounded: 'md',
  p: {
    x: '16px',
    y: '16px'
  },
  textColor: 'white',
  iconsSize: '18px',
  iconSize: '20px',
  textWeight: '600',
  w: '320px',
  zIndex: '1050',
  shadow: '3',
  position: 'fromTopRight',
  opacity: 1,
  backdropFilter: 'none'
};

var _templateObject$i, _templateObject2$3, _templateObject3$3;
var animation$1 = keyframes(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"])));
var Spinner = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  left: 99px;\n  top: 5px;\n  position: absolute;\n  animation: ", " linear 1s infinite;\n  background: ", ";\n  width: 2px;\n  height: 30px;\n  border-radius: 60px;\n  transform-origin: 1px 95px;\n"])), animation$1, function (props) {
  return props.theme.colors.brand500;
});
var LoaderBlock = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  width: 128px;\n  height: 128px;\n  position: relative;\n  transform: translate(-64px, -64px) scale(0.64) translate(64px, 64px);\n\n  & ", ":nth-child(1) {\n    transform: rotate(0deg);\n    animation-delay: -0.972222222222222s;\n  }\n  & ", ":nth-child(2) {\n    transform: rotate(10deg);\n    animation-delay: -0.944444444444444s;\n  }\n  & ", ":nth-child(3) {\n    transform: rotate(20deg);\n    animation-delay: -0.916666666666667s;\n  }\n  & ", ":nth-child(4) {\n    transform: rotate(30deg);\n    animation-delay: -0.888888888888889s;\n  }\n  & ", ":nth-child(5) {\n    transform: rotate(40deg);\n    animation-delay: -0.861111111111111s;\n  }\n  & ", ":nth-child(6) {\n    transform: rotate(50deg);\n    animation-delay: -0.833333333333333s;\n  }\n  & ", ":nth-child(7) {\n    transform: rotate(60deg);\n    animation-delay: -0.833333333333333s;\n  }\n  & ", ":nth-child(8) {\n    transform: rotate(70deg);\n    animation-delay: -0.777777777777778s;\n  }\n  & ", ":nth-child(9) {\n    transform: rotate(80deg);\n    animation-delay: -0.777777777777778s;\n  }\n  & ", ":nth-child(10) {\n    transform: rotate(90deg);\n    animation-delay: -0.75s;\n  }\n  & ", ":nth-child(11) {\n    transform: rotate(100deg);\n    animation-delay: -0.694444444444444s;\n  }\n  & ", ":nth-child(12) {\n    transform: rotate(110deg);\n    animation-delay: -0.666666666666667s;\n  }\n  & ", ":nth-child(13) {\n    transform: rotate(120deg);\n    animation-delay: -0.638888888888889s;\n  }\n  & ", ":nth-child(14) {\n    transform: rotate(130deg);\n    animation-delay: -0.611111111111111s;\n  }\n  & ", ":nth-child(15) {\n    transform: rotate(140deg);\n    animation-delay: -0.583333333333333s;\n  }\n  & ", ":nth-child(16) {\n    transform: rotate(150deg);\n    animation-delay: -0.555555555555556s;\n  }\n  & ", ":nth-child(17) {\n    transform: rotate(160deg);\n    animation-delay: -0.527777777777778s;\n  }\n  & ", ":nth-child(18) {\n    transform: rotate(170deg);\n    animation-delay: -0.5s;\n  }\n  & ", ":nth-child(19) {\n    transform: rotate(180deg);\n    animation-delay: -0.472222222222222s;\n  }\n  & ", ":nth-child(20) {\n    transform: rotate(190deg);\n    animation-delay: -0.444444444444444s;\n  }\n  & ", ":nth-child(21) {\n    transform: rotate(200deg);\n    animation-delay: -0.416666666666667s;\n  }\n  & ", ":nth-child(22) {\n    transform: rotate(210deg);\n    animation-delay: -0.388888888888889s;\n  }\n  & ", ":nth-child(23) {\n    transform: rotate(220deg);\n    animation-delay: -0.361111111111111s;\n  }\n  & ", ":nth-child(24) {\n    transform: rotate(230deg);\n    animation-delay: -0.333333333333333s;\n  }\n  & ", ":nth-child(25) {\n    transform: rotate(240deg);\n    animation-delay: -0.305555555555556s;\n  }\n  & ", ":nth-child(26) {\n    transform: rotate(250deg);\n    animation-delay: -0.277777777777778s;\n  }\n  & ", ":nth-child(27) {\n    transform: rotate(260deg);\n    animation-delay: -0.25s;\n  }\n  & ", ":nth-child(28) {\n    transform: rotate(270deg);\n    animation-delay: -0.222222222222222s;\n  }\n  & ", ":nth-child(29) {\n    transform: rotate(280deg);\n    animation-delay: -0.194444444444444s;\n  }\n  & ", ":nth-child(30) {\n    transform: rotate(290deg);\n    animation-delay: -0.166666666666667s;\n  }\n  & ", ":nth-child(31) {\n    transform: rotate(300deg);\n    animation-delay: -0.138888888888889s;\n  }\n  & ", ":nth-child(32) {\n    transform: rotate(310deg);\n    animation-delay: -0.111111111111111s;\n  }\n  & ", ":nth-child(33) {\n    transform: rotate(320deg);\n    animation-delay: -0.083333333333333s;\n  }\n  & ", ":nth-child(34) {\n    transform: rotate(330deg);\n    animation-delay: -0.055555555555556s;\n  }\n  & ", ":nth-child(35) {\n    transform: rotate(340deg);\n    animation-delay: -0.027777777777778s;\n  }\n  & ", ":nth-child(36) {\n    transform: rotate(350deg);\n    animation-delay: 0s;\n  }\n"])), Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner, Spinner);
var Loader = function Loader(props) {
  return /*#__PURE__*/React.createElement(LoaderBlock, null, /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props), /*#__PURE__*/React.createElement(Spinner, props));
};
var Loader$1 = withTheme(Loader);

var _templateObject$j, _templateObject2$4;
var animation$2 = keyframes(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"])));
var Loader$2 = withTheme(styled.span(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  line-height: 1;\n  background-color: ", ";\n  background-image: ", ";\n  animation: ", " ease-in-out ", " infinite;\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref) {
  var skeleton = _ref.theme.skeleton;
  return skeleton.baseColor;
}, function (_ref2) {
  var skeleton = _ref2.theme.skeleton;
  return "linear-gradient(\n    90deg, ".concat(skeleton.baseColor, ", ").concat(skeleton.hightlightColor, ", ").concat(skeleton.baseColor, "\n  )");
}, animation$2, function (_ref3) {
  var skeleton = _ref3.theme.skeleton;
  return "".concat(skeleton.duration, "s");
}, function (props) {
  return functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return functions.makeResponsive('width', props.w);
}, function (props) {
  return functions.makeResponsive('height', props.h);
}));
Loader$2.propTypes = {
  theme: PropTypes.shape({
    skeleton: PropTypes.shape({})
  }),
  rounded: PropTypesRepo.rounded,
  w: PropTypesRepo.w,
  h: PropTypesRepo.h
};
Loader$2.defaultProps = {
  rounded: 'sm',
  w: '100%',
  h: 'auto'
};
var Skeleton = function Skeleton(_ref4) {
  var count = _ref4.count,
    w = _ref4.w,
    h = _ref4.h,
    rounded = _ref4.rounded;
  var elements = [];
  for (var i = 0; i < count; i += 1) {
    elements.push( /*#__PURE__*/React.createElement(Loader$2, {
      w: w,
      h: h,
      rounded: rounded
    }));
  }
  return /*#__PURE__*/React.createElement("span", null, elements);
};
Skeleton.propTypes = {
  rounded: PropTypesRepo.rounded,
  w: PropTypesRepo.w,
  h: PropTypesRepo.h,
  count: PropTypes.number
};
Skeleton.defaultProps = {
  rounded: 'sm',
  w: '100%',
  h: 'auto',
  count: 1
};
var Skeleton$1 = withTheme(Skeleton);

var Content = function Content(_ref) {
  var mini = _ref.mini,
    theme = _ref.theme,
    children = _ref.children,
    contentStyle = _ref.contentStyle;
  return /*#__PURE__*/React.createElement(Div$1, _extends({
    pos: "relative",
    minH: "calc(100vh - ".concat(theme.application.headerHeight, ")"),
    m: {
      l: mini ? theme.application.miniMenuWidth : theme.application.menuWidth
    },
    transition: theme.application.menuTransition,
    overflow: "auto"
  }, contentStyle), children);
};
Content.propTypes = {
  theme: PropTypes.shape({
    application: {}
  }).isRequired,
  contentStyle: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  mini: PropTypes.bool
};
Content.defaultProps = {
  children: null,
  mini: false
};
var Content$1 = withTheme(Content);

var _templateObject$k;
var HeaderStyled = withTheme(styled.header(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.zIndex && functions.makeResponsive('z-index', props.zIndex);
}, function (props) {
  return props.shadow && functions.makeResponsiveShadow(props.shadow, props.theme.shadows);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}));
HeaderStyled.defaultProps = {
  pos: 'relative',
  w: '100%'
};
var Header = function Header(_ref) {
  var mini = _ref.mini,
    bg = _ref.bg,
    hoverBg = _ref.hoverBg,
    textColor = _ref.textColor,
    onToggle = _ref.onToggle,
    rightChildren = _ref.rightChildren,
    theme = _ref.theme,
    leftChildren = _ref.leftChildren;
  return /*#__PURE__*/React.createElement(HeaderStyled, {
    bg: bg,
    textColor: textColor,
    minH: theme.application.headerHeight,
    h: theme.application.headerHeight,
    shadow: "4"
  }, /*#__PURE__*/React.createElement(Div$1, {
    m: {
      l: mini ? theme.application.miniMenuWidth : theme.application.menuWidth
    },
    minW: "75px",
    minH: theme.application.headerHeight,
    d: "inline-flex",
    justify: "center",
    align: "center",
    hoverBg: hoverBg,
    cursor: "pointer",
    onClick: function onClick() {
      return onToggle();
    }
  }, /*#__PURE__*/React.createElement(Icon$1, {
    name: "Menu",
    color: textColor
  })), leftChildren ? /*#__PURE__*/React.createElement(Div$1, {
    pos: "absolute",
    top: "0",
    left: "0",
    m: {
      l: "calc(75px + ".concat(mini ? theme.application.miniMenuWidth : theme.application.menuWidth, ")")
    },
    minH: theme.application.headerHeight,
    d: "inline-flex",
    justify: "flex-start",
    align: "center"
  }, leftChildren) : null, rightChildren ? /*#__PURE__*/React.createElement(Div$1, {
    pos: "absolute",
    top: "0",
    right: "0",
    m: {
      r: '25px'
    },
    minH: theme.application.headerHeight,
    d: "inline-flex",
    justify: "flex-end",
    align: "center"
  }, rightChildren) : null);
};
Header.propTypes = {
  theme: PropTypes.shape({
    application: {}
  }).isRequired,
  mini: PropTypes.bool,
  bg: PropTypesRepo.bg,
  hoverBg: PropTypesRepo.hoverBg,
  textColor: PropTypesRepo.textColor,
  onToggle: PropTypes.func,
  rightChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  leftChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Header.defaultProps = {
  mini: false,
  bg: 'gray100',
  hoverBg: 'gray400',
  textColor: 'brand500',
  onToggle: function onToggle() {
    return null;
  },
  rightChildren: null,
  leftChildren: null
};
var MonochromeHeader = withTheme(Header);

var _templateObject$l, _templateObject2$5, _templateObject3$4, _templateObject4$2, _templateObject5$2, _templateObject6$1;
var MenuItem = styled.li(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  display: list-item;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n"])));
var MenuLink = withTheme(styled(Link)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: none !important;\n  padding: ", ";\n  position: relative;\n  margin: 0;\n  display: flex;\n  background-color: transparent;\n  align-items: center;\n  ", ";\n  ", ";\n  transition: all 0.1s ease;\n  border-left: ", ";\n  ", ";\n\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none !important;\n    text-decoration: none !important;\n    border-left: ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.padding ? props.padding : '12px 5px 12px 10px';
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.textSize && functions.makeResponsiveFontSize(props.textSize, props.theme.textSize);
}, function (props) {
  return props.leftBorder ? '4px solid transparent' : 'none';
}, function (props) {
  return props.highlighted ? props.hoverBg && functions.makeResponsiveProperty(props.hoverBg, 'background', props.theme.colors) : props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.leftBorder ? '4px solid white' : 'none';
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.hoverBg, 'background', props.theme.colors);
}));
MenuLink.defaultProps = {
  leftBorder: true
};
var Header$1 = withTheme(styled.li(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  display: ", ";\n  position: relative;\n  margin: 0;\n  padding: 10px 25px 10px 15px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.mini ? 'none !important' : 'list-item';
}, function (props) {
  return props.textSize && functions.makeResponsiveFontSize(props.textSize, props.theme.textSize);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.fontFamily && "font-family: ".concat(props.theme.fontFamily[props.fontFamily]);
}));
var Group = withTheme(styled.li(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: none !important;\n  padding: 12px 5px 12px 10px;\n  position: relative;\n  margin: 0;\n  background-color: transparent;\n  align-items: center;\n  display: flex;\n  ", ";\n  transition: all 0.1s ease;\n  border-left: 4px solid transparent;\n\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none !important;\n    text-decoration: none !important;\n    border-left: 4px solid white;\n    ", ";\n  }\n"])), function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}));
var OptionsPopup = withTheme(styled.li(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  ", ";\n  margin: 0px 0px 0px 10px;\n  position: absolute;\n  overflow: visible;\n  z-index: 10;\n  transition: all 0.1s ease;\n  ", ";\n  ", ";\n"])), function (props) {
  return "transform: translate(".concat(props.theme.application.miniMenuWidth, ", -54px)");
}, function (props) {
  return props.rounded && functions.findRoundedDirection(props.rounded, props.theme.rounded);
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}));
var Options = withTheme(styled.ul(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n\n  &:hover {\n    overflow: visible;\n  }\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}));
var SubMenu = function SubMenu(_ref) {
  var icon = _ref.icon,
    name = _ref.name,
    options = _ref.options,
    iconsStyle = _ref.iconsStyle,
    itemsStyle = _ref.itemsStyle,
    optionsStyle = _ref.optionsStyle,
    subMenuPopupStyle = _ref.subMenuPopupStyle,
    mini = _ref.mini;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHovered = _useState4[0],
    setIsHovered = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isChildHovered = _useState6[0],
    setChildHovered = _useState6[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(Group, _extends({}, itemsStyle, {
    onMouseEnter: function onMouseEnter() {
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      setTimeout(function () {
        setIsHovered(false);
      }, 200);
    },
    onClick: function onClick() {
      setIsOpen(!isOpen);
    }
  }), /*#__PURE__*/React.createElement(Icon$1, _extends({
    name: icon
  }, iconsStyle)), name, !mini ? isOpen ? /*#__PURE__*/React.createElement(Icon$1, _extends({
    name: "DownArrow"
  }, iconsStyle, {
    pos: "absolute",
    right: "0"
  })) : /*#__PURE__*/React.createElement(Icon$1, _extends({
    name: "UpArrow"
  }, iconsStyle, {
    pos: "absolute",
    right: "0"
  })) : null)), isOpen && !mini ? /*#__PURE__*/React.createElement(Options, optionsStyle, options.map(function (option) {
    return {
      ITEM: /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(MenuLink, _extends({
        padding: "5px 5px 5px 60px",
        textSize: "subheader",
        highlighted: typeof window !== 'undefined' && window.location.pathname === option.link,
        to: option.link
      }, itemsStyle), option.name))
    }[option.type];
  })) : null, mini && (isHovered || isChildHovered) ? /*#__PURE__*/React.createElement(OptionsPopup, _extends({
    onMouseEnter: function onMouseEnter() {
      setChildHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      setChildHovered(false);
    },
    rounded: "md"
  }, subMenuPopupStyle), /*#__PURE__*/React.createElement(Options, optionsStyle, options.map(function (option) {
    return {
      ITEM: /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(MenuLink, _extends({
        padding: "5px 40px",
        leftBorder: false,
        textSize: "subheader",
        highlighted: typeof window !== 'undefined' && window.location.pathname === option.link
      }, itemsStyle, {
        to: option.link
      }), option.name))
    }[option.type];
  }))) : null);
};
SubMenu.propTypes = {
  theme: PropTypes.shape({
    application: {}
  }).isRequired,
  mini: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf(['HEADER', 'ITEM']),
    icon: PropTypes.string,
    link: PropTypes.string
  })).isRequired,
  iconsStyle: PropTypes.shape({}).isRequired,
  itemsStyle: PropTypes.shape({}).isRequired,
  optionsStyle: PropTypes.shape({}).isRequired,
  subMenuPopupStyle: PropTypes.shape({}).isRequired
};
var Menu = function Menu(_ref2) {
  var mini = _ref2.mini,
    menuStyle = _ref2.menuStyle,
    subMenuPopupStyle = _ref2.subMenuPopupStyle,
    optionsStyle = _ref2.optionsStyle,
    itemsStyle = _ref2.itemsStyle,
    logo = _ref2.logo,
    logoStyle = _ref2.logoStyle,
    iconsStyle = _ref2.iconsStyle,
    headersStyle = _ref2.headersStyle,
    options = _ref2.options,
    theme = _ref2.theme;
  return /*#__PURE__*/React.createElement(Div$1, _extends({
    top: "0",
    left: "0",
    minH: "100%",
    h: "100%",
    minW: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    w: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    transition: theme.application.menuTransition
  }, menuStyle), /*#__PURE__*/React.createElement(Options, optionsStyle, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Div$1, _extends({
    minW: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    w: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    minH: theme.application.headerHeight,
    h: theme.application.headerHeight,
    d: "inline-flex",
    justify: "center",
    align: "center"
  }, logoStyle), /*#__PURE__*/React.createElement(Div$1, {
    tag: "span"
  }, mini ? logo.smallLogo : logo.largeLogo))), options.map(function (option) {
    return {
      HEADER: /*#__PURE__*/React.createElement(Header$1, _extends({
        mini: mini
      }, headersStyle), option.name.toUpperCase()),
      ITEM: /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(MenuLink, _extends({
        highlighted: typeof window !== 'undefined' && window.location.pathname === option.link
      }, itemsStyle, {
        to: option.link
      }), /*#__PURE__*/React.createElement(Icon$1, _extends({
        name: option.icon
      }, iconsStyle)), option.name)),
      SUB_MENU: /*#__PURE__*/React.createElement(SubMenu, {
        icon: option.icon,
        name: option.name,
        options: option.options,
        iconsStyle: iconsStyle,
        itemsStyle: itemsStyle,
        optionsStyle: optionsStyle,
        subMenuPopupStyle: subMenuPopupStyle,
        mini: mini
      })
    }[option.type];
  })));
};
Menu.propTypes = {
  theme: PropTypes.shape({
    application: {}
  }).isRequired,
  mini: PropTypes.bool,
  menuStyle: PropTypes.shape({}),
  subMenuPopupStyle: PropTypes.shape({}),
  optionsStyle: PropTypes.shape({}),
  iconsStyle: PropTypes.shape({}),
  headersStyle: PropTypes.shape({}),
  itemsStyle: PropTypes.shape({}),
  logoStyle: PropTypes.shape({}),
  logo: PropTypes.shape({
    largeLogo: PropTypes.string,
    smallLogo: PropTypes.string
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf(['HEADER', 'ITEM']),
    icon: PropTypes.string,
    link: PropTypes.string
  }))
};
Menu.defaultProps = {
  mini: false,
  menuStyle: {
    pos: 'absolute',
    bg: 'brand500'
  },
  subMenuPopupStyle: {
    bg: 'brand500'
  },
  optionsStyle: {
    textColor: 'white',
    p: {
      y: '8px',
      x: '0px'
    }
  },
  headersStyle: {
    textSize: 'caption',
    textColor: 'brand300',
    bg: 'brand700'
  },
  logoStyle: {
    textColor: 'gray100',
    bg: 'brand500'
  },
  logo: {
    largeLogo: 'Onpoint',
    smallLogo: 'OP'
  },
  itemsStyle: {
    textColor: 'gray100',
    bg: 'brand500',
    hoverBg: 'brand700'
  },
  iconsStyle: {
    color: 'gray100',
    p: {
      r: '16px'
    }
  },
  options: []
};
var MonochromeMenu = withTheme(Menu);

var _templateObject$m;
var TITLE_MARGIN = '35px';
var HeaderStyled$1 = withTheme(styled.header(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-shadow: 5px 0 8px 0 rgba(0, 0, 0, 0.5);\n"])), function (props) {
  return props.pos && functions.makeResponsive('position', props.pos);
}, function (props) {
  return props.w && functions.makeResponsive('width', props.w);
}, function (props) {
  return props.zIndex && functions.makeResponsive('z-index', props.zIndex);
}, function (props) {
  return props.minH && functions.makeResponsive('min-height', props.minH);
}, function (props) {
  return props.h && functions.makeResponsive('height', props.h);
}, function (props) {
  return props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}));
HeaderStyled$1.defaultProps = {
  pos: 'relative',
  w: '100%'
};
var Header$2 = function Header(_ref) {
  var mini = _ref.mini,
    bg = _ref.bg,
    textColor = _ref.textColor,
    onToggle = _ref.onToggle,
    zIndex = _ref.zIndex,
    rightChildren = _ref.rightChildren,
    theme = _ref.theme,
    leftChildren = _ref.leftChildren,
    headerStyle = _ref.headerStyle;
  return /*#__PURE__*/React.createElement(HeaderStyled$1, _extends({
    bg: bg,
    textColor: textColor,
    zIndex: zIndex,
    minH: theme.application.headerHeight,
    h: theme.application.headerHeight
  }, headerStyle), /*#__PURE__*/React.createElement(Div$1, {
    m: {
      l: mini ? theme.application.miniMenuWidth : theme.application.menuWidth
    },
    minH: theme.application.headerHeight,
    d: "inline-flex",
    justify: "flex-start",
    align: "flex-start"
  }, mini ? /*#__PURE__*/React.createElement(Icon$1, {
    name: "Next",
    color: "shade99",
    cursor: "pointer",
    pos: "relative",
    hoverAnimation: "right-shake",
    onClick: function onClick() {
      return onToggle();
    }
  }) : /*#__PURE__*/React.createElement(Icon$1, {
    name: "Back",
    color: "shade99",
    cursor: "pointer",
    pos: "relative",
    hoverAnimation: "left-shake",
    onClick: function onClick() {
      return onToggle();
    }
  })), leftChildren ? /*#__PURE__*/React.createElement(Div$1, {
    pos: "absolute",
    top: "0",
    left: "0",
    m: {
      l: "calc(".concat(TITLE_MARGIN, " + ").concat(mini ? theme.application.miniMenuWidth : theme.application.menuWidth, ")")
    },
    minH: theme.application.headerHeight,
    d: "inline-flex",
    justify: "flex-start",
    align: "center"
  }, leftChildren) : null, rightChildren ? /*#__PURE__*/React.createElement(Div$1, {
    pos: "absolute",
    top: "0",
    right: "0",
    m: {
      r: '26px'
    },
    minH: theme.application.headerHeight,
    d: "inline-flex",
    justify: "flex-end",
    align: "center"
  }, rightChildren) : null);
};
Header$2.propTypes = {
  theme: PropTypes.shape({
    application: {}
  }).isRequired,
  mini: PropTypes.bool,
  bg: PropTypesRepo.bg,
  textColor: PropTypesRepo.textColor,
  onToggle: PropTypes.func,
  zIndex: PropTypes.string,
  rightChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  leftChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  headerStyle: PropTypes.shape({})
};
Header$2.defaultProps = {
  mini: false,
  bg: 'white',
  textColor: 'brand500',
  onToggle: function onToggle() {
    return null;
  },
  zIndex: '10',
  rightChildren: null,
  leftChildren: null,
  headerStyle: {}
};
var OnpointHeader = withTheme(Header$2);

var _templateObject$n, _templateObject2$6, _templateObject3$5;
var MenuItem$1 = styled.li(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  display: list-item;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n"])));
var MenuLink$1 = withTheme(styled(Link)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: none !important;\n  margin: 0;\n  display: flex;\n  position: absolute;\n  background-color: transparent;\n  align-items: center;\n  top: ", ";\n  ", ";\n  transition: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none !important;\n    text-decoration: none !important;\n    ", ";\n  }\n\n  svg {\n    path {\n      transition: ", ";\n      fill: ", ";\n    }\n    circle {\n      transition: ", ";\n      fill: ", ";\n    }\n  }\n\n  :hover svg {\n    path {\n      fill: ", ";\n    }\n    circle {\n      fill: ", ";\n    }\n  }\n\n  & Div {\n    min-width: 7px;\n    width: 7px;\n    height: ", ";\n    ", ";\n    ", ";\n    ", "\n  }\n"])), function (props) {
  return props.top;
}, function (props) {
  return props.textSize && functions.makeResponsiveFontSize(props.textSize, props.theme.textSize);
}, function (props) {
  return props.theme.transition;
}, function (props) {
  return props.highlighted ? props.hoverBg && functions.makeResponsiveProperty(props.hoverBg, 'background', props.theme.colors) : props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors);
}, function (props) {
  return props.highlighted ? props.hoverTextColor && functions.makeResponsiveProperty(props.hoverTextColor, 'color', props.theme.colors) : props.textColor && functions.makeResponsiveProperty(props.textColor, 'color', props.theme.colors);
}, function (props) {
  return props.highlighted ? functions.makeResponsive('width', props.mini ? "calc(".concat(props.theme.application.miniMenuWidth, " + ").concat(props.theme.application.menuAdditionalWidth, ")") : "calc(".concat(props.theme.application.menuWidth, " + ").concat(props.theme.application.menuAdditionalWidth, ")")) : functions.makeResponsive('width', props.mini ? props.theme.application.miniMenuWidth : props.theme.application.menuWidth);
}, function (props) {
  return props.highlighted ? functions.makeResponsive('border-radius', '0 4px 4px 0') : functions.makeResponsive('border-radius', '0px');
}, function (props) {
  return props.hoverTextColor && functions.makeResponsiveProperty(props.hoverTextColor, 'color', props.theme.colors);
}, function (props) {
  return props.theme.transition;
}, function (props) {
  return props.highlighted ? props.theme.colors[props.hoverTextColor] : props.theme.colors[props.textColor];
}, function (props) {
  return props.theme.transition;
}, function (props) {
  return props.highlighted ? props.theme.colors[props.hoverTextColor] : props.theme.colors[props.textColor];
}, function (props) {
  return props.theme.colors[props.hoverTextColor];
}, function (props) {
  return props.theme.colors[props.hoverTextColor];
}, function (props) {
  return props.theme.application.menuHeight;
}, function () {
  return functions.findDirection('border', {
    t: '1px solid'
  });
}, function (props) {
  return props.highlighted ? functions.makeResponsive('border-color', props.theme.colors[props.hoverBg]) : functions.makeResponsive('border-color', props.theme.colors[props.bg]);
}, function (props) {
  return props.hoverBg && functions.makeResponsiveProperty(props.hoverBg, 'background', props.theme.colors);
}));
var Options$1 = withTheme(styled.ul(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n\n  &:hover {\n    overflow: visible;\n  }\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.p && functions.findDirection('padding', props.p);
}, function (props) {
  return props.m && functions.findDirection('margin', props.m);
}, function (props) {
  return props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor]);
}));
var Menu$1 = function Menu(_ref) {
  var mini = _ref.mini,
    menuStyle = _ref.menuStyle,
    optionsStyle = _ref.optionsStyle,
    itemsStyle = _ref.itemsStyle,
    logo = _ref.logo,
    logoStyle = _ref.logoStyle,
    iconsStyle = _ref.iconsStyle,
    options = _ref.options,
    theme = _ref.theme,
    footerLogo = _ref.footerLogo,
    footerStyle = _ref.footerStyle,
    isHighlighted = _ref.isHighlighted;
  var location = useLocation();
  return /*#__PURE__*/React.createElement(Div$1, _extends({
    top: "0",
    left: "0",
    minH: "100%",
    h: "100%",
    minW: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    w: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    transition: theme.application.menuTransition
  }, menuStyle), /*#__PURE__*/React.createElement(Options$1, optionsStyle, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Div$1, _extends({
    minW: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    w: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
    minH: theme.application.headerHeight,
    h: theme.application.headerHeight,
    d: "inline-flex",
    justify: "center",
    align: "center"
  }, logoStyle), /*#__PURE__*/React.createElement(Div$1, {
    tag: "span"
  }, mini ? logo.smallLogo : logo.largeLogo))), options.map(function (option, index) {
    return {
      ITEM: /*#__PURE__*/React.createElement(MenuItem$1, null, index === 0 ? /*#__PURE__*/React.createElement(Div$1, {
        w: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
        h: "1px",
        bg: "black",
        pos: "absolute",
        top: "calc(".concat(theme.application.headerHeight, " + 0px)")
      }) : null, /*#__PURE__*/React.createElement(MenuLink$1, _extends({
        highlighted: option.isHighlighted ? option.isHighlighted(location.pathname, option.link) : isHighlighted(location.pathname, option.link),
        mini: mini
      }, itemsStyle, {
        hoverBg: option.color,
        top: "calc(".concat(theme.application.headerHeight, " + (").concat(index, " * (").concat(theme.application.menuHeight, " + 1px) + 1px))"),
        to: option.link
      }), /*#__PURE__*/React.createElement(Div$1, null), /*#__PURE__*/React.createElement(Icon$1, _extends({
        name: option.icon,
        viewBox: option.iconViewBox
      }, iconsStyle, option.iconsStyle)), !mini ? /*#__PURE__*/React.createElement(Text$1, {
        textSize: "body"
      }, option.name) : null), /*#__PURE__*/React.createElement(Div$1, {
        w: mini ? theme.application.miniMenuWidth : theme.application.menuWidth,
        h: "1px",
        bg: "black",
        pos: "absolute",
        top: "calc(".concat(theme.application.headerHeight, " + (").concat(index, " * (").concat(theme.application.menuHeight, " + 1px)) + ").concat(theme.application.menuHeight, ")")
      }))
    }[option.type];
  })), /*#__PURE__*/React.createElement(Div$1, _extends({
    bottom: "0",
    left: "0",
    w: "100%",
    textColor: "white",
    d: "inline-flex",
    justify: "center",
    align: "center"
  }, _objectSpread2(_objectSpread2(_objectSpread2({}, menuStyle), footerStyle), {}, {
    zIndex: (menuStyle.zIndex || 10) + 1
  })), footerLogo));
};
Menu$1.propTypes = {
  theme: PropTypes.shape({
    application: {}
  }).isRequired,
  mini: PropTypes.bool,
  menuStyle: PropTypes.shape({
    zIndex: PropTypes.number
  }),
  optionsStyle: PropTypes.shape({}),
  iconsStyle: PropTypes.shape({}),
  itemsStyle: PropTypes.shape({}),
  logoStyle: PropTypes.shape({}),
  logo: PropTypes.shape({
    largeLogo: PropTypes.node,
    smallLogo: PropTypes.node
  }),
  footerLogo: PropTypes.node,
  footerStyle: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf(['HEADER', 'ITEM']),
    icon: PropTypes.string,
    link: PropTypes.string,
    iconsStyle: PropTypes.shape({})
  })),
  isHighlighted: PropTypes.func
};
Menu$1.defaultProps = {
  mini: false,
  menuStyle: {
    pos: 'absolute',
    bg: 'shade33',
    zIndex: 10
  },
  optionsStyle: {
    textColor: 'white',
    p: {
      y: '1px',
      x: '0px'
    }
  },
  logoStyle: {
    textColor: 'shade99',
    bg: 'shade33'
  },
  logo: {
    largeLogo: 'Onpoint',
    smallLogo: 'OP'
  },
  itemsStyle: {
    textColor: 'shade99',
    hoverTextColor: 'white',
    bg: 'shade33'
  },
  iconsStyle: {
    p: {
      l: '13px',
      r: '16px'
    },
    size: '18px'
  },
  footerLogo: null,
  footerStyle: {},
  options: [],
  isHighlighted: function isHighlighted(pathname, link) {
    return pathname === link;
  }
};
var OnpointMenu = withTheme(Menu$1);

var _excluded$m = ["children"],
  _excluded2$1 = ["children"];
var Application = function Application(_ref) {
  var minH = _ref.minH,
    minW = _ref.minW,
    _ref$header = _ref.header,
    headerChildren = _ref$header.children,
    headerRest = _objectWithoutProperties(_ref$header, _excluded$m),
    _ref$content = _ref.content,
    contentChildren = _ref$content.children,
    contentRest = _objectWithoutProperties(_ref$content, _excluded2$1),
    menu = _ref.menu,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement(Div$1, {
    minH: minH,
    h: "100%",
    minW: minW,
    w: "100%",
    pos: "relative"
  }, variant === 'monochrome' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MonochromeHeader, headerRest, headerChildren), /*#__PURE__*/React.createElement(MonochromeMenu, menu)), variant === 'onpoint' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OnpointHeader, headerRest, headerChildren), /*#__PURE__*/React.createElement(OnpointMenu, menu)), /*#__PURE__*/React.createElement(Content$1, contentRest, contentChildren));
};
Application.propTypes = {
  header: PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  }),
  content: PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    contentStyle: PropTypes.shape({})
  }),
  menu: PropTypes.shape({}),
  minH: PropTypesRepo.minH,
  minW: PropTypesRepo.minW,
  variant: PropTypes.oneOf(['onpoint', 'monochrome'])
};
Application.defaultProps = {
  header: {
    children: null
  },
  content: {
    children: null,
    contentStyle: {}
  },
  menu: {},
  minH: '100vh',
  minW: '100vw',
  variant: 'onpoint'
};
var Application$1 = withTheme(Application);

var MessageAlerts = function MessageAlerts(_ref) {
  var messages = _ref.messages,
    onSnooze = _ref.onSnooze,
    onAction = _ref.onAction,
    buttonCloseText = _ref.buttonCloseText,
    buttonOpenText = _ref.buttonOpenText,
    noMessagesCopy = _ref.noMessagesCopy,
    showUnreadMessageCount = _ref.showUnreadMessageCount;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Collapse, {
    isOpen: isOpen,
    pos: "fixed",
    bottom: "24px",
    right: "32px",
    flexDir: "column",
    bg: "brand100",
    w: "640px",
    shadow: "5",
    rounded: "md"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, messages.length > 0 ? messages.map(function (message, index) {
    return /*#__PURE__*/React.createElement(Div$1, {
      p: {
        x: '16px',
        y: '8px'
      }
    }, /*#__PURE__*/React.createElement(Text$1, {
      p: {
        b: '8px'
      },
      textSize: "subheader"
    }, message), /*#__PURE__*/React.createElement(Div$1, {
      d: "flex",
      justify: "space-between"
    }, /*#__PURE__*/React.createElement(Button$1, {
      onClick: function onClick() {
        return onSnooze(index);
      },
      bg: "gray200",
      textColor: "medium",
      m: {
        r: '16px'
      },
      h: "24px"
    }, "Snooze"), /*#__PURE__*/React.createElement(Button$1, {
      onClick: function onClick() {
        return onAction(index);
      },
      bg: "info700",
      h: "24px"
    }, "Take Action")));
  }) : /*#__PURE__*/React.createElement(Text$1, {
    textSize: "subheader"
  }, noMessagesCopy))), /*#__PURE__*/React.createElement(Button$1, {
    pos: "fixed",
    bottom: "0px",
    right: "32px",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    rounded: {
      tl: 'md',
      tr: 'md'
    },
    h: "40px",
    w: "128px",
    shadow: "3",
    bg: "brand500"
  }, isOpen ? buttonCloseText : showUnreadMessageCount && messages.length ? "".concat(buttonOpenText, "(").concat(messages.length, ")") : buttonOpenText));
};
MessageAlerts.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSnooze: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  buttonOpenText: PropTypes.string,
  buttonCloseText: PropTypes.string,
  noMessagesCopy: PropTypes.string,
  showUnreadMessageCount: PropTypes.bool
};
MessageAlerts.defaultProps = {
  buttonOpenText: 'Messages',
  buttonCloseText: 'Hide',
  noMessagesCopy: 'You have no unread messages',
  showUnreadMessageCount: true
};

var _excluded$n = ["children"],
  _excluded2$2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children", "subRowExpanderCell", "depth"],
  _excluded5 = ["getTableProps", "getTableBodyProps", "headerGroups", "rows", "prepareRow", "onRowClick", "onRowSelect", "onRowDeselect", "onRowExpand", "hasExpansion", "numCols", "paginate", "canPreviousPage", "canNextPage", "pageOptions", "pageCount", "gotoPage", "nextPage", "previousPage", "setPageSize", "state", "widths"],
  _excluded6 = ["subRowsColsIndentIndexes"],
  _excluded7 = ["columns", "data", "gridState", "controlledGridState", "onRowClick", "onRowSelect", "onRowDeselect", "onRowExpand", "hasGlobalFilter", "hasSelection", "enableSelection", "selectionTooltip", "hasExpansion", "setGridState", "subRowsColsIndentIndexes", "paginate", "widths"];
var _templateObject$o, _templateObject2$7, _templateObject3$6, _templateObject4$3, _templateObject5$3;

/* eslint-disable react/prop-types */

var GlobalFilter = function GlobalFilter(_ref) {
  var globalFilter = _ref.globalFilter,
    setGlobalFilter = _ref.setGlobalFilter;
  return /*#__PURE__*/React.createElement(Div$1, {
    w: "25rem",
    d: "flex",
    align: "center",
    justify: "center",
    m: "auto",
    p: {
      t: '1.25rem',
      b: '0'
    }
  }, /*#__PURE__*/React.createElement(Input$1, {
    p: {
      x: '1.5rem',
      y: '.5rem'
    },
    h: "1.875rem",
    type: "text",
    name: "filter",
    value: globalFilter || '',
    onChange: function onChange(e) {
      setGlobalFilter(e.target.value || undefined);
    },
    rounded: {
      l: 'sm'
    },
    suffix: /*#__PURE__*/React.createElement(Button$1, {
      h: "1.875rem",
      rounded: {
        r: 'sm'
      },
      bg: "brand500",
      hoverBg: "brand600"
    }, /*#__PURE__*/React.createElement(Icon$1, {
      name: "Search",
      color: "white"
    }))
  }));
};
var SelectColumn = {
  id: 'selection',
  groupByBoundary: true,
  disableSortBy: true,
  Header: function Header() {
    return /*#__PURE__*/React.createElement(Div$1, null);
  },
  Cell: function Cell(_ref2) {
    var row = _ref2.row;
    var _row$getToggleRowSele = row.getToggleRowSelectedProps(),
      checked = _row$getToggleRowSele.checked,
      selectionTooltip = _row$getToggleRowSele.selectionTooltip,
      enableSelection = _row$getToggleRowSele.enableSelection;
    var isEnabled = enableSelection(row);
    return /*#__PURE__*/React.createElement(Div$1, {
      w: "100%",
      d: "flex",
      align: "center",
      justify: "center",
      "data-tip": selectionTooltip(row),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (isEnabled) {
          var _row$getToggleRowSele2 = row.getToggleRowSelectedProps(),
            _checked = _row$getToggleRowSele2.checked,
            onRowSelect = _row$getToggleRowSele2.onRowSelect,
            onRowDeselect = _row$getToggleRowSele2.onRowDeselect;
          if (!_checked) {
            onRowSelect(row);
          } else {
            onRowDeselect(row);
          }
        }
      }
    }, /*#__PURE__*/React.createElement(Label, {
      cursor: isEnabled ? 'pointer' : 'not-allowed'
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: checked,
      size: ".75rem",
      disabled: !isEnabled
    })));
  }
};
var ExpanderColumn = {
  id: 'expander',
  disableSortBy: true,
  Header: function Header(_ref3) {
    var getToggleAllRowsExpandedProps = _ref3.getToggleAllRowsExpandedProps,
      isAllRowsExpanded = _ref3.isAllRowsExpanded;
    return /*#__PURE__*/React.createElement(Div$1, _extends({
      tag: "span",
      p: {
        x: '1em'
      },
      "data-tip": isAllRowsExpanded ? 'Close expanded rows' : 'Expand all rows'
    }, getToggleAllRowsExpandedProps()), isAllRowsExpanded ? /*#__PURE__*/React.createElement(Icon$1, {
      name: "ArrowDown",
      color: "tabSelected",
      size: ".75rem"
    }) : /*#__PURE__*/React.createElement(Icon$1, {
      name: "ArrowRight",
      color: "tabSelected",
      size: ".75rem"
    }));
  },
  Cell: function Cell(_ref4) {
    var row = _ref4.row;
    return row.canExpand ? /*#__PURE__*/React.createElement(Div$1, _extends({
      className: "expander",
      d: "flex",
      align: "center",
      justify: "center",
      w: "100%"
      // p={{ x: '1em' }}
      ,
      m: ".125rem"
    }, row.getToggleRowExpandedProps(), {
      onClick: function onClick(e) {
        var _row$getToggleRowExpa = row.getToggleRowExpandedProps(),
          _onClick = _row$getToggleRowExpa.onClick;
        e.preventDefault();
        e.stopPropagation();
        _onClick(e);
      }
    }), row.isExpanded ? /*#__PURE__*/React.createElement(Icon$1, {
      name: "ArrowDown",
      color: "tabSelected",
      size: ".75rem"
    }) : /*#__PURE__*/React.createElement(Icon$1, {
      name: "ArrowRight",
      color: "tabSelected",
      size: ".75rem"
    })) : /*#__PURE__*/React.createElement(Div$1, {
      w: "100%",
      h: "100%"
    });
  }
};
var STATES = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
};
var AutocompleteEditableCell = function AutocompleteEditableCell(_ref5) {
  var initialValue = _ref5.value,
    row = _ref5.row,
    original = _ref5.row.original,
    _ref5$column = _ref5.column,
    onEdit = _ref5$column.onEdit,
    Cell = _ref5$column.Cell,
    isEditable = _ref5$column.isEditable,
    options = _ref5$column.options;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEdit = _useState2[0],
    setEdit = _useState2[1];
  var _useState3 = useState(initialValue),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var onSelection = function onSelection(index) {
    setValue(options[index]);
  };
  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Autocomplete$1, {
    isOpen: isOpen,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    menu: options,
    value: value,
    onSelection: onSelection
  }), /*#__PURE__*/React.createElement(Div$1, {
    d: "flex",
    flexDir: "column-reverse",
    justify: "flex-start"
  }, /*#__PURE__*/React.createElement(Div$1, {
    m: {
      y: '0',
      x: '.125rem'
    },
    h: "1rem",
    w: "1rem",
    border: "1px solid",
    borderColor: "tabRest",
    p: "0",
    rounded: "sm"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    m: "0",
    size: "1rem",
    name: "Checked",
    cursor: "pointer",
    color: "tabRest",
    onClick: function onClick() {
      if (onEdit) {
        onEdit(original, value);
      }
      setEdit(false);
    }
  })), /*#__PURE__*/React.createElement(Div$1, {
    d: "none",
    h: "1rem",
    w: "1rem",
    p: "0",
    m: "1px",
    border: "1px solid",
    borderColor: "tabRest",
    rounded: "sm"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    m: "0",
    size: "1rem",
    name: "Cross",
    cursor: "pointer",
    color: "tabRest",
    onClick: function onClick() {
      setEdit(false);
    }
  })))) : isEditable === STATES.DISABLED ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, {
    p: "0",
    rounded: "sm",
    m: {
      y: '.125rem',
      r: '.25rem',
      l: '.125rem'
    }
  }, /*#__PURE__*/React.createElement(Icon$1, {
    m: "0",
    size: ".5rem",
    name: "DownArrow",
    cursor: "not-allowed",
    color: "tabRest"
  })), /*#__PURE__*/React.createElement(Cell, {
    value: value,
    row: row
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, {
    h: "1.5rem",
    w: "1.5rem",
    p: "0",
    rounded: "sm",
    m: {
      y: '.125rem',
      r: '.25rem',
      l: '.125rem'
    }
  }, /*#__PURE__*/React.createElement(Icon$1, {
    size: ".5rem",
    p: ".5rem",
    name: "DownArrow",
    cursor: "pointer",
    color: "tabSelected",
    onClick: function onClick() {
      setEdit(true);
    },
    "data-tip": "Choose"
  })), /*#__PURE__*/React.createElement(Cell, {
    value: value,
    row: row
  })));
};
var EditableCell = function EditableCell(_ref6) {
  var initialValue = _ref6.value,
    row = _ref6.row,
    original = _ref6.row.original,
    _ref6$column = _ref6.column,
    onEdit = _ref6$column.onEdit,
    Cell = _ref6$column.Cell,
    isEditable = _ref6$column.isEditable,
    colId = _ref6$column.id;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isEdit = _useState8[0],
    setEdit = _useState8[1];
  var _useState9 = useState(initialValue),
    _useState10 = _slicedToArray(_useState9, 2),
    value = _useState10[0],
    setValue = _useState10[1];
  var onChange = function onChange(e) {
    setValue(e.target.value);
  };
  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input$1, {
    value: value,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Div$1, {
    d: "flex",
    flexDir: "column"
  }, /*#__PURE__*/React.createElement(Div$1, {
    m: "1px",
    h: "1rem",
    w: "1rem",
    border: "1px solid",
    borderColor: "tabRest",
    p: "0",
    rounded: "sm"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    m: "0",
    size: "1rem",
    name: "Checked",
    cursor: "pointer",
    color: "tabSelected",
    onClick: function onClick() {
      if (onEdit) {
        onEdit(original, value);
      }
      setEdit(false);
    }
  })))) : isEditable === STATES.DISABLED ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, {
    h: "1.5rem",
    w: "1.5rem",
    rounded: "sm",
    m: {
      r: '.375rem'
    },
    d: "flex",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    name: "Edit",
    cursor: "not-allowed",
    color: "tabDisabled",
    size: ".75rem",
    hoverTransform: "scale(1.25)"
  })), /*#__PURE__*/React.createElement(Cell, {
    value: value,
    row: row
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div$1, {
    h: "1.5rem",
    w: "1.5rem",
    rounded: "sm",
    m: {
      r: '.375rem'
    },
    d: "flex",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    name: "Edit",
    cursor: "pointer",
    color: "lightGrey",
    "data-tip": "Edit ".concat(colId),
    size: ".75rem",
    hoverTransform: "scale(1.25)",
    onClick: function onClick() {
      setEdit(true);
    }
  })), /*#__PURE__*/React.createElement(Cell, {
    value: value,
    row: row
  })));
};
var getHeaderProps = function getHeaderProps(props, _ref7) {
  var column = _ref7.column;
  return [props, {
    justify: column.justify || 'center',
    p: column.padding || {}
  }];
};
var getCellProps = function getCellProps(props, _ref8) {
  var cell = _ref8.cell;
  return [props, {
    justify: cell.column.cellJustify || 'flex-start',
    p: cell.column.cellPadding || {}
  }];
};
var BaseStyledHeader = function BaseStyledHeader(props) {
  return /*#__PURE__*/React.createElement(Div$1, _extends({}, props, {
    tag: "tr"
  }));
};
var StyledHeader = styled(BaseStyledHeader)(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  & > th:first-child {\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n  }\n  & > th:last-child {\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n  }\n"])));
var StyledTableHeadingCell = function StyledTableHeadingCell(props) {
  return /*#__PURE__*/React.createElement(Div$1, _extends({}, props, {
    tag: "th"
  }));
};
var TableHeadingCell = function TableHeadingCell(_ref9) {
  var children = _ref9.children,
    rest = _objectWithoutProperties(_ref9, _excluded$n);
  return /*#__PURE__*/React.createElement(StyledTableHeadingCell, _extends({
    d: "flex",
    align: "center",
    justify: "center",
    bg: "secondary",
    textColor: "black",
    textSize: "subtitle",
    textWeight: "600",
    h: "2.25rem",
    p: {
      y: '1rem',
      x: '1rem'
    },
    m: {
      b: '.625rem'
    },
    textTransform: "capitalize"
  }, rest), children);
};
var BaseStyledRow = function BaseStyledRow(props) {
  return /*#__PURE__*/React.createElement(Div$1, _extends({}, props, {
    tag: "tr"
  }));
};
var StyledRow = styled(BaseStyledRow)(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  & > td {\n    background-color: white;\n  }\n  tr.sub-row + &.row > td {\n    margin-top: 1rem;\n  }\n  tbody > &.row > td {\n    border-top: 1px solid #e6e6e6;\n  }\n  tr.row + &.row > td {\n    border-top: 1px solid #e6e6e6;\n  }\n"])));
var StyledSubRow = styled(BaseStyledRow)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  tr.row + &.sub-row > td {\n    margin-top: 1rem;\n  }\n  & > td:nth-child(2) {\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n  }\n  & > td:last-child {\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n  }\n"])));
var StyledBottomBorderShell = styled(Div$1)(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  display: contents;\n  .sub-row + & > .bottomBorder {\n    margin-top: 1rem;\n  }\n"])));
var StyledBottomBorder = styled(Div$1)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 1px;\n  background-color: #e6e6e6;\n"])));
var Row$2 = function Row(_ref10) {
  var children = _ref10.children,
    rest = _objectWithoutProperties(_ref10, _excluded2$2);
  return /*#__PURE__*/React.createElement(StyledRow, _extends({
    className: "row",
    d: "contents"
  }, rest), children);
};
var SubRow = function SubRow(_ref11) {
  var children = _ref11.children,
    rest = _objectWithoutProperties(_ref11, _excluded3);
  return /*#__PURE__*/React.createElement(StyledSubRow, _extends({
    className: "sub-row",
    d: "contents"
  }, rest), children);
};
var StyledCell = function StyledCell(props) {
  return /*#__PURE__*/React.createElement(Div$1, _extends({}, props, {
    tag: "td"
  }));
};
var Cell = function Cell(_ref12) {
  var children = _ref12.children,
    subRowExpanderCell = _ref12.subRowExpanderCell,
    depth = _ref12.depth,
    rest = _objectWithoutProperties(_ref12, _excluded4);
  return /*#__PURE__*/React.createElement(StyledCell, _extends({
    d: "flex",
    align: "center",
    justify: "flex-start",
    textColor: "black",
    textSize: "subtitle",
    textWeight: "400",
    bg: subRowExpanderCell ? 'white' : 'secondary',
    border: {
      b: '1px solid'
    },
    borderColor: "white",
    h: "1.875rem",
    p: {
      x: '.5rem'
    }
  }, rest), children);
};
var Pagination = function Pagination(_ref13) {
  var canPreviousPage = _ref13.canPreviousPage,
    canNextPage = _ref13.canNextPage,
    pageOptions = _ref13.pageOptions,
    pageCount = _ref13.pageCount,
    gotoPage = _ref13.gotoPage,
    nextPage = _ref13.nextPage,
    previousPage = _ref13.previousPage,
    setPageSize = _ref13.setPageSize,
    pageIndex = _ref13.pageIndex,
    pageSize = _ref13.pageSize,
    menuDirection = _ref13.menuDirection;
  var _useState11 = useState(pageIndex + 1),
    _useState12 = _slicedToArray(_useState11, 2),
    page = _useState12[0],
    setPage = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isOpen = _useState14[0],
    setIsOpen = _useState14[1];
  var RECORDS = ['10', '20', '30', '40', '50'];
  return /*#__PURE__*/React.createElement(Div$1, {
    d: "flex",
    justify: "space-between",
    align: "center",
    p: {
      b: '1.5rem',
      t: '.5rem',
      x: '1.5rem'
    }
  }, /*#__PURE__*/React.createElement(Div$1, {
    d: "flex",
    m: {
      x: '-.5rem'
    }
  }, /*#__PURE__*/React.createElement(Button$1, {
    bg: "brand500",
    hoverBg: "brand600",
    m: {
      x: '.5rem'
    },
    h: "1.875rem",
    disabled: !canPreviousPage,
    onClick: function onClick() {
      gotoPage(0);
    },
    "data-tip": "first"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    color: "white",
    name: "Back"
  })), /*#__PURE__*/React.createElement(Button$1, {
    bg: "brand500",
    hoverBg: "brand600",
    m: {
      x: '.5rem'
    },
    h: "1.875rem",
    disabled: !canPreviousPage,
    onClick: function onClick() {
      previousPage();
    },
    "data-tip": "previous"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    color: "white",
    name: "LeftArrow"
  })), /*#__PURE__*/React.createElement(Div$1, {
    m: {
      x: '.5rem'
    },
    d: "flex",
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Text$1, {
    textSize: "body"
  }, "Page ".concat(pageIndex + 1, " of ").concat(pageOptions.length))), /*#__PURE__*/React.createElement(Button$1, {
    textColor: "white",
    bg: "brand500",
    hoverBg: "brand600",
    m: {
      x: '.5rem'
    },
    h: "1.875rem",
    disabled: !canNextPage,
    onClick: function onClick() {
      nextPage();
    },
    "data-tip": "next"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    color: "white",
    name: "RightArrow"
  })), /*#__PURE__*/React.createElement(Button$1, {
    bg: "brand500",
    hoverBg: "brand600",
    m: {
      x: '.5rem'
    },
    h: "1.875rem",
    disabled: !canNextPage,
    onClick: function onClick() {
      gotoPage(pageCount - 1);
    },
    "data-tip": "last"
  }, /*#__PURE__*/React.createElement(Icon$1, {
    color: "white",
    name: "Next"
  }))), /*#__PURE__*/React.createElement(Div$1, {
    d: "flex",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text$1, {
    p: {
      x: '.5rem'
    },
    textSize: "body"
  }, "Go To Page"), /*#__PURE__*/React.createElement(Input$1, {
    w: "4rem",
    h: "1.875rem",
    type: "number",
    value: page,
    onChange: function onChange(e) {
      setPage(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Button$1, {
    bg: "brand500",
    hoverBg: "brand600",
    m: {
      x: '.5rem'
    },
    h: "1.875rem",
    disabled: Number(page) < 0 || Number(page) > pageCount,
    onClick: function onClick() {
      gotoPage(Number(page) - 1);
    },
    "data-tip": "jump"
  }, /*#__PURE__*/React.createElement(Text$1, {
    textSize: "body",
    color: "white"
  }, "Go"))), /*#__PURE__*/React.createElement(Div$1, {
    d: "flex",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text$1, {
    textSize: "body",
    p: {
      r: '.5rem'
    }
  }, "Show"), /*#__PURE__*/React.createElement(Autocomplete$1, {
    w: "12.5rem",
    h: "1.875rem",
    hoverBg: "gray200",
    focusBg: "gray200",
    bg: "white",
    isOpen: isOpen,
    value: pageSize.toString(),
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    DropdownButtonOptions: {
      h: '1.875rem'
    },
    inputStyle: {
      h: 'calc(1.875rem-1px)'
    },
    menuOptions: {
      pos: 'absolute',
      shadow: 4,
      minW: '100%',
      rounded: 'sm',
      maxH: '15rem',
      bg: 'white',
      overflow: 'auto'
    },
    DivOptions: {
      bg: 'white'
    },
    direction: menuDirection !== null && menuDirection !== void 0 ? menuDirection : 'topright',
    menu: RECORDS,
    onSelection: function onSelection(index) {
      setPageSize(RECORDS[index]);
    }
  }), /*#__PURE__*/React.createElement(Text$1, {
    p: {
      l: '.5rem'
    },
    textSize: "body"
  }, "records per page")));
};
var StyledTable = function StyledTable(props) {
  return /*#__PURE__*/React.createElement(Div$1, _extends({}, props, {
    tag: "table"
  }));
};
var TableComponent = function TableComponent(_ref14) {
  var getTableProps = _ref14.getTableProps,
    getTableBodyProps = _ref14.getTableBodyProps,
    headerGroups = _ref14.headerGroups,
    rows = _ref14.rows,
    prepareRow = _ref14.prepareRow,
    onRowClick = _ref14.onRowClick,
    onRowSelect = _ref14.onRowSelect,
    onRowDeselect = _ref14.onRowDeselect,
    onRowExpand = _ref14.onRowExpand,
    hasExpansion = _ref14.hasExpansion,
    numCols = _ref14.numCols,
    paginate = _ref14.paginate,
    canPreviousPage = _ref14.canPreviousPage,
    canNextPage = _ref14.canNextPage,
    pageOptions = _ref14.pageOptions,
    pageCount = _ref14.pageCount,
    gotoPage = _ref14.gotoPage,
    nextPage = _ref14.nextPage,
    previousPage = _ref14.previousPage,
    setPageSize = _ref14.setPageSize,
    state = _ref14.state,
    widths = _ref14.widths,
    rest = _objectWithoutProperties(_ref14, _excluded5);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTable, _extends({}, getTableProps(), {
    d: "grid",
    justify: "left",
    align: "center",
    minW: "100%",
    p: {
      y: '1.25rem'
    },
    overflow: "auto",
    style: {
      gridTemplateColumns: widths || "repeat(".concat(numCols || '1fr', ", 1fr)")
    }
  }, rest), /*#__PURE__*/React.createElement("thead", {
    style: {
      display: 'contents'
    }
  }, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement(StyledHeader, _extends({
      className: "header"
    }, headerGroup.getHeaderGroupProps(), {
      style: {
        display: 'contents'
      }
    }), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/React.createElement(TableHeadingCell, _extends({}, column.getHeaderProps(column.getSortByToggleProps()), {
        onClick: function onClick() {
          var _column$toggleSortBy;
          return (_column$toggleSortBy = column.toggleSortBy) === null || _column$toggleSortBy === void 0 ? void 0 : _column$toggleSortBy.call(column, !column.isSortedDesc);
        }
      }), column.render('Header'), !column.disableSortBy ? /*#__PURE__*/React.createElement(Div$1, {
        d: "flex",
        flexDir: "column",
        m: {
          l: '.4rem'
        }
      }, /*#__PURE__*/React.createElement(Icon$1, {
        size: ".5rem",
        name: "Play",
        transform: "rotate(-90deg)",
        color: column.isSorted ? column.isSortedDesc ? 'tabRest' : 'tabSelected' : 'tabRest'
      }), /*#__PURE__*/React.createElement(Icon$1, {
        size: ".5rem",
        name: "Play",
        transform: "rotate(90deg)",
        color: column.isSorted ? !column.isSortedDesc ? 'tabRest' : 'tabSelected' : 'tabRest'
      })) : '');
    }));
  })), /*#__PURE__*/React.createElement("tbody", _extends({
    style: {
      display: 'contents'
    }
  }, getTableBodyProps()), rows.map(function (row) {
    prepareRow(row);
    var isSubRow = row.depth !== 0;
    var additionalProps = {};
    if (isSubRow) {
      var _row$id$split$map = row.id.split('.').map(function (id) {
          return parseInt(id, 10);
        }),
        _row$id$split$map2 = _slicedToArray(_row$id$split$map, 2),
        parentRowId = _row$id$split$map2[0],
        childRowId = _row$id$split$map2[1];
      var numSubRows = rows[parentRowId].subRows.length;
      var firstRow = childRowId === 0;
      var lastRow = childRowId === numSubRows - 1;
      additionalProps.firstRow = firstRow;
      additionalProps.lastRow = lastRow;
    }
    var Component = isSubRow ? SubRow : Row$2;
    return /*#__PURE__*/React.createElement(Component, _extends({
      onClick: function onClick() {}
    }, row.getRowProps(), {
      depth: row.depth
    }, additionalProps), row.cells.map(function (cell, i) {
      var _cell$getCellProps = cell.getCellProps([{
          style: cell.column.style
        }]),
        subRowsColsIndentIndexes = _cell$getCellProps.subRowsColsIndentIndexes,
        cellProps = _objectWithoutProperties(_cell$getCellProps, _excluded6);
      var _cell$column = cell.column,
        options = _cell$column.options,
        isEditable = _cell$column.isEditable;
      return /*#__PURE__*/React.createElement(Cell, _extends({}, cellProps, {
        depth: subRowsColsIndentIndexes.includes(i) ? row.depth : 0,
        subRowExpanderCell: isSubRow && i === 0
      }), isEditable ? options ? cell.render('AutocompleteEditableCell') : cell.render('EditableCell') : cell.render('Cell'));
    }));
  }), /*#__PURE__*/React.createElement(StyledBottomBorderShell, {
    className: "bottomBorderShell"
  }, new Array(numCols).fill(true).map(function () {
    return /*#__PURE__*/React.createElement(StyledBottomBorder, {
      className: "bottomBorder"
    });
  })))), paginate ? /*#__PURE__*/React.createElement(Pagination, {
    canPreviousPage: canPreviousPage,
    canNextPage: canNextPage,
    pageOptions: pageOptions,
    pageCount: pageCount,
    gotoPage: gotoPage,
    nextPage: nextPage,
    previousPage: previousPage,
    setPageSize: setPageSize,
    pageIndex: state.pageIndex,
    pageSize: state.pageSize
  }) : null);
};
var Table = function Table(_ref15) {
  var columns = _ref15.columns,
    data = _ref15.data,
    gridState = _ref15.gridState,
    controlledGridState = _ref15.controlledGridState,
    _onRowClick = _ref15.onRowClick,
    _onRowSelect = _ref15.onRowSelect,
    _onRowDeselect = _ref15.onRowDeselect,
    onRowExpand = _ref15.onRowExpand,
    hasGlobalFilter = _ref15.hasGlobalFilter,
    hasSelection = _ref15.hasSelection,
    _enableSelection = _ref15.enableSelection,
    _selectionTooltip = _ref15.selectionTooltip,
    hasExpansion = _ref15.hasExpansion,
    setGridState = _ref15.setGridState,
    subRowsColsIndentIndexes = _ref15.subRowsColsIndentIndexes,
    paginate = _ref15.paginate,
    widths = _ref15.widths,
    rest = _objectWithoutProperties(_ref15, _excluded7);
  var _useTable = useTable({
      columns: columns,
      data: data,
      defaultColumn: {
        EditableCell: EditableCell,
        AutocompleteEditableCell: AutocompleteEditableCell
      },
      selectSubRows: false,
      initialState: gridState,
      stateReducer: function stateReducer(_state) {
        var expanded = _state.expanded;
        var newState = _objectSpread2(_objectSpread2({}, _state), controlledGridState);
        var anyRowOpen = Object.keys(expanded).map(function (key) {
          return expanded[key];
        }).some(function (elem) {
          return elem;
        });
        onRowExpand(anyRowOpen);
        setGridState(newState);
        return newState;
      },
      useControlledState: function useControlledState(_state) {
        return useMemo(function () {
          return _objectSpread2(_objectSpread2({}, _state), controlledGridState);
        }, [_state, controlledGridState]);
      }
    }, useGlobalFilter, useSortBy, useExpanded, usePagination, useRowSelect, function (hooks) {
      hooks.getToggleRowSelectedProps.push({
        onRowSelect: function onRowSelect(row) {
          _onRowSelect(row);
        },
        onRowDeselect: function onRowDeselect(row) {
          _onRowDeselect(row);
        },
        enableSelection: function enableSelection(row) {
          return _enableSelection(row);
        },
        selectionTooltip: function selectionTooltip(row) {
          return _selectionTooltip(row);
        }
      });
      if (hasSelection) {
        hooks.visibleColumns.push(function (_columns) {
          var hasExpander = _columns[0].id === 'expander';
          if (hasExpander) {
            var _columns2 = _toArray(_columns),
              expanderColumn = _columns2[0],
              _rest = _columns2.slice(1);
            return [expanderColumn, SelectColumn].concat(_toConsumableArray(_rest));
          }
          return [SelectColumn].concat(_toConsumableArray(_columns));
        });
      }
      hooks.getCellProps.push(getCellProps);
      hooks.getCellProps.push({
        subRowsColsIndentIndexes: subRowsColsIndentIndexes
      });
      hooks.getHeaderProps.push(getHeaderProps);
    }),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    page = _useTable.page,
    prepareRow = _useTable.prepareRow,
    canPreviousPage = _useTable.canPreviousPage,
    canNextPage = _useTable.canNextPage,
    pageOptions = _useTable.pageOptions,
    pageCount = _useTable.pageCount,
    gotoPage = _useTable.gotoPage,
    nextPage = _useTable.nextPage,
    previousPage = _useTable.previousPage,
    setPageSize = _useTable.setPageSize,
    state = _useTable.state,
    setGlobalFilter = _useTable.setGlobalFilter;
  return data && data.length > 0 ? /*#__PURE__*/React.createElement(Div$1, null, hasGlobalFilter ? /*#__PURE__*/React.createElement(GlobalFilter, {
    globalFilter: state.globalFilter,
    setGlobalFilter: setGlobalFilter
  }) : null, /*#__PURE__*/React.createElement(TableComponent, _extends({
    getTableProps: getTableProps,
    getTableBodyProps: getTableBodyProps,
    headerGroups: headerGroups,
    rows: paginate ? page : rows,
    prepareRow: prepareRow,
    onRowClick: function onRowClick(_ref16) {
      var original = _ref16.original;
      _onRowClick(original);
    },
    onRowSelect: function onRowSelect(_ref17) {
      var original = _ref17.original;
      _onRowSelect(original);
    },
    onRowDeselect: function onRowDeselect(_ref18) {
      var original = _ref18.original;
      _onRowDeselect(original);
    },
    numCols: hasSelection ? 1 + columns.length : columns.length,
    hasExpansion: true,
    state: state,
    paginate: paginate,
    canPreviousPage: canPreviousPage,
    canNextPage: canNextPage,
    pageOptions: pageOptions,
    pageCount: pageCount,
    gotoPage: gotoPage,
    nextPage: nextPage,
    previousPage: previousPage,
    setPageSize: setPageSize,
    widths: widths
  }, rest))) : /*#__PURE__*/React.createElement(Div$1, null, "No Data");
};
Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  gridState: PropTypes.shape({}),
  controlledGridState: PropTypes.shape({}),
  onRowClick: PropTypes.func,
  onRowSelect: PropTypes.func,
  onRowDeselect: PropTypes.func,
  onRowExpand: PropTypes.func,
  hasGlobalFilter: PropTypes.bool,
  hasSelection: PropTypes.bool,
  enableSelection: PropTypes.func,
  selectionTooltip: PropTypes.func,
  hasExpansion: PropTypes.bool,
  setGridState: PropTypes.func,
  subRowsColsIndentIndexes: PropTypes.arrayOf(PropTypes.number),
  paginate: PropTypes.bool,
  widths: PropTypes.string
};
Table.defaultProps = {
  gridState: {},
  controlledGridState: {},
  onRowClick: function onRowClick() {
    return null;
  },
  onRowSelect: function onRowSelect() {
    return null;
  },
  onRowDeselect: function onRowDeselect() {
    return null;
  },
  onRowExpand: function onRowExpand() {
    return null;
  },
  hasGlobalFilter: false,
  hasSelection: false,
  enableSelection: function enableSelection() {
    return true;
  },
  selectionTooltip: function selectionTooltip() {
    return null;
  },
  hasExpansion: false,
  setGridState: function setGridState() {
    return null;
  },
  subRowsColsIndentIndexes: [],
  paginate: false,
  widths: null
};

var ease = function ease(t, b, c, d) {
  var time = t;
  var start = b;
  var dist = c;
  var dur = d;
  time /= dur / 2;
  if (time < 1) return dist / 2 * time * time + start;
  time -= 1;
  return -dist / 2 * (time * (time - 2) - 1) + start;
};
var scrollTo = function scrollTo(goTo) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var goToNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 600;
  var target = document.querySelectorAll(goTo)[goToNumber];
  var targetPosition = target.offsetTop - offset;
  var startPosition = window.scrollY;
  var distance = targetPosition - startPosition;
  var duration = time;
  var startTime = null;
  function animationScroll(currentTime) {
    if (startTime === null) startTime = currentTime;
    var timeElapsed = currentTime - startTime;
    var run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animationScroll);
  }
  requestAnimationFrame(animationScroll);
};

var currentDevice = function currentDevice() {
  var currentWidth = window.innerWidth;
  if (currentWidth < 576) return 'xs';
  if (currentWidth < 768) return 'sm';
  if (currentWidth < 992) return 'md';
  if (currentWidth < 992) return 'lg';
  if (currentWidth > 1200) return 'xl';
  return "Couldn't find device";
};

var iconPaths$2 = _objectSpread2(_objectSpread2({}, icons), iconPaths);

export { Accordion$1 as Accordion, Anchor, Application$1 as Application, Autocomplete$1 as Autocomplete, Avatar, Button$1 as Button, ButtonGroup, Checkbox, Col$1 as Col, Collapse, Container$1 as Container, Content$1 as Content, DefaultTheme, Div$1 as Div, Dropdown$1 as Dropdown, DropdownMenu, ExpanderColumn, Icon$1 as Icon, Image$1 as Image, Input$1 as Input, InputGroup, Label, Loader$1 as Loader, MessageAlerts, Modal, Notification, Pagination, Radiobox, Row$1 as Row, SideDrawer, SimpleSlideshow, Skeleton$1 as Skeleton, Slideshow, StyleReset$1 as StyleReset, Switch, Tab$1 as Tab, Table, Tag, Text$1 as Text, Textarea, ThemeProvider, currentDevice, iconPaths$2 as iconPaths, scrollTo, withTheme };
//# sourceMappingURL=index.es.js.map
